export const mpidData = [
  {
    "type": "OTC",
    "mpid": "AALC",
    "clearingBroker": "0226",
    "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "ABAI",
    "clearingBroker": "0279",
    "brokerName": "ABACUS INVESTMENTS, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "ABBA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "ABBK",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "ABDA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "ABDW",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "ABEA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "ABHE",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "ABIG",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "ABLE",
    "clearingBroker": "0031",
    "brokerName": "NATIXIS SECURITIES AMERICAS LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "ABNA",
    "clearingBroker": "0349",
    "brokerName": "ABN AMRO SECURITIES (USA) LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "ABPR",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "ABRM",
    "clearingBroker": "0534",
    "brokerName": "ABRAHAM & CO., INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "ABRP",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "ABST",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "ACAD",
    "clearingBroker": "0443",
    "brokerName": "ACADEMY SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "ACAP",
    "clearingBroker": "0235",
    "brokerName": "ALAMO CAPITAL                                                         "
  },
  {
    "type": "OTC",
    "mpid": "ACCI",
    "clearingBroker": "0226",
    "brokerName": "WORTH FINANCIAL GROUP INC                                             "
  },
  {
    "type": "OTC",
    "mpid": "ACCP",
    "clearingBroker": "0158",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "ACCU",
    "clearingBroker": "0052",
    "brokerName": "ATB CAPITAL MARKETS USA INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "ACII",
    "clearingBroker": "0158",
    "brokerName": "ARCA CAPITAL INVESTMENTS, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "ACLP",
    "clearingBroker": "0235",
    "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
  },
  {
    "type": "OTC",
    "mpid": "ACLV",
    "clearingBroker": "0294",
    "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
  },
  {
    "type": "OTC",
    "mpid": "ACPL",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN CAPITAL PARTNERS                                             "
  },
  {
    "type": "OTC",
    "mpid": "ACPS",
    "clearingBroker": "0534",
    "brokerName": "ACP SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "ACRA",
    "clearingBroker": "0436",
    "brokerName": "ARCHIPELAGO SECURITIES, L.L.C.                                        "
  },
  {
    "type": "OTC",
    "mpid": "ACRN",
    "clearingBroker": "0235",
    "brokerName": "ACORNS SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "ACSS",
    "clearingBroker": "3450",
    "brokerName": "AC SUNSHINE SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "ADAM",
    "clearingBroker": "0161",
    "brokerName": "CANACCORD GENUITY INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "ADSB",
    "clearingBroker": "1476",
    "brokerName": "ADELPHI STOCK BROKERS                                                 "
  },
  {
    "type": "OTC",
    "mpid": "ADSO",
    "clearingBroker": "0141",
    "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "AEFA",
    "clearingBroker": "0756",
    "brokerName": "AMERIPRISE FINANCIAL SERVICES, LLC                                    "
  },
  {
    "type": "OTC",
    "mpid": "AETL",
    "clearingBroker": "0158",
    "brokerName": "AET INVESTMENT SERVICES, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "AEXG",
    "clearingBroker": "0158",
    "brokerName": "ALTERNATIVE EXECUTION GROUP                                           "
  },
  {
    "type": "OTC",
    "mpid": "AFBS",
    "clearingBroker": "0158",
    "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
  },
  {
    "type": "OTC",
    "mpid": "AFCO",
    "clearingBroker": "0284",
    "brokerName": "TD PRIME SERVICES LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "AFSS",
    "clearingBroker": "0750",
    "brokerName": "FOUR POINTS CAPITAL PARTNERS LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "AGCO",
    "clearingBroker": "0052",
    "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "AGCP",
    "clearingBroker": "0052",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "AGES",
    "clearingBroker": "0750",
    "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
  },
  {
    "type": "OTC",
    "mpid": "AGFA",
    "clearingBroker": "0226",
    "brokerName": "VALIC FINANCIAL ADVISORS, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "AGIS",
    "clearingBroker": "0235",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "AGPM",
    "clearingBroker": "1043",
    "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
  },
  {
    "type": "OTC",
    "mpid": "AGTS",
    "clearingBroker": "0158",
    "brokerName": "AVANT-GARDE TRADING SECURITIES                                        "
  },
  {
    "type": "OTC",
    "mpid": "AHSI",
    "clearingBroker": "0141",
    "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "AIRS",
    "clearingBroker": "0279",
    "brokerName": "HAND SECURITIES, INC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "AISG",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
  },
  {
    "type": "OTC",
    "mpid": "AJCO",
    "clearingBroker": "0443",
    "brokerName": "IDB CAPITAL CORP.                                                     "
  },
  {
    "type": "OTC",
    "mpid": "AKUN",
    "clearingBroker": "0695",
    "brokerName": "AKUNA SECURITIES LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "ALBS",
    "clearingBroker": "0158",
    "brokerName": "ALBERT SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "ALCG",
    "clearingBroker": "0235",
    "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "ALDN",
    "clearingBroker": "0052",
    "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "ALEG",
    "clearingBroker": "0534",
    "brokerName": "ALLEGRO SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "ALFA",
    "clearingBroker": "0352",
    "brokerName": "ALPHA TRADING L.P.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "ALGP",
    "clearingBroker": "0235",
    "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
  },
  {
    "type": "OTC",
    "mpid": "ALGR",
    "clearingBroker": "0158",
    "brokerName": "ALGER (FRED) & CO INC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "ALIS",
    "clearingBroker": "0235",
    "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
  },
  {
    "type": "OTC",
    "mpid": "ALLC",
    "clearingBroker": "0436",
    "brokerName": "ARCHIPELAGO SECURITIES L.L.C.                                         "
  },
  {
    "type": "OTC",
    "mpid": "ALLN",
    "clearingBroker": "0443",
    "brokerName": "ALLEN & COMPANY LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "ALNC",
    "clearingBroker": "0226",
    "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
  },
  {
    "type": "OTC",
    "mpid": "ALPS",
    "clearingBroker": "8072",
    "brokerName": "ALPINE SECURITIES CORPORATION                                         "
  },
  {
    "type": "OTC",
    "mpid": "ALPX",
    "clearingBroker": "0067",
    "brokerName": "TSX ALPHA U.S., INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "ALTR",
    "clearingBroker": "3164",
    "brokerName": "ALTRUIST FINANCIAL LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "ALTS",
    "clearingBroker": "0052",
    "brokerName": "LODAS SECURITIES LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "AMBB",
    "clearingBroker": "0141",
    "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
  },
  {
    "type": "OTC",
    "mpid": "AMER",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
  },
  {
    "type": "OTC",
    "mpid": "AMIC",
    "clearingBroker": "0226",
    "brokerName": "AMERICAN INVESTORS COMPANY                                            "
  },
  {
    "type": "OTC",
    "mpid": "AMLU",
    "clearingBroker": "3652",
    "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "AMMS",
    "clearingBroker": "0141",
    "brokerName": "AMUNI FINANCIAL, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "AMRI",
    "clearingBroker": "8199",
    "brokerName": "AMERICAS EXECUTIONS, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "ANDG",
    "clearingBroker": "0235",
    "brokerName": "GARRETT (ANDREW), INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "ANOS",
    "clearingBroker": "0235",
    "brokerName": "ABEL NOSER, LLC.                                                      "
  },
  {
    "type": "OTC",
    "mpid": "ANOV",
    "clearingBroker": "0750",
    "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "AORP",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "AOSD",
    "clearingBroker": "0158",
    "brokerName": "TRADING BLOCK                                                         "
  },
  {
    "type": "OTC",
    "mpid": "APBD",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "APBO",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "APCA",
    "clearingBroker": "3021",
    "brokerName": "ALPACA SECURITIES LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "APCC",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "APOG",
    "clearingBroker": "8430",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "APRO",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "APRT",
    "clearingBroker": "0226",
    "brokerName": "PARTNERS                                                              "
  },
  {
    "type": "OTC",
    "mpid": "APTO",
    "clearingBroker": "0103",
    "brokerName": "APTO PARTNERS, LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "APXO",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "APXS",
    "clearingBroker": "0052",
    "brokerName": "APEXUS CAPITAL LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "AQUA",
    "clearingBroker": "0197",
    "brokerName": "AQUA SECURITIES L.P.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "AQUB",
    "clearingBroker": "0197",
    "brokerName": "AQUA SECURITIES L.P.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "ARBC",
    "clearingBroker": "0235",
    "brokerName": "ARKADIOS CAPITAL                                                      "
  },
  {
    "type": "OTC",
    "mpid": "ARCA",
    "clearingBroker": "0436",
    "brokerName": "ARCHIPELAGO TRADING SERVICES, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "ARCD",
    "clearingBroker": "0443",
    "brokerName": "ARCADIA SECURITIES, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "ARCT",
    "clearingBroker": "4305",
    "brokerName": "ARCHITECT SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "ARKI",
    "clearingBroker": "0226",
    "brokerName": "ARKADIOS CAPITAL                                                      "
  },
  {
    "type": "OTC",
    "mpid": "ARMS",
    "clearingBroker": "0534",
    "brokerName": "ARMSTRONG SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "ARRB",
    "clearingBroker": "0436",
    "brokerName": "ARCHIPELAGO SECURITIES L.L.C.                                         "
  },
  {
    "type": "OTC",
    "mpid": "ARSC",
    "clearingBroker": "1043",
    "brokerName": "ARCTIC SECURITIES LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "ARVS",
    "clearingBroker": "0443",
    "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
  },
  {
    "type": "OTC",
    "mpid": "ASCM",
    "clearingBroker": "0052",
    "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "ASEL",
    "clearingBroker": "0370",
    "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
  },
  {
    "type": "OTC",
    "mpid": "ASII",
    "clearingBroker": "0226",
    "brokerName": "AURORA SECURITIES                                                     "
  },
  {
    "type": "OTC",
    "mpid": "ASLB",
    "clearingBroker": "0370",
    "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
  },
  {
    "type": "OTC",
    "mpid": "ASLT",
    "clearingBroker": "1043",
    "brokerName": "ASL CAPITAL MARKETS INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "ASOI",
    "clearingBroker": "0226",
    "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "ASPI",
    "clearingBroker": "0534",
    "brokerName": "ASIA PACIFIC FINANCIAL MANAGEMENT GROUP, INC.                         "
  },
  {
    "type": "OTC",
    "mpid": "ASSO",
    "clearingBroker": "0075",
    "brokerName": "ASSOCIATED SECURITIES CORP.                                           "
  },
  {
    "type": "OTC",
    "mpid": "ASTW",
    "clearingBroker": "0551",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "ATIS",
    "clearingBroker": "0052",
    "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
  },
  {
    "type": "OTC",
    "mpid": "ATMC",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "ATVT",
    "clearingBroker": "0443",
    "brokerName": "ATOMIC BROKERAGE LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "AUTO",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "AVEN",
    "clearingBroker": "0226",
    "brokerName": "AVENTURA SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "AVEW",
    "clearingBroker": "8199",
    "brokerName": "AVENTURA SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "AVIL",
    "clearingBroker": "0158",
    "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "AVML",
    "clearingBroker": "0443",
    "brokerName": "AVM, L.P.                                                             "
  },
  {
    "type": "OTC",
    "mpid": "AVNU",
    "clearingBroker": "0158",
    "brokerName": "AVENUE SECURITIES LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "AVSC",
    "clearingBroker": "0294",
    "brokerName": "AVENUE SECURITIES LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "AVSI",
    "clearingBroker": "0443",
    "brokerName": "AMERIVET SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "AVST",
    "clearingBroker": "0235",
    "brokerName": "ATOMIC BROKERAGE LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "AVTR",
    "clearingBroker": "8199",
    "brokerName": "AVATAR SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "AXCL",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "AXCS",
    "clearingBroker": "0443",
    "brokerName": "ACCESS SECURITIES INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "AXGP",
    "clearingBroker": "0443",
    "brokerName": "ACCESS SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "AXIO",
    "clearingBroker": "0279",
    "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "AXOS",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "AXXX",
    "clearingBroker": "8601",
    "brokerName": "DTC/NSCC FTS TEST ACCOUNT 1                                           "
  },
  {
    "type": "OTC",
    "mpid": "BALA",
    "clearingBroker": "0005",
    "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "BALE",
    "clearingBroker": "0443",
    "brokerName": "M&T SECURITIES, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "BALS",
    "clearingBroker": "0750",
    "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "BANK",
    "clearingBroker": "0701",
    "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "BARD",
    "clearingBroker": "0547",
    "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
  },
  {
    "type": "OTC",
    "mpid": "BARR",
    "clearingBroker": "0226",
    "brokerName": "BARRETT & COMPANY                                                     "
  },
  {
    "type": "OTC",
    "mpid": "BATM",
    "clearingBroker": "0050",
    "brokerName": "BATS TRADING, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "BATS",
    "clearingBroker": "8199",
    "brokerName": "BATS TRADING, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "BAYC",
    "clearingBroker": "0161",
    "brokerName": "BAY CREST PARTNERS,  LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "BAYP",
    "clearingBroker": "0161",
    "brokerName": "BAY CREST PARTNERS, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "BAYT",
    "clearingBroker": "0005",
    "brokerName": "BTIG, LLC                                                             "
  },
  {
    "type": "OTC",
    "mpid": "BBAR",
    "clearingBroker": "0595",
    "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "BBGC",
    "clearingBroker": "0235",
    "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
  },
  {
    "type": "OTC",
    "mpid": "BBHC",
    "clearingBroker": "0010",
    "brokerName": "BROWN BROTHERS HARRIMAN & CO.                                         "
  },
  {
    "type": "OTC",
    "mpid": "BBOK",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "BCDX",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "BCEP",
    "clearingBroker": "0551",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "BCEX",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "BCMX",
    "clearingBroker": "0443",
    "brokerName": "BERENBERG CAPITAL MARKETS LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "BCPI",
    "clearingBroker": "0279",
    "brokerName": "GVC CAPITAL LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "BCPL",
    "clearingBroker": "0750",
    "brokerName": "STOCKKINGS CAPITAL LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "BCRK",
    "clearingBroker": "0279",
    "brokerName": "BEAR CREEK SECURITIES, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "BCSA",
    "clearingBroker": "0443",
    "brokerName": "BCS AMERICAS, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "BCSG",
    "clearingBroker": "0294",
    "brokerName": "BCS GLOBAL MARKETS                                                    "
  },
  {
    "type": "OTC",
    "mpid": "BCWM",
    "clearingBroker": "4077",
    "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "BCZC",
    "clearingBroker": "0443",
    "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
  },
  {
    "type": "OTC",
    "mpid": "BDCO",
    "clearingBroker": "0534",
    "brokerName": "BARDI CO. LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "BEAF",
    "clearingBroker": "0235",
    "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
  },
  {
    "type": "OTC",
    "mpid": "BEAR",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "BELZ",
    "clearingBroker": "0627",
    "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "BERN",
    "clearingBroker": "0013",
    "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "BERS",
    "clearingBroker": "0235",
    "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "BEST",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "BESX",
    "clearingBroker": "8199",
    "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "BFAB",
    "clearingBroker": "0695",
    "brokerName": "BLUEFIN CAPITAL MANAGEMENT, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "BFEC",
    "clearingBroker": "0443",
    "brokerName": "BENJAMIN F. EDWARDS & COMPANY                                         "
  },
  {
    "type": "OTC",
    "mpid": "BFFI",
    "clearingBroker": "0226",
    "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
  },
  {
    "type": "OTC",
    "mpid": "BFSL",
    "clearingBroker": "0235",
    "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "BGCE",
    "clearingBroker": "0161",
    "brokerName": "BGC FINANCIAL INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "BGCF",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL, L.P.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "BGHT",
    "clearingBroker": "0141",
    "brokerName": "BRIGHTON SECURITIES CORP.                                             "
  },
  {
    "type": "OTC",
    "mpid": "BGIS",
    "clearingBroker": "0443",
    "brokerName": "BLACKROCK EXECUTION SERVICES                                          "
  },
  {
    "type": "OTC",
    "mpid": "BGMI",
    "clearingBroker": "0158",
    "brokerName": "BRICKELL GLOBAL MARKETS, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "BGSG",
    "clearingBroker": "0226",
    "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "BHKS",
    "clearingBroker": "0141",
    "brokerName": "BHK SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "BIDS",
    "clearingBroker": "0161",
    "brokerName": "BIDS TRADING L.P.                                                     "
  },
  {
    "type": "OTC",
    "mpid": "BIGG",
    "clearingBroker": "0005",
    "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "BIGP",
    "clearingBroker": "0443",
    "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "BIGZ",
    "clearingBroker": "0443",
    "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "BIMI",
    "clearingBroker": "0136",
    "brokerName": "INTESA SANPAOLO IMI SECURITIES CORP.                                  "
  },
  {
    "type": "OTC",
    "mpid": "BIRM",
    "clearingBroker": "0013",
    "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "BISB",
    "clearingBroker": "0286",
    "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
  },
  {
    "type": "OTC",
    "mpid": "BISE",
    "clearingBroker": "0286",
    "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
  },
  {
    "type": "OTC",
    "mpid": "BISG",
    "clearingBroker": "0286",
    "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
  },
  {
    "type": "OTC",
    "mpid": "BISH",
    "clearingBroker": "0286",
    "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
  },
  {
    "type": "OTC",
    "mpid": "BISI",
    "clearingBroker": "0443",
    "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
  },
  {
    "type": "OTC",
    "mpid": "BISO",
    "clearingBroker": "0286",
    "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
  },
  {
    "type": "OTC",
    "mpid": "BIVO",
    "clearingBroker": "0534",
    "brokerName": "BIVO FINANCIAL LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "BJCM",
    "clearingBroker": "0235",
    "brokerName": "ESSEX SECURITIES LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "BJRC",
    "clearingBroker": "0235",
    "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "BKCM",
    "clearingBroker": "0443",
    "brokerName": "BNY CAPITAL MARKETS INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "BKES",
    "clearingBroker": "0443",
    "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "BKRT",
    "clearingBroker": "0235",
    "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "BLAV",
    "clearingBroker": "0013",
    "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "BLCK",
    "clearingBroker": "0534",
    "brokerName": "JAMES I. BLACK & COMPANY                                              "
  },
  {
    "type": "OTC",
    "mpid": "BLKX",
    "clearingBroker": "0067",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "BLNI",
    "clearingBroker": "0226",
    "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "BLOC",
    "clearingBroker": "0158",
    "brokerName": "TRADING BLOCK                                                         "
  },
  {
    "type": "OTC",
    "mpid": "BLOX",
    "clearingBroker": "0443",
    "brokerName": "JONESTRADING                                                          "
  },
  {
    "type": "OTC",
    "mpid": "BLTK",
    "clearingBroker": "0443",
    "brokerName": "BULLTICK, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "BLTN",
    "clearingBroker": "0534",
    "brokerName": "BOLTON SECURITIES CORPORATION                                         "
  },
  {
    "type": "OTC",
    "mpid": "BLUE",
    "clearingBroker": "4305",
    "brokerName": "BLUE OCEAN ATS, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "BMOC",
    "clearingBroker": "0045",
    "brokerName": "BMO CAPITAL MARKETS CORP.                                             "
  },
  {
    "type": "OTC",
    "mpid": "BMSI",
    "clearingBroker": "0750",
    "brokerName": "BULL MARKET SECURITIES, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "BMSX",
    "clearingBroker": "4305",
    "brokerName": "BULL MARKET SECURITIES, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "BMSY",
    "clearingBroker": "0294",
    "brokerName": "BULL MARKET SECURITIES, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "BMUR",
    "clearingBroker": "0443",
    "brokerName": "BREAN CAPITAL, LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "BNBB",
    "clearingBroker": "0750",
    "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "BNCH",
    "clearingBroker": "0235",
    "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "BNJM",
    "clearingBroker": "0235",
    "brokerName": "BENJAMIN SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "BNPS",
    "clearingBroker": "2154",
    "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
  },
  {
    "type": "OTC",
    "mpid": "BNPX",
    "clearingBroker": "2154",
    "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
  },
  {
    "type": "OTC",
    "mpid": "BNTE",
    "clearingBroker": "0158",
    "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
  },
  {
    "type": "OTC",
    "mpid": "BNYN",
    "clearingBroker": "0226",
    "brokerName": "BANYAN SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "BOBS",
    "clearingBroker": "0534",
    "brokerName": "BULLISH BOB BAGLEY SECURITIES, INC.                                   "
  },
  {
    "type": "OTC",
    "mpid": "BOKI",
    "clearingBroker": "0443",
    "brokerName": "BOSC, INC.                                                            "
  },
  {
    "type": "OTC",
    "mpid": "BOLL",
    "clearingBroker": "0279",
    "brokerName": "BODELL OVERCASH ANDERSON & CO.                                        "
  },
  {
    "type": "OTC",
    "mpid": "BOSS",
    "clearingBroker": "0158",
    "brokerName": "ALL TIME ATS                                                          "
  },
  {
    "type": "OTC",
    "mpid": "BPWP",
    "clearingBroker": "0226",
    "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "BRBR",
    "clearingBroker": "0279",
    "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "BRCY",
    "clearingBroker": "0443",
    "brokerName": "BCP SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "BRGE",
    "clearingBroker": "0052",
    "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
  },
  {
    "type": "OTC",
    "mpid": "BRLI",
    "clearingBroker": "0226",
    "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "BRLY",
    "clearingBroker": "0158",
    "brokerName": "B. RILEY WEALTH MANAGEMENT, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "BRNK",
    "clearingBroker": "0226",
    "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "BROC",
    "clearingBroker": "0443",
    "brokerName": "PAVILION GLOBAL MARKETS LTD                                           "
  },
  {
    "type": "OTC",
    "mpid": "BRPR",
    "clearingBroker": "0534",
    "brokerName": "BRASIL PLURAL SECURITIES LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "BRRR",
    "clearingBroker": "8199",
    "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "BRSA",
    "clearingBroker": "0103",
    "brokerName": "BOURSA INVESTMENTS                                                    "
  },
  {
    "type": "OTC",
    "mpid": "BRSE",
    "clearingBroker": "0226",
    "brokerName": "BRADESCO SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "BRUT",
    "clearingBroker": "0568",
    "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "BRVL",
    "clearingBroker": "0443",
    "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "BRWM",
    "clearingBroker": "0226",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "OTC",
    "mpid": "BSCM",
    "clearingBroker": "0052",
    "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "BSPI",
    "clearingBroker": "0235",
    "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "BSSC",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "BSTX",
    "clearingBroker": "4305",
    "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "BTBS",
    "clearingBroker": "0695",
    "brokerName": "BELVEDERE TRADING LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "BTCK",
    "clearingBroker": "0158",
    "brokerName": "BULLTICK, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "BTDG",
    "clearingBroker": "0161",
    "brokerName": "BIDS TRADING LP                                                       "
  },
  {
    "type": "OTC",
    "mpid": "BTGP",
    "clearingBroker": "2402",
    "brokerName": "BTG PACTUAL US CAPITAL, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "BTIG",
    "clearingBroker": "0005",
    "brokerName": "BTIG, LLC                                                             "
  },
  {
    "type": "OTC",
    "mpid": "BTIM",
    "clearingBroker": "1043",
    "brokerName": "BTIG, LLC                                                             "
  },
  {
    "type": "OTC",
    "mpid": "BTIS",
    "clearingBroker": "0443",
    "brokerName": "BTIG, LLC                                                             "
  },
  {
    "type": "OTC",
    "mpid": "BTSI",
    "clearingBroker": "0158",
    "brokerName": "LIGHT HORSE MARKET SOLUTIONS INC                                      "
  },
  {
    "type": "OTC",
    "mpid": "BTSS",
    "clearingBroker": "0279",
    "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "BULL",
    "clearingBroker": "0158",
    "brokerName": "WEBULL FINANCIAL LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "BUMP",
    "clearingBroker": "0158",
    "brokerName": "BUMPED FINANCIAL LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "BUNT",
    "clearingBroker": "5017",
    "brokerName": "UBS SECURITIES CANADA INC./CDS                                        "
  },
  {
    "type": "OTC",
    "mpid": "BWNA",
    "clearingBroker": "0235",
    "brokerName": "BROWN ASSOCIATES INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "BXXX",
    "clearingBroker": "8602",
    "brokerName": "ANONYMOUS BROKER ACCOUNT                                              "
  },
  {
    "type": "OTC",
    "mpid": "BYXM",
    "clearingBroker": "0050",
    "brokerName": "BATS TRADING, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "BYXX",
    "clearingBroker": "8199",
    "brokerName": "BATS TRADING, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "BZTN",
    "clearingBroker": "0141",
    "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
  },
  {
    "type": "OTC",
    "mpid": "BZWV",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "BZYD",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "BZYF",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "BZYJ",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "CAAA",
    "clearingBroker": "0750",
    "brokerName": "AKAR CAPITAL MANAGEMENT, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "CABR",
    "clearingBroker": "0161",
    "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "CADG",
    "clearingBroker": "0005",
    "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "CADZ",
    "clearingBroker": "0279",
    "brokerName": "CADZ SECURITIES INC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "CAES",
    "clearingBroker": "0734",
    "brokerName": "THE NASDAQ STOCK MARKET LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "CAFS",
    "clearingBroker": "0158",
    "brokerName": "COMMUNITYAMERICA FINANCIAL SOLUTIONS, LLC                             "
  },
  {
    "type": "OTC",
    "mpid": "CAGI",
    "clearingBroker": "0279",
    "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "CAIX",
    "clearingBroker": "0235",
    "brokerName": "CAIS CAPITAL LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "CALD",
    "clearingBroker": "0103",
    "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "CALT",
    "clearingBroker": "0279",
    "brokerName": "CALTON & ASSOCIATES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "CANA",
    "clearingBroker": "0443",
    "brokerName": "CANACCORD GENUITY INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "CANR",
    "clearingBroker": "0388",
    "brokerName": "CANTONE RESEARCH INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "CANT",
    "clearingBroker": "0696",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "OTC",
    "mpid": "CAPC",
    "clearingBroker": "0235",
    "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "CAPE",
    "clearingBroker": "0279",
    "brokerName": "CAPE SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "CARY",
    "clearingBroker": "0141",
    "brokerName": "CARY STREET PARTNERS                                                  "
  },
  {
    "type": "OTC",
    "mpid": "CASH",
    "clearingBroker": "0158",
    "brokerName": "PLANNER SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CATE",
    "clearingBroker": "0235",
    "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "CATH",
    "clearingBroker": "0534",
    "brokerName": "CATHAY SECURITIES, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "CATS",
    "clearingBroker": "8430",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CBLC",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "CBOL",
    "clearingBroker": "0226",
    "brokerName": "MUTUAL SECURITIES, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "CBRA",
    "clearingBroker": "0103",
    "brokerName": "COBRA TRADING, INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "CBRC",
    "clearingBroker": "3450",
    "brokerName": "COBRA TRADING, INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "CBRV",
    "clearingBroker": "8199",
    "brokerName": "COBRA TRADING, INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "CBTD",
    "clearingBroker": "0226",
    "brokerName": "SYNOVOUS SECURITIES INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "CBUZ",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "CCAI",
    "clearingBroker": "5046",
    "brokerName": "CANACCORD CAPITAL CORPORATION/CDS                                     "
  },
  {
    "type": "OTC",
    "mpid": "CCAT",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "CCCO",
    "clearingBroker": "0226",
    "brokerName": "CARNES CAPITAL CORPORATION                                            "
  },
  {
    "type": "OTC",
    "mpid": "CCIG",
    "clearingBroker": "0235",
    "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
  },
  {
    "type": "OTC",
    "mpid": "CCMB",
    "clearingBroker": "0443",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "CCMI",
    "clearingBroker": "0443",
    "brokerName": "JMP SECURITIES LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "CCMM",
    "clearingBroker": "0235",
    "brokerName": "CRAFT CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "CCMX",
    "clearingBroker": "8430",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CCPM",
    "clearingBroker": "0595",
    "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "CDEA",
    "clearingBroker": "0438",
    "brokerName": "CIBC WORLD MARKETS CORP.                                              "
  },
  {
    "type": "OTC",
    "mpid": "CDED",
    "clearingBroker": "8430",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CDEL",
    "clearingBroker": "0161",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CDFS",
    "clearingBroker": "0052",
    "brokerName": "NAVIAN CAPITAL SECURITIES, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "CDGO",
    "clearingBroker": "0551",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CDLC",
    "clearingBroker": "0395",
    "brokerName": "CITADEL CLEARING LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "CDMA",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "CDMI",
    "clearingBroker": "0005",
    "brokerName": "CITIGROUP DERIVATIVES MARKETS INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "CDON",
    "clearingBroker": "0534",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "CDRG",
    "clearingBroker": "8430",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CDSO",
    "clearingBroker": "4305",
    "brokerName": "CDS1 SECURITIES LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "CECL",
    "clearingBroker": "0158",
    "brokerName": "CARVER EDISON CAPITAL, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "CEDL",
    "clearingBroker": "8430",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CEMM",
    "clearingBroker": "8430",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CERS",
    "clearingBroker": "0226",
    "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "CFCD",
    "clearingBroker": "0005",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "OTC",
    "mpid": "CFCO",
    "clearingBroker": "7311",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "OTC",
    "mpid": "CFCS",
    "clearingBroker": "0005",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "OTC",
    "mpid": "CFDI",
    "clearingBroker": "0226",
    "brokerName": "CFD INVESTMENTS, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "CFGM",
    "clearingBroker": "0235",
    "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "CFGT",
    "clearingBroker": "0235",
    "brokerName": "CF GLOBAL TRADING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CFII",
    "clearingBroker": "0235",
    "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
  },
  {
    "type": "OTC",
    "mpid": "CFIN",
    "clearingBroker": "0279",
    "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
  },
  {
    "type": "OTC",
    "mpid": "CFPT",
    "clearingBroker": "0197",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "OTC",
    "mpid": "CFRC",
    "clearingBroker": "3259",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "OTC",
    "mpid": "CFSI",
    "clearingBroker": "0052",
    "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "CFSX",
    "clearingBroker": "0794",
    "brokerName": "CF SECURED, LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "CGQT",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "CGWM",
    "clearingBroker": "0443",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "CGXS",
    "clearingBroker": "0067",
    "brokerName": "ONECHRONOS                                                            "
  },
  {
    "type": "OTC",
    "mpid": "CHAS",
    "clearingBroker": "0164",
    "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "CHBC",
    "clearingBroker": "0235",
    "brokerName": "PENSERRA SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CHCH",
    "clearingBroker": "0226",
    "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CHCK",
    "clearingBroker": "0226",
    "brokerName": "CHICKASAW SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "CHDA",
    "clearingBroker": "0141",
    "brokerName": "CHAPIN, DAVIS                                                         "
  },
  {
    "type": "OTC",
    "mpid": "CHDN",
    "clearingBroker": "8199",
    "brokerName": "CHARDAN CAPITAL MARKETS LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "CHLC",
    "clearingBroker": "0443",
    "brokerName": "CHURCHILL CAPITAL USA, INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "CHLM",
    "clearingBroker": "0226",
    "brokerName": "CRAIG-HALLUM CAPITAL GROUP LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "CHMR",
    "clearingBroker": "0294",
    "brokerName": "CHIMERA SECURITIES, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "CHPP",
    "clearingBroker": "0624",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "CHRD",
    "clearingBroker": "0158",
    "brokerName": "CHERRY TRADING                                                        "
  },
  {
    "type": "OTC",
    "mpid": "CHRS",
    "clearingBroker": "0750",
    "brokerName": "ROYAL TREASURE SECURITIES LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "CHUB",
    "clearingBroker": "0226",
    "brokerName": "OSAIC FS, INC.                                                        "
  },
  {
    "type": "OTC",
    "mpid": "CIBP",
    "clearingBroker": "0438",
    "brokerName": "CIBC WORLD MARKETS CORP.                                              "
  },
  {
    "type": "OTC",
    "mpid": "CICC",
    "clearingBroker": "0443",
    "brokerName": "CICC US SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "CICF",
    "clearingBroker": "5046",
    "brokerName": "CANACCORD GENUITY CORP./CDS                                           "
  },
  {
    "type": "OTC",
    "mpid": "CIIV",
    "clearingBroker": "0052",
    "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "CIMB",
    "clearingBroker": "0005",
    "brokerName": "CIMB SECURITIES (USA), INC                                            "
  },
  {
    "type": "OTC",
    "mpid": "CIOI",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "CIRI",
    "clearingBroker": "0443",
    "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
  },
  {
    "type": "OTC",
    "mpid": "CISI",
    "clearingBroker": "0352",
    "brokerName": "CHASE INVESTMENT SERVICES CORP.                                       "
  },
  {
    "type": "OTC",
    "mpid": "CIST",
    "clearingBroker": "0161",
    "brokerName": "CAPITAL INSTITUTIONAL SERVICES, INC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "CISV",
    "clearingBroker": "0226",
    "brokerName": "CITIZENS SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "CITO",
    "clearingBroker": "8430",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CJSC",
    "clearingBroker": "0443",
    "brokerName": "CJS SECURITIES, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "CLCU",
    "clearingBroker": "9132",
    "brokerName": "CLSA AMERICAS, LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "CLDN",
    "clearingBroker": "0235",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "CLHT",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "CLIC",
    "clearingBroker": "0158",
    "brokerName": "CLICK IPO SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "CLRK",
    "clearingBroker": "0235",
    "brokerName": "CLARK DODGE & CO, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "CLSA",
    "clearingBroker": "0161",
    "brokerName": "CLSA AMERICAS, LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "CLSC",
    "clearingBroker": "0235",
    "brokerName": "CABOT LODGE SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "CLST",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "CLTN",
    "clearingBroker": "0226",
    "brokerName": "CALTON & ASSOCIATES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "CMBA",
    "clearingBroker": "0551",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "CMBB",
    "clearingBroker": "0551",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "CMBC",
    "clearingBroker": "0551",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "CMBD",
    "clearingBroker": "0551",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "CMCE",
    "clearingBroker": "0226",
    "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
  },
  {
    "type": "OTC",
    "mpid": "CMMW",
    "clearingBroker": "0226",
    "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
  },
  {
    "type": "OTC",
    "mpid": "CMPR",
    "clearingBroker": "0158",
    "brokerName": "COMPOSER SECURITIES LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "CMPT",
    "clearingBroker": "0750",
    "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
  },
  {
    "type": "OTC",
    "mpid": "CMRA",
    "clearingBroker": "9132",
    "brokerName": "CHIMERA SECURITIES, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "CMSI",
    "clearingBroker": "0279",
    "brokerName": "CAPITAL MANAGEMENT SECURITIES, INC.                                   "
  },
  {
    "type": "OTC",
    "mpid": "CNAB",
    "clearingBroker": "1186",
    "brokerName": "COR CLEARING LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "CNCD",
    "clearingBroker": "0235",
    "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "CNFR",
    "clearingBroker": "0443",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "CNSI",
    "clearingBroker": "0226",
    "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "CNTR",
    "clearingBroker": "0103",
    "brokerName": "PRECISION SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "COAK",
    "clearingBroker": "0443",
    "brokerName": "CASTLE OAK SECURITIES, L.P.                                           "
  },
  {
    "type": "OTC",
    "mpid": "CODA",
    "clearingBroker": "0161",
    "brokerName": "CODA MARKETS, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "COEI",
    "clearingBroker": "0052",
    "brokerName": "COASTAL EQUITIES, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "COEX",
    "clearingBroker": "0161",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "COFS",
    "clearingBroker": "0279",
    "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
  },
  {
    "type": "OTC",
    "mpid": "COHN",
    "clearingBroker": "0235",
    "brokerName": "COHEN BROS. & COMPANY                                                 "
  },
  {
    "type": "OTC",
    "mpid": "COHR",
    "clearingBroker": "9132",
    "brokerName": "COMHAR CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "COKE",
    "clearingBroker": "0235",
    "brokerName": "COKER & PALMER, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "COMP",
    "clearingBroker": "0595",
    "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
  },
  {
    "type": "OTC",
    "mpid": "CONI",
    "clearingBroker": "0235",
    "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "CONR",
    "clearingBroker": "0235",
    "brokerName": "CONNERS & CO., INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "COOR",
    "clearingBroker": "0141",
    "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "COWN",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "COWP",
    "clearingBroker": "0226",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "COWR",
    "clearingBroker": "0443",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "COWX",
    "clearingBroker": "0161",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "COWZ",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "COYL",
    "clearingBroker": "0235",
    "brokerName": "COYLE SECURITIES LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "CPEM",
    "clearingBroker": "0161",
    "brokerName": "CLEARPOOL EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "CPLC",
    "clearingBroker": "0595",
    "brokerName": "COVA CAPITAL PARTNERS LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "CPNT",
    "clearingBroker": "8199",
    "brokerName": "PRECISION SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "CPRC",
    "clearingBroker": "0235",
    "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
  },
  {
    "type": "OTC",
    "mpid": "CPRM",
    "clearingBroker": "8199",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "CPST",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "CRAG",
    "clearingBroker": "0443",
    "brokerName": "KEPLER CAPITAL MARKETS, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "CRCM",
    "clearingBroker": "0235",
    "brokerName": "COHNREZNICK CAPITAL                                                   "
  },
  {
    "type": "OTC",
    "mpid": "CRDL",
    "clearingBroker": "0235",
    "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "CRED",
    "clearingBroker": "0443",
    "brokerName": "CREDICORP CAPITAL LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "CRFN",
    "clearingBroker": "6769",
    "brokerName": "ROBINHOOD FINANCIAL, LLC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "CRIT",
    "clearingBroker": "0294",
    "brokerName": "CRITO CAPITAL LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "CRNJ",
    "clearingBroker": "0103",
    "brokerName": "CANTONE RESEARCH INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "CRPT",
    "clearingBroker": "0235",
    "brokerName": "CROSS POINT CAPITAL LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "CRUS",
    "clearingBroker": "0005",
    "brokerName": "CHINA RENAISSANCE SECURITIES (US) INC.                                "
  },
  {
    "type": "OTC",
    "mpid": "CRWE",
    "clearingBroker": "0534",
    "brokerName": "CREWE CAPITAL                                                         "
  },
  {
    "type": "OTC",
    "mpid": "CRYN",
    "clearingBroker": "0235",
    "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
  },
  {
    "type": "OTC",
    "mpid": "CSAI",
    "clearingBroker": "0793",
    "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "CSAP",
    "clearingBroker": "0141",
    "brokerName": "CRESAP, INC.                                                          "
  },
  {
    "type": "OTC",
    "mpid": "CSCM",
    "clearingBroker": "0279",
    "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
  },
  {
    "type": "OTC",
    "mpid": "CSEC",
    "clearingBroker": "8430",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CSGI",
    "clearingBroker": "7587",
    "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "CSIN",
    "clearingBroker": "0161",
    "brokerName": "CITADEL SECURITIES INSTITUTIONAL LLC                                  "
  },
  {
    "type": "OTC",
    "mpid": "CSMI",
    "clearingBroker": "0534",
    "brokerName": "CAPITOL SECURITIES MANAGEMENT, INC.                                   "
  },
  {
    "type": "OTC",
    "mpid": "CSMM",
    "clearingBroker": "9132",
    "brokerName": "SUMMIT SECURITIES GROUP, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "CSOT",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "CSPD",
    "clearingBroker": "0197",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "OTC",
    "mpid": "CSPI",
    "clearingBroker": "0235",
    "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
  },
  {
    "type": "OTC",
    "mpid": "CSSA",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "CSSB",
    "clearingBroker": "0551",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "CSTI",
    "clearingBroker": "0161",
    "brokerName": "CANACCORD GENUITY INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "CTAS",
    "clearingBroker": "0443",
    "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "CTCA",
    "clearingBroker": "0551",
    "brokerName": "CTC, LLC                                                              "
  },
  {
    "type": "OTC",
    "mpid": "CTCB",
    "clearingBroker": "0005",
    "brokerName": "CTC, LLC                                                              "
  },
  {
    "type": "OTC",
    "mpid": "CTCO",
    "clearingBroker": "0534",
    "brokerName": "CITCO SECURITIES, INC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "CTDL",
    "clearingBroker": "0551",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CTDN",
    "clearingBroker": "0352",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CTLA",
    "clearingBroker": "0443",
    "brokerName": "CANTELLA & CO, INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "CTNL",
    "clearingBroker": "0235",
    "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "CTRD",
    "clearingBroker": "3856",
    "brokerName": "CHOICETRADE                                                           "
  },
  {
    "type": "OTC",
    "mpid": "CUAL",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CUAN",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CUAX",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CUFT",
    "clearingBroker": "0226",
    "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "CUGS",
    "clearingBroker": "8199",
    "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "CURG",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CURI",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "CURM",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "CURO",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CURT",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CURV",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "CUTW",
    "clearingBroker": "0235",
    "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "CUWB",
    "clearingBroker": "0103",
    "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "CVCG",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CVCN",
    "clearingBroker": "0158",
    "brokerName": "CV BROKERAGE, INC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "CVDC",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "CVFM",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CVHE",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "CVKD",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CVKX",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CVMS",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CVRB",
    "clearingBroker": "0005",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "CVRJ",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CVSB",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CVSH",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CVSX",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CVVG",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CVWS",
    "clearingBroker": "3450",
    "brokerName": "CURVATURE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "CWMC",
    "clearingBroker": "0438",
    "brokerName": "CIBC WORLD MARKETS CORP.                                              "
  },
  {
    "type": "OTC",
    "mpid": "CWMK",
    "clearingBroker": "0438",
    "brokerName": "CIBC WORLD MARKETS CORP.                                              "
  },
  {
    "type": "OTC",
    "mpid": "CXCX",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "CXPS",
    "clearingBroker": "0534",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "CXXX",
    "clearingBroker": "8603",
    "brokerName": "DTC/NSCC FTS TEST ACCOUNT #3                                          "
  },
  {
    "type": "OTC",
    "mpid": "CYND",
    "clearingBroker": "0443",
    "brokerName": "TIGRESS FINANCIAL PARTNERS LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "DABS",
    "clearingBroker": "0534",
    "brokerName": "DABBAH SECURITIES CORP.                                               "
  },
  {
    "type": "OTC",
    "mpid": "DADA",
    "clearingBroker": "0361",
    "brokerName": "D. A. DAVIDSON & CO.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DAIN",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "DAIS",
    "clearingBroker": "0052",
    "brokerName": "DAI SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "DARA",
    "clearingBroker": "0235",
    "brokerName": "DARWOOD ASSOCIATES, INC                                               "
  },
  {
    "type": "OTC",
    "mpid": "DARQ",
    "clearingBroker": "0568",
    "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "DART",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DASH",
    "clearingBroker": "0161",
    "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "DAVA",
    "clearingBroker": "0443",
    "brokerName": "DAVENPORT & COMPANY LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "DAVS",
    "clearingBroker": "0534",
    "brokerName": "DAVIS SECURITIES LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DAWA",
    "clearingBroker": "0647",
    "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "DBAB",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBAE",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBAT",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBAX",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBCC",
    "clearingBroker": "0235",
    "brokerName": "D. BORAL CAPITAL                                                      "
  },
  {
    "type": "OTC",
    "mpid": "DBCH",
    "clearingBroker": "0052",
    "brokerName": "D. BORAL CAPITAL                                                      "
  },
  {
    "type": "OTC",
    "mpid": "DBIB",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBLV",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBMS",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBPC",
    "clearingBroker": "0443",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBPR",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBPT",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBQT",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBRC",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBRT",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBST",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DBUL",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DCMI",
    "clearingBroker": "0226",
    "brokerName": "DAVINCI CAPITAL MANAGEMENT, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "DCSD",
    "clearingBroker": "0235",
    "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
  },
  {
    "type": "OTC",
    "mpid": "DCVL",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DEAN",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "DEDT",
    "clearingBroker": "0695",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "DEFA",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "DEGS",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DEIF",
    "clearingBroker": "0551",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "DEMA",
    "clearingBroker": "0534",
    "brokerName": "DEMATTEO MONNESS LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DENI",
    "clearingBroker": "0279",
    "brokerName": "H.C. DENISON CO.                                                      "
  },
  {
    "type": "OTC",
    "mpid": "DESJ",
    "clearingBroker": "5028",
    "brokerName": "DESJARDINS SECURITIES INC./CDS                                        "
  },
  {
    "type": "OTC",
    "mpid": "DETF",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DEXP",
    "clearingBroker": "0551",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "DFIN",
    "clearingBroker": "0161",
    "brokerName": "DASH FINANCIAL LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "DFPG",
    "clearingBroker": "0235",
    "brokerName": "DFPG INVESTMENTS, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "DFTA",
    "clearingBroker": "0695",
    "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "DFTR",
    "clearingBroker": "9132",
    "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "DGLE",
    "clearingBroker": "0695",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "DIBS",
    "clearingBroker": "0226",
    "brokerName": "DIGITAL BROKERAGE SERVICES LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "DIGG",
    "clearingBroker": "0595",
    "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "DINO",
    "clearingBroker": "8199",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "OTC",
    "mpid": "DJMA",
    "clearingBroker": "0158",
    "brokerName": "DOJIMA SERVICES LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "DJSA",
    "clearingBroker": "0750",
    "brokerName": "DAWSON JAMES SECURITIES, INC                                          "
  },
  {
    "type": "OTC",
    "mpid": "DLAI",
    "clearingBroker": "0235",
    "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "DLPS",
    "clearingBroker": "0595",
    "brokerName": "DLP SECURITIES,.LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "DLSI",
    "clearingBroker": "0226",
    "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "DLTA",
    "clearingBroker": "8445",
    "brokerName": "DEALERWEB INC.                                                        "
  },
  {
    "type": "OTC",
    "mpid": "DMCD",
    "clearingBroker": "0279",
    "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
  },
  {
    "type": "OTC",
    "mpid": "DMER",
    "clearingBroker": "0551",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "DMFE",
    "clearingBroker": "0551",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "DMKC",
    "clearingBroker": "0141",
    "brokerName": "D.M. KELLY & COMPANY                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DNOR",
    "clearingBroker": "0005",
    "brokerName": "DNB MARKETS, INC.                                                     "
  },
  {
    "type": "OTC",
    "mpid": "DNSR",
    "clearingBroker": "0158",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "OTC",
    "mpid": "DNWL",
    "clearingBroker": "0443",
    "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "DOFI",
    "clearingBroker": "4305",
    "brokerName": "DOO FINANCIAL US, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "DOFT",
    "clearingBroker": "0443",
    "brokerName": "DOFT & CO., INC.                                                      "
  },
  {
    "type": "OTC",
    "mpid": "DOMI",
    "clearingBroker": "0279",
    "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "DOMS",
    "clearingBroker": "0235",
    "brokerName": "DOMINARI SECURITIES LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "DOPE",
    "clearingBroker": "0158",
    "brokerName": "DOUGH LLC                                                             "
  },
  {
    "type": "OTC",
    "mpid": "DORN",
    "clearingBroker": "0235",
    "brokerName": "DORN & CO., INC.                                                      "
  },
  {
    "type": "OTC",
    "mpid": "DOTC",
    "clearingBroker": "0226",
    "brokerName": "COLLIERS SECURITIES LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "DOVE",
    "clearingBroker": "0226",
    "brokerName": "SECURITIES EQUITY GROUP                                               "
  },
  {
    "type": "OTC",
    "mpid": "DOWL",
    "clearingBroker": "0443",
    "brokerName": "DOWLING & PARTNERS SECURITIES LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "DQNY",
    "clearingBroker": "0551",
    "brokerName": "DRW SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "DRAT",
    "clearingBroker": "0571",
    "brokerName": "DRATEL GROUP (THE)                                                    "
  },
  {
    "type": "OTC",
    "mpid": "DREX",
    "clearingBroker": "0443",
    "brokerName": "DREXEL HAMILTON, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DRIV",
    "clearingBroker": "2402",
    "brokerName": "DRIVEWEALTH, LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "DRSC",
    "clearingBroker": "0443",
    "brokerName": "BNY MELLON SECURITIES CORPORATION                                     "
  },
  {
    "type": "OTC",
    "mpid": "DRTG",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DRTR",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DRVW",
    "clearingBroker": "0235",
    "brokerName": "DRIVEWEALTH, LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "DRWC",
    "clearingBroker": "0005",
    "brokerName": "DRW SECURITIES, L.L.C.                                                "
  },
  {
    "type": "OTC",
    "mpid": "DRWJ",
    "clearingBroker": "0551",
    "brokerName": "DRW SECURITIES, L.L.C.                                                "
  },
  {
    "type": "OTC",
    "mpid": "DRWK",
    "clearingBroker": "0695",
    "brokerName": "DRW SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "DRWM",
    "clearingBroker": "0005",
    "brokerName": "DRW SECURITIES, L.L.C.                                                "
  },
  {
    "type": "OTC",
    "mpid": "DRWP",
    "clearingBroker": "0695",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "DRWS",
    "clearingBroker": "0005",
    "brokerName": "DRW SECURITIES, L.L.C.                                                "
  },
  {
    "type": "OTC",
    "mpid": "DRWW",
    "clearingBroker": "8199",
    "brokerName": "DRIVEWEALTH, LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "DRXL",
    "clearingBroker": "0443",
    "brokerName": "DREXEL HAMILTON, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DSEC",
    "clearingBroker": "8199",
    "brokerName": "DOMINARI SECURITIES LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "DSGG",
    "clearingBroker": "0226",
    "brokerName": "DMG SECURITIES, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "DSIO",
    "clearingBroker": "0551",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "DSNG",
    "clearingBroker": "0695",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "DTEX",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
  },
  {
    "type": "OTC",
    "mpid": "DTTX",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "DUST",
    "clearingBroker": "0161",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "DVEQ",
    "clearingBroker": "0695",
    "brokerName": "DV EQUITIES                                                           "
  },
  {
    "type": "OTC",
    "mpid": "DVES",
    "clearingBroker": "0005",
    "brokerName": "DV EQUITIES                                                           "
  },
  {
    "type": "OTC",
    "mpid": "DWEL",
    "clearingBroker": "3856",
    "brokerName": "DRIVEWEALTH, LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "DWEQ",
    "clearingBroker": "0695",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "DWIZ",
    "clearingBroker": "0235",
    "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "DWLY",
    "clearingBroker": "2402",
    "brokerName": "DRIVELOYALTY                                                          "
  },
  {
    "type": "OTC",
    "mpid": "DXXX",
    "clearingBroker": "8604",
    "brokerName": "DTC/NSCC FTS TEST ACCOUNT #4                                          "
  },
  {
    "type": "OTC",
    "mpid": "EAMC",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
  },
  {
    "type": "OTC",
    "mpid": "EAMG",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
  },
  {
    "type": "OTC",
    "mpid": "EBKR",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "EBRD",
    "clearingBroker": "0103",
    "brokerName": "EARLYBIRD CAPITAL, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "EBXL",
    "clearingBroker": "0067",
    "brokerName": "KEZAR TRADING, LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "ECFI",
    "clearingBroker": "0158",
    "brokerName": "DASTA FINANCIAL, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "ECUT",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "EDDI",
    "clearingBroker": "0294",
    "brokerName": "EDDID SECURITIES USA INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "EDDY",
    "clearingBroker": "0294",
    "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "EDFC",
    "clearingBroker": "0443",
    "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "EDFI",
    "clearingBroker": "8873",
    "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "EDFO",
    "clearingBroker": "0158",
    "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "EDFP",
    "clearingBroker": "8873",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "EDJC",
    "clearingBroker": "5012",
    "brokerName": "EDWARD JONES/CDS                                                      "
  },
  {
    "type": "OTC",
    "mpid": "EDJO",
    "clearingBroker": "0057",
    "brokerName": "EDWARD D. JONES & CO.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "EGAM",
    "clearingBroker": "0050",
    "brokerName": "BATS TRADING, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "EGAW",
    "clearingBroker": "8199",
    "brokerName": "BATS TRADING, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "EGLE",
    "clearingBroker": "1043",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "OTC",
    "mpid": "EGXM",
    "clearingBroker": "0050",
    "brokerName": "BATS TRADING, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "EGXW",
    "clearingBroker": "8199",
    "brokerName": "BATS TRADING, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "ELEQ",
    "clearingBroker": "0551",
    "brokerName": "ELEQUIN SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "ELET",
    "clearingBroker": "0388",
    "brokerName": "ELECTRONIFIE SECURITIES LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "ELEV",
    "clearingBroker": "0235",
    "brokerName": "ELEVATION, LLC                                                        "
  },
  {
    "type": "OTC",
    "mpid": "EMOC",
    "clearingBroker": "0750",
    "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "ENTR",
    "clearingBroker": "0235",
    "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "EQHA",
    "clearingBroker": "0075",
    "brokerName": "EQUITABLE ADVISORS, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "EQSV",
    "clearingBroker": "0226",
    "brokerName": "EQUITY SERVICES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "EROP",
    "clearingBroker": "0158",
    "brokerName": "EROOM SECURITIES L.L.C.                                               "
  },
  {
    "type": "OTC",
    "mpid": "ESBD",
    "clearingBroker": "0235",
    "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "ESGT",
    "clearingBroker": "0294",
    "brokerName": "EASTGATE SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "ESPD",
    "clearingBroker": "0696",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "OTC",
    "mpid": "ETBE",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "ETCB",
    "clearingBroker": "3505",
    "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "ETCL",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "ETDX",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "ETEJ",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "ETFU",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "ETMM",
    "clearingBroker": "0005",
    "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "ETOR",
    "clearingBroker": "0158",
    "brokerName": "ETORO USA SECURITIES INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "ETRF",
    "clearingBroker": "0161",
    "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "ETRS",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "EWMX",
    "clearingBroker": "0279",
    "brokerName": "EAST WEST MARKETS, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "EXTF",
    "clearingBroker": "0534",
    "brokerName": "WYNSTON HILL CAPITAL, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "EZOP",
    "clearingBroker": "0158",
    "brokerName": "OPTIONSHOUSE, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "FALC",
    "clearingBroker": "0103",
    "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "FARA",
    "clearingBroker": "8199",
    "brokerName": "FARINA & ASSOCIATES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "FATS",
    "clearingBroker": "0443",
    "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "FBLM",
    "clearingBroker": "0235",
    "brokerName": "FBL MARKETING SERVICES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "FBLT",
    "clearingBroker": "8199",
    "brokerName": "FIRST BALLANTYNE, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "FBNS",
    "clearingBroker": "0235",
    "brokerName": "FBN SECURITIES, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "FBPC",
    "clearingBroker": "0443",
    "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
  },
  {
    "type": "OTC",
    "mpid": "FBSB",
    "clearingBroker": "0280",
    "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "FCCP",
    "clearingBroker": "0141",
    "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
  },
  {
    "type": "OTC",
    "mpid": "FCML",
    "clearingBroker": "0279",
    "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "FCMP",
    "clearingBroker": "0595",
    "brokerName": "PRIME EXECUTIONS, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "FCST",
    "clearingBroker": "0443",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "FDMI",
    "clearingBroker": "0571",
    "brokerName": "FREEDOM INVESTMENTS, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "FDSC",
    "clearingBroker": "0158",
    "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "FDSI",
    "clearingBroker": "0141",
    "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "FEDR",
    "clearingBroker": "0235",
    "brokerName": "FEDERATED SECURITIES INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "FENV",
    "clearingBroker": "0294",
    "brokerName": "FENIX SECURITIES, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "FENX",
    "clearingBroker": "0595",
    "brokerName": "FENIX SECURITIES, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "FFCM",
    "clearingBroker": "0235",
    "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "FFGI",
    "clearingBroker": "0235",
    "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "FFSI",
    "clearingBroker": "0158",
    "brokerName": "FIRSTRADE SECURITIES INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "FGIC",
    "clearingBroker": "0534",
    "brokerName": "FINANCORP GROUP INTERNATIONAL CORPORATION                             "
  },
  {
    "type": "OTC",
    "mpid": "FGOE",
    "clearingBroker": "0226",
    "brokerName": "FIRST GEORGETOWN SECURITIES, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "FHON",
    "clearingBroker": "0235",
    "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "FIBS",
    "clearingBroker": "0226",
    "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "FIDT",
    "clearingBroker": "5040",
    "brokerName": "FIDELITY CLEARING CANADA ULC/CDS                                      "
  },
  {
    "type": "OTC",
    "mpid": "FISA",
    "clearingBroker": "0443",
    "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "FISH",
    "clearingBroker": "0235",
    "brokerName": "L.B. FISHER & COMPANY                                                 "
  },
  {
    "type": "OTC",
    "mpid": "FJRF",
    "clearingBroker": "0052",
    "brokerName": "PARITER SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "FKSC",
    "clearingBroker": "0235",
    "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
  },
  {
    "type": "OTC",
    "mpid": "FLAT",
    "clearingBroker": "0226",
    "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
  },
  {
    "type": "OTC",
    "mpid": "FLEX",
    "clearingBroker": "0158",
    "brokerName": "GWM GROUP, INC.                                                       "
  },
  {
    "type": "OTC",
    "mpid": "FLIB",
    "clearingBroker": "0235",
    "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
  },
  {
    "type": "OTC",
    "mpid": "FLIO",
    "clearingBroker": "0158",
    "brokerName": "SANTOS CAPITAL GROUP, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "FLTG",
    "clearingBroker": "0005",
    "brokerName": "FLOW TRADERS U.S. LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "FLTL",
    "clearingBroker": "0235",
    "brokerName": "FELTL & COMPANY                                                       "
  },
  {
    "type": "OTC",
    "mpid": "FLTU",
    "clearingBroker": "0551",
    "brokerName": "FLOW TRADERS U.S. LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "FLWT",
    "clearingBroker": "0161",
    "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
  },
  {
    "type": "OTC",
    "mpid": "FMAF",
    "clearingBroker": "5008",
    "brokerName": "NBCN INC./CDS                                                         "
  },
  {
    "type": "OTC",
    "mpid": "FMAT",
    "clearingBroker": "0608",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "FMCO",
    "clearingBroker": "0443",
    "brokerName": "FIRST MANHATTAN CO.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "FMEX",
    "clearingBroker": "0750",
    "brokerName": "FINAMEX INTERNATIONAL, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "FMGF",
    "clearingBroker": "0695",
    "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "FMNC",
    "clearingBroker": "0226",
    "brokerName": "FMN CAPITAL CORPORATION                                               "
  },
  {
    "type": "OTC",
    "mpid": "FNBR",
    "clearingBroker": "0728",
    "brokerName": "FOLIOFN INVESTMENTS, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "FNET",
    "clearingBroker": "0141",
    "brokerName": "WACHOVIA SECURITIES FINANCIAL NETWORK, LLC                            "
  },
  {
    "type": "OTC",
    "mpid": "FNFD",
    "clearingBroker": "0443",
    "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
  },
  {
    "type": "OTC",
    "mpid": "FNIC",
    "clearingBroker": "0443",
    "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
  },
  {
    "type": "OTC",
    "mpid": "FNNL",
    "clearingBroker": "0158",
    "brokerName": "FENNEL                                                                "
  },
  {
    "type": "OTC",
    "mpid": "FNSJ",
    "clearingBroker": "0443",
    "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
  },
  {
    "type": "OTC",
    "mpid": "FNTN",
    "clearingBroker": "0158",
    "brokerName": "FINTRON INVEST                                                        "
  },
  {
    "type": "OTC",
    "mpid": "FNXE",
    "clearingBroker": "0158",
    "brokerName": "FENIX SECURITIES, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "FNXS",
    "clearingBroker": "0750",
    "brokerName": "FENIX SECURITIES, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "FOGS",
    "clearingBroker": "0235",
    "brokerName": "FOG EQUITIES LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "FORI",
    "clearingBroker": "0750",
    "brokerName": "FORTREND SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "FORS",
    "clearingBroker": "0158",
    "brokerName": "FORIS CAPITAL US LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "FRAC",
    "clearingBroker": "4305",
    "brokerName": "ATOMIC VAULTS SECURITIES, LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "FRCE",
    "clearingBroker": "2402",
    "brokerName": "FIN2                                                                  "
  },
  {
    "type": "OTC",
    "mpid": "FREC",
    "clearingBroker": "0158",
    "brokerName": "FREC SECURITIES LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "FRKS",
    "clearingBroker": "0294",
    "brokerName": "FARKAS CAPITAL                                                        "
  },
  {
    "type": "OTC",
    "mpid": "FRSO",
    "clearingBroker": "0534",
    "brokerName": "FIRST OMEGA, LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "FRTN",
    "clearingBroker": "0103",
    "brokerName": "FORTUNE SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "FRTS",
    "clearingBroker": "0534",
    "brokerName": "FORTRESS PRIVATE LEDGER, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "FSRP",
    "clearingBroker": "0443",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "FTBR",
    "clearingBroker": "0728",
    "brokerName": "FOLIO INVESTMENTS, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "FTEN",
    "clearingBroker": "0226",
    "brokerName": "FTB ADVISORS, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "FTIT",
    "clearingBroker": "0005",
    "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
  },
  {
    "type": "OTC",
    "mpid": "FTLP",
    "clearingBroker": "8244",
    "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
  },
  {
    "type": "OTC",
    "mpid": "FTRD",
    "clearingBroker": "0161",
    "brokerName": "FLOW TRADERS U.S. LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "FTSC",
    "clearingBroker": "0202",
    "brokerName": "FHN FINANCIAL SECURITIES CORP.                                        "
  },
  {
    "type": "OTC",
    "mpid": "FTSR",
    "clearingBroker": "0226",
    "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "FUTA",
    "clearingBroker": "4272",
    "brokerName": "FUTU CLEARING INC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "FUTC",
    "clearingBroker": "4272",
    "brokerName": "FUTU CLEARING INC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "FUTG",
    "clearingBroker": "4272",
    "brokerName": "FUTU CLEARING INC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "FUTI",
    "clearingBroker": "4272",
    "brokerName": "FUTU INC                                                              "
  },
  {
    "type": "OTC",
    "mpid": "FUTJ",
    "clearingBroker": "4272",
    "brokerName": "FUTU CLEARING INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "FUTM",
    "clearingBroker": "4272",
    "brokerName": "FUTU CLEARING INC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "FUTU",
    "clearingBroker": "0534",
    "brokerName": "FUTU INC                                                              "
  },
  {
    "type": "OTC",
    "mpid": "FWSI",
    "clearingBroker": "0141",
    "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "GABE",
    "clearingBroker": "0534",
    "brokerName": "G. RESEARCH, INC.                                                     "
  },
  {
    "type": "OTC",
    "mpid": "GAFI",
    "clearingBroker": "0235",
    "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "GAGN",
    "clearingBroker": "0226",
    "brokerName": "GAGNON SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "GALX",
    "clearingBroker": "0534",
    "brokerName": "GALAXY SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "GARB",
    "clearingBroker": "0148",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
  },
  {
    "type": "OTC",
    "mpid": "GARC",
    "clearingBroker": "0161",
    "brokerName": "ICAP CORPORATES LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "GARR",
    "clearingBroker": "0226",
    "brokerName": "GARRETT NAGLE & CO., INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "GARW",
    "clearingBroker": "0595",
    "brokerName": "GAR WOOD SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "GATE",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "GBMT",
    "clearingBroker": "0443",
    "brokerName": "GBM INTERNATIONAL, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "GBTS",
    "clearingBroker": "0005",
    "brokerName": "GTS SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "GDOC",
    "clearingBroker": "0551",
    "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "GEBB",
    "clearingBroker": "0551",
    "brokerName": "GLOBAL EXECUTION BROKERS, LP                                          "
  },
  {
    "type": "OTC",
    "mpid": "GELB",
    "clearingBroker": "0005",
    "brokerName": "GELBER SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "GELP",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "GENS",
    "clearingBroker": "0279",
    "brokerName": "GENERAL SECURITIES CORP                                               "
  },
  {
    "type": "OTC",
    "mpid": "GENW",
    "clearingBroker": "0226",
    "brokerName": "GENEOS WEALTH MANAGEMENT, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "GETS",
    "clearingBroker": "0295",
    "brokerName": "GETCO SECURITIES, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "GFIG",
    "clearingBroker": "0537",
    "brokerName": "GFI SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "GFIS",
    "clearingBroker": "0005",
    "brokerName": "GFI SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "GFLO",
    "clearingBroker": "0443",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "GFRY",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "GFYC",
    "clearingBroker": "0438",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "GHCC",
    "clearingBroker": "0226",
    "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
  },
  {
    "type": "OTC",
    "mpid": "GILG",
    "clearingBroker": "0226",
    "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "GJSS",
    "clearingBroker": "0235",
    "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "GLED",
    "clearingBroker": "0283",
    "brokerName": "GLENDALE SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "GLII",
    "clearingBroker": "5005",
    "brokerName": "TD SECURITIES INC./CDS                                                "
  },
  {
    "type": "OTC",
    "mpid": "GLIP",
    "clearingBroker": "5062",
    "brokerName": "TD SECURITIES INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "GLIR",
    "clearingBroker": "5021",
    "brokerName": "TD WATERHOUSE CANADA INC. #5/CDS                                      "
  },
  {
    "type": "OTC",
    "mpid": "GLIS",
    "clearingBroker": "5036",
    "brokerName": "TD WATERHOUSE CANADA INC./CDS                                         "
  },
  {
    "type": "OTC",
    "mpid": "GLLL",
    "clearingBroker": "0279",
    "brokerName": "GILL CAPITAL PARTNERS                                                 "
  },
  {
    "type": "OTC",
    "mpid": "GLPX",
    "clearingBroker": "9132",
    "brokerName": "ACS EXECUTION SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "GLTV",
    "clearingBroker": "0294",
    "brokerName": "GTS SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "GMSE",
    "clearingBroker": "0750",
    "brokerName": "GAMMA SECURITIES, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "GMSG",
    "clearingBroker": "0443",
    "brokerName": "GMS GROUP (THE), L.L.C.                                               "
  },
  {
    "type": "OTC",
    "mpid": "GONE",
    "clearingBroker": "0551",
    "brokerName": "GROUP ONE TRADING, L.P.                                               "
  },
  {
    "type": "OTC",
    "mpid": "GPCA",
    "clearingBroker": "0235",
    "brokerName": "GREAT POINT CAPITAL LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GPCE",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "GPCW",
    "clearingBroker": "8199",
    "brokerName": "GREAT POINT CAPITAL LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GPSA",
    "clearingBroker": "0294",
    "brokerName": "GLOBAL PACIFIC SECURITIES US, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "GPSS",
    "clearingBroker": "0443",
    "brokerName": "GREAT PACIFIC SECURITIES                                              "
  },
  {
    "type": "OTC",
    "mpid": "GPTG",
    "clearingBroker": "0534",
    "brokerName": "SMITH CAPITAL MARKETS, LLC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "GRAD",
    "clearingBroker": "0235",
    "brokerName": "GRADIENT SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "GRBD",
    "clearingBroker": "0052",
    "brokerName": "GREENBIRD CAPITAL LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "GRFN",
    "clearingBroker": "0103",
    "brokerName": "GRIFFIN FINANCIAL GROUP, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "GRIL",
    "clearingBroker": "0235",
    "brokerName": "GLOBAL RESOURCE INVESTMENTS, LTD.                                     "
  },
  {
    "type": "OTC",
    "mpid": "GROD",
    "clearingBroker": "0226",
    "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "GRPS",
    "clearingBroker": "0226",
    "brokerName": "MML INVESTORS SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "GRWD",
    "clearingBroker": "0052",
    "brokerName": "GAR WOOD SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "GSBI",
    "clearingBroker": "0279",
    "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "GSCO",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSCS",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSFS",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "GSIB",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSLM",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSLT",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSLZ",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSMM",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSQQ",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSSC",
    "clearingBroker": "0161",
    "brokerName": "GEORGESON SHAREHOLDER SECURITIES CORP.                                "
  },
  {
    "type": "OTC",
    "mpid": "GSSI",
    "clearingBroker": "0052",
    "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "GSUU",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSVV",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSWW",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSXX",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSYY",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GSZZ",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "GTBY",
    "clearingBroker": "0158",
    "brokerName": "GATSBY SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "GTEX",
    "clearingBroker": "0005",
    "brokerName": "GTS EXECUTION SERVICES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "GTNA",
    "clearingBroker": "0294",
    "brokerName": "GTN AMERICAS FINANCIAL SERVICES INC                                   "
  },
  {
    "type": "OTC",
    "mpid": "GTNB",
    "clearingBroker": "0595",
    "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
  },
  {
    "type": "OTC",
    "mpid": "GTNC",
    "clearingBroker": "9132",
    "brokerName": "GTN AMERICAS FINANCIAL SERVICES INC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "GTSB",
    "clearingBroker": "0005",
    "brokerName": "GTS SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "GTSM",
    "clearingBroker": "0005",
    "brokerName": "GTS SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "GTSW",
    "clearingBroker": "0005",
    "brokerName": "GTS SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "GTSY",
    "clearingBroker": "0005",
    "brokerName": "GTS SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "GTSZ",
    "clearingBroker": "0005",
    "brokerName": "GTS SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "GTTX",
    "clearingBroker": "0695",
    "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "GUGI",
    "clearingBroker": "0526",
    "brokerName": "GUGGENHEIM FUNDS DISTRIBUTORS, LLC                                    "
  },
  {
    "type": "OTC",
    "mpid": "GUGS",
    "clearingBroker": "0443",
    "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "GWDS",
    "clearingBroker": "0534",
    "brokerName": "GAR WOOD SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "GWNS",
    "clearingBroker": "0226",
    "brokerName": "GWN SECURITIES INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "GZML",
    "clearingBroker": "0161",
    "brokerName": "GUZMAN & COMPANY                                                      "
  },
  {
    "type": "OTC",
    "mpid": "HACA",
    "clearingBroker": "0701",
    "brokerName": "HARVEST CAPITAL LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "HAFS",
    "clearingBroker": "0279",
    "brokerName": "HANTZ FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "HALA",
    "clearingBroker": "0534",
    "brokerName": "HALIFAX AMERICA LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "HALO",
    "clearingBroker": "0235",
    "brokerName": "HALO SECURITIES, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "HAPI",
    "clearingBroker": "0158",
    "brokerName": "HAPI                                                                  "
  },
  {
    "type": "OTC",
    "mpid": "HAPX",
    "clearingBroker": "0551",
    "brokerName": "HAP TRADING, LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "HARC",
    "clearingBroker": "0235",
    "brokerName": "HARLEY CAPITAL LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "HARS",
    "clearingBroker": "8199",
    "brokerName": "HARVESTONS SECURITIES, INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "HASF",
    "clearingBroker": "5058",
    "brokerName": "HAYWOOD SECURITIES INC./ CDS                                          "
  },
  {
    "type": "OTC",
    "mpid": "HAVK",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "HAZL",
    "clearingBroker": "0226",
    "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "HBCA",
    "clearingBroker": "0430",
    "brokerName": "HOLD BROTHERS CAPITAL LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "HBCL",
    "clearingBroker": "0430",
    "brokerName": "HOLD BROTHERS CAPITAL LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "HBIF",
    "clearingBroker": "0695",
    "brokerName": "DRW SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "HBIW",
    "clearingBroker": "0695",
    "brokerName": "DRW SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "HCGC",
    "clearingBroker": "0103",
    "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "HCMX",
    "clearingBroker": "0235",
    "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "HCTA",
    "clearingBroker": "0005",
    "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "HCWW",
    "clearingBroker": "0235",
    "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "HDVS",
    "clearingBroker": "0226",
    "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "HEAD",
    "clearingBroker": "0443",
    "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
  },
  {
    "type": "OTC",
    "mpid": "HEDG",
    "clearingBroker": "0158",
    "brokerName": "HEDGE PRO LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "HENN",
    "clearingBroker": "0235",
    "brokerName": "CARL M. HENNIG, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "HENY",
    "clearingBroker": "0443",
    "brokerName": "HENLEY & COMPANY LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "HFLD",
    "clearingBroker": "0279",
    "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "HIGG",
    "clearingBroker": "0235",
    "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "HNTR",
    "clearingBroker": "0443",
    "brokerName": "HUNTER ASSOCIATES, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "HOLD",
    "clearingBroker": "0430",
    "brokerName": "HOLD BROTHERS CAPITAL LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "HONR",
    "clearingBroker": "0235",
    "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "HOOD",
    "clearingBroker": "6769",
    "brokerName": "ROBINHOOD SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "HOPK",
    "clearingBroker": "0750",
    "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
  },
  {
    "type": "OTC",
    "mpid": "HORW",
    "clearingBroker": "0534",
    "brokerName": "INSIGHT SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "HOVD",
    "clearingBroker": "0103",
    "brokerName": "HOVDE GROUP, LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "HPOM",
    "clearingBroker": "0235",
    "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
  },
  {
    "type": "OTC",
    "mpid": "HPSR",
    "clearingBroker": "0534",
    "brokerName": "HEWLETT POINT SECURITIES, LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "HRBF",
    "clearingBroker": "0756",
    "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
  },
  {
    "type": "OTC",
    "mpid": "HRGR",
    "clearingBroker": "0235",
    "brokerName": "HARGER AND COMPANY, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "HRTB",
    "clearingBroker": "0551",
    "brokerName": "HRT FINANCIAL LP                                                      "
  },
  {
    "type": "OTC",
    "mpid": "HRTF",
    "clearingBroker": "0369",
    "brokerName": "HRT FINANCIAL LP                                                      "
  },
  {
    "type": "OTC",
    "mpid": "HRTW",
    "clearingBroker": "0369",
    "brokerName": "HRT FINANCIAL LP                                                      "
  },
  {
    "type": "OTC",
    "mpid": "HRTX",
    "clearingBroker": "0369",
    "brokerName": "HRT EXECUTION SERVICES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "HSAC",
    "clearingBroker": "0158",
    "brokerName": "KBFG SECURITIES AMERICA INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "HSAI",
    "clearingBroker": "0443",
    "brokerName": "INDEPENDENT FINANCIAL GROUP, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "HSBC",
    "clearingBroker": "0816",
    "brokerName": "HSBC SECURITIES (USA), INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "HSBK",
    "clearingBroker": "0816",
    "brokerName": "HSBC SECURITIES (USA) INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "HTCM",
    "clearingBroker": "0235",
    "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
  },
  {
    "type": "OTC",
    "mpid": "HTIS",
    "clearingBroker": "0443",
    "brokerName": "HAITONG INTERNATIONAL SECURITIES (USA) INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "HTSC",
    "clearingBroker": "0750",
    "brokerName": "HUATAI SECURITIES (USA), INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "HTWR",
    "clearingBroker": "0226",
    "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "HUCO",
    "clearingBroker": "0226",
    "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
  },
  {
    "type": "OTC",
    "mpid": "HUNT",
    "clearingBroker": "0141",
    "brokerName": "HUNTLEIGH SECURITIES CORPORATION                                      "
  },
  {
    "type": "OTC",
    "mpid": "HWJC",
    "clearingBroker": "0052",
    "brokerName": "HWJ CAPITAL PARTNERS II, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "HWLS",
    "clearingBroker": "0443",
    "brokerName": "M.S. HOWELLS & CO.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "HYSI",
    "clearingBroker": "0226",
    "brokerName": "HEIM, YOUNG & ASSOCIATES, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "IAAK",
    "clearingBroker": "0279",
    "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "IAEA",
    "clearingBroker": "0294",
    "brokerName": "SRT SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "IAEW",
    "clearingBroker": "0595",
    "brokerName": "SRT SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "IAEX",
    "clearingBroker": "0235",
    "brokerName": "SRT SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "IATS",
    "clearingBroker": "0017",
    "brokerName": "INTERACTIVE BROKERS LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "IBCO",
    "clearingBroker": "0534",
    "brokerName": "INTERACTIVE BROKERS CORP.                                             "
  },
  {
    "type": "OTC",
    "mpid": "IBFS",
    "clearingBroker": "0824",
    "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
  },
  {
    "type": "OTC",
    "mpid": "IBKR",
    "clearingBroker": "0534",
    "brokerName": "INTERACTIVE BROKERS LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "IBND",
    "clearingBroker": "0103",
    "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "IBPR",
    "clearingBroker": "0052",
    "brokerName": "IB CAPITAL LLC                                                        "
  },
  {
    "type": "OTC",
    "mpid": "IBSH",
    "clearingBroker": "0595",
    "brokerName": "INTEGRITY BROKERAGE SERVICES, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "IBSJ",
    "clearingBroker": "0052",
    "brokerName": "INTEGRITY BROKERAGE SERVICES, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "ICAN",
    "clearingBroker": "0226",
    "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "ICBC",
    "clearingBroker": "0824",
    "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL                     "
  },
  {
    "type": "OTC",
    "mpid": "ICBK",
    "clearingBroker": "0388",
    "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
  },
  {
    "type": "OTC",
    "mpid": "ICBX",
    "clearingBroker": "0067",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "ICCP",
    "clearingBroker": "0443",
    "brokerName": "INVESTORS CAPITAL CORPORATION                                         "
  },
  {
    "type": "OTC",
    "mpid": "ICDS",
    "clearingBroker": "0750",
    "brokerName": "ICD SECURITIES                                                        "
  },
  {
    "type": "OTC",
    "mpid": "ICFS",
    "clearingBroker": "0534",
    "brokerName": "INTERCAROLINA FINANCIAL SERVICES, INC.                                "
  },
  {
    "type": "OTC",
    "mpid": "ICMH",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
  },
  {
    "type": "OTC",
    "mpid": "ICON",
    "clearingBroker": "0595",
    "brokerName": "ICON CAPITAL GROUP, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "ICRD",
    "clearingBroker": "0551",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "ICVT",
    "clearingBroker": "8430",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "IDAY",
    "clearingBroker": "0103",
    "brokerName": "BROKERAGESELECT                                                       "
  },
  {
    "type": "OTC",
    "mpid": "IELP",
    "clearingBroker": "8430",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "IEOS",
    "clearingBroker": "0534",
    "brokerName": "INTERACTIVE BROKERS LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "IEQY",
    "clearingBroker": "0551",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "IESI",
    "clearingBroker": "0443",
    "brokerName": "ITAU EUROPA SECURITIES INC                                            "
  },
  {
    "type": "OTC",
    "mpid": "IEXG",
    "clearingBroker": "0161",
    "brokerName": "IEX SERVICES, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "IFCS",
    "clearingBroker": "0161",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "ILND",
    "clearingBroker": "0520",
    "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "ILNK",
    "clearingBroker": "0750",
    "brokerName": "INVESTORLINK CAPITAL MARKETS, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "IMAB",
    "clearingBroker": "0695",
    "brokerName": "IMC-CHICAGO, LLC, IMC FINANCIAL MARKETS                               "
  },
  {
    "type": "OTC",
    "mpid": "IMCC",
    "clearingBroker": "0005",
    "brokerName": "IMC FINANCIAL MARKETS                                                 "
  },
  {
    "type": "OTC",
    "mpid": "IMCS",
    "clearingBroker": "0005",
    "brokerName": "IMC FINANCIAL MARKETS                                                 "
  },
  {
    "type": "OTC",
    "mpid": "IMCX",
    "clearingBroker": "0005",
    "brokerName": "IMC EXECUTION SERVICES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "IMMG",
    "clearingBroker": "0226",
    "brokerName": "INTERNATIONAL MONEY MANAGEMENT GROUP, INC.                            "
  },
  {
    "type": "OTC",
    "mpid": "IMPC",
    "clearingBroker": "0443",
    "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "IMSE",
    "clearingBroker": "0695",
    "brokerName": "IMC SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "INAB",
    "clearingBroker": "0695",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "INAM",
    "clearingBroker": "0695",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "INCA",
    "clearingBroker": "0067",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "INCE",
    "clearingBroker": "0067",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "INCR",
    "clearingBroker": "0067",
    "brokerName": "INTELLIGENT CROSS LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "INCV",
    "clearingBroker": "0294",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "INCW",
    "clearingBroker": "0294",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "INCX",
    "clearingBroker": "9132",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "INCY",
    "clearingBroker": "9132",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "INDB",
    "clearingBroker": "0067",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "INDX",
    "clearingBroker": "0158",
    "brokerName": "LINDEN THOMAS AND COMPANY SECURITIES, LLC                             "
  },
  {
    "type": "OTC",
    "mpid": "INDY",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "INET",
    "clearingBroker": "0568",
    "brokerName": "NADAQ EXECUTION SERVICES, LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "INFI",
    "clearingBroker": "0279",
    "brokerName": "INTEGRAL FINANCIAL, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "INFX",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "INGF",
    "clearingBroker": "0270",
    "brokerName": "ING FINANCIAL MARKETS LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "INGS",
    "clearingBroker": "0124",
    "brokerName": "INGALLS & SNYDER, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "INJX",
    "clearingBroker": "0536",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "INNO",
    "clearingBroker": "0052",
    "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "INPI",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT PLANNERS INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "INPS",
    "clearingBroker": "0235",
    "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "INSR",
    "clearingBroker": "0067",
    "brokerName": "INTELLIGENT CROSS LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "INTB",
    "clearingBroker": "0158",
    "brokerName": "INTER&CO SECURITIES LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "INTL",
    "clearingBroker": "0161",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "INTW",
    "clearingBroker": "0067",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "INTX",
    "clearingBroker": "0235",
    "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
  },
  {
    "type": "OTC",
    "mpid": "ISCN",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
  },
  {
    "type": "OTC",
    "mpid": "ISEY",
    "clearingBroker": "0520",
    "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "ISIG",
    "clearingBroker": "0226",
    "brokerName": "EVERCORE GROUP L.L.C.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "ISLL",
    "clearingBroker": "0052",
    "brokerName": "INLET SECURITIES LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "ISSI",
    "clearingBroker": "0052",
    "brokerName": "INSIGHT SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "ITAU",
    "clearingBroker": "0443",
    "brokerName": "ITAU BBA USA SECURITIES INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "ITCC",
    "clearingBroker": "0750",
    "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "ITGI",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "ITGP",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "IURS",
    "clearingBroker": "0534",
    "brokerName": "IUR SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "IVNT",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT NETWORK, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "IVOL",
    "clearingBroker": "0235",
    "brokerName": "UNION CAPITAL COMPANY                                                 "
  },
  {
    "type": "OTC",
    "mpid": "JANE",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET MARKETS, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "JANS",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET MARKETS, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "JANY",
    "clearingBroker": "0374",
    "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "JBDX",
    "clearingBroker": "0294",
    "brokerName": "JB DRAX HONORE INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "JBLK",
    "clearingBroker": "0019",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "JDRB",
    "clearingBroker": "0595",
    "brokerName": "J.H. DARBIE & CO., INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "JEFF",
    "clearingBroker": "0019",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "JEFM",
    "clearingBroker": "0235",
    "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
  },
  {
    "type": "OTC",
    "mpid": "JEFX",
    "clearingBroker": "0536",
    "brokerName": "JEFFERIES EXECUTION SERVICES, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "JEVO",
    "clearingBroker": "0235",
    "brokerName": "ATIS, INC                                                             "
  },
  {
    "type": "OTC",
    "mpid": "JEXF",
    "clearingBroker": "0536",
    "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "JGRC",
    "clearingBroker": "0103",
    "brokerName": "JOSEPH GRACE                                                          "
  },
  {
    "type": "OTC",
    "mpid": "JGUN",
    "clearingBroker": "0235",
    "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "JHDR",
    "clearingBroker": "0052",
    "brokerName": "JH DARBIE & CO. INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "JHYT",
    "clearingBroker": "0019",
    "brokerName": "JEFFERIES PARTNER OPPORTUNITY FUND II, LLC                            "
  },
  {
    "type": "OTC",
    "mpid": "JKFS",
    "clearingBroker": "0279",
    "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "JLEQ",
    "clearingBroker": "0161",
    "brokerName": "JUMP EXECUTION, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "JMLS",
    "clearingBroker": "0235",
    "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "JMPT",
    "clearingBroker": "0551",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "JMSI",
    "clearingBroker": "0374",
    "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "JNST",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET CAPITAL LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "JOHN",
    "clearingBroker": "8072",
    "brokerName": "SCOTTSDALE CAPITAL ADVISORS                                           "
  },
  {
    "type": "OTC",
    "mpid": "JONE",
    "clearingBroker": "0161",
    "brokerName": "JONESTRADING                                                          "
  },
  {
    "type": "OTC",
    "mpid": "JPBX",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "JPII",
    "clearingBroker": "0534",
    "brokerName": "JAYPEE INTERNATIONAL, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "JPME",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "JPMG",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "JPMP",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "JPMS",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "JPMT",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "JPMX",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "JPPB",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "JRCO",
    "clearingBroker": "0226",
    "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
  },
  {
    "type": "OTC",
    "mpid": "JSAP",
    "clearingBroker": "8497",
    "brokerName": "JANE STREET CAPITAL, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "JSBA",
    "clearingBroker": "0161",
    "brokerName": "JANE STREET CAPITAL, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "JSCA",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET CAPITAL LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "JSCL",
    "clearingBroker": "0052",
    "brokerName": "JOSEPH STONE CAPITAL L.L.C.                                           "
  },
  {
    "type": "OTC",
    "mpid": "JSCO",
    "clearingBroker": "3856",
    "brokerName": "J. STREICHER & CO. L.L.C.                                             "
  },
  {
    "type": "OTC",
    "mpid": "JSCT",
    "clearingBroker": "0005",
    "brokerName": "JANE STREET CAPITAL LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "JSEB",
    "clearingBroker": "0161",
    "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
  },
  {
    "type": "OTC",
    "mpid": "JSEG",
    "clearingBroker": "0161",
    "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
  },
  {
    "type": "OTC",
    "mpid": "JSJX",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET CAPITAL LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "JSML",
    "clearingBroker": "0551",
    "brokerName": "JANE STREET CAPITAL, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "JSOL",
    "clearingBroker": "0551",
    "brokerName": "JANE STREET OPTIONS, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "JSPT",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET MARKETS, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "JSSC",
    "clearingBroker": "3492",
    "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
  },
  {
    "type": "OTC",
    "mpid": "JSSF",
    "clearingBroker": "0226",
    "brokerName": "JMP SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "JTOT",
    "clearingBroker": "0005",
    "brokerName": "JONES TRADING                                                         "
  },
  {
    "type": "OTC",
    "mpid": "JUSX",
    "clearingBroker": "3856",
    "brokerName": "JUST2TRADE, INC.                                                      "
  },
  {
    "type": "OTC",
    "mpid": "JVBF",
    "clearingBroker": "0235",
    "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
  },
  {
    "type": "OTC",
    "mpid": "JVBG",
    "clearingBroker": "0443",
    "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "JVDA",
    "clearingBroker": "0294",
    "brokerName": "CHAINCE SECURITIES, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "JWCF",
    "clearingBroker": "0226",
    "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "JWTT",
    "clearingBroker": "0158",
    "brokerName": "JWTT INC.                                                             "
  },
  {
    "type": "OTC",
    "mpid": "JXLI",
    "clearingBroker": "0536",
    "brokerName": "LIME BROKERAGE LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "KALA",
    "clearingBroker": "0226",
    "brokerName": "KA ASSOCIATES, INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "KALS",
    "clearingBroker": "0235",
    "brokerName": "KALOS CAPITAL, INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "KAPG",
    "clearingBroker": "0158",
    "brokerName": "KAPITALL GENERATION, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "KART",
    "clearingBroker": "0750",
    "brokerName": "REVERE SECURITIES CORP.                                               "
  },
  {
    "type": "OTC",
    "mpid": "KBWI",
    "clearingBroker": "0793",
    "brokerName": "KEEFE, BRUYETTE & WOODS, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "KCAM",
    "clearingBroker": "0052",
    "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "KCGM",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "KCIM",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
  },
  {
    "type": "OTC",
    "mpid": "KCIX",
    "clearingBroker": "0279",
    "brokerName": "KILEY PARTNERS, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "KCMP",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "KCRD",
    "clearingBroker": "0052",
    "brokerName": "PHX FINANCIAL, INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "KEEN",
    "clearingBroker": "0279",
    "brokerName": "ST. BERNARD FINANCIAL SERVICES, INC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "KELG",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "KELL",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "KENS",
    "clearingBroker": "0279",
    "brokerName": "KENSINGTON CAPITAL CORP.                                              "
  },
  {
    "type": "OTC",
    "mpid": "KEYB",
    "clearingBroker": "0443",
    "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "KEYS",
    "clearingBroker": "2402",
    "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "KIML",
    "clearingBroker": "0226",
    "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "KING",
    "clearingBroker": "0235",
    "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "KISA",
    "clearingBroker": "0294",
    "brokerName": "KOREA INVESTMENT & SECURITIES AMERICA, INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "KLFX",
    "clearingBroker": "9132",
    "brokerName": "KLEON FINANCIAL, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "KNGS",
    "clearingBroker": "0235",
    "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "KNGW",
    "clearingBroker": "0158",
    "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "KOVS",
    "clearingBroker": "0226",
    "brokerName": "KOVACK SECURITIES INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "KRCO",
    "clearingBroker": "0235",
    "brokerName": "KR SECURITIES, LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "KRMQ",
    "clearingBroker": "0158",
    "brokerName": "KARMEQ, LLC                                                           "
  },
  {
    "type": "OTC",
    "mpid": "KRSH",
    "clearingBroker": "0005",
    "brokerName": "KERSHNER SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "KRTH",
    "clearingBroker": "0235",
    "brokerName": "J.W. KORTH & COMPANY                                                  "
  },
  {
    "type": "OTC",
    "mpid": "KUYK",
    "clearingBroker": "0279",
    "brokerName": "KUYKENDALL & SCHNEIDER, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "KWSC",
    "clearingBroker": "0294",
    "brokerName": "KW SECURITIES CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "KYAN",
    "clearingBroker": "0103",
    "brokerName": "KAYAN SECURITIES, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "KYCS",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "LAFB",
    "clearingBroker": "0235",
    "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "LAFC",
    "clearingBroker": "0443",
    "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "LAFF",
    "clearingBroker": "0443",
    "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "LAFI",
    "clearingBroker": "0750",
    "brokerName": "LAFISE SECURITIES CORPORATION                                         "
  },
  {
    "type": "OTC",
    "mpid": "LAGI",
    "clearingBroker": "0226",
    "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "LAMA",
    "clearingBroker": "0141",
    "brokerName": "XML SECURITIES                                                        "
  },
  {
    "type": "OTC",
    "mpid": "LAMP",
    "clearingBroker": "4305",
    "brokerName": "LAMPOST CAPITAL, L.C.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "LANE",
    "clearingBroker": "0235",
    "brokerName": "MARC J. LANE & COMPANY                                                "
  },
  {
    "type": "OTC",
    "mpid": "LASI",
    "clearingBroker": "0141",
    "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "LASS",
    "clearingBroker": "0226",
    "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "LATG",
    "clearingBroker": "0537",
    "brokerName": "GFI SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "LATM",
    "clearingBroker": "0537",
    "brokerName": "GFI SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "LATN",
    "clearingBroker": "0443",
    "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "LATS",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "LBKI",
    "clearingBroker": "0235",
    "brokerName": "LIBUCKI & CO., LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "LDGA",
    "clearingBroker": "0052",
    "brokerName": "DOUGALL & ASSOCIATES                                                  "
  },
  {
    "type": "OTC",
    "mpid": "LDIL",
    "clearingBroker": "0226",
    "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "LDLW",
    "clearingBroker": "0750",
    "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
  },
  {
    "type": "OTC",
    "mpid": "LDOT",
    "clearingBroker": "0235",
    "brokerName": "LANDOLT SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "LEAD",
    "clearingBroker": "0226",
    "brokerName": "THE LEADERS GROUP, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "LEBO",
    "clearingBroker": "0226",
    "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "LEDE",
    "clearingBroker": "5071",
    "brokerName": "LEEDE JONES GABLE INC./CDS                                            "
  },
  {
    "type": "OTC",
    "mpid": "LEER",
    "clearingBroker": "0443",
    "brokerName": "LEERINK SWANN & COMPANY                                               "
  },
  {
    "type": "OTC",
    "mpid": "LEHB",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "LEHM",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "LEHP",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "LEIM",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "LESW",
    "clearingBroker": "0443",
    "brokerName": "LEERINK SWANN & COMPANY                                               "
  },
  {
    "type": "OTC",
    "mpid": "LETS",
    "clearingBroker": "3450",
    "brokerName": "CHOICETRADE                                                           "
  },
  {
    "type": "OTC",
    "mpid": "LEXM",
    "clearingBroker": "0158",
    "brokerName": "LEX MARKETS LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "LEYA",
    "clearingBroker": "0235",
    "brokerName": "LEMLEY, YARLING & CO.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "LFAC",
    "clearingBroker": "0226",
    "brokerName": "OSAIC FA, INC.                                                        "
  },
  {
    "type": "OTC",
    "mpid": "LFRO",
    "clearingBroker": "0235",
    "brokerName": "LF ROTHSCHILD, LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "LGLL",
    "clearingBroker": "0534",
    "brokerName": "MM GLOBAL SECURITIES, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "LGNT",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "LGSA",
    "clearingBroker": "0158",
    "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
  },
  {
    "type": "OTC",
    "mpid": "LHMA",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "LHMB",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "LHSB",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "LIFG",
    "clearingBroker": "0279",
    "brokerName": "LONG ISLAND FINANCIAL GROUP, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "LIME",
    "clearingBroker": "8199",
    "brokerName": "SCORE PRIORITY CORP.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "LINC",
    "clearingBroker": "0158",
    "brokerName": "LIBERUM                                                               "
  },
  {
    "type": "OTC",
    "mpid": "LIVC",
    "clearingBroker": "0294",
    "brokerName": "LIME TRADING CORP                                                     "
  },
  {
    "type": "OTC",
    "mpid": "LIWM",
    "clearingBroker": "0695",
    "brokerName": "SCORE PRIORITY CORP.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "LIWO",
    "clearingBroker": "0695",
    "brokerName": "SCORE PRIORITY CORP.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "LMAR",
    "clearingBroker": "0226",
    "brokerName": "LIFEMARK SECURITIES CORP.                                             "
  },
  {
    "type": "OTC",
    "mpid": "LMGP",
    "clearingBroker": "8199",
    "brokerName": "SCORE PRIORITY CORP.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "LMKO",
    "clearingBroker": "0235",
    "brokerName": "KOHN (L.M.) & COMPANY                                                 "
  },
  {
    "type": "OTC",
    "mpid": "LMNX",
    "clearingBroker": "0226",
    "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "LMPC",
    "clearingBroker": "0695",
    "brokerName": "SCORE PRIORITY CORP.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "LMPT",
    "clearingBroker": "0695",
    "brokerName": "SCORE PRIORITY CORP.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "LNCL",
    "clearingBroker": "0443",
    "brokerName": "LINCOLN INVESTMENT                                                    "
  },
  {
    "type": "OTC",
    "mpid": "LOMB",
    "clearingBroker": "0141",
    "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
  },
  {
    "type": "OTC",
    "mpid": "LOOP",
    "clearingBroker": "0443",
    "brokerName": "LOOP CAPITAL MARKETS LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "LOTC",
    "clearingBroker": "0226",
    "brokerName": "L.O. THOMAS & CO. INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "LOUE",
    "clearingBroker": "0161",
    "brokerName": "ICAP CORPORATES LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "LOUI",
    "clearingBroker": "0005",
    "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
  },
  {
    "type": "OTC",
    "mpid": "LPCA",
    "clearingBroker": "3856",
    "brokerName": "ALPACA SECURITIES LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "LPCM",
    "clearingBroker": "0103",
    "brokerName": "LAMPERT CAPITAL MARKETS INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "LPFS",
    "clearingBroker": "0235",
    "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
  },
  {
    "type": "OTC",
    "mpid": "LPLE",
    "clearingBroker": "0075",
    "brokerName": "LPL ENTERPRISE, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "LPSP",
    "clearingBroker": "1043",
    "brokerName": "LPS CAPITAL LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "LQFI",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "LQNA",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "OTC",
    "mpid": "LQNB",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "OTC",
    "mpid": "LQNF",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "OTC",
    "mpid": "LQNT",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "OTC",
    "mpid": "LQPT",
    "clearingBroker": "0161",
    "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "LRBC",
    "clearingBroker": "0235",
    "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "LRCM",
    "clearingBroker": "0279",
    "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "LSAH",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
  },
  {
    "type": "OTC",
    "mpid": "LSCM",
    "clearingBroker": "0235",
    "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "LSCP",
    "clearingBroker": "8199",
    "brokerName": "LIFESCI CAPITAL, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "LSKO",
    "clearingBroker": "0226",
    "brokerName": "LESKO SECURITIES INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "LSPS",
    "clearingBroker": "8199",
    "brokerName": "LIGHTSPEED FINANCIAL SERVICES GROUP LLC                               "
  },
  {
    "type": "OTC",
    "mpid": "LSSI",
    "clearingBroker": "0750",
    "brokerName": "EJ STERLING INC.                                                      "
  },
  {
    "type": "OTC",
    "mpid": "LSUS",
    "clearingBroker": "0443",
    "brokerName": "LATIN SECURITIES INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "LTAA",
    "clearingBroker": "0226",
    "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "LTCO",
    "clearingBroker": "0226",
    "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "LTCS",
    "clearingBroker": "0141",
    "brokerName": "LINDEN THOMAS AND COMPANY SECURITIES, LLC                             "
  },
  {
    "type": "OTC",
    "mpid": "LVAR",
    "clearingBroker": "0443",
    "brokerName": "LARRAINVIAL SECURITIES US LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "LVMR",
    "clearingBroker": "0235",
    "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "MACC",
    "clearingBroker": "0226",
    "brokerName": "NEWEDGE SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "MACQ",
    "clearingBroker": "0114",
    "brokerName": "MACQUARIE CAPITAL (USA) INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "MADV",
    "clearingBroker": "0443",
    "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MATD",
    "clearingBroker": "3856",
    "brokerName": "MM GLOBAL SECURITIES, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "MATI",
    "clearingBroker": "9132",
    "brokerName": "MATRIX EXECUTIONS, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "MAVB",
    "clearingBroker": "0103",
    "brokerName": "GREAT POINT CAPITAL LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "MAXC",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "MAXM",
    "clearingBroker": "0443",
    "brokerName": "MAXIM GROUP LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "MAXN",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "MBSE",
    "clearingBroker": "0052",
    "brokerName": "MBS SOURCE ETRADING, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "MBTS",
    "clearingBroker": "0158",
    "brokerName": "MB TRADING                                                            "
  },
  {
    "type": "OTC",
    "mpid": "MBUS",
    "clearingBroker": "0052",
    "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "MCAP",
    "clearingBroker": "0161",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "OTC",
    "mpid": "MCBT",
    "clearingBroker": "0235",
    "brokerName": "MOORS & CABOT, INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "MCMF",
    "clearingBroker": "5076",
    "brokerName": "RAYMOND JAMES LTD./CDS                                                "
  },
  {
    "type": "OTC",
    "mpid": "MCMG",
    "clearingBroker": "0279",
    "brokerName": "MUNICIPAL CAPITAL MARKETS GROUP, INC.                                 "
  },
  {
    "type": "OTC",
    "mpid": "MDBC",
    "clearingBroker": "0534",
    "brokerName": "MDB CAPITAL GROUP LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MDGP",
    "clearingBroker": "0235",
    "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "MEAL",
    "clearingBroker": "0226",
    "brokerName": "M. E. ALLISON & CO., INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "MEMX",
    "clearingBroker": "0161",
    "brokerName": "MEMX EXECUTION SERVICES LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "MERP",
    "clearingBroker": "0235",
    "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "MESF",
    "clearingBroker": "0443",
    "brokerName": "MESIROW FINANCIAL, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "MEXD",
    "clearingBroker": "0551",
    "brokerName": "DYNAMEX TRADING, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "MFGX",
    "clearingBroker": "0443",
    "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "MGIS",
    "clearingBroker": "5008",
    "brokerName": "INDUSTRIAL ALLIANCE SECURITIES INC.                                   "
  },
  {
    "type": "OTC",
    "mpid": "MGPC",
    "clearingBroker": "0534",
    "brokerName": "MADISON GLOBAL PARTNERS LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "MGTX",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "MHFI",
    "clearingBroker": "0226",
    "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "MIAM",
    "clearingBroker": "0141",
    "brokerName": "FMSBONDS, INC.                                                        "
  },
  {
    "type": "OTC",
    "mpid": "MIDL",
    "clearingBroker": "0226",
    "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
  },
  {
    "type": "OTC",
    "mpid": "MILE",
    "clearingBroker": "0052",
    "brokerName": "I-BANKERS SECURITIES INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "MINP",
    "clearingBroker": "0235",
    "brokerName": "MINISTRY PARTNERS SECURITIES, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "MINT",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "MINV",
    "clearingBroker": "0235",
    "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "MIRA",
    "clearingBroker": "1043",
    "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "MISL",
    "clearingBroker": "0161",
    "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "MITR",
    "clearingBroker": "0443",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MJWH",
    "clearingBroker": "0235",
    "brokerName": "ETICO PARTNERS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "MKRT",
    "clearingBroker": "0235",
    "brokerName": "MARKET SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "MKTI",
    "clearingBroker": "0226",
    "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "MKTX",
    "clearingBroker": "4265",
    "brokerName": "MARKETAXESS CORPORATION                                               "
  },
  {
    "type": "OTC",
    "mpid": "MKTY",
    "clearingBroker": "4265",
    "brokerName": "MARKETAXESS CORPORATION                                               "
  },
  {
    "type": "OTC",
    "mpid": "MLBC",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLCA",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLCB",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLCC",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLCD",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLCG",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLCO",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLCP",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLCQ",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLCS",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLCX",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLEL",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLEX",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLIX",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLMA",
    "clearingBroker": "0671",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLPK",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLPL",
    "clearingBroker": "0075",
    "brokerName": "MUTUAL SERVICE CORPORATION                                            "
  },
  {
    "type": "OTC",
    "mpid": "MLRM",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLRO",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLSE",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLSK",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLSL",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLTA",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTB",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTC",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTE",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLTF",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTG",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTH",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTI",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLTJ",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTK",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLTL",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTO",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTP",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTQ",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTR",
    "clearingBroker": "0158",
    "brokerName": "MONEYLION SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "MLTT",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTU",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTW",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTX",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLTY",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLUA",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLUB",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLUC",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLUD",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLVX",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLWM",
    "clearingBroker": "0671",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "MLZB",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZC",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZD",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZE",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZF",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZI",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZJ",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZL",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZM",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZN",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZO",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZP",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZQ",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZR",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZS",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZT",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZU",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZV",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MLZW",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MMNT",
    "clearingBroker": "0158",
    "brokerName": "MOMENT MARKETS, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "MNCO",
    "clearingBroker": "0279",
    "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "MNDC",
    "clearingBroker": "4305",
    "brokerName": "MONDEUM CAPITAL, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "MNDX",
    "clearingBroker": "9132",
    "brokerName": "TJM INVESTMENTS, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "MOCM",
    "clearingBroker": "0235",
    "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "MOFI",
    "clearingBroker": "0158",
    "brokerName": "M1 FINANCE LLC                                                        "
  },
  {
    "type": "OTC",
    "mpid": "MOFO",
    "clearingBroker": "1497",
    "brokerName": "M1 FINANCE LLC                                                        "
  },
  {
    "type": "OTC",
    "mpid": "MOLO",
    "clearingBroker": "0235",
    "brokerName": "MOLONEY SECURITIES                                                    "
  },
  {
    "type": "OTC",
    "mpid": "MONR",
    "clearingBroker": "0226",
    "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "MOON",
    "clearingBroker": "0158",
    "brokerName": "OTC LINK LLC                                                          "
  },
  {
    "type": "OTC",
    "mpid": "MORE",
    "clearingBroker": "0361",
    "brokerName": "MITCHELL SECURITIES CORPORATION OF OREGON                             "
  },
  {
    "type": "OTC",
    "mpid": "MPLA",
    "clearingBroker": "0158",
    "brokerName": "EMPALA SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "MPLW",
    "clearingBroker": "0226",
    "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
  },
  {
    "type": "OTC",
    "mpid": "MPSG",
    "clearingBroker": "0161",
    "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "MRAD",
    "clearingBroker": "0052",
    "brokerName": "MACRO RISK ADVISORS LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "MRBA",
    "clearingBroker": "0052",
    "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "MRCY",
    "clearingBroker": "0520",
    "brokerName": "NASDAQ EXECUTION SERVICES, LLC/OPTIONS                                "
  },
  {
    "type": "OTC",
    "mpid": "MREC",
    "clearingBroker": "5029",
    "brokerName": "MACKIE RESERCH CAPITAL CORPORATION/CDS                                "
  },
  {
    "type": "OTC",
    "mpid": "MRNA",
    "clearingBroker": "0161",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "MRSC",
    "clearingBroker": "0287",
    "brokerName": "TRADEUP SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSBT",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "MSCB",
    "clearingBroker": "0279",
    "brokerName": "MAINE SECURITIES CORPORATION                                          "
  },
  {
    "type": "OTC",
    "mpid": "MSCO",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSEC",
    "clearingBroker": "0235",
    "brokerName": "MSEC, LLC                                                             "
  },
  {
    "type": "OTC",
    "mpid": "MSED",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSEM",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSET",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSFP",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSLC",
    "clearingBroker": "0534",
    "brokerName": "MCDONNAUGH SECURITIES LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "MSML",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSMP",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSNY",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSPL",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSPW",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "MSRO",
    "clearingBroker": "0226",
    "brokerName": "MESIROW FINANCIAL, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "MSRP",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSTC",
    "clearingBroker": "0226",
    "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
  },
  {
    "type": "OTC",
    "mpid": "MSTI",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSTW",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MSTX",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "MTDB",
    "clearingBroker": "0443",
    "brokerName": "M&T SECURITIES, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "MTGO",
    "clearingBroker": "0158",
    "brokerName": "MTG, LLC                                                              "
  },
  {
    "type": "OTC",
    "mpid": "MTHN",
    "clearingBroker": "0005",
    "brokerName": "MARATHON TRADING GROUP LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "MTLE",
    "clearingBroker": "0235",
    "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "MTSL",
    "clearingBroker": "0226",
    "brokerName": "MSEC, LLC                                                             "
  },
  {
    "type": "OTC",
    "mpid": "MUFG",
    "clearingBroker": "0076",
    "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "MULA",
    "clearingBroker": "0534",
    "brokerName": "MUNDIAL FINANCIAL GROUP, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "MULL",
    "clearingBroker": "8199",
    "brokerName": "MARK J. MULLER EQUITIES, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "MURJ",
    "clearingBroker": "0750",
    "brokerName": "COMMERCE ONE FINANCIAL INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "MVMP",
    "clearingBroker": "0534",
    "brokerName": "MICROVENTURE MARKETPLACE INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "MWCC",
    "clearingBroker": "0235",
    "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "MWIL",
    "clearingBroker": "0235",
    "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "MYSS",
    "clearingBroker": "0158",
    "brokerName": "M.Y. SAFRA SECURITIES, INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "MZHO",
    "clearingBroker": "0892",
    "brokerName": "MIZUHO SECURITIES USA LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "NACM",
    "clearingBroker": "0161",
    "brokerName": "NABSECURITIES, LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "NADL",
    "clearingBroker": "0235",
    "brokerName": "WARREN D. NADEL & COMPANY                                             "
  },
  {
    "type": "OTC",
    "mpid": "NAPK",
    "clearingBroker": "0052",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "OTC",
    "mpid": "NASC",
    "clearingBroker": "0235",
    "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "NASJ",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET MARKETS, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "NATI",
    "clearingBroker": "4305",
    "brokerName": "NATISA SECURITIES LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "NAVC",
    "clearingBroker": "0235",
    "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "NBAR",
    "clearingBroker": "0226",
    "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "NBCS",
    "clearingBroker": "0235",
    "brokerName": "NBC SECURITIES, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "NBFI",
    "clearingBroker": "5008",
    "brokerName": "NBF SECURITIES (USA) CORP.                                            "
  },
  {
    "type": "OTC",
    "mpid": "NBKT",
    "clearingBroker": "8353",
    "brokerName": "NATIONAL BANK OF CANADA FINANCIAL INC.                                "
  },
  {
    "type": "OTC",
    "mpid": "NBLB",
    "clearingBroker": "0226",
    "brokerName": "NEUBERGER BERMAN BD LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "NBSL",
    "clearingBroker": "0226",
    "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
  },
  {
    "type": "OTC",
    "mpid": "NEED",
    "clearingBroker": "0443",
    "brokerName": "NEEDHAM & COMPANY, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "NEFO",
    "clearingBroker": "0608",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "NENB",
    "clearingBroker": "0608",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "NEST",
    "clearingBroker": "0235",
    "brokerName": "NEST INVESTMENTS BD LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "NEUS",
    "clearingBroker": "0750",
    "brokerName": "NINTH ETERNITY SECURITIES LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "NFBS",
    "clearingBroker": "2402",
    "brokerName": "NAVY FEDERAL INVESTMENT SERVICES, LLC                                 "
  },
  {
    "type": "OTC",
    "mpid": "NFGR",
    "clearingBroker": "0141",
    "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "NFSC",
    "clearingBroker": "0226",
    "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "NFTY",
    "clearingBroker": "0235",
    "brokerName": "INFINITY FINANCIAL SERVICES                                           "
  },
  {
    "type": "OTC",
    "mpid": "NHFS",
    "clearingBroker": "0158",
    "brokerName": "ALIGHT FINANCIAL SOLUTIONS, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "NHWI",
    "clearingBroker": "0141",
    "brokerName": "HENNION & WALSH, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "NIAD",
    "clearingBroker": "0052",
    "brokerName": "NI ADVISORS                                                           "
  },
  {
    "type": "OTC",
    "mpid": "NICK",
    "clearingBroker": "0161",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "NITC",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "NITD",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "NITE",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "NITP",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "NITX",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "NLOV",
    "clearingBroker": "0534",
    "brokerName": "NORTLOV SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "NMRA",
    "clearingBroker": "0180",
    "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC./FIXED INCOME                    "
  },
  {
    "type": "OTC",
    "mpid": "NMRB",
    "clearingBroker": "0180",
    "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC                                  "
  },
  {
    "type": "OTC",
    "mpid": "NOBL",
    "clearingBroker": "0750",
    "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
  },
  {
    "type": "OTC",
    "mpid": "NORC",
    "clearingBroker": "0235",
    "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
  },
  {
    "type": "OTC",
    "mpid": "NORT",
    "clearingBroker": "0443",
    "brokerName": "NORTHLAND SECURITIES, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "NORW",
    "clearingBroker": "0250",
    "brokerName": "WELLS FARGO BROKERAGE SERVICES, LLC                                   "
  },
  {
    "type": "OTC",
    "mpid": "NOSO",
    "clearingBroker": "0443",
    "brokerName": "NORTH SOUTH CAPITAL LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "NPNT",
    "clearingBroker": "0005",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "NPTP",
    "clearingBroker": "0443",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "NQBX",
    "clearingBroker": "0163",
    "brokerName": "NASDAQ BX, INC.                                                       "
  },
  {
    "type": "OTC",
    "mpid": "NQOP",
    "clearingBroker": "0520",
    "brokerName": "NASDAQ EXECUTION SERVICES, LLC/OPTIONS                                "
  },
  {
    "type": "OTC",
    "mpid": "NQPX",
    "clearingBroker": "0237",
    "brokerName": "NASDAQ PHLX LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "NQRB",
    "clearingBroker": "0568",
    "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "NSDQ",
    "clearingBroker": "0759",
    "brokerName": "NASDAQ STOCK MARKET LLC/OMNIBUS ACCOUNT                               "
  },
  {
    "type": "OTC",
    "mpid": "NSFP",
    "clearingBroker": "0235",
    "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "NSIF",
    "clearingBroker": "5061",
    "brokerName": "TD WATERHOUSE - NORSTAR SECURITIES/CDS                                "
  },
  {
    "type": "OTC",
    "mpid": "NSRD",
    "clearingBroker": "0235",
    "brokerName": "NESTLERODE & CO., INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "NTBF",
    "clearingBroker": "5043",
    "brokerName": "BMO NESBITT BURNS INC./CDS                                            "
  },
  {
    "type": "OTC",
    "mpid": "NTFN",
    "clearingBroker": "0052",
    "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
  },
  {
    "type": "OTC",
    "mpid": "NTRC",
    "clearingBroker": "0226",
    "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "NVEN",
    "clearingBroker": "0448",
    "brokerName": "NUVEEN SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "NVGT",
    "clearingBroker": "0388",
    "brokerName": "NAVIGATE ADVISORS LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "NVSR",
    "clearingBroker": "0158",
    "brokerName": "NVSTR FINANCIAL LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "NWCM",
    "clearingBroker": "0235",
    "brokerName": "NW CAPITAL MARKETS INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "NWIA",
    "clearingBroker": "0750",
    "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
  },
  {
    "type": "OTC",
    "mpid": "NYFX",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "NYLS",
    "clearingBroker": "0226",
    "brokerName": "NYLIFE SECURITIES INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "OAIF",
    "clearingBroker": "0158",
    "brokerName": "OPTIONS AI FINANCIAL, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "OAKR",
    "clearingBroker": "0235",
    "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
  },
  {
    "type": "OTC",
    "mpid": "OBEX",
    "clearingBroker": "0534",
    "brokerName": "OBEX SECURITIES LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "OBWS",
    "clearingBroker": "0226",
    "brokerName": "OBERWEIS SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "OCAC",
    "clearingBroker": "0235",
    "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "OCEA",
    "clearingBroker": "0052",
    "brokerName": "OCEAN FINANCIAL SERVICES, LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "OCEE",
    "clearingBroker": "4305",
    "brokerName": "OCEANUS SECURITIES, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "OCEN",
    "clearingBroker": "0568",
    "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "OCTG",
    "clearingBroker": "0295",
    "brokerName": "OCTEG, LLC                                                            "
  },
  {
    "type": "OTC",
    "mpid": "ODNC",
    "clearingBroker": "0235",
    "brokerName": "ODEON CAPITAL GROUP LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "OFGF",
    "clearingBroker": "0235",
    "brokerName": "OFG FINANCIAL SERVICES INC                                            "
  },
  {
    "type": "OTC",
    "mpid": "OFMC",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "OGRU",
    "clearingBroker": "0161",
    "brokerName": "OSCAR GRUSS & SON, INCORPORATED                                       "
  },
  {
    "type": "OTC",
    "mpid": "OGTL",
    "clearingBroker": "0005",
    "brokerName": "OUTSET GLOBAL TRADING LIMITED                                         "
  },
  {
    "type": "OTC",
    "mpid": "OHIO",
    "clearingBroker": "0443",
    "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "OHOS",
    "clearingBroker": "0551",
    "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "OLDM",
    "clearingBroker": "0005",
    "brokerName": "OLD MISSION CAPITAL, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "OLMN",
    "clearingBroker": "0005",
    "brokerName": "OLD MISSION MARKETS LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "OLNE",
    "clearingBroker": "0279",
    "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "OMMA",
    "clearingBroker": "0005",
    "brokerName": "OLD MISSION MARKETS LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "ONEC",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "ONEL",
    "clearingBroker": "0161",
    "brokerName": "O'NEIL (WILLIAM) & CO                                                 "
  },
  {
    "type": "OTC",
    "mpid": "OPAL",
    "clearingBroker": "8199",
    "brokerName": "OPAL SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "OPCO",
    "clearingBroker": "0571",
    "brokerName": "OPPENHEIMER & CO. INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "OPDL",
    "clearingBroker": "0158",
    "brokerName": "OPENDEAL BROKER LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "OPTE",
    "clearingBroker": "0695",
    "brokerName": "OPTIVER US LLC                                                        "
  },
  {
    "type": "OTC",
    "mpid": "OPTF",
    "clearingBroker": "0005",
    "brokerName": "OPTIVER US LLC                                                        "
  },
  {
    "type": "OTC",
    "mpid": "OPTG",
    "clearingBroker": "0005",
    "brokerName": "OPTIVER US, LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "OPTU",
    "clearingBroker": "0695",
    "brokerName": "OPTIVER US, LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "OPTY",
    "clearingBroker": "0158",
    "brokerName": "OPTIONALITY SECURITIES                                                "
  },
  {
    "type": "OTC",
    "mpid": "OSFI",
    "clearingBroker": "0534",
    "brokerName": "ONESOURCE FI LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "OSIC",
    "clearingBroker": "0226",
    "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "OTAA",
    "clearingBroker": "0551",
    "brokerName": "OTA LIMITED PARTNERSHIP                                               "
  },
  {
    "type": "OTC",
    "mpid": "OTCN",
    "clearingBroker": "0158",
    "brokerName": "OTC LINK LLC                                                          "
  },
  {
    "type": "OTC",
    "mpid": "OTCO",
    "clearingBroker": "0158",
    "brokerName": "OTC LINK LLC                                                          "
  },
  {
    "type": "OTC",
    "mpid": "OTCX",
    "clearingBroker": "0158",
    "brokerName": "OTC LINK LLC                                                          "
  },
  {
    "type": "OTC",
    "mpid": "OTSB",
    "clearingBroker": "0103",
    "brokerName": "OAK TREE SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "OYLD",
    "clearingBroker": "0235",
    "brokerName": "OPENYIELD TRADING LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "PACT",
    "clearingBroker": "0443",
    "brokerName": "BTG PACTUAL US CAPITAL LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "PAPP",
    "clearingBroker": "0534",
    "brokerName": "EUROPEAN FAMILY OFFICE INSTITUTE LLC.                                 "
  },
  {
    "type": "OTC",
    "mpid": "PARK",
    "clearingBroker": "0750",
    "brokerName": "PARK WALK CAPITAL MARKETS, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "PARX",
    "clearingBroker": "0695",
    "brokerName": "PARX TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "PASF",
    "clearingBroker": "2402",
    "brokerName": "PASSFOLIO SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "PASL",
    "clearingBroker": "0443",
    "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "PATR",
    "clearingBroker": "0624",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "PAUL",
    "clearingBroker": "0595",
    "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "PAVE",
    "clearingBroker": "0534",
    "brokerName": "PAVE SECURITIES, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "PBON",
    "clearingBroker": "0161",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "PCAP",
    "clearingBroker": "0608",
    "brokerName": "SG AMERICAS SECURITIES, LLC/SUB 608                                   "
  },
  {
    "type": "OTC",
    "mpid": "PCCA",
    "clearingBroker": "0279",
    "brokerName": "PEACHCAP SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "PCFF",
    "clearingBroker": "5075",
    "brokerName": "PI FINANCIAL CORP./CDS                                                "
  },
  {
    "type": "OTC",
    "mpid": "PCIS",
    "clearingBroker": "0226",
    "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "PCPT",
    "clearingBroker": "8460",
    "brokerName": "PHILLIP CAPITAL INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "PCSG",
    "clearingBroker": "0158",
    "brokerName": "PACIFIC CENTURY SECURITIES, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "PCSS",
    "clearingBroker": "0294",
    "brokerName": "PACIFIC CENTURY SECURITIES, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "PECA",
    "clearingBroker": "0388",
    "brokerName": "PERAZA CAPITAL AND INVESTMENT, LLC                                    "
  },
  {
    "type": "OTC",
    "mpid": "PERC",
    "clearingBroker": "0279",
    "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
  },
  {
    "type": "OTC",
    "mpid": "PERO",
    "clearingBroker": "9132",
    "brokerName": "CLEAR STREET LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "PERS",
    "clearingBroker": "0443",
    "brokerName": "PERSHING LLC                                                          "
  },
  {
    "type": "OTC",
    "mpid": "PERX",
    "clearingBroker": "0443",
    "brokerName": "PERSHING LLC                                                          "
  },
  {
    "type": "OTC",
    "mpid": "PFCG",
    "clearingBroker": "0279",
    "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "PFCL",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "PFCM",
    "clearingBroker": "0158",
    "brokerName": "PENSON FINANCIAL SERVICES, INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "PFDC",
    "clearingBroker": "0235",
    "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "PFPI",
    "clearingBroker": "0161",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "PFRA",
    "clearingBroker": "0443",
    "brokerName": "PERSHING LLC                                                          "
  },
  {
    "type": "OTC",
    "mpid": "PHBP",
    "clearingBroker": "0052",
    "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "PHLY",
    "clearingBroker": "0520",
    "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "PHRS",
    "clearingBroker": "0279",
    "brokerName": "NAVAID FINANCIAL SERVICES, INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "PICF",
    "clearingBroker": "5027",
    "brokerName": "PICTET CANADA L.P./CDS                                                "
  },
  {
    "type": "OTC",
    "mpid": "PICI",
    "clearingBroker": "0279",
    "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "PICL",
    "clearingBroker": "0052",
    "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "PICT",
    "clearingBroker": "5027",
    "brokerName": "PICTET OVERSEAS, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "PIER",
    "clearingBroker": "3018",
    "brokerName": "GREEN PIER FINTECH LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "PINA",
    "clearingBroker": "0141",
    "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "PIPR",
    "clearingBroker": "0443",
    "brokerName": "PIPER SANDLER & CO.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "PISC",
    "clearingBroker": "0750",
    "brokerName": "PACIFIC INVESTMENT SECURITIES CORP.                                   "
  },
  {
    "type": "OTC",
    "mpid": "PIUS",
    "clearingBroker": "5075",
    "brokerName": "PI FINANCIAL (US) CORP.                                               "
  },
  {
    "type": "OTC",
    "mpid": "PJCX",
    "clearingBroker": "0443",
    "brokerName": "PIPER SANDLER & CO.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "PJEF",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "PKAX",
    "clearingBroker": "0158",
    "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "PKCM",
    "clearingBroker": "0005",
    "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "PKSD",
    "clearingBroker": "8460",
    "brokerName": "PARKSIDE SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "PLAT",
    "clearingBroker": "0443",
    "brokerName": "CLARKSONS PLATOU SECURITIES, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "PLHT",
    "clearingBroker": "0750",
    "brokerName": "PEEL HUNT INC.                                                        "
  },
  {
    "type": "OTC",
    "mpid": "PLTF",
    "clearingBroker": "0534",
    "brokerName": "PLACE TRADE FINANCIAL, INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "PNCC",
    "clearingBroker": "0226",
    "brokerName": "PNC INVESTMENTS                                                       "
  },
  {
    "type": "OTC",
    "mpid": "PNCS",
    "clearingBroker": "3856",
    "brokerName": "PRIME NUMBER CAPITAL, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "PNFP",
    "clearingBroker": "0279",
    "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "PNSA",
    "clearingBroker": "0235",
    "brokerName": "PENSERRA SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "PNSR",
    "clearingBroker": "0161",
    "brokerName": "PENSERRA SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "PODE",
    "clearingBroker": "0235",
    "brokerName": "PODESTA & CO.                                                         "
  },
  {
    "type": "OTC",
    "mpid": "POPS",
    "clearingBroker": "0226",
    "brokerName": "POPULAR SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "PPNY",
    "clearingBroker": "3450",
    "brokerName": "PRIME NUMBER CAPITAL LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "PPPP",
    "clearingBroker": "0122",
    "brokerName": "PPPP CLEARING 0122 TEST                                               "
  },
  {
    "type": "OTC",
    "mpid": "PPSI",
    "clearingBroker": "0235",
    "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "PPSL",
    "clearingBroker": "0443",
    "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "PRAG",
    "clearingBroker": "0067",
    "brokerName": "PRAGMA LLC                                                            "
  },
  {
    "type": "OTC",
    "mpid": "PRDG",
    "clearingBroker": "0551",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "PREB",
    "clearingBroker": "0005",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "PRFA",
    "clearingBroker": "0235",
    "brokerName": "PROOF SERVICES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "PRFT",
    "clearingBroker": "0158",
    "brokerName": "PROOF SERVICES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "PRJX",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "PRST",
    "clearingBroker": "0551",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "PRXX",
    "clearingBroker": "2793",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "PSFL",
    "clearingBroker": "0534",
    "brokerName": "PUENTE SERVICIOS FINANCIEROS LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "PSII",
    "clearingBroker": "0226",
    "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "PSIM",
    "clearingBroker": "0226",
    "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "PSRI",
    "clearingBroker": "0103",
    "brokerName": "GLOBALINK SECURITIES, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "PSUT",
    "clearingBroker": "0235",
    "brokerName": "INNOVATION PARTNERS LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "PTFI",
    "clearingBroker": "0221",
    "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "PTIS",
    "clearingBroker": "0235",
    "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
  },
  {
    "type": "OTC",
    "mpid": "PTIX",
    "clearingBroker": "0534",
    "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
  },
  {
    "type": "OTC",
    "mpid": "PTLV",
    "clearingBroker": "8353",
    "brokerName": "NATIONAL BANK OF CANADA FINANCIAL INC.                                "
  },
  {
    "type": "OTC",
    "mpid": "PTSB",
    "clearingBroker": "0534",
    "brokerName": "PTS BROKERAGE, LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "PUBV",
    "clearingBroker": "3341",
    "brokerName": "MDB CAPITAL                                                           "
  },
  {
    "type": "OTC",
    "mpid": "PULX",
    "clearingBroker": "0067",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "PUMA",
    "clearingBroker": "8199",
    "brokerName": "PUMA CAPITAL, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "PUMX",
    "clearingBroker": "8199",
    "brokerName": "PUMA CAPITAL, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "PUND",
    "clearingBroker": "0551",
    "brokerName": "PUNDION LLC                                                           "
  },
  {
    "type": "OTC",
    "mpid": "PUPL",
    "clearingBroker": "0226",
    "brokerName": "PUPLAVA SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "PURE",
    "clearingBroker": "0067",
    "brokerName": "PURESTREAM, LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "PURP",
    "clearingBroker": "0279",
    "brokerName": "LIBERTY CAPITAL INVESTMENT CORPORATION                                "
  },
  {
    "type": "OTC",
    "mpid": "PWCP",
    "clearingBroker": "0534",
    "brokerName": "PICKWICK CAPITAL PARTNERS, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "PWJC",
    "clearingBroker": "0221",
    "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "PWJX",
    "clearingBroker": "0221",
    "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "PXCJ",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "OTC",
    "mpid": "PXGA",
    "clearingBroker": "0551",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "PXGG",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING                                                          "
  },
  {
    "type": "OTC",
    "mpid": "PXGJ",
    "clearingBroker": "0352",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "QAMM",
    "clearingBroker": "0294",
    "brokerName": "QUANTEX CLEARING, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "QBND",
    "clearingBroker": "0161",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "OTC",
    "mpid": "QBSI",
    "clearingBroker": "0226",
    "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "QCAP",
    "clearingBroker": "0235",
    "brokerName": "QUINT CAPITAL CORPORATION                                             "
  },
  {
    "type": "OTC",
    "mpid": "QCAS",
    "clearingBroker": "0226",
    "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
  },
  {
    "type": "OTC",
    "mpid": "QGSB",
    "clearingBroker": "0158",
    "brokerName": "QUAESTOR GLOBAL SECURITIES, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "QLBR",
    "clearingBroker": "0695",
    "brokerName": "QUANTLAB BROKERAGE, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "QMSR",
    "clearingBroker": "0235",
    "brokerName": "QUATTRO M SECURITIES INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "QMSX",
    "clearingBroker": "0294",
    "brokerName": "QUATTRO M SECURITIES INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "QNTX",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "QRQR",
    "clearingBroker": "0534",
    "brokerName": "QUANTRIVER FINANCIAL, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "QUES",
    "clearingBroker": "5084",
    "brokerName": "QUESTRADE INC./CDS                                                    "
  },
  {
    "type": "OTC",
    "mpid": "QUOI",
    "clearingBroker": "0279",
    "brokerName": "QUOIN CAPITAL LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "QWIK",
    "clearingBroker": "0161",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "OTC",
    "mpid": "RAAA",
    "clearingBroker": "0052",
    "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "RAAI",
    "clearingBroker": "0226",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "RABO",
    "clearingBroker": "0443",
    "brokerName": "RABO SECURITIES USA, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "RACO",
    "clearingBroker": "0158",
    "brokerName": "SHEARMAN, RALSTON, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "RAJA",
    "clearingBroker": "0725",
    "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "RAYG",
    "clearingBroker": "0443",
    "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
  },
  {
    "type": "OTC",
    "mpid": "RBAC",
    "clearingBroker": "0235",
    "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "RBCD",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
  },
  {
    "type": "OTC",
    "mpid": "RBCF",
    "clearingBroker": "5002",
    "brokerName": "RBC DOMINION SECURITIES INC./CDS                                      "
  },
  {
    "type": "OTC",
    "mpid": "RBCM",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
  },
  {
    "type": "OTC",
    "mpid": "RBCX",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
  },
  {
    "type": "OTC",
    "mpid": "RBDG",
    "clearingBroker": "0158",
    "brokerName": "REDBRIDGE SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "RCKF",
    "clearingBroker": "0534",
    "brokerName": "ROCKFLEET FINANCIAL SERVICES, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "RCMA",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS ARBITRAGE, S.A.                                   "
  },
  {
    "type": "OTC",
    "mpid": "RCMI",
    "clearingBroker": "0608",
    "brokerName": "DEALERWEB INC.                                                        "
  },
  {
    "type": "OTC",
    "mpid": "RDBN",
    "clearingBroker": "0443",
    "brokerName": "REDBURN PARTNERS (USA) LP                                             "
  },
  {
    "type": "OTC",
    "mpid": "RECA",
    "clearingBroker": "5029",
    "brokerName": "RESEARCH CAPITAL USA INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "REGN",
    "clearingBroker": "0443",
    "brokerName": "REGIONS SECURITIES LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "REGR",
    "clearingBroker": "0141",
    "brokerName": "REGISTER & AKERS INVESTMENTS, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "REPP",
    "clearingBroker": "0226",
    "brokerName": "G. A. REPPLE & COMPANY                                                "
  },
  {
    "type": "OTC",
    "mpid": "REVE",
    "clearingBroker": "3450",
    "brokerName": "REVERE SECURITIES CORP.                                               "
  },
  {
    "type": "OTC",
    "mpid": "REVO",
    "clearingBroker": "2402",
    "brokerName": "REVOLUT SECURITIES INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "RFRC",
    "clearingBroker": "0279",
    "brokerName": "THE ROCKWELL FINANCIAL GROUP, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "RGLD",
    "clearingBroker": "0279",
    "brokerName": "REGAL SECURITIES, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "RGLS",
    "clearingBroker": "0235",
    "brokerName": "REGAL SECURITIES, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "RHCO",
    "clearingBroker": "0226",
    "brokerName": "TRUIST SECURITIES, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "RHDS",
    "clearingBroker": "0141",
    "brokerName": "RHODES SECURITIES, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "RHOX",
    "clearingBroker": "0005",
    "brokerName": "XR SECURITIES LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "RIAN",
    "clearingBroker": "0226",
    "brokerName": "OSAIC SERVICES, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "RICD",
    "clearingBroker": "4305",
    "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
  },
  {
    "type": "OTC",
    "mpid": "RICJ",
    "clearingBroker": "0235",
    "brokerName": "RICE SECURITIES, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "RICM",
    "clearingBroker": "0595",
    "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
  },
  {
    "type": "OTC",
    "mpid": "RIED",
    "clearingBroker": "0235",
    "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
  },
  {
    "type": "OTC",
    "mpid": "RILY",
    "clearingBroker": "0226",
    "brokerName": "B. RILEY FBR, INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "RJFI",
    "clearingBroker": "0390",
    "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "RKWS",
    "clearingBroker": "0235",
    "brokerName": "ROCKWELL SECURITIES LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "RLIN",
    "clearingBroker": "0005",
    "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "RMAC",
    "clearingBroker": "0235",
    "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "RMPI",
    "clearingBroker": "0141",
    "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "RNYB",
    "clearingBroker": "3350",
    "brokerName": "ROYAL BANK OF CANADA, WFC BRANCH                                      "
  },
  {
    "type": "OTC",
    "mpid": "ROBT",
    "clearingBroker": "0443",
    "brokerName": "ROBOTTI & COMPANY, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "ROCK",
    "clearingBroker": "0226",
    "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "ROCM",
    "clearingBroker": "0443",
    "brokerName": "RIM SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "RODM",
    "clearingBroker": "1043",
    "brokerName": "RODMAN & RENSHAW, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "ROMO",
    "clearingBroker": "0141",
    "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
  },
  {
    "type": "OTC",
    "mpid": "RONI",
    "clearingBroker": "0005",
    "brokerName": "RONIN CAPITAL, LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "ROSN",
    "clearingBroker": "0443",
    "brokerName": "ROSENBLATT SECURITIES INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "ROTB",
    "clearingBroker": "0235",
    "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "ROTH",
    "clearingBroker": "0161",
    "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "RPTR",
    "clearingBroker": "0235",
    "brokerName": "DINOSAUR SECURITIES, L.L.C.                                           "
  },
  {
    "type": "OTC",
    "mpid": "RQDR",
    "clearingBroker": "0235",
    "brokerName": "RQD* CLEARING LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "RREZ",
    "clearingBroker": "0443",
    "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "RRUD",
    "clearingBroker": "0235",
    "brokerName": "REID & RUDIGER, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "RSCM",
    "clearingBroker": "0235",
    "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
  },
  {
    "type": "OTC",
    "mpid": "RSKY",
    "clearingBroker": "0695",
    "brokerName": "ITG DERIVATIVES, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "RSSE",
    "clearingBroker": "0443",
    "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
  },
  {
    "type": "OTC",
    "mpid": "RTHS",
    "clearingBroker": "0443",
    "brokerName": "ROTHSCHILD INVESTMENT CORPORATION                                     "
  },
  {
    "type": "OTC",
    "mpid": "RWPS",
    "clearingBroker": "0443",
    "brokerName": "R.W. PRESSPRICH & CO.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "RWSM",
    "clearingBroker": "0279",
    "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "RYDS",
    "clearingBroker": "0235",
    "brokerName": "RBC DOMINION SECURITIES CORPORATION                                   "
  },
  {
    "type": "OTC",
    "mpid": "SAFS",
    "clearingBroker": "0750",
    "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
  },
  {
    "type": "OTC",
    "mpid": "SAFX",
    "clearingBroker": "0235",
    "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "SAGE",
    "clearingBroker": "0141",
    "brokerName": "SAGE, RUTTY & CO., INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "SAGL",
    "clearingBroker": "9132",
    "brokerName": "SAGETRADER LLC                                                        "
  },
  {
    "type": "OTC",
    "mpid": "SAGP",
    "clearingBroker": "8199",
    "brokerName": "SAGETRADER, LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "SAGR",
    "clearingBroker": "4305",
    "brokerName": "SAGETRADER, LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "SAGT",
    "clearingBroker": "3856",
    "brokerName": "SAGETRADER, LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "SAKL",
    "clearingBroker": "0279",
    "brokerName": "DMK ADVISORS GROUP, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "SALI",
    "clearingBroker": "0750",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "SALL",
    "clearingBroker": "0534",
    "brokerName": "SUPREME ALLIANCE LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "SAMI",
    "clearingBroker": "0226",
    "brokerName": "SAMI BROKERAGE LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "SANC",
    "clearingBroker": "3499",
    "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "SANT",
    "clearingBroker": "0443",
    "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "SARG",
    "clearingBroker": "0226",
    "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
  },
  {
    "type": "OTC",
    "mpid": "SBER",
    "clearingBroker": "0013",
    "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "SBLS",
    "clearingBroker": "0235",
    "brokerName": "SAN BLAS SECURITIES LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "SBLT",
    "clearingBroker": "0226",
    "brokerName": "SUNBELT SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "SBRO",
    "clearingBroker": "0443",
    "brokerName": "STERN BROTHERS & CO.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "SBRT",
    "clearingBroker": "0226",
    "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "SBRX",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "SBSC",
    "clearingBroker": "0226",
    "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
  },
  {
    "type": "OTC",
    "mpid": "SBSH",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "SBSI",
    "clearingBroker": "0103",
    "brokerName": "SUN'S BROTHERS SECURITIES INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "SBSL",
    "clearingBroker": "1043",
    "brokerName": "STOCKBLOCK SECURITIES LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "SCAP",
    "clearingBroker": "0595",
    "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "SCBO",
    "clearingBroker": "0013",
    "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "SCBT",
    "clearingBroker": "0013",
    "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "SCIL",
    "clearingBroker": "0052",
    "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
  },
  {
    "type": "OTC",
    "mpid": "SCMC",
    "clearingBroker": "0096",
    "brokerName": "SCOTIA CAPITAL MARKETS (USA) INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "SCMF",
    "clearingBroker": "5011",
    "brokerName": "SCOTIA CAPITAL INC./CDS                                               "
  },
  {
    "type": "OTC",
    "mpid": "SCSI",
    "clearingBroker": "0370",
    "brokerName": "STANDARD CREDIT SECURITIES INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "SCSS",
    "clearingBroker": "0750",
    "brokerName": "STONECASTLE SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "SDIC",
    "clearingBroker": "0235",
    "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
  },
  {
    "type": "OTC",
    "mpid": "SEAP",
    "clearingBroker": "0226",
    "brokerName": "SEAPORT SECURITIES CORP.                                              "
  },
  {
    "type": "OTC",
    "mpid": "SEBR",
    "clearingBroker": "0158",
    "brokerName": "SENTINEL BROKERS COMPANY, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "SEEL",
    "clearingBroker": "0443",
    "brokerName": "R. SEELAUS & CO., INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "SEFB",
    "clearingBroker": "0052",
    "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "SEIB",
    "clearingBroker": "0158",
    "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "SEIC",
    "clearingBroker": "0295",
    "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
  },
  {
    "type": "OTC",
    "mpid": "SEID",
    "clearingBroker": "0388",
    "brokerName": "SEIDEL & SHAW LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "SEIF",
    "clearingBroker": "0696",
    "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
  },
  {
    "type": "OTC",
    "mpid": "SEMT",
    "clearingBroker": "7311",
    "brokerName": "MINT BROKERS                                                          "
  },
  {
    "type": "OTC",
    "mpid": "SERL",
    "clearingBroker": "0443",
    "brokerName": "SEARLE & CO.                                                          "
  },
  {
    "type": "OTC",
    "mpid": "SETX",
    "clearingBroker": "0695",
    "brokerName": "ABN AMRO CLEARING USA LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "SFGB",
    "clearingBroker": "0161",
    "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
  },
  {
    "type": "OTC",
    "mpid": "SFSI",
    "clearingBroker": "0235",
    "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "SGAL",
    "clearingBroker": "0534",
    "brokerName": "S. GOLDMAN ADVISORS, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "SGAS",
    "clearingBroker": "0286",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "SGBI",
    "clearingBroker": "0226",
    "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "SGFC",
    "clearingBroker": "0226",
    "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
  },
  {
    "type": "OTC",
    "mpid": "SGLC",
    "clearingBroker": "0235",
    "brokerName": "S.G. LONG & COMPANY                                                   "
  },
  {
    "type": "OTC",
    "mpid": "SGMA",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS EXECUTION & CLEARING, L.P.                              "
  },
  {
    "type": "OTC",
    "mpid": "SGMT",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "SGNL",
    "clearingBroker": "0279",
    "brokerName": "SIGNAL SECURITIES, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "SGOV",
    "clearingBroker": "0286",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "SGSM",
    "clearingBroker": "1043",
    "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "SHMR",
    "clearingBroker": "0695",
    "brokerName": "ABN AMRO CLEARING USA LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "SHOT",
    "clearingBroker": "0005",
    "brokerName": "SCHOTTENFELD GROUP LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "SHYR",
    "clearingBroker": "0158",
    "brokerName": "STERLINGSHIRE INVESTMENTS                                             "
  },
  {
    "type": "OTC",
    "mpid": "SIBO",
    "clearingBroker": "8199",
    "brokerName": "PRIME EXECUTIONS, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "SILC",
    "clearingBroker": "0158",
    "brokerName": "SOCIAL INVSTR                                                         "
  },
  {
    "type": "OTC",
    "mpid": "SILK",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS EXECUTION & CLEARING, L.P.                              "
  },
  {
    "type": "OTC",
    "mpid": "SIMP",
    "clearingBroker": "0551",
    "brokerName": "SIMPLEX TRADING, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "SKTR",
    "clearingBroker": "0279",
    "brokerName": "STOCK TRADERS                                                         "
  },
  {
    "type": "OTC",
    "mpid": "SLRD",
    "clearingBroker": "0226",
    "brokerName": "S.L. REED & COMPANY                                                   "
  },
  {
    "type": "OTC",
    "mpid": "SMCO",
    "clearingBroker": "0235",
    "brokerName": "SMITH, MOORE & CO.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "SMHI",
    "clearingBroker": "0443",
    "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "SMNS",
    "clearingBroker": "0226",
    "brokerName": "PARKLAND SECURITIES, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "SMPX",
    "clearingBroker": "0695",
    "brokerName": "SIMPLEX TRADING, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "SMRD",
    "clearingBroker": "0443",
    "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "SMRI",
    "clearingBroker": "0226",
    "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
  },
  {
    "type": "OTC",
    "mpid": "SNCC",
    "clearingBroker": "0534",
    "brokerName": "SNC CAPITAL MANAGEMENT CORP.                                          "
  },
  {
    "type": "OTC",
    "mpid": "SNEX",
    "clearingBroker": "0750",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "SOCO",
    "clearingBroker": "0443",
    "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "SOFI",
    "clearingBroker": "0158",
    "brokerName": "SOFI SECURITIES LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "SOGO",
    "clearingBroker": "0158",
    "brokerName": "WANG INVESTMENT ASSOCIATES, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "SOHO",
    "clearingBroker": "0161",
    "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "SORS",
    "clearingBroker": "0235",
    "brokerName": "SORSBY FINANCIAL CORP.                                                "
  },
  {
    "type": "OTC",
    "mpid": "SOVG",
    "clearingBroker": "8199",
    "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "SPAC",
    "clearingBroker": "0793",
    "brokerName": "SIERRA PACIFIC SECURITIES, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "SPBR",
    "clearingBroker": "3856",
    "brokerName": "SPRINKLEBROKERAGE, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "SPCS",
    "clearingBroker": "0052",
    "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "SPCX",
    "clearingBroker": "8199",
    "brokerName": "SCORE PRIORITY CORP.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "SPEX",
    "clearingBroker": "0235",
    "brokerName": "INSPEREX LLC                                                          "
  },
  {
    "type": "OTC",
    "mpid": "SPFI",
    "clearingBroker": "2402",
    "brokerName": "NORTHBOUND SECURITIES LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "SPGS",
    "clearingBroker": "0443",
    "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "SPHN",
    "clearingBroker": "0443",
    "brokerName": "STEPHENS INC.                                                         "
  },
  {
    "type": "OTC",
    "mpid": "SPLC",
    "clearingBroker": "0226",
    "brokerName": "SPIRE SECURITIES, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "SPLN",
    "clearingBroker": "8199",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "SPLX",
    "clearingBroker": "0695",
    "brokerName": "SIMPLEX TRADING, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "SPNN",
    "clearingBroker": "0052",
    "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "SPOT",
    "clearingBroker": "0005",
    "brokerName": "SPOT TRADING                                                          "
  },
  {
    "type": "OTC",
    "mpid": "SPTD",
    "clearingBroker": "0052",
    "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "SPTS",
    "clearingBroker": "0158",
    "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "SRBC",
    "clearingBroker": "0235",
    "brokerName": "SPIDERROCK EXS, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "SRPT",
    "clearingBroker": "9132",
    "brokerName": "SPEEDROUTE LLC                                                        "
  },
  {
    "type": "OTC",
    "mpid": "SSBS",
    "clearingBroker": "0189",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "SSCO",
    "clearingBroker": "8457",
    "brokerName": "SAFRA SECURITIES LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "SSEI",
    "clearingBroker": "0824",
    "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
  },
  {
    "type": "OTC",
    "mpid": "SSGC",
    "clearingBroker": "0226",
    "brokerName": "SIGNATURE SECURITIES                                                  "
  },
  {
    "type": "OTC",
    "mpid": "SSGM",
    "clearingBroker": "0226",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "SSGR",
    "clearingBroker": "0443",
    "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "SSIN",
    "clearingBroker": "0226",
    "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "SSLC",
    "clearingBroker": "0279",
    "brokerName": "SANDERLIN SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "SSLL",
    "clearingBroker": "0189",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "SSNE",
    "clearingBroker": "0226",
    "brokerName": "SANTANDER SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "SSUS",
    "clearingBroker": "0551",
    "brokerName": "SUSQUEHANNA SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "STEP",
    "clearingBroker": "0235",
    "brokerName": "FERRETTI GROUP, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "STFC",
    "clearingBroker": "0443",
    "brokerName": "STUART FRANKEL & CO., INCORPORATED                                    "
  },
  {
    "type": "OTC",
    "mpid": "STFL",
    "clearingBroker": "0793",
    "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
  },
  {
    "type": "OTC",
    "mpid": "STFX",
    "clearingBroker": "0793",
    "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
  },
  {
    "type": "OTC",
    "mpid": "STGC",
    "clearingBroker": "0279",
    "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
  },
  {
    "type": "OTC",
    "mpid": "STHR",
    "clearingBroker": "0388",
    "brokerName": "STORMHARBOUR SECURITIES LP                                            "
  },
  {
    "type": "OTC",
    "mpid": "STKP",
    "clearingBroker": "0158",
    "brokerName": "STOCKPILE INVESTMENTS, INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "STNH",
    "clearingBroker": "0534",
    "brokerName": "STONEHAVEN, LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "STOX",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "STRM",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "OTC",
    "mpid": "STRS",
    "clearingBroker": "0161",
    "brokerName": "STRATEGAS RESEARCH PARTNERS, LLC                                      "
  },
  {
    "type": "OTC",
    "mpid": "STSB",
    "clearingBroker": "3856",
    "brokerName": "SOUTHERN TRUST SECURITIES, INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "STSH",
    "clearingBroker": "0158",
    "brokerName": "STASH CAPITAL LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "STSV",
    "clearingBroker": "3856",
    "brokerName": "SOUTHERN TRUST SECURITIES, INC.                                       "
  },
  {
    "type": "OTC",
    "mpid": "STTT",
    "clearingBroker": "0052",
    "brokerName": "STATETRUST INVESTMENTS INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "STUR",
    "clearingBroker": "0158",
    "brokerName": "STURDIVANT & CO., INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "STXG",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "SUFI",
    "clearingBroker": "0551",
    "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
  },
  {
    "type": "OTC",
    "mpid": "SUMI",
    "clearingBroker": "0443",
    "brokerName": "SMBC NIKKO SECURITIES AMERICA, INC.                                   "
  },
  {
    "type": "OTC",
    "mpid": "SUNX",
    "clearingBroker": "0695",
    "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "SUSQ",
    "clearingBroker": "0551",
    "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
  },
  {
    "type": "OTC",
    "mpid": "SUST",
    "clearingBroker": "0235",
    "brokerName": "SUNSTREET SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "SVBS",
    "clearingBroker": "0443",
    "brokerName": "SVB SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "SWSS",
    "clearingBroker": "0443",
    "brokerName": "SANCTUARY SECURITIES, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "SWST",
    "clearingBroker": "0279",
    "brokerName": "HILLTOP SECURITIES INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "TAGB",
    "clearingBroker": "0052",
    "brokerName": "TAGLICH BROTHERS, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "TAGC",
    "clearingBroker": "1043",
    "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "TAGD",
    "clearingBroker": "1043",
    "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "TAIQ",
    "clearingBroker": "8199",
    "brokerName": "THINK ALPHA SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "TAPP",
    "clearingBroker": "0294",
    "brokerName": "TAPP ENGINE SECURITIES                                                "
  },
  {
    "type": "OTC",
    "mpid": "TAPR",
    "clearingBroker": "4305",
    "brokerName": "TAPP ENGINE SECURITIES                                                "
  },
  {
    "type": "OTC",
    "mpid": "TBCL",
    "clearingBroker": "0750",
    "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "TBCR",
    "clearingBroker": "0235",
    "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "TBGO",
    "clearingBroker": "4305",
    "brokerName": "TRADINGBLOCK                                                          "
  },
  {
    "type": "OTC",
    "mpid": "TBIA",
    "clearingBroker": "0158",
    "brokerName": "TRADIER BROKERAGE, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "TBIS",
    "clearingBroker": "0158",
    "brokerName": "TRADIER BROKERAGE, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "TBLK",
    "clearingBroker": "4305",
    "brokerName": "TRADINGBLOCK                                                          "
  },
  {
    "type": "OTC",
    "mpid": "TBRD",
    "clearingBroker": "0226",
    "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
  },
  {
    "type": "OTC",
    "mpid": "TBRO",
    "clearingBroker": "8199",
    "brokerName": "TUOHY BROTHERS INVESTMENT RESEARCH, INC.                              "
  },
  {
    "type": "OTC",
    "mpid": "TCBI",
    "clearingBroker": "0443",
    "brokerName": "TCBI SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "TDCO",
    "clearingBroker": "0235",
    "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "TDED",
    "clearingBroker": "0284",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "TDFS",
    "clearingBroker": "0052",
    "brokerName": "TRADERFIELD SECURITIES INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "TDFV",
    "clearingBroker": "0294",
    "brokerName": "TRADERFIELD SECURITIES INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "TDNF",
    "clearingBroker": "2568",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "TDSI",
    "clearingBroker": "0226",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "TFAI",
    "clearingBroker": "0226",
    "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
  },
  {
    "type": "OTC",
    "mpid": "TFAS",
    "clearingBroker": "0443",
    "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
  },
  {
    "type": "OTC",
    "mpid": "TFSL",
    "clearingBroker": "0235",
    "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
  },
  {
    "type": "OTC",
    "mpid": "THEM",
    "clearingBroker": "0235",
    "brokerName": "THEMIS TRADING LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "THNK",
    "clearingBroker": "0052",
    "brokerName": "THINKEQUITY, LLC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "TIAD",
    "clearingBroker": "8199",
    "brokerName": "TRIAD SECURITIES CORP                                                 "
  },
  {
    "type": "OTC",
    "mpid": "TIAN",
    "clearingBroker": "0226",
    "brokerName": "TRIAD SECURITIES CORP                                                 "
  },
  {
    "type": "OTC",
    "mpid": "TIGC",
    "clearingBroker": "0235",
    "brokerName": "NELSONREID, INC.                                                      "
  },
  {
    "type": "OTC",
    "mpid": "TIGE",
    "clearingBroker": "1043",
    "brokerName": "US TIGER SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "TIRE",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING                                                          "
  },
  {
    "type": "OTC",
    "mpid": "TJMI",
    "clearingBroker": "9132",
    "brokerName": "TJM INVESTMENTS, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "TKEQ",
    "clearingBroker": "1186",
    "brokerName": "FORDHAM FINANCIAL MANAGEMENT, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "TKNG",
    "clearingBroker": "0158",
    "brokerName": "TRADEKING LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "TLSA",
    "clearingBroker": "4230",
    "brokerName": "TRADELINK SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "TMAS",
    "clearingBroker": "0235",
    "brokerName": "TRADEMAS INC.                                                         "
  },
  {
    "type": "OTC",
    "mpid": "TMBI",
    "clearingBroker": "0141",
    "brokerName": "THURSTON SPRINGER FINANCIAL                                           "
  },
  {
    "type": "OTC",
    "mpid": "TMBR",
    "clearingBroker": "0534",
    "brokerName": "IBKR SECURITIES SERVICES LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "TMCD",
    "clearingBroker": "0235",
    "brokerName": "MCDONALD PARTNERS LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "TMIN",
    "clearingBroker": "0443",
    "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
  },
  {
    "type": "OTC",
    "mpid": "TOCQ",
    "clearingBroker": "0443",
    "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
  },
  {
    "type": "OTC",
    "mpid": "TONE",
    "clearingBroker": "8199",
    "brokerName": "2021 CAPITAL                                                          "
  },
  {
    "type": "OTC",
    "mpid": "TORB",
    "clearingBroker": "0294",
    "brokerName": "TOR BROKERAGE LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "TORM",
    "clearingBroker": "0294",
    "brokerName": "TOR BROKERAGE LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "TOUR",
    "clearingBroker": "0005",
    "brokerName": "TOURMALINE PARTNERS, LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "TPIS",
    "clearingBroker": "0161",
    "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
  },
  {
    "type": "OTC",
    "mpid": "TPMG",
    "clearingBroker": "0005",
    "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "TPMR",
    "clearingBroker": "0141",
    "brokerName": "TRADE-PMR INC.                                                        "
  },
  {
    "type": "OTC",
    "mpid": "TPMX",
    "clearingBroker": "0695",
    "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "TPRO",
    "clearingBroker": "4305",
    "brokerName": "TRADEPRO SECURITIES, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "TPTG",
    "clearingBroker": "2402",
    "brokerName": "CASH APP INVESTING LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "TPVC",
    "clearingBroker": "0294",
    "brokerName": "TRADEPRO SECURITIES,INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "TRAD",
    "clearingBroker": "0271",
    "brokerName": "TRADESTATION SECURITIES, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "TRBT",
    "clearingBroker": "0083",
    "brokerName": "TRADEBOT SYSTEMS, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "TRCG",
    "clearingBroker": "0005",
    "brokerName": "TRC MARKETS LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "TRCJ",
    "clearingBroker": "0352",
    "brokerName": "TRC MARKETS LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "TRCM",
    "clearingBroker": "0695",
    "brokerName": "TRC MARKETS LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "TRCS",
    "clearingBroker": "0388",
    "brokerName": "TIGERRISK CAPITAL MARKETS & ADVISORY                                  "
  },
  {
    "type": "OTC",
    "mpid": "TRCX",
    "clearingBroker": "0695",
    "brokerName": "TRC MARKETS LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "TREX",
    "clearingBroker": "1043",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "OTC",
    "mpid": "TRIB",
    "clearingBroker": "0235",
    "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "TRIM",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "TRIP",
    "clearingBroker": "0235",
    "brokerName": "TRIDENT PARTNERS LTD                                                  "
  },
  {
    "type": "OTC",
    "mpid": "TRLN",
    "clearingBroker": "4230",
    "brokerName": "TRADELINK SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "TRMZ",
    "clearingBroker": "0161",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "TRSH",
    "clearingBroker": "0279",
    "brokerName": "THRASHER & CHAMBERS, INC.                                             "
  },
  {
    "type": "OTC",
    "mpid": "TRSQ",
    "clearingBroker": "0443",
    "brokerName": "TOWER SQUARE SECURITIES, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "TRUB",
    "clearingBroker": "0141",
    "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "TRWN",
    "clearingBroker": "0443",
    "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "TRYC",
    "clearingBroker": "0158",
    "brokerName": "SIXTEEN SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "TRYN",
    "clearingBroker": "0279",
    "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "TSCD",
    "clearingBroker": "0235",
    "brokerName": "STURGES COMPANY (THE)                                                 "
  },
  {
    "type": "OTC",
    "mpid": "TSER",
    "clearingBroker": "0161",
    "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "TSSM",
    "clearingBroker": "0161",
    "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
  },
  {
    "type": "OTC",
    "mpid": "TTCS",
    "clearingBroker": "9132",
    "brokerName": "T3 TRADING GROUP, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "TTSC",
    "clearingBroker": "0052",
    "brokerName": "TREND TRADE SECURITIES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "TTSI",
    "clearingBroker": "0158",
    "brokerName": "T3 SECURITIES, INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "TTTG",
    "clearingBroker": "0294",
    "brokerName": "T3 TRADING GROUP, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "TTTS",
    "clearingBroker": "0158",
    "brokerName": "T3 SECURITIES, INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "TWDP",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "TWTT",
    "clearingBroker": "0158",
    "brokerName": "TASTYWORKS, INC.                                                      "
  },
  {
    "type": "OTC",
    "mpid": "TWXS",
    "clearingBroker": "0161",
    "brokerName": "TRADEWORX SECURITIES LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "TYLO",
    "clearingBroker": "1186",
    "brokerName": "DOUGALL & ASSOCIATES                                                  "
  },
  {
    "type": "OTC",
    "mpid": "TZCL",
    "clearingBroker": "0712",
    "brokerName": "TZ CLEAR LLC                                                          "
  },
  {
    "type": "OTC",
    "mpid": "UBII",
    "clearingBroker": "0221",
    "brokerName": "UBS INTERNATIONAL, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "UBSA",
    "clearingBroker": "0642",
    "brokerName": "UBS SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "UBSB",
    "clearingBroker": "0642",
    "brokerName": "UBS SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "UBSI",
    "clearingBroker": "0141",
    "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
  },
  {
    "type": "OTC",
    "mpid": "UBSS",
    "clearingBroker": "0642",
    "brokerName": "UBS SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "UBSW",
    "clearingBroker": "0642",
    "brokerName": "UBS SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "UBSX",
    "clearingBroker": "0642",
    "brokerName": "UBS SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "UCAP",
    "clearingBroker": "0750",
    "brokerName": "UCAP SECURITIES LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "UCCM",
    "clearingBroker": "0279",
    "brokerName": "CU INVESTMENT SOLUTIONS, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "UCML",
    "clearingBroker": "0052",
    "brokerName": "UNITED CAPITAL MARKETS, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "UFPF",
    "clearingBroker": "0226",
    "brokerName": "UNITED FIRST PARTNERS, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "UHLM",
    "clearingBroker": "0235",
    "brokerName": "UHLMANN PRICE SECURITIES, LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "UMBF",
    "clearingBroker": "0226",
    "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "OTC",
    "mpid": "UNIS",
    "clearingBroker": "3450",
    "brokerName": "UNIVEST SECURITIES, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "UNIV",
    "clearingBroker": "3856",
    "brokerName": "UNIVEST SECURITIES, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "UPLN",
    "clearingBroker": "0443",
    "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
  },
  {
    "type": "OTC",
    "mpid": "USCA",
    "clearingBroker": "0226",
    "brokerName": "USCA SECURITIES LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "USDB",
    "clearingBroker": "0279",
    "brokerName": "U.S. BROKERAGE, INC.                                                  "
  },
  {
    "type": "OTC",
    "mpid": "USEC",
    "clearingBroker": "3450",
    "brokerName": "UNIVEST SECURITIES, LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "USFB",
    "clearingBroker": "0595",
    "brokerName": "U.S. FINANCIAL INVESTMENTS, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "USIC",
    "clearingBroker": "0226",
    "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
  },
  {
    "type": "OTC",
    "mpid": "USLF",
    "clearingBroker": "5075",
    "brokerName": "PI FINANCIAL CORP.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "USSI",
    "clearingBroker": "0279",
    "brokerName": "U.S. STERLING SECURITIES, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "USTZ",
    "clearingBroker": "0595",
    "brokerName": "TRADEZERO AMERINCA, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "UVUV",
    "clearingBroker": "0161",
    "brokerName": "ULTRAVIOLET SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "VALA",
    "clearingBroker": "0294",
    "brokerName": "VALUABLE CAPITAL SECURITIES                                           "
  },
  {
    "type": "OTC",
    "mpid": "VALD",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "VALI",
    "clearingBroker": "0226",
    "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "VALR",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "VALU",
    "clearingBroker": "0294",
    "brokerName": "VALUABLE CAPITAL SECURITIES                                           "
  },
  {
    "type": "OTC",
    "mpid": "VALX",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "VBLT",
    "clearingBroker": "0226",
    "brokerName": "VANDERBILT SECURITIES, LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "VBSL",
    "clearingBroker": "0595",
    "brokerName": "VISION BROKERAGE SERVICES, LLC                                        "
  },
  {
    "type": "OTC",
    "mpid": "VCAB",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCAX",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCBB",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCBR",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CAPITAL, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "VCBY",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCCA",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCEC",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCEL",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCEX",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCFL",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCFN",
    "clearingBroker": "0235",
    "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
  },
  {
    "type": "OTC",
    "mpid": "VCFS",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCGD",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCGL",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCGO",
    "clearingBroker": "0005",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCGP",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCGS",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCGT",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCIM",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCIN",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCIT",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCKW",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCLT",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCMA",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCPR",
    "clearingBroker": "4424",
    "brokerName": "VELOCITY CAPITAL, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "VCPS",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCRB",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCSG",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCSH",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCSK",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCSM",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCSO",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCSS",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCST",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCSV",
    "clearingBroker": "0052",
    "brokerName": "PRIMARY CAPITAL, LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "VCTC",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCTH",
    "clearingBroker": "6019",
    "brokerName": "VELOCITY CAPITAL LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "VCTP",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCTS",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCTY",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCUG",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCUH",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCUS",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCVL",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCVS",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCVT",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCVU",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCVV",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCVW",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCWC",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCWP",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VCWS",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VEAA",
    "clearingBroker": "3856",
    "brokerName": "VELOX CLEARING LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "VEAB",
    "clearingBroker": "3856",
    "brokerName": "VELOX CLEARING LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "VEAD",
    "clearingBroker": "3856",
    "brokerName": "VELOX CLEARING LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "VEAE",
    "clearingBroker": "3856",
    "brokerName": "VELOX CLEARING LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "VEAF",
    "clearingBroker": "3856",
    "brokerName": "VELOX CLEARING LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "VELC",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CAPITAL, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "VERF",
    "clearingBroker": "0235",
    "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "VERT",
    "clearingBroker": "8199",
    "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "VESB",
    "clearingBroker": "0158",
    "brokerName": "VESTFI INC.                                                           "
  },
  {
    "type": "OTC",
    "mpid": "VEST",
    "clearingBroker": "0750",
    "brokerName": "VESTECH SECURITIES, INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "VETS",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
  },
  {
    "type": "OTC",
    "mpid": "VFSI",
    "clearingBroker": "2402",
    "brokerName": "VF SECURITIES                                                         "
  },
  {
    "type": "OTC",
    "mpid": "VGRD",
    "clearingBroker": "0062",
    "brokerName": "VANGUARD MARKETING CORPORATION                                        "
  },
  {
    "type": "OTC",
    "mpid": "VHTO",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VIEW",
    "clearingBroker": "9132",
    "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "VIRT",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "VKMI",
    "clearingBroker": "0692",
    "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "VLCT",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VLEO",
    "clearingBroker": "0158",
    "brokerName": "VOLEO USA, INC                                                        "
  },
  {
    "type": "OTC",
    "mpid": "VLET",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VLFX",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VLMM",
    "clearingBroker": "0294",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VLNT",
    "clearingBroker": "4305",
    "brokerName": "VOLANT SECURITIES, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "VLOX",
    "clearingBroker": "3856",
    "brokerName": "VELOX CLEARING LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "VMDI",
    "clearingBroker": "0443",
    "brokerName": "DESJARDINS SECURITIES INTERNATIONAL INC.                              "
  },
  {
    "type": "OTC",
    "mpid": "VNDM",
    "clearingBroker": "0443",
    "brokerName": "VANDHAM SECURITIES CORP.                                              "
  },
  {
    "type": "OTC",
    "mpid": "VNMS",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "VPEW",
    "clearingBroker": "0158",
    "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
  },
  {
    "type": "OTC",
    "mpid": "VRTG",
    "clearingBroker": "0695",
    "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "VSIN",
    "clearingBroker": "0595",
    "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "VTDT",
    "clearingBroker": "0158",
    "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "VTRN",
    "clearingBroker": "0443",
    "brokerName": "BANCROFT CAPITAL, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "WABR",
    "clearingBroker": "0443",
    "brokerName": "WALL STREET ACCESS                                                    "
  },
  {
    "type": "OTC",
    "mpid": "WACC",
    "clearingBroker": "0279",
    "brokerName": "MIDLAND SECURITIES, LTD                                               "
  },
  {
    "type": "OTC",
    "mpid": "WACL",
    "clearingBroker": "0709",
    "brokerName": "WACHTEL & CO., INC.                                                   "
  },
  {
    "type": "OTC",
    "mpid": "WAIN",
    "clearingBroker": "1043",
    "brokerName": "H.C. WAINWRIGHT & CO., INC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "WBAX",
    "clearingBroker": "0052",
    "brokerName": "WALLACHBETH CAPITAL LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "WBBC",
    "clearingBroker": "0226",
    "brokerName": "WBB SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "WBET",
    "clearingBroker": "0161",
    "brokerName": "WALLACHBETH CAPITAL LLC                                               "
  },
  {
    "type": "OTC",
    "mpid": "WBLR",
    "clearingBroker": "0771",
    "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
  },
  {
    "type": "OTC",
    "mpid": "WBNF",
    "clearingBroker": "0226",
    "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
  },
  {
    "type": "OTC",
    "mpid": "WBPA",
    "clearingBroker": "0161",
    "brokerName": "CLEAR STREET MARKETS LLC                                              "
  },
  {
    "type": "OTC",
    "mpid": "WBPX",
    "clearingBroker": "0551",
    "brokerName": "SUMMIT SECURITIES GROUP, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "WBSI",
    "clearingBroker": "8199",
    "brokerName": "WEDBUSH SECURITIES INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "WBUL",
    "clearingBroker": "0158",
    "brokerName": "WEBULL FINANCIAL LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "WCHV",
    "clearingBroker": "0250",
    "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "WCIG",
    "clearingBroker": "0750",
    "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "WCSC",
    "clearingBroker": "0235",
    "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
  },
  {
    "type": "OTC",
    "mpid": "WCSF",
    "clearingBroker": "0235",
    "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "WDCO",
    "clearingBroker": "0283",
    "brokerName": "WILSON-DAVIS & CO., INC.                                              "
  },
  {
    "type": "OTC",
    "mpid": "WDLF",
    "clearingBroker": "5078",
    "brokerName": "W.D. LATIMER CO LTD./CDS                                              "
  },
  {
    "type": "OTC",
    "mpid": "WDLP",
    "clearingBroker": "0005",
    "brokerName": "WOLVERINE TRADING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "WDOG",
    "clearingBroker": "0158",
    "brokerName": "WATCHDOG CAPITAL, LLC                                                 "
  },
  {
    "type": "OTC",
    "mpid": "WDSB",
    "clearingBroker": "0536",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "WEBL",
    "clearingBroker": "0158",
    "brokerName": "WEBULL FINANCIAL LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "WEBS",
    "clearingBroker": "0226",
    "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
  },
  {
    "type": "OTC",
    "mpid": "WEDB",
    "clearingBroker": "0103",
    "brokerName": "WEDBUSH SECURITIES INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "WEDP",
    "clearingBroker": "0103",
    "brokerName": "WEDBUSH MORGAN SECURITIES INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "WEGI",
    "clearingBroker": "0235",
    "brokerName": "WORLD EQUITY GROUP INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "WEGP",
    "clearingBroker": "0235",
    "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
  },
  {
    "type": "OTC",
    "mpid": "WELX",
    "clearingBroker": "0250",
    "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "WEMM",
    "clearingBroker": "0250",
    "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "WESC",
    "clearingBroker": "0443",
    "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
  },
  {
    "type": "OTC",
    "mpid": "WEXC",
    "clearingBroker": "7350",
    "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "WEXM",
    "clearingBroker": "0161",
    "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "WEXR",
    "clearingBroker": "0235",
    "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "WEXS",
    "clearingBroker": "9132",
    "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "WEXX",
    "clearingBroker": "0005",
    "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "OTC",
    "mpid": "WEYE",
    "clearingBroker": "0005",
    "brokerName": "WALLEYE TRADING LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "WFES",
    "clearingBroker": "0250",
    "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "WFGP",
    "clearingBroker": "0075",
    "brokerName": "WATERSTONE FINANCIAL GROUP, INC.                                      "
  },
  {
    "type": "OTC",
    "mpid": "WFPB",
    "clearingBroker": "0250",
    "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "WGIF",
    "clearingBroker": "5030",
    "brokerName": "CIBC WORLD MARKETS INC./CDS                                           "
  },
  {
    "type": "OTC",
    "mpid": "WHBB",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL INC.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "WHOT",
    "clearingBroker": "0595",
    "brokerName": "JUST2TRADE, INC.                                                      "
  },
  {
    "type": "OTC",
    "mpid": "WIDS",
    "clearingBroker": "0279",
    "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
  },
  {
    "type": "OTC",
    "mpid": "WINO",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "WINR",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING                                                          "
  },
  {
    "type": "OTC",
    "mpid": "WINZ",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "WISC",
    "clearingBroker": "0235",
    "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "WISE",
    "clearingBroker": "0052",
    "brokerName": "AXOS INVEST LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "WISP",
    "clearingBroker": "0443",
    "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
  },
  {
    "type": "OTC",
    "mpid": "WLMS",
    "clearingBroker": "0443",
    "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
  },
  {
    "type": "OTC",
    "mpid": "WLTH",
    "clearingBroker": "0235",
    "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
  },
  {
    "type": "OTC",
    "mpid": "WMCL",
    "clearingBroker": "0279",
    "brokerName": "WHITE MOUNTAIN CAPITAL, LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "WMFS",
    "clearingBroker": "0226",
    "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
  },
  {
    "type": "OTC",
    "mpid": "WMLL",
    "clearingBroker": "0235",
    "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
  },
  {
    "type": "OTC",
    "mpid": "WNUT",
    "clearingBroker": "0443",
    "brokerName": "WALNUT STREET SECURITIES, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "WPCC",
    "clearingBroker": "0052",
    "brokerName": "WESTPARK CAPITAL, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "WPCI",
    "clearingBroker": "0595",
    "brokerName": "WESTPARK CAPITAL, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "WPRM",
    "clearingBroker": "8199",
    "brokerName": "WEDBUSH SECURITIES INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "WPSG",
    "clearingBroker": "0005",
    "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
  },
  {
    "type": "OTC",
    "mpid": "WPSX",
    "clearingBroker": "0445",
    "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
  },
  {
    "type": "OTC",
    "mpid": "WRDN",
    "clearingBroker": "0534",
    "brokerName": "WORDENTRADE, INC.                                                     "
  },
  {
    "type": "OTC",
    "mpid": "WRET",
    "clearingBroker": "0141",
    "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
  },
  {
    "type": "OTC",
    "mpid": "WRIS",
    "clearingBroker": "0141",
    "brokerName": "SMH CAPITAL INVESTMENTS LLC                                           "
  },
  {
    "type": "OTC",
    "mpid": "WSAG",
    "clearingBroker": "0443",
    "brokerName": "WALL STREET ACCESS                                                    "
  },
  {
    "type": "OTC",
    "mpid": "WSAT",
    "clearingBroker": "0443",
    "brokerName": "WALL STREET ACCESS                                                    "
  },
  {
    "type": "OTC",
    "mpid": "WSCC",
    "clearingBroker": "0235",
    "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
  },
  {
    "type": "OTC",
    "mpid": "WSCX",
    "clearingBroker": "0235",
    "brokerName": "WORKMAN SECURITIES CORP                                               "
  },
  {
    "type": "OTC",
    "mpid": "WSGD",
    "clearingBroker": "8199",
    "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
  },
  {
    "type": "OTC",
    "mpid": "WSIW",
    "clearingBroker": "8199",
    "brokerName": "WEDBUSH SECURITIES INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "WSRP",
    "clearingBroker": "0052",
    "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
  },
  {
    "type": "OTC",
    "mpid": "WSTI",
    "clearingBroker": "0226",
    "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
  },
  {
    "type": "OTC",
    "mpid": "WTCO",
    "clearingBroker": "0005",
    "brokerName": "WILLIAMS TRADING LLC                                                  "
  },
  {
    "type": "OTC",
    "mpid": "WTFS",
    "clearingBroker": "0052",
    "brokerName": "LIME TRADING CORP                                                     "
  },
  {
    "type": "OTC",
    "mpid": "WTLP",
    "clearingBroker": "0005",
    "brokerName": "WOLVERINE TRADING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "WTRI",
    "clearingBroker": "0235",
    "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
  },
  {
    "type": "OTC",
    "mpid": "WUND",
    "clearingBroker": "0141",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "OTC",
    "mpid": "WVBD",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "WWLD",
    "clearingBroker": "0647",
    "brokerName": "WHITEWELD TRADING, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "XCNC",
    "clearingBroker": "0005",
    "brokerName": "C&C TRADING L.L.C.                                                    "
  },
  {
    "type": "OTC",
    "mpid": "XDOZ",
    "clearingBroker": "0438",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "XGWD",
    "clearingBroker": "0695",
    "brokerName": "LATOUR TRADING LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "XIST",
    "clearingBroker": "0067",
    "brokerName": "INSTINET, LLC                                                         "
  },
  {
    "type": "OTC",
    "mpid": "XPQR",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING                                                          "
  },
  {
    "type": "OTC",
    "mpid": "XPSE",
    "clearingBroker": "0158",
    "brokerName": "XP INVESTMENTS US, LLC                                                "
  },
  {
    "type": "OTC",
    "mpid": "XPUS",
    "clearingBroker": "0443",
    "brokerName": "XP SECURITIES, LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "XRVR",
    "clearingBroker": "0279",
    "brokerName": "CRB SECURITIES, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "XSTM",
    "clearingBroker": "0226",
    "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
  },
  {
    "type": "OTC",
    "mpid": "XTLS",
    "clearingBroker": "0052",
    "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "XTLW",
    "clearingBroker": "0052",
    "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
  },
  {
    "type": "OTC",
    "mpid": "XTXE",
    "clearingBroker": "0161",
    "brokerName": "XTX EXECUTION SERVICES LLC                                            "
  },
  {
    "type": "OTC",
    "mpid": "XTXM",
    "clearingBroker": "0551",
    "brokerName": "XTX MARKETS LLC                                                       "
  },
  {
    "type": "OTC",
    "mpid": "XXXX",
    "clearingBroker": "0123",
    "brokerName": "XXXX CLEARING 0123 TEST                                               "
  },
  {
    "type": "OTC",
    "mpid": "YLPL",
    "clearingBroker": "0075",
    "brokerName": "LPL FINANCIAL LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "YOSE",
    "clearingBroker": "0052",
    "brokerName": "YORK SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "YSBI",
    "clearingBroker": "0534",
    "brokerName": "YORK STOCKBROKERS, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "YYYY",
    "clearingBroker": "0122",
    "brokerName": "TEST ACCOUNT FORWARD TO P & S DEPT                                    "
  },
  {
    "type": "OTC",
    "mpid": "ZACK",
    "clearingBroker": "0534",
    "brokerName": "LBMZ SECURITIES, INC.                                                 "
  },
  {
    "type": "OTC",
    "mpid": "ZBAH",
    "clearingBroker": "0712",
    "brokerName": "TZ CLEAR LLC                                                          "
  },
  {
    "type": "OTC",
    "mpid": "ZCAN",
    "clearingBroker": "0712",
    "brokerName": "TZ CLEAR LLC                                                          "
  },
  {
    "type": "OTC",
    "mpid": "ZEDB",
    "clearingBroker": "0161",
    "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "ZEDD",
    "clearingBroker": "0295",
    "brokerName": "VAN KAMPEN FUNDS, INC.                                                "
  },
  {
    "type": "OTC",
    "mpid": "ZERO",
    "clearingBroker": "0158",
    "brokerName": "TRADEZERO AMERICA, INC.                                               "
  },
  {
    "type": "OTC",
    "mpid": "ZEUS",
    "clearingBroker": "0443",
    "brokerName": "ZEUS FINANCIAL, LLC                                                   "
  },
  {
    "type": "OTC",
    "mpid": "ZIPD",
    "clearingBroker": "3450",
    "brokerName": "SPEEDTRADER, INC                                                      "
  },
  {
    "type": "OTC",
    "mpid": "ZIVI",
    "clearingBroker": "8082",
    "brokerName": "ZIV INVESTMENT COMPANY                                                "
  },
  {
    "type": "OTC",
    "mpid": "ZNTH",
    "clearingBroker": "0695",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "OTC",
    "mpid": "ZOES",
    "clearingBroker": "0158",
    "brokerName": "ZOE SECURITIES LLC                                                    "
  },
  {
    "type": "OTC",
    "mpid": "ZOUL",
    "clearingBroker": "0235",
    "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
  },
  {
    "type": "OTC",
    "mpid": "ZPFD",
    "clearingBroker": "0443",
    "brokerName": "B. C. ZIEGLER AND COMPANY                                             "
  },
  {
    "type": "OTC",
    "mpid": "ZZZZ",
    "clearingBroker": "0123",
    "brokerName": "TEST ACCOUNT - FORWARD TO P&S DEPARTMENT                              "
  },
  {
    "type": "CORP",
    "mpid": "AALC",
    "clearingBroker": "0226",
    "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "ABAI",
    "clearingBroker": "0279",
    "brokerName": "ABACUS INVESTMENTS, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "ABBA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "ABBK",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "ABDA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "ABDW",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "ABEA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "ABEN",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "ABHE",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "ABIG",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "ABPR",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "ABRP",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "ABST",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "ACAD",
    "clearingBroker": "0443",
    "brokerName": "ACADEMY SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "ACAM",
    "clearingBroker": "0388",
    "brokerName": "ACADEMY SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "ACAP",
    "clearingBroker": "0235",
    "brokerName": "ALAMO CAPITAL                                                         "
  },
  {
    "type": "CORP",
    "mpid": "ACCP",
    "clearingBroker": "0158",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "ACCU",
    "clearingBroker": "0052",
    "brokerName": "ATB CAPITAL MARKETS USA INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "ACII",
    "clearingBroker": "0158",
    "brokerName": "ARCA CAPITAL INVESTMENTS, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "ACLP",
    "clearingBroker": "0235",
    "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
  },
  {
    "type": "CORP",
    "mpid": "ACPL",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN CAPITAL PARTNERS                                             "
  },
  {
    "type": "CORP",
    "mpid": "ACPS",
    "clearingBroker": "0443",
    "brokerName": "ACP SECURITIES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "ACRN",
    "clearingBroker": "0235",
    "brokerName": "ACORNS SECURITIES, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "ACTI",
    "clearingBroker": "0443",
    "brokerName": "ACTIVNER SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "ADAM",
    "clearingBroker": "0161",
    "brokerName": "CANACCORD GENUITY INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "ADSD",
    "clearingBroker": "0725",
    "brokerName": "ROGAN & ASSOCIATES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "ADSO",
    "clearingBroker": "0141",
    "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "AEFS",
    "clearingBroker": "0226",
    "brokerName": "AE FINANCIAL SERVICES, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "AETL",
    "clearingBroker": "0158",
    "brokerName": "AET INVESTMENT SERVICES, LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "AEXG",
    "clearingBroker": "0158",
    "brokerName": "ALTERNATIVE EXECUTION GROUP                                           "
  },
  {
    "type": "CORP",
    "mpid": "AFBS",
    "clearingBroker": "0158",
    "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
  },
  {
    "type": "CORP",
    "mpid": "AFGI",
    "clearingBroker": "0725",
    "brokerName": "ACCESS FINANCIAL GROUP, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "AFGT",
    "clearingBroker": "0052",
    "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "AFSL",
    "clearingBroker": "0443",
    "brokerName": "SORRENTO PACIFIC FINANCIAL                                            "
  },
  {
    "type": "CORP",
    "mpid": "AFSS",
    "clearingBroker": "0750",
    "brokerName": "FOUR POINTS CAPITAL PARTNERS LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "AGCO",
    "clearingBroker": "0052",
    "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "AGCP",
    "clearingBroker": "0052",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "AGES",
    "clearingBroker": "0750",
    "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
  },
  {
    "type": "CORP",
    "mpid": "AGFA",
    "clearingBroker": "0226",
    "brokerName": "VALIC FINANCIAL ADVISORS, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "AGIS",
    "clearingBroker": "0235",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "AGPM",
    "clearingBroker": "1043",
    "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
  },
  {
    "type": "CORP",
    "mpid": "AGSS",
    "clearingBroker": "0443",
    "brokerName": "GREAT AMERICAN ADVISORS, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "AHSI",
    "clearingBroker": "0141",
    "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "AIGF",
    "clearingBroker": "0443",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "AIGN",
    "clearingBroker": "0226",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "AIRS",
    "clearingBroker": "0279",
    "brokerName": "HAND SECURITIES, INC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "AISG",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
  },
  {
    "type": "CORP",
    "mpid": "AJCO",
    "clearingBroker": "0443",
    "brokerName": "IDB CAPITAL CORP.                                                     "
  },
  {
    "type": "CORP",
    "mpid": "ALCG",
    "clearingBroker": "0235",
    "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "ALCM",
    "clearingBroker": "0279",
    "brokerName": "ALPHALEDGER MARKETS, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "ALDN",
    "clearingBroker": "0052",
    "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "ALGP",
    "clearingBroker": "0235",
    "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
  },
  {
    "type": "CORP",
    "mpid": "ALGR",
    "clearingBroker": "0158",
    "brokerName": "ALGER (FRED) & CO INC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "ALIS",
    "clearingBroker": "0235",
    "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
  },
  {
    "type": "CORP",
    "mpid": "ALLN",
    "clearingBroker": "0443",
    "brokerName": "ALLEN & COMPANY LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "ALNC",
    "clearingBroker": "0226",
    "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
  },
  {
    "type": "CORP",
    "mpid": "ALTR",
    "clearingBroker": "3164",
    "brokerName": "ALTRUIST FINANCIAL LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "AMBB",
    "clearingBroker": "0141",
    "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
  },
  {
    "type": "CORP",
    "mpid": "AMER",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
  },
  {
    "type": "CORP",
    "mpid": "AMIC",
    "clearingBroker": "0226",
    "brokerName": "AMERICAN INVESTORS COMPANY                                            "
  },
  {
    "type": "CORP",
    "mpid": "AMLU",
    "clearingBroker": "3652",
    "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "AMMS",
    "clearingBroker": "0141",
    "brokerName": "AMUNI FINANCIAL, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "AMRG",
    "clearingBroker": "0443",
    "brokerName": "WORLD CAPITAL BROKERAGE, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "ANDB",
    "clearingBroker": "0443",
    "brokerName": "ANDBANC BROKERAGE, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "ANDG",
    "clearingBroker": "0235",
    "brokerName": "GARRETT (ANDREW), INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "ANOS",
    "clearingBroker": "0235",
    "brokerName": "ABEL NOSER, LLC.                                                      "
  },
  {
    "type": "CORP",
    "mpid": "ANOV",
    "clearingBroker": "0750",
    "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "AOCS",
    "clearingBroker": "0388",
    "brokerName": "AOC SECURITIES                                                        "
  },
  {
    "type": "CORP",
    "mpid": "AONC",
    "clearingBroker": "0443",
    "brokerName": "AON BENFIELD SECURITIES                                               "
  },
  {
    "type": "CORP",
    "mpid": "AORP",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "AOSD",
    "clearingBroker": "0158",
    "brokerName": "TRADING BLOCK                                                         "
  },
  {
    "type": "CORP",
    "mpid": "APBD",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "APBO",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "APFS",
    "clearingBroker": "0443",
    "brokerName": "AMERICA'S PORTFOLIO'S                                                 "
  },
  {
    "type": "CORP",
    "mpid": "APRT",
    "clearingBroker": "0226",
    "brokerName": "PARTNERS                                                              "
  },
  {
    "type": "CORP",
    "mpid": "APXO",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "APXS",
    "clearingBroker": "0052",
    "brokerName": "APEXUS CAPITAL LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "ARBC",
    "clearingBroker": "0235",
    "brokerName": "ARKADIOS CAPITAL                                                      "
  },
  {
    "type": "CORP",
    "mpid": "ARCD",
    "clearingBroker": "0443",
    "brokerName": "ARCADIA SECURITIES, LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "ARKA",
    "clearingBroker": "0443",
    "brokerName": "ARKA SECURITIES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "ARKI",
    "clearingBroker": "0226",
    "brokerName": "ARKADIOS CAPITAL                                                      "
  },
  {
    "type": "CORP",
    "mpid": "ARSC",
    "clearingBroker": "1043",
    "brokerName": "ARCTIC SECURITIES LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "ARTI",
    "clearingBroker": "1043",
    "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "ARVS",
    "clearingBroker": "0443",
    "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
  },
  {
    "type": "CORP",
    "mpid": "ASCM",
    "clearingBroker": "0052",
    "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "ASCP",
    "clearingBroker": "0443",
    "brokerName": "BOK FINANCIAL SECURITIES                                              "
  },
  {
    "type": "CORP",
    "mpid": "ASII",
    "clearingBroker": "0226",
    "brokerName": "AURORA SECURITIES                                                     "
  },
  {
    "type": "CORP",
    "mpid": "ASLB",
    "clearingBroker": "0370",
    "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
  },
  {
    "type": "CORP",
    "mpid": "ASOI",
    "clearingBroker": "0226",
    "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "ASPI",
    "clearingBroker": "0725",
    "brokerName": "ASIA PACIFIC FINANCIAL MANAGEMENT GROUP, INC.                         "
  },
  {
    "type": "CORP",
    "mpid": "ATIS",
    "clearingBroker": "0052",
    "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
  },
  {
    "type": "CORP",
    "mpid": "ATLS",
    "clearingBroker": "0443",
    "brokerName": "APOLLO GLOBAL SECURITIES, LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "ATMC",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "ATVT",
    "clearingBroker": "0443",
    "brokerName": "ATOMIC BROKERAGE LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "AULC",
    "clearingBroker": "0443",
    "brokerName": "ONEAMERICA SECURITIES, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "AVEN",
    "clearingBroker": "0226",
    "brokerName": "AVENTURA SECURITIES, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "AVEW",
    "clearingBroker": "8199",
    "brokerName": "AVENTURA SECURITIES, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "AVIL",
    "clearingBroker": "0158",
    "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "AVML",
    "clearingBroker": "0443",
    "brokerName": "AVM, L.P.                                                             "
  },
  {
    "type": "CORP",
    "mpid": "AVON",
    "clearingBroker": "0226",
    "brokerName": "AVONDALE PARTNERS, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "AVSI",
    "clearingBroker": "0443",
    "brokerName": "AMERIVET SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "AVST",
    "clearingBroker": "0235",
    "brokerName": "ATOMIC BROKERAGE LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "AWMI",
    "clearingBroker": "0725",
    "brokerName": "AMERICAN WEALTH MANAGEMENT INC                                        "
  },
  {
    "type": "CORP",
    "mpid": "AXAA",
    "clearingBroker": "0075",
    "brokerName": "AXA ADVISORS LLC                                                      "
  },
  {
    "type": "CORP",
    "mpid": "AXCB",
    "clearingBroker": "0443",
    "brokerName": "ACCESS SECURITIES                                                     "
  },
  {
    "type": "CORP",
    "mpid": "AXCL",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "CORP",
    "mpid": "AXCS",
    "clearingBroker": "0443",
    "brokerName": "ACCESS SECURITIES INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "AXGP",
    "clearingBroker": "0443",
    "brokerName": "ACCESS SECURITIES, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "AXIO",
    "clearingBroker": "0279",
    "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "AXOS",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "CORP",
    "mpid": "AXTN",
    "clearingBroker": "0052",
    "brokerName": "AX TRADING, LLC                                                       "
  },
  {
    "type": "CORP",
    "mpid": "BAKR",
    "clearingBroker": "0443",
    "brokerName": "JAMES BAKER & ASSOCIATES, L.P.                                        "
  },
  {
    "type": "CORP",
    "mpid": "BALE",
    "clearingBroker": "0443",
    "brokerName": "M&T SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "BALS",
    "clearingBroker": "0750",
    "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "BANK",
    "clearingBroker": "0701",
    "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "BARC",
    "clearingBroker": "0388",
    "brokerName": "BARCLAY                                                               "
  },
  {
    "type": "CORP",
    "mpid": "BARD",
    "clearingBroker": "0547",
    "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
  },
  {
    "type": "CORP",
    "mpid": "BARR",
    "clearingBroker": "0226",
    "brokerName": "BARRETT & COMPANY                                                     "
  },
  {
    "type": "CORP",
    "mpid": "BAYC",
    "clearingBroker": "0161",
    "brokerName": "BAY CREST PARTNERS,  LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "BAYP",
    "clearingBroker": "0161",
    "brokerName": "BAY CREST PARTNERS, LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "BBAR",
    "clearingBroker": "0595",
    "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "BBGC",
    "clearingBroker": "0235",
    "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
  },
  {
    "type": "CORP",
    "mpid": "BBNI",
    "clearingBroker": "0443",
    "brokerName": "PERFORMANCE TRUST CAPITAL PARTNERS, INC.                              "
  },
  {
    "type": "CORP",
    "mpid": "BCAP",
    "clearingBroker": "7256",
    "brokerName": "BARCLAYS CAPITAL, INC./FIXED INCOME                                   "
  },
  {
    "type": "CORP",
    "mpid": "BCCS",
    "clearingBroker": "0443",
    "brokerName": "BAC FLORIDA INVESTMENTS CORP.                                         "
  },
  {
    "type": "CORP",
    "mpid": "BCEX",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "BCGS",
    "clearingBroker": "0443",
    "brokerName": "BCG SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "BCIB",
    "clearingBroker": "0443",
    "brokerName": "BCI SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "BCKL",
    "clearingBroker": "0443",
    "brokerName": "BANCOLOMBIA CAPITAL LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "BCLE",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
  },
  {
    "type": "CORP",
    "mpid": "BCPI",
    "clearingBroker": "0279",
    "brokerName": "GVC CAPITAL LLC                                                       "
  },
  {
    "type": "CORP",
    "mpid": "BCRK",
    "clearingBroker": "0279",
    "brokerName": "BEAR CREEK SECURITIES, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "BCSA",
    "clearingBroker": "0443",
    "brokerName": "BCS AMERICAS, INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "BCWM",
    "clearingBroker": "4077",
    "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "BCZC",
    "clearingBroker": "0443",
    "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
  },
  {
    "type": "CORP",
    "mpid": "BDBS",
    "clearingBroker": "0443",
    "brokerName": "BANCO DO BRASIL SECURITIES                                            "
  },
  {
    "type": "CORP",
    "mpid": "BDDK",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "BDIR",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "CORP",
    "mpid": "BDTR",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "BEAF",
    "clearingBroker": "0235",
    "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
  },
  {
    "type": "CORP",
    "mpid": "BECM",
    "clearingBroker": "0725",
    "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "BELS",
    "clearingBroker": "0443",
    "brokerName": "BEL AIR SECURITIES LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "BERN",
    "clearingBroker": "0013",
    "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "BERS",
    "clearingBroker": "0235",
    "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "BEST",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "BFEC",
    "clearingBroker": "0443",
    "brokerName": "BENJAMIN F. EDWARDS & COMPANY                                         "
  },
  {
    "type": "CORP",
    "mpid": "BFEW",
    "clearingBroker": "0443",
    "brokerName": "BILL FEW ASSOCIATES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "BFFI",
    "clearingBroker": "0226",
    "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
  },
  {
    "type": "CORP",
    "mpid": "BFSL",
    "clearingBroker": "0235",
    "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "BGCE",
    "clearingBroker": "0161",
    "brokerName": "BGC FINANCIAL INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "BGCF",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL, L.P.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "BGCX",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "BGHT",
    "clearingBroker": "0141",
    "brokerName": "BRIGHTON SECURITIES CORP.                                             "
  },
  {
    "type": "CORP",
    "mpid": "BGIS",
    "clearingBroker": "0443",
    "brokerName": "BLACKROCK EXECUTION SERVICES                                          "
  },
  {
    "type": "CORP",
    "mpid": "BGMI",
    "clearingBroker": "0158",
    "brokerName": "BRICKELL GLOBAL MARKETS, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "BGSG",
    "clearingBroker": "0226",
    "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "BGVS",
    "clearingBroker": "0443",
    "brokerName": "BGV SECURITIES                                                        "
  },
  {
    "type": "CORP",
    "mpid": "BHII",
    "clearingBroker": "0443",
    "brokerName": "BELLE HAVEN INVESTMENTS, LP                                           "
  },
  {
    "type": "CORP",
    "mpid": "BHKS",
    "clearingBroker": "0141",
    "brokerName": "BHK SECURITIES, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "BIFS",
    "clearingBroker": "0443",
    "brokerName": "BROKERS INTERNATIONAL FINANCIAL SERVICES, LLC                         "
  },
  {
    "type": "CORP",
    "mpid": "BIGG",
    "clearingBroker": "0005",
    "brokerName": "BROWNSTONE INVESTMENT GROUP                                           "
  },
  {
    "type": "CORP",
    "mpid": "BIGP",
    "clearingBroker": "0443",
    "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "BIMI",
    "clearingBroker": "0136",
    "brokerName": "INTESA SANPAOLO IMI SECURITIES CORP.                                  "
  },
  {
    "type": "CORP",
    "mpid": "BISI",
    "clearingBroker": "0443",
    "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
  },
  {
    "type": "CORP",
    "mpid": "BJCM",
    "clearingBroker": "0235",
    "brokerName": "ESSEX SECURITIES LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "BJRC",
    "clearingBroker": "0235",
    "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "BKCM",
    "clearingBroker": "0443",
    "brokerName": "BNY CAPITAL MARKETS INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "BKES",
    "clearingBroker": "0443",
    "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "BKRT",
    "clearingBroker": "0235",
    "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "BLEY",
    "clearingBroker": "0443",
    "brokerName": "BLEY INVESTMENT GROUP, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "BLNI",
    "clearingBroker": "0226",
    "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "BLOC",
    "clearingBroker": "0158",
    "brokerName": "TRADING BLOCK                                                         "
  },
  {
    "type": "CORP",
    "mpid": "BLTK",
    "clearingBroker": "0443",
    "brokerName": "BULLTICK, LLC                                                         "
  },
  {
    "type": "CORP",
    "mpid": "BMKS",
    "clearingBroker": "0443",
    "brokerName": "BENCHMARK SECURITIES, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "BMSA",
    "clearingBroker": "0443",
    "brokerName": "MARIVA CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "BMSI",
    "clearingBroker": "0750",
    "brokerName": "BULL MARKET SECURITIES, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "BMUR",
    "clearingBroker": "0443",
    "brokerName": "BREAN CAPITAL, LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "BNBB",
    "clearingBroker": "0750",
    "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "BNCH",
    "clearingBroker": "0235",
    "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "BNDI",
    "clearingBroker": "0443",
    "brokerName": "BERNARDI SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "BNDS",
    "clearingBroker": "0226",
    "brokerName": "MTS MARKETS INTERNATIONAL, INC                                        "
  },
  {
    "type": "CORP",
    "mpid": "BNJM",
    "clearingBroker": "0235",
    "brokerName": "BENJAMIN SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "BNPS",
    "clearingBroker": "2154",
    "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
  },
  {
    "type": "CORP",
    "mpid": "BNPX",
    "clearingBroker": "2154",
    "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
  },
  {
    "type": "CORP",
    "mpid": "BNTE",
    "clearingBroker": "0158",
    "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
  },
  {
    "type": "CORP",
    "mpid": "BNYM",
    "clearingBroker": "8355",
    "brokerName": "BNYM/UIT NSCC CNS CLEARANCE                                           "
  },
  {
    "type": "CORP",
    "mpid": "BNYN",
    "clearingBroker": "0226",
    "brokerName": "BANYAN SECURITIES, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "BOFA",
    "clearingBroker": "0773",
    "brokerName": "BOFA SECURITIES, INC./FIXED INCOME                                    "
  },
  {
    "type": "CORP",
    "mpid": "BOKI",
    "clearingBroker": "0443",
    "brokerName": "BOSC, INC.                                                            "
  },
  {
    "type": "CORP",
    "mpid": "BOLL",
    "clearingBroker": "0279",
    "brokerName": "BODELL OVERCASH ANDERSON & CO.                                        "
  },
  {
    "type": "CORP",
    "mpid": "BOSE",
    "clearingBroker": "0443",
    "brokerName": "BOE SECURITIES INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "BOSS",
    "clearingBroker": "0158",
    "brokerName": "ALL TIME ATS                                                          "
  },
  {
    "type": "CORP",
    "mpid": "BOTS",
    "clearingBroker": "0052",
    "brokerName": "C A BOTZUM & CO                                                       "
  },
  {
    "type": "CORP",
    "mpid": "BPWP",
    "clearingBroker": "0226",
    "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "BRAD",
    "clearingBroker": "0443",
    "brokerName": "BERNARD HEROLD & CO                                                   "
  },
  {
    "type": "CORP",
    "mpid": "BRAZ",
    "clearingBroker": "0279",
    "brokerName": "BRAZOS SECURITIES INC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "BRBR",
    "clearingBroker": "0279",
    "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "BRCY",
    "clearingBroker": "0443",
    "brokerName": "BCP SECURITIES, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "BRGE",
    "clearingBroker": "0052",
    "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
  },
  {
    "type": "CORP",
    "mpid": "BRLI",
    "clearingBroker": "0226",
    "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "BRNK",
    "clearingBroker": "0226",
    "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "BROC",
    "clearingBroker": "0443",
    "brokerName": "PAVILION GLOBAL MARKETS LTD                                           "
  },
  {
    "type": "CORP",
    "mpid": "BRRR",
    "clearingBroker": "8199",
    "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "BRSA",
    "clearingBroker": "0103",
    "brokerName": "BOURSA INVESTMENT                                                     "
  },
  {
    "type": "CORP",
    "mpid": "BRSE",
    "clearingBroker": "0226",
    "brokerName": "BRADESCO SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "BRVL",
    "clearingBroker": "0443",
    "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "BRWM",
    "clearingBroker": "0226",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "CORP",
    "mpid": "BSCM",
    "clearingBroker": "0052",
    "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "BSPI",
    "clearingBroker": "0235",
    "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "BTCK",
    "clearingBroker": "0158",
    "brokerName": "BULLTICK, LLC                                                         "
  },
  {
    "type": "CORP",
    "mpid": "BTDG",
    "clearingBroker": "0161",
    "brokerName": "BIDS TRADING LP                                                       "
  },
  {
    "type": "CORP",
    "mpid": "BTIM",
    "clearingBroker": "1043",
    "brokerName": "BTIG, LLC                                                             "
  },
  {
    "type": "CORP",
    "mpid": "BTIS",
    "clearingBroker": "0443",
    "brokerName": "BTIG, LLC                                                             "
  },
  {
    "type": "CORP",
    "mpid": "BTSS",
    "clearingBroker": "0279",
    "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
  },
  {
    "type": "CORP",
    "mpid": "BURK",
    "clearingBroker": "0141",
    "brokerName": "BURKE, LAWTON, BREWER & BURKE                                         "
  },
  {
    "type": "CORP",
    "mpid": "BURT",
    "clearingBroker": "0725",
    "brokerName": "HARBOR FINANCIAL SERVICES, L.L.C.                                     "
  },
  {
    "type": "CORP",
    "mpid": "BWNA",
    "clearingBroker": "0235",
    "brokerName": "BROWN ASSOCIATES INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "BYAI",
    "clearingBroker": "0226",
    "brokerName": "BRECEK & YOUNG                                                        "
  },
  {
    "type": "CORP",
    "mpid": "BZCP",
    "clearingBroker": "0443",
    "brokerName": "BALANZ CAPITAL USA LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "BZTN",
    "clearingBroker": "0141",
    "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
  },
  {
    "type": "CORP",
    "mpid": "BZWV",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "BZYD",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "BZYF",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "CABA",
    "clearingBroker": "0443",
    "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "CABR",
    "clearingBroker": "0161",
    "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "CADG",
    "clearingBroker": "0005",
    "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "CADZ",
    "clearingBroker": "0279",
    "brokerName": "CADZ SECURITIES INC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "CAFS",
    "clearingBroker": "0158",
    "brokerName": "COMMUNITYAMERICA FINANCIAL SOLUTIONS, LLC                             "
  },
  {
    "type": "CORP",
    "mpid": "CAGI",
    "clearingBroker": "0279",
    "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "CAIX",
    "clearingBroker": "0235",
    "brokerName": "CAIS CAPITAL LLC                                                      "
  },
  {
    "type": "CORP",
    "mpid": "CALD",
    "clearingBroker": "0103",
    "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "CALT",
    "clearingBroker": "0279",
    "brokerName": "CALTON & ASSOCIATES                                                   "
  },
  {
    "type": "CORP",
    "mpid": "CAMS",
    "clearingBroker": "0443",
    "brokerName": "COMPREHENSIVE ASSET MANAGEMENT AND SERVICING, INC.                    "
  },
  {
    "type": "CORP",
    "mpid": "CANA",
    "clearingBroker": "0443",
    "brokerName": "CANACCORD GENUITY INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "CANT",
    "clearingBroker": "0696",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "CORP",
    "mpid": "CAPC",
    "clearingBroker": "0235",
    "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "CAPE",
    "clearingBroker": "0279",
    "brokerName": "CAPE SECURITIES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "CAPF",
    "clearingBroker": "0443",
    "brokerName": "CAPITAL FINANCIAL SERVICES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "CAPP",
    "clearingBroker": "0443",
    "brokerName": "CAPTRUST FINANCIAL ADVISORS                                           "
  },
  {
    "type": "CORP",
    "mpid": "CARG",
    "clearingBroker": "0141",
    "brokerName": "CARTHAGE GROUP INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "CART",
    "clearingBroker": "0443",
    "brokerName": "CARTY & COMPANY, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "CARY",
    "clearingBroker": "0141",
    "brokerName": "CARY STREET PARTNERS                                                  "
  },
  {
    "type": "CORP",
    "mpid": "CASH",
    "clearingBroker": "0158",
    "brokerName": "PLANNER SECURITIES LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "CATE",
    "clearingBroker": "0235",
    "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "CAVU",
    "clearingBroker": "0443",
    "brokerName": "CAVU SECURITIES LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "CBEV",
    "clearingBroker": "0226",
    "brokerName": "CITY NATIONAL BANK, BEVERLY HILLS, CALIFORNIA                         "
  },
  {
    "type": "CORP",
    "mpid": "CBII",
    "clearingBroker": "0443",
    "brokerName": "WESBANCO SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "CBIN",
    "clearingBroker": "0443",
    "brokerName": "COMPASS BROKERAGE, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "CBOL",
    "clearingBroker": "0226",
    "brokerName": "MUTUAL SECURITIES, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "CBSE",
    "clearingBroker": "1043",
    "brokerName": "CAMBRIDGE INTERNATIONAL SECURITIES, LLC                               "
  },
  {
    "type": "CORP",
    "mpid": "CBTD",
    "clearingBroker": "0226",
    "brokerName": "SYNOVOUS SECURITIES INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "CCCO",
    "clearingBroker": "0226",
    "brokerName": "CARNES CAPITAL CORPORATION                                            "
  },
  {
    "type": "CORP",
    "mpid": "CCIG",
    "clearingBroker": "0235",
    "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
  },
  {
    "type": "CORP",
    "mpid": "CCMB",
    "clearingBroker": "0443",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "CCMC",
    "clearingBroker": "0443",
    "brokerName": "COMMERZEBANK CAPITAL CORP.                                            "
  },
  {
    "type": "CORP",
    "mpid": "CCMI",
    "clearingBroker": "0443",
    "brokerName": "JMP SECURITIES LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "CCMM",
    "clearingBroker": "0235",
    "brokerName": "CRAFT CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "CCPM",
    "clearingBroker": "0595",
    "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "CCRD",
    "clearingBroker": "0443",
    "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "CCSS",
    "clearingBroker": "0443",
    "brokerName": "CROWN CAPITAL SECURITIES, L.P.                                        "
  },
  {
    "type": "CORP",
    "mpid": "CDFS",
    "clearingBroker": "0052",
    "brokerName": "NAVIAN CAPITAL SECURITIES, LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "CDGO",
    "clearingBroker": "0551",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "CERS",
    "clearingBroker": "0226",
    "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "CFCO",
    "clearingBroker": "7311",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "CORP",
    "mpid": "CFCS",
    "clearingBroker": "0005",
    "brokerName": "CANTOR FITZGERALD & CO                                                "
  },
  {
    "type": "CORP",
    "mpid": "CFGM",
    "clearingBroker": "0235",
    "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "CFGT",
    "clearingBroker": "0235",
    "brokerName": "CF GLOBAL TRADING, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "CFII",
    "clearingBroker": "0235",
    "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
  },
  {
    "type": "CORP",
    "mpid": "CFIN",
    "clearingBroker": "0279",
    "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
  },
  {
    "type": "CORP",
    "mpid": "CFSC",
    "clearingBroker": "0443",
    "brokerName": "INSIGNEO SECURITIES LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "CFSI",
    "clearingBroker": "0052",
    "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "CFSX",
    "clearingBroker": "0794",
    "brokerName": "CF SECURED, LLC                                                       "
  },
  {
    "type": "CORP",
    "mpid": "CGAM",
    "clearingBroker": "0443",
    "brokerName": "CGIS SECURITIES LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "CGAT",
    "clearingBroker": "0443",
    "brokerName": "CADARET, GRANT & CO., INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "CGCO",
    "clearingBroker": "0443",
    "brokerName": "CG COMPASS (USA) LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "CGLN",
    "clearingBroker": "0103",
    "brokerName": "COUGHLIN & CO                                                         "
  },
  {
    "type": "CORP",
    "mpid": "CGMI",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "CGWM",
    "clearingBroker": "0443",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "CHAS",
    "clearingBroker": "0164",
    "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "CHBC",
    "clearingBroker": "0235",
    "brokerName": "PENSERRA SECURITIES, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "CHCH",
    "clearingBroker": "0226",
    "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "CHCK",
    "clearingBroker": "0226",
    "brokerName": "CHICKASAW SECURITIES, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "CHDA",
    "clearingBroker": "0141",
    "brokerName": "CHAPIN, DAVIS                                                         "
  },
  {
    "type": "CORP",
    "mpid": "CHHS",
    "clearingBroker": "0141",
    "brokerName": "CHESTER HARRIS & CO., INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "CHLC",
    "clearingBroker": "0443",
    "brokerName": "CHURCHILL CAPITAL USA, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "CHPP",
    "clearingBroker": "0624",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "CHRS",
    "clearingBroker": "0750",
    "brokerName": "ROYAL TREASURE SECURITIES LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "CHSI",
    "clearingBroker": "0187",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "CHUB",
    "clearingBroker": "0226",
    "brokerName": "OSAIC FS, INC.                                                        "
  },
  {
    "type": "CORP",
    "mpid": "CICC",
    "clearingBroker": "0443",
    "brokerName": "CICC US SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "CICI",
    "clearingBroker": "0443",
    "brokerName": "COMMERCE BANK INVESTMENT SERVICES, INC.                               "
  },
  {
    "type": "CORP",
    "mpid": "CICL",
    "clearingBroker": "0141",
    "brokerName": "CAROLINAS INVESTMENT CONSULTING                                       "
  },
  {
    "type": "CORP",
    "mpid": "CIIV",
    "clearingBroker": "0052",
    "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "CIMB",
    "clearingBroker": "0005",
    "brokerName": "CIMB SECURITIES (USA), INC                                            "
  },
  {
    "type": "CORP",
    "mpid": "CIRI",
    "clearingBroker": "0443",
    "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
  },
  {
    "type": "CORP",
    "mpid": "CIST",
    "clearingBroker": "0161",
    "brokerName": "CAPITAL INSTITUTIONAL SERVICES, INC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "CISV",
    "clearingBroker": "0226",
    "brokerName": "CITIZENS SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "CJSC",
    "clearingBroker": "0443",
    "brokerName": "CJS SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "CLDN",
    "clearingBroker": "0235",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "CLRK",
    "clearingBroker": "0235",
    "brokerName": "CLARK DODGE & CO, INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "CLRT",
    "clearingBroker": "1043",
    "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "CLSA",
    "clearingBroker": "0161",
    "brokerName": "CLSA AMERICAS, LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "CLSC",
    "clearingBroker": "0235",
    "brokerName": "CABOT LODGE SECURITIES LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "CLSS",
    "clearingBroker": "0235",
    "brokerName": "CABOT LODGE SECURITIES LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "CLTN",
    "clearingBroker": "0226",
    "brokerName": "CALTON & ASSOCIATES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "CMCE",
    "clearingBroker": "0226",
    "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
  },
  {
    "type": "CORP",
    "mpid": "CMCX",
    "clearingBroker": "0624",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
  },
  {
    "type": "CORP",
    "mpid": "CMFS",
    "clearingBroker": "0443",
    "brokerName": "BNY MELLON CAP MKTS                                                   "
  },
  {
    "type": "CORP",
    "mpid": "CMGF",
    "clearingBroker": "0443",
    "brokerName": "CMG SECURITIES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "CMMW",
    "clearingBroker": "0226",
    "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
  },
  {
    "type": "CORP",
    "mpid": "CMPT",
    "clearingBroker": "0750",
    "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
  },
  {
    "type": "CORP",
    "mpid": "CMSI",
    "clearingBroker": "0279",
    "brokerName": "CAPITAL MANAGEMENT SECURITIES, INC.                                   "
  },
  {
    "type": "CORP",
    "mpid": "CNCD",
    "clearingBroker": "0235",
    "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "CNFI",
    "clearingBroker": "0443",
    "brokerName": "CENTAURUS FINANCIAL INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "CNFR",
    "clearingBroker": "0443",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "CNSI",
    "clearingBroker": "0226",
    "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "CNTR",
    "clearingBroker": "0103",
    "brokerName": "PRECISION SECURITIES                                                  "
  },
  {
    "type": "CORP",
    "mpid": "COAK",
    "clearingBroker": "0443",
    "brokerName": "CASTLE OAK SECURITIES, L.P.                                           "
  },
  {
    "type": "CORP",
    "mpid": "COAS",
    "clearingBroker": "0443",
    "brokerName": "REALTA EQUITIES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "CODA",
    "clearingBroker": "0161",
    "brokerName": "CODA MARKETS, INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "COEI",
    "clearingBroker": "0052",
    "brokerName": "COASTAL EQUITIES, INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "COEX",
    "clearingBroker": "0161",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "COFS",
    "clearingBroker": "0279",
    "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
  },
  {
    "type": "CORP",
    "mpid": "COHN",
    "clearingBroker": "0235",
    "brokerName": "COHEN BROS. & COMPANY                                                 "
  },
  {
    "type": "CORP",
    "mpid": "COKE",
    "clearingBroker": "0235",
    "brokerName": "COKER & PALMER, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "COLS",
    "clearingBroker": "0279",
    "brokerName": "COLONIAL SECURITIES INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "COMP",
    "clearingBroker": "0595",
    "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
  },
  {
    "type": "CORP",
    "mpid": "CONI",
    "clearingBroker": "0235",
    "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "CONR",
    "clearingBroker": "0235",
    "brokerName": "CONNERS & CO., INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "CONS",
    "clearingBroker": "0141",
    "brokerName": "CONSULTIVA SECURITIES, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "COOR",
    "clearingBroker": "0141",
    "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "COSL",
    "clearingBroker": "0443",
    "brokerName": "CLIENT ONE SECURITIES, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "COWN",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "COWP",
    "clearingBroker": "0226",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "COWR",
    "clearingBroker": "0443",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "COWX",
    "clearingBroker": "0161",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "COYL",
    "clearingBroker": "0235",
    "brokerName": "COYLE SECURITIES LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "CPGL",
    "clearingBroker": "0226",
    "brokerName": "CONTINUITY PARTNERS GROUP, LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "CPLC",
    "clearingBroker": "0595",
    "brokerName": "COVA CAPITAL PARTNERS LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "CPRC",
    "clearingBroker": "0235",
    "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
  },
  {
    "type": "CORP",
    "mpid": "CPRM",
    "clearingBroker": "8199",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "CRCM",
    "clearingBroker": "0235",
    "brokerName": "COHNREZNICK CAPITAL                                                   "
  },
  {
    "type": "CORP",
    "mpid": "CRDL",
    "clearingBroker": "0235",
    "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "CRED",
    "clearingBroker": "0443",
    "brokerName": "CREDICORP CAPITAL LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "CREF",
    "clearingBroker": "0443",
    "brokerName": "TIAA-CREF INDIVIDUAL AND INSTITUTIONAL SERVICES, LLC                  "
  },
  {
    "type": "CORP",
    "mpid": "CREW",
    "clearingBroker": "0443",
    "brokerName": "CREWS & ASSOCIATES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "CRFN",
    "clearingBroker": "6769",
    "brokerName": "ROBINHOOD FINANCIAL, LLC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "CRII",
    "clearingBroker": "0443",
    "brokerName": "CRI SECURITIES INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "CRNJ",
    "clearingBroker": "0103",
    "brokerName": "CANTONE RESEARCH                                                      "
  },
  {
    "type": "CORP",
    "mpid": "CRON",
    "clearingBroker": "0443",
    "brokerName": "CRONIN & CO., INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "CRPT",
    "clearingBroker": "0235",
    "brokerName": "CROSS POINT CAPITAL LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "CRTH",
    "clearingBroker": "0443",
    "brokerName": "CORINTHIAN PARTNERS, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "CRYN",
    "clearingBroker": "0235",
    "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
  },
  {
    "type": "CORP",
    "mpid": "CSAI",
    "clearingBroker": "0793",
    "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "CSAP",
    "clearingBroker": "0141",
    "brokerName": "CRESAP, INC.                                                          "
  },
  {
    "type": "CORP",
    "mpid": "CSCA",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "CORP",
    "mpid": "CSCM",
    "clearingBroker": "0279",
    "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
  },
  {
    "type": "CORP",
    "mpid": "CSPA",
    "clearingBroker": "0226",
    "brokerName": "CREDIT SUISSE PRIVATE ADVISORS                                        "
  },
  {
    "type": "CORP",
    "mpid": "CSPD",
    "clearingBroker": "0197",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "CORP",
    "mpid": "CSPI",
    "clearingBroker": "0235",
    "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
  },
  {
    "type": "CORP",
    "mpid": "CSTI",
    "clearingBroker": "0161",
    "brokerName": "CANACCORD GENUITY INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "CTAS",
    "clearingBroker": "0443",
    "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "CTBK",
    "clearingBroker": "4270",
    "brokerName": "CENTRAL TRUST BANK                                                    "
  },
  {
    "type": "CORP",
    "mpid": "CTDL",
    "clearingBroker": "0551",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "CTDN",
    "clearingBroker": "0352",
    "brokerName": "CITADEL SECURITIES LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "CTNL",
    "clearingBroker": "0235",
    "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "CTSC",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "CORP",
    "mpid": "CUFT",
    "clearingBroker": "0226",
    "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "CUGS",
    "clearingBroker": "8199",
    "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "CULL",
    "clearingBroker": "0725",
    "brokerName": "CULLEN INVESTMENT GROUP, LTD.                                         "
  },
  {
    "type": "CORP",
    "mpid": "CUSO",
    "clearingBroker": "0443",
    "brokerName": "CUSO FINANCIAL SERVICES, L.P.                                         "
  },
  {
    "type": "CORP",
    "mpid": "CUTW",
    "clearingBroker": "0235",
    "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "CUWB",
    "clearingBroker": "0103",
    "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "CVGP",
    "clearingBroker": "0443",
    "brokerName": "COWEN AND COMPANY LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "CWEI",
    "clearingBroker": "0443",
    "brokerName": "BEECH HILL SECURITIES, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "CWMK",
    "clearingBroker": "0438",
    "brokerName": "CIBC WORLD MARKETS CORP.                                              "
  },
  {
    "type": "CORP",
    "mpid": "CYND",
    "clearingBroker": "0443",
    "brokerName": "TIGRESS FINANCIAL PARTNERS LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "DADA",
    "clearingBroker": "0361",
    "brokerName": "D. A. DAVIDSON & CO.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "DAII",
    "clearingBroker": "0235",
    "brokerName": "ALEXANDER (DON) INVESTMENTS, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "DAIN",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "DAIS",
    "clearingBroker": "0052",
    "brokerName": "DAI SECURITIES, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "DARA",
    "clearingBroker": "0235",
    "brokerName": "DARWOOD ASSOCIATES, INC                                               "
  },
  {
    "type": "CORP",
    "mpid": "DART",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "DASH",
    "clearingBroker": "0161",
    "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "DAVA",
    "clearingBroker": "0443",
    "brokerName": "DAVENPORT & COMPANY LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "DAWA",
    "clearingBroker": "0647",
    "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "DBCC",
    "clearingBroker": "0235",
    "brokerName": "D. BORAL CAPITAL                                                      "
  },
  {
    "type": "CORP",
    "mpid": "DBCH",
    "clearingBroker": "0052",
    "brokerName": "D. BORAL CAPITAL                                                      "
  },
  {
    "type": "CORP",
    "mpid": "DBKS",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "DBPC",
    "clearingBroker": "0443",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "DCAN",
    "clearingBroker": "0279",
    "brokerName": "R. M. DUNCAN SECURITIES, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "DCSD",
    "clearingBroker": "0235",
    "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
  },
  {
    "type": "CORP",
    "mpid": "DCVL",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "DEAN",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "DEGS",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "DENI",
    "clearingBroker": "0279",
    "brokerName": "H.C. DENISON CO.                                                      "
  },
  {
    "type": "CORP",
    "mpid": "DETF",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "DFIN",
    "clearingBroker": "0161",
    "brokerName": "DASH FINANCIAL LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "DFPG",
    "clearingBroker": "0235",
    "brokerName": "DFPG INVESTMENTS, INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "DIGG",
    "clearingBroker": "0595",
    "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "DINO",
    "clearingBroker": "0103",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "CORP",
    "mpid": "DJSA",
    "clearingBroker": "0750",
    "brokerName": "DAWSON JAMES SECURITIES, INC                                          "
  },
  {
    "type": "CORP",
    "mpid": "DLAI",
    "clearingBroker": "0235",
    "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "DLPS",
    "clearingBroker": "0595",
    "brokerName": "DLP SECURITIES,.LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "DLSI",
    "clearingBroker": "0226",
    "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "DMCD",
    "clearingBroker": "0279",
    "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
  },
  {
    "type": "CORP",
    "mpid": "DMKC",
    "clearingBroker": "0141",
    "brokerName": "D.M. KELLY & COMPANY                                                  "
  },
  {
    "type": "CORP",
    "mpid": "DNOR",
    "clearingBroker": "0005",
    "brokerName": "DNB MARKETS, INC.                                                     "
  },
  {
    "type": "CORP",
    "mpid": "DNSR",
    "clearingBroker": "0158",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "CORP",
    "mpid": "DNWL",
    "clearingBroker": "0443",
    "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "DOFT",
    "clearingBroker": "0443",
    "brokerName": "DOFT & CO., INC.                                                      "
  },
  {
    "type": "CORP",
    "mpid": "DOMI",
    "clearingBroker": "0279",
    "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "DOMS",
    "clearingBroker": "0235",
    "brokerName": "DOMINARI SECURITIES LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "DORN",
    "clearingBroker": "0235",
    "brokerName": "DORN & CO., INC.                                                      "
  },
  {
    "type": "CORP",
    "mpid": "DOTC",
    "clearingBroker": "0226",
    "brokerName": "COLLIERS SECURITIES LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "DOVE",
    "clearingBroker": "0226",
    "brokerName": "SECURITIES EQUITY GROUP                                               "
  },
  {
    "type": "CORP",
    "mpid": "DOWL",
    "clearingBroker": "0443",
    "brokerName": "DOWLING & PARTNERS SECURITIES LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "DREX",
    "clearingBroker": "0443",
    "brokerName": "DREXEL HAMILTON, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "DRSC",
    "clearingBroker": "0443",
    "brokerName": "BNY MELLON SECURITIES CORPORATION                                     "
  },
  {
    "type": "CORP",
    "mpid": "DRTG",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "DRTR",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "DRVW",
    "clearingBroker": "0235",
    "brokerName": "DRIVEWEALTH, LLC                                                      "
  },
  {
    "type": "CORP",
    "mpid": "DRWM",
    "clearingBroker": "0005",
    "brokerName": "DRW SECURITIES, L.L.C.                                                "
  },
  {
    "type": "CORP",
    "mpid": "DSAI",
    "clearingBroker": "0443",
    "brokerName": "DAEWOO SECURITIES (AMERICA) INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "DSGG",
    "clearingBroker": "0226",
    "brokerName": "DMG SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "DTEX",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
  },
  {
    "type": "CORP",
    "mpid": "DUST",
    "clearingBroker": "0161",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "CORP",
    "mpid": "DVES",
    "clearingBroker": "0005",
    "brokerName": "DV EQUITIES                                                           "
  },
  {
    "type": "CORP",
    "mpid": "DWIZ",
    "clearingBroker": "0235",
    "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "EAMC",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
  },
  {
    "type": "CORP",
    "mpid": "EAMG",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
  },
  {
    "type": "CORP",
    "mpid": "EBKD",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL, L.P.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "EBKR",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "EBRD",
    "clearingBroker": "0103",
    "brokerName": "EARLYBIRD CAPITAL, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "ECCC",
    "clearingBroker": "0226",
    "brokerName": "EAGLES COAST CAPITAL, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "EDFC",
    "clearingBroker": "0443",
    "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "EDFO",
    "clearingBroker": "0158",
    "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "EDIR",
    "clearingBroker": "0235",
    "brokerName": "EDI FINANCIAL, INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "EDJO",
    "clearingBroker": "0057",
    "brokerName": "EDWARD D. JONES & CO.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "EFGC",
    "clearingBroker": "0443",
    "brokerName": "EFG CAPITAL INTERNATIONAL                                             "
  },
  {
    "type": "CORP",
    "mpid": "EFSP",
    "clearingBroker": "0443",
    "brokerName": "ESSEX FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "EGLE",
    "clearingBroker": "1043",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "CORP",
    "mpid": "EGMT",
    "clearingBroker": "0005",
    "brokerName": "EG MARKET TECHNOLOGIES LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "ELEQ",
    "clearingBroker": "0551",
    "brokerName": "ELEQUIN SECURITIES LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "ELET",
    "clearingBroker": "0388",
    "brokerName": "ELECTRONIFIE SECURITIES LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "ELEV",
    "clearingBroker": "0235",
    "brokerName": "ELEVATION, LLC                                                        "
  },
  {
    "type": "CORP",
    "mpid": "ELQN",
    "clearingBroker": "0443",
    "brokerName": "ELEQUIN SECURITIES LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "EMER",
    "clearingBroker": "0443",
    "brokerName": "EMERSON EQUITY LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "EMOC",
    "clearingBroker": "0750",
    "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "EMPR",
    "clearingBroker": "0279",
    "brokerName": "SELKIRK INVESTMENTS, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "EMRP",
    "clearingBroker": "0161",
    "brokerName": "EMPIRICAL RESEARCH PARTNERS LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "ENTR",
    "clearingBroker": "0235",
    "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "EPIC",
    "clearingBroker": "0443",
    "brokerName": "EPIC CAPITAL SECURITIES                                               "
  },
  {
    "type": "CORP",
    "mpid": "EQHA",
    "clearingBroker": "0075",
    "brokerName": "EQUITABLE ADVISORS, LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "EQSV",
    "clearingBroker": "0226",
    "brokerName": "EQUITY SERVICES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "EROP",
    "clearingBroker": "0158",
    "brokerName": "EROOM SECURITIES LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "ESBD",
    "clearingBroker": "0235",
    "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "ESHC",
    "clearingBroker": "0443",
    "brokerName": "FIRST SOUTHERN, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "ETCB",
    "clearingBroker": "3505",
    "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "ETCL",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "ETRF",
    "clearingBroker": "0161",
    "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "ETRS",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "EUBR",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "EVOL",
    "clearingBroker": "0226",
    "brokerName": "EVOLVE SECURITIES, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "EWMX",
    "clearingBroker": "0279",
    "brokerName": "EAST WEST MARKETS, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "EXCS",
    "clearingBroker": "0443",
    "brokerName": "EXCEL SECURITIES AND ASSOCIATES, INC.                                 "
  },
  {
    "type": "CORP",
    "mpid": "FAFI",
    "clearingBroker": "0279",
    "brokerName": "FIRST ASSET FINANCIAL                                                 "
  },
  {
    "type": "CORP",
    "mpid": "FALC",
    "clearingBroker": "0103",
    "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "FALL",
    "clearingBroker": "0725",
    "brokerName": "FALLLINE SECURITIES LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "FANC",
    "clearingBroker": "0235",
    "brokerName": "FINANCE 500, INC.                                                     "
  },
  {
    "type": "CORP",
    "mpid": "FARA",
    "clearingBroker": "8199",
    "brokerName": "FARINA & ASSOCIATES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "FATS",
    "clearingBroker": "0443",
    "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "FBLM",
    "clearingBroker": "0235",
    "brokerName": "FBL MARKETING SERVICES LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "FBLT",
    "clearingBroker": "8199",
    "brokerName": "FIRST BALLANTYNE, LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "FBNS",
    "clearingBroker": "0235",
    "brokerName": "FBN SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "FBPC",
    "clearingBroker": "0443",
    "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
  },
  {
    "type": "CORP",
    "mpid": "FBSB",
    "clearingBroker": "0280",
    "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "FCFP",
    "clearingBroker": "0141",
    "brokerName": "FIRST CITIZENS FINANCIAL PLUS, INC.                                   "
  },
  {
    "type": "CORP",
    "mpid": "FCFS",
    "clearingBroker": "0443",
    "brokerName": "FIRST COMMAND FINANCIAL PLANNING, INC.                                "
  },
  {
    "type": "CORP",
    "mpid": "FCGB",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL, L.P.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "FCIT",
    "clearingBroker": "0443",
    "brokerName": "FIRST CITIZENS INVESTOR SERVICES, INC.                                "
  },
  {
    "type": "CORP",
    "mpid": "FCML",
    "clearingBroker": "0279",
    "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "FCMP",
    "clearingBroker": "0595",
    "brokerName": "PRIME EXECUTIONS, INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "FCST",
    "clearingBroker": "0443",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "FDSC",
    "clearingBroker": "0158",
    "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "FDSI",
    "clearingBroker": "0141",
    "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "FEDR",
    "clearingBroker": "0235",
    "brokerName": "FEDERATED SECURITIES INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "FENX",
    "clearingBroker": "0595",
    "brokerName": "FENIX SECURITIES, LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "FERN",
    "clearingBroker": "0443",
    "brokerName": "FEARNLEY SECURITIES                                                   "
  },
  {
    "type": "CORP",
    "mpid": "FFCM",
    "clearingBroker": "0235",
    "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "FFGI",
    "clearingBroker": "0235",
    "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "FFSI",
    "clearingBroker": "0158",
    "brokerName": "FIRSTRADE SECURITIES INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "FHCI",
    "clearingBroker": "0443",
    "brokerName": "FIRST HEARTLAND CAPITAL, INC                                          "
  },
  {
    "type": "CORP",
    "mpid": "FHON",
    "clearingBroker": "0235",
    "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "FIBS",
    "clearingBroker": "0226",
    "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "FISA",
    "clearingBroker": "0443",
    "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "FISB",
    "clearingBroker": "0226",
    "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "FISH",
    "clearingBroker": "0235",
    "brokerName": "L.B. FISHER & COMPANY                                                 "
  },
  {
    "type": "CORP",
    "mpid": "FJRF",
    "clearingBroker": "0052",
    "brokerName": "PARITER SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "FKSC",
    "clearingBroker": "0235",
    "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
  },
  {
    "type": "CORP",
    "mpid": "FLAT",
    "clearingBroker": "0226",
    "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
  },
  {
    "type": "CORP",
    "mpid": "FLCO",
    "clearingBroker": "0750",
    "brokerName": "THE FRAZER LANIER COMPANY, INCORPORATED                               "
  },
  {
    "type": "CORP",
    "mpid": "FLEX",
    "clearingBroker": "0158",
    "brokerName": "GWM GROUP, INC.                                                       "
  },
  {
    "type": "CORP",
    "mpid": "FLIB",
    "clearingBroker": "0235",
    "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
  },
  {
    "type": "CORP",
    "mpid": "FLIO",
    "clearingBroker": "0750",
    "brokerName": "SANTOS CAPITAL GROUP, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "FLOU",
    "clearingBroker": "0443",
    "brokerName": "FIRST ST. LOUIS SECURITIES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "FLTG",
    "clearingBroker": "0005",
    "brokerName": "FLOW TRADERS U.S. LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "FLTL",
    "clearingBroker": "0235",
    "brokerName": "FELTL & COMPANY                                                       "
  },
  {
    "type": "CORP",
    "mpid": "FLTU",
    "clearingBroker": "0551",
    "brokerName": "FLOW TRADERS US LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "FLWT",
    "clearingBroker": "0161",
    "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
  },
  {
    "type": "CORP",
    "mpid": "FMAT",
    "clearingBroker": "0608",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "FMCO",
    "clearingBroker": "0443",
    "brokerName": "FIRST MANHATTAN CO.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "FMEX",
    "clearingBroker": "0750",
    "brokerName": "FINAMEX INTERNATIONAL, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "FMFS",
    "clearingBroker": "0226",
    "brokerName": "FISRT MERIT FINANCIAL SERVICES, INC                                   "
  },
  {
    "type": "CORP",
    "mpid": "FMGT",
    "clearingBroker": "0443",
    "brokerName": "FAMILY MANAGEMENT SECURITIES, LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "FNFD",
    "clearingBroker": "0443",
    "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
  },
  {
    "type": "CORP",
    "mpid": "FNIC",
    "clearingBroker": "0443",
    "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
  },
  {
    "type": "CORP",
    "mpid": "FNPN",
    "clearingBroker": "0443",
    "brokerName": "UNIVEST INVESTMENTS                                                   "
  },
  {
    "type": "CORP",
    "mpid": "FNSJ",
    "clearingBroker": "0443",
    "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
  },
  {
    "type": "CORP",
    "mpid": "FNXB",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL, L.P.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "FNXS",
    "clearingBroker": "0750",
    "brokerName": "FENIX SECURITIES, LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "FOGS",
    "clearingBroker": "0235",
    "brokerName": "FOG EQUITIES LLC                                                      "
  },
  {
    "type": "CORP",
    "mpid": "FORI",
    "clearingBroker": "0750",
    "brokerName": "FORTREND SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "FOXC",
    "clearingBroker": "0443",
    "brokerName": "FOX CHASE CAPITAL PARTNERS, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "FRLZ",
    "clearingBroker": "0103",
    "brokerName": "FRIEDMAN LUZZATTO & CO                                                "
  },
  {
    "type": "CORP",
    "mpid": "FRTN",
    "clearingBroker": "0103",
    "brokerName": "FORTUNE SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "FSCS",
    "clearingBroker": "0443",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "FSIX",
    "clearingBroker": "0725",
    "brokerName": "FSIC                                                                  "
  },
  {
    "type": "CORP",
    "mpid": "FSRP",
    "clearingBroker": "0443",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "FTEN",
    "clearingBroker": "0226",
    "brokerName": "FTB ADVISORS, INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "FTLP",
    "clearingBroker": "8244",
    "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
  },
  {
    "type": "CORP",
    "mpid": "FTSC",
    "clearingBroker": "0202",
    "brokerName": "FHN FINANCIAL SECURITIES CORP.                                        "
  },
  {
    "type": "CORP",
    "mpid": "FTSR",
    "clearingBroker": "0226",
    "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "FUBO",
    "clearingBroker": "0443",
    "brokerName": "GRIFFINEST ASIA SECURITIES, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "FWSI",
    "clearingBroker": "0141",
    "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "GABE",
    "clearingBroker": "0141",
    "brokerName": "G. RESEARCH, INC.                                                     "
  },
  {
    "type": "CORP",
    "mpid": "GAFI",
    "clearingBroker": "0235",
    "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "GAGN",
    "clearingBroker": "0226",
    "brokerName": "GAGNON SECURITIES, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "GAII",
    "clearingBroker": "0279",
    "brokerName": "GREAT AMERICAN INVESTORS, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "GARB",
    "clearingBroker": "0148",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
  },
  {
    "type": "CORP",
    "mpid": "GARC",
    "clearingBroker": "0161",
    "brokerName": "ICAP CORPORATES LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "GARE",
    "clearingBroker": "0148",
    "brokerName": "GARE                                                                  "
  },
  {
    "type": "CORP",
    "mpid": "GARR",
    "clearingBroker": "0226",
    "brokerName": "GARRETT NAGLE & CO., INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "GARW",
    "clearingBroker": "0595",
    "brokerName": "GAR WOOD SECURITIES, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "GBMS",
    "clearingBroker": "0158",
    "brokerName": "GBM INTERNATIONAL, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "GBMT",
    "clearingBroker": "0443",
    "brokerName": "GBM INTERNATIONAL, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "GBTS",
    "clearingBroker": "0005",
    "brokerName": "GTS SECURITIES, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "GCMC",
    "clearingBroker": "0443",
    "brokerName": "GLADOWSKY CAPITAL MANAGEMENT CORP.                                    "
  },
  {
    "type": "CORP",
    "mpid": "GDCO",
    "clearingBroker": "0443",
    "brokerName": "GILBERT, DONIGER CO., INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "GELP",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "GENS",
    "clearingBroker": "0279",
    "brokerName": "GENERAL SECURITIES CORP                                               "
  },
  {
    "type": "CORP",
    "mpid": "GENW",
    "clearingBroker": "0443",
    "brokerName": "GENEOS WEALTH MANAGEMENT, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "GFIG",
    "clearingBroker": "0537",
    "brokerName": "GFI SECURITIES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "GFSI",
    "clearingBroker": "0725",
    "brokerName": "GLOBAL FINANCIAL SERVICES, L.L.C.                                     "
  },
  {
    "type": "CORP",
    "mpid": "GGWI",
    "clearingBroker": "0141",
    "brokerName": "GAGE-WILEY & COMPANY INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "GHCC",
    "clearingBroker": "0226",
    "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
  },
  {
    "type": "CORP",
    "mpid": "GILG",
    "clearingBroker": "0226",
    "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "GJSS",
    "clearingBroker": "0235",
    "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "GLCM",
    "clearingBroker": "0443",
    "brokerName": "GREENSLEDGE CAPITAL MARKETS                                           "
  },
  {
    "type": "CORP",
    "mpid": "GLLL",
    "clearingBroker": "0279",
    "brokerName": "GILL CAPITAL PARTNERS                                                 "
  },
  {
    "type": "CORP",
    "mpid": "GLYN",
    "clearingBroker": "0443",
    "brokerName": "GLYNN (J.A.) & CO.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "GMSE",
    "clearingBroker": "0750",
    "brokerName": "GAMMA SECURITIES, LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "GMSG",
    "clearingBroker": "0443",
    "brokerName": "GMS GROUP (THE), L.L.C.                                               "
  },
  {
    "type": "CORP",
    "mpid": "GPCA",
    "clearingBroker": "0158",
    "brokerName": "GREAT POINT CAPITAL LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "GPCG",
    "clearingBroker": "0443",
    "brokerName": "GREENMAN, PARKER, CONNALLY, GREENMAN, INC.                            "
  },
  {
    "type": "CORP",
    "mpid": "GPSS",
    "clearingBroker": "0443",
    "brokerName": "GREAT PACIFIC SECURITIES                                              "
  },
  {
    "type": "CORP",
    "mpid": "GRAD",
    "clearingBroker": "0235",
    "brokerName": "GRADIENT SECURITIES, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "GRBD",
    "clearingBroker": "0052",
    "brokerName": "GREENBIRD CAPITAL LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "GRIL",
    "clearingBroker": "0235",
    "brokerName": "GLOBAL RESOURCE INVESTMENTS, LTD.                                     "
  },
  {
    "type": "CORP",
    "mpid": "GROD",
    "clearingBroker": "0226",
    "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "GRPS",
    "clearingBroker": "0226",
    "brokerName": "MML INVESTORS SERVICES, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "GRWD",
    "clearingBroker": "0052",
    "brokerName": "GAR WOOD SECURITIES, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "GRYG",
    "clearingBroker": "0226",
    "brokerName": "GOLDBERG (GARY) & CO., INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "GSBI",
    "clearingBroker": "0279",
    "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "GSCO",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "GSIL",
    "clearingBroker": "0158",
    "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "GSMM",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "GSQQ",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "GSSC",
    "clearingBroker": "0161",
    "brokerName": "GEORGESON SHAREHOLDER SECURITIES CORP.                                "
  },
  {
    "type": "CORP",
    "mpid": "GSSI",
    "clearingBroker": "0052",
    "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "GSUU",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "GSVV",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "GTNB",
    "clearingBroker": "0595",
    "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
  },
  {
    "type": "CORP",
    "mpid": "GTSM",
    "clearingBroker": "0005",
    "brokerName": "GTS SECURITIES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "GWFS",
    "clearingBroker": "0443",
    "brokerName": "GWFS EQUITIES, INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "GWNS",
    "clearingBroker": "0443",
    "brokerName": "GWN SECURITIES INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "GZML",
    "clearingBroker": "0161",
    "brokerName": "GUZMAN & COMPANY                                                      "
  },
  {
    "type": "CORP",
    "mpid": "HAFS",
    "clearingBroker": "0279",
    "brokerName": "HANTZ FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "HALO",
    "clearingBroker": "0235",
    "brokerName": "HALO SECURITIES, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "HARB",
    "clearingBroker": "0443",
    "brokerName": "HARBOUR INVESTMENTS INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "HARC",
    "clearingBroker": "0235",
    "brokerName": "HARLEY CAPITAL LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "HARS",
    "clearingBroker": "8199",
    "brokerName": "HARVESTONS SECURITIES, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "HAVK",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "HAZL",
    "clearingBroker": "0226",
    "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "HBCO",
    "clearingBroker": "0443",
    "brokerName": "GLOBAL INVESTOR SERVICES, L.C.                                        "
  },
  {
    "type": "CORP",
    "mpid": "HBUS",
    "clearingBroker": "0443",
    "brokerName": "HOLISTIC BROKERAGE, LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "HCGC",
    "clearingBroker": "0103",
    "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "HCMX",
    "clearingBroker": "0235",
    "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "HCTA",
    "clearingBroker": "0005",
    "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "HCWW",
    "clearingBroker": "0235",
    "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "HDVS",
    "clearingBroker": "0226",
    "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "HEAD",
    "clearingBroker": "0443",
    "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
  },
  {
    "type": "CORP",
    "mpid": "HEGS",
    "clearingBroker": "1043",
    "brokerName": "HEG SECURITIES, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "HENN",
    "clearingBroker": "0235",
    "brokerName": "CARL M. HENNIG, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "HENY",
    "clearingBroker": "0443",
    "brokerName": "HENLEY & COMPANY LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "HFLD",
    "clearingBroker": "0279",
    "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "HIAL",
    "clearingBroker": "0443",
    "brokerName": "HARBOR INVESTMENT ADVISORY, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "HIGG",
    "clearingBroker": "0235",
    "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "HINO",
    "clearingBroker": "0235",
    "brokerName": "TRB CAPITAL MARKETS,LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "HITS",
    "clearingBroker": "0443",
    "brokerName": "HEIGHT SECURITIES, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "HJSC",
    "clearingBroker": "0443",
    "brokerName": "SIMS (HERBERT J.) & CO., INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "HNTR",
    "clearingBroker": "0443",
    "brokerName": "HUNTER ASSOCIATES, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "HONR",
    "clearingBroker": "0235",
    "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "HOOD",
    "clearingBroker": "6769",
    "brokerName": "ROBINHOOD SECURITIES, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "HOPK",
    "clearingBroker": "0750",
    "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
  },
  {
    "type": "CORP",
    "mpid": "HOTO",
    "clearingBroker": "0443",
    "brokerName": "HORNOR, TOWNSEND & KENT, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "HPOM",
    "clearingBroker": "0235",
    "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
  },
  {
    "type": "CORP",
    "mpid": "HPWD",
    "clearingBroker": "0443",
    "brokerName": "PIPER SANDLER & CO.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "HRBF",
    "clearingBroker": "0756",
    "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
  },
  {
    "type": "CORP",
    "mpid": "HRCO",
    "clearingBroker": "0103",
    "brokerName": "H RIVKIN & COMPANY                                                    "
  },
  {
    "type": "CORP",
    "mpid": "HRCS",
    "clearingBroker": "0443",
    "brokerName": "HRC INVESTMENT SERVICES, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "HRGR",
    "clearingBroker": "0235",
    "brokerName": "HARGER AND COMPANY, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "HRRS",
    "clearingBroker": "0443",
    "brokerName": "HARRIS INVESTORS SERVICES, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "HSAI",
    "clearingBroker": "0443",
    "brokerName": "INDEPENDENT FINANCIAL GROUP, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "HSBK",
    "clearingBroker": "0443",
    "brokerName": "HSBC SECURITIES (USA) INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "HSBM",
    "clearingBroker": "0486",
    "brokerName": "HSBC SECURITIES (USA), INC/ FIXED INCOME SECS                         "
  },
  {
    "type": "CORP",
    "mpid": "HTCM",
    "clearingBroker": "0235",
    "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
  },
  {
    "type": "CORP",
    "mpid": "HTDX",
    "clearingBroker": "0279",
    "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "HTIS",
    "clearingBroker": "0443",
    "brokerName": "HAITONG INTERNATIONAL SECURITIES (USA) INC.                           "
  },
  {
    "type": "CORP",
    "mpid": "HTPS",
    "clearingBroker": "0443",
    "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "HTWR",
    "clearingBroker": "0226",
    "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "HUCO",
    "clearingBroker": "0226",
    "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
  },
  {
    "type": "CORP",
    "mpid": "HUFS",
    "clearingBroker": "0443",
    "brokerName": "HUNT FINANCIAL SECURITIES, LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "HUNT",
    "clearingBroker": "0141",
    "brokerName": "HUNTLEIGH SECURITIES CORPORATION                                      "
  },
  {
    "type": "CORP",
    "mpid": "HUTC",
    "clearingBroker": "0443",
    "brokerName": "HUNTINGTON SECURITIES, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "HWJC",
    "clearingBroker": "0052",
    "brokerName": "HWJ CAPITAL PARTNERS II, LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "HWLS",
    "clearingBroker": "0443",
    "brokerName": "M.S. HOWELLS & CO.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "IAAK",
    "clearingBroker": "0279",
    "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "IAEW",
    "clearingBroker": "0595",
    "brokerName": "SRT SECURITIES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "IAEX",
    "clearingBroker": "0235",
    "brokerName": "SRT SECURITIES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "IBKR",
    "clearingBroker": "0017",
    "brokerName": "INTERACTIVE BROKERS LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "IBND",
    "clearingBroker": "0103",
    "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "IBOT",
    "clearingBroker": "0279",
    "brokerName": "INVESTORS BROKERAGE OF TEXAS, INC                                     "
  },
  {
    "type": "CORP",
    "mpid": "IBPR",
    "clearingBroker": "0052",
    "brokerName": "IB CAPITAL LLC                                                        "
  },
  {
    "type": "CORP",
    "mpid": "IBSJ",
    "clearingBroker": "0052",
    "brokerName": "INTEGRITY BROKERAGE                                                   "
  },
  {
    "type": "CORP",
    "mpid": "ICAN",
    "clearingBroker": "0226",
    "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "ICBK",
    "clearingBroker": "0388",
    "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
  },
  {
    "type": "CORP",
    "mpid": "ICCI",
    "clearingBroker": "0279",
    "brokerName": "INDEPENDENCE CAPITAL CO.                                              "
  },
  {
    "type": "CORP",
    "mpid": "ICDS",
    "clearingBroker": "0750",
    "brokerName": "ICD SECURITIES                                                        "
  },
  {
    "type": "CORP",
    "mpid": "ICEX",
    "clearingBroker": "4264",
    "brokerName": "ICE SECURITIES EXECUTION & CLEARING, LLC                              "
  },
  {
    "type": "CORP",
    "mpid": "ICMB",
    "clearingBroker": "1043",
    "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "ICMH",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
  },
  {
    "type": "CORP",
    "mpid": "ICMI",
    "clearingBroker": "0279",
    "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "ICON",
    "clearingBroker": "0595",
    "brokerName": "ICON CAPITAL GROUP, LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "ICRL",
    "clearingBroker": "0443",
    "brokerName": "RIDEAU (I.C.) LYONS AND CO.                                           "
  },
  {
    "type": "CORP",
    "mpid": "ICTI",
    "clearingBroker": "0158",
    "brokerName": "INTERNATIONAL CORRESPONDENT TRADING, INC.                             "
  },
  {
    "type": "CORP",
    "mpid": "IDAY",
    "clearingBroker": "0103",
    "brokerName": "BROKERAGESELECT                                                       "
  },
  {
    "type": "CORP",
    "mpid": "IESI",
    "clearingBroker": "0443",
    "brokerName": "ITAU EUROPA SECURITIES INC                                            "
  },
  {
    "type": "CORP",
    "mpid": "IFCS",
    "clearingBroker": "0161",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "IMCC",
    "clearingBroker": "0005",
    "brokerName": "IMC FINANCIAL MARKETS                                                 "
  },
  {
    "type": "CORP",
    "mpid": "IMPC",
    "clearingBroker": "0443",
    "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "INCC",
    "clearingBroker": "0443",
    "brokerName": "SATURNA BROKERAGE SERVICES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "INFI",
    "clearingBroker": "0279",
    "brokerName": "INTEGRAL FINANCIAL, LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "INGF",
    "clearingBroker": "0270",
    "brokerName": "ING FINANCIAL MARKETS LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "INGS",
    "clearingBroker": "0124",
    "brokerName": "INGALLS & SNYDER, LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "INNO",
    "clearingBroker": "0052",
    "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "INPI",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT PLANNERS INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "INPS",
    "clearingBroker": "0235",
    "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "INTL",
    "clearingBroker": "0750",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "INTX",
    "clearingBroker": "0235",
    "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
  },
  {
    "type": "CORP",
    "mpid": "IPGR",
    "clearingBroker": "0443",
    "brokerName": "INVESTMENT PLACEMENT GROUP                                            "
  },
  {
    "type": "CORP",
    "mpid": "IRMD",
    "clearingBroker": "0443",
    "brokerName": "PLANMEMBER SECURITIES CORP                                            "
  },
  {
    "type": "CORP",
    "mpid": "ISCN",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
  },
  {
    "type": "CORP",
    "mpid": "ISIG",
    "clearingBroker": "0226",
    "brokerName": "EVERCORE GROUP L.L.C.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "ISLL",
    "clearingBroker": "0052",
    "brokerName": "INLET SECURITIES LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "ISSI",
    "clearingBroker": "0052",
    "brokerName": "INSIGHT SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "ITAU",
    "clearingBroker": "0443",
    "brokerName": "ITAU BBA USA SECURITIES INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "ITCC",
    "clearingBroker": "0750",
    "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "ITCM",
    "clearingBroker": "0443",
    "brokerName": "INTERCAM SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "ITFS",
    "clearingBroker": "0226",
    "brokerName": "KEEL POINT CAPITAL, LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "IVEX",
    "clearingBroker": "0443",
    "brokerName": "INVEX, INC.                                                           "
  },
  {
    "type": "CORP",
    "mpid": "IVNT",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT NETWORK, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "IVOL",
    "clearingBroker": "0235",
    "brokerName": "UNION CAPITAL COMPANY                                                 "
  },
  {
    "type": "CORP",
    "mpid": "IVST",
    "clearingBroker": "0443",
    "brokerName": "INTERVEST INTERNATIONAL EQUITIES CORPORATION                          "
  },
  {
    "type": "CORP",
    "mpid": "JADN",
    "clearingBroker": "0725",
    "brokerName": "J ALDEN ASSOCIATES                                                    "
  },
  {
    "type": "CORP",
    "mpid": "JANY",
    "clearingBroker": "0374",
    "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "JBLW",
    "clearingBroker": "0443",
    "brokerName": "OHANESIAN / LECOURS, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "JDLS",
    "clearingBroker": "0103",
    "brokerName": "JDL SECURITIES                                                        "
  },
  {
    "type": "CORP",
    "mpid": "JDRB",
    "clearingBroker": "0595",
    "brokerName": "J.H. DARBIE & CO., INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "JEFF",
    "clearingBroker": "0019",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "CORP",
    "mpid": "JEFM",
    "clearingBroker": "0235",
    "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
  },
  {
    "type": "CORP",
    "mpid": "JEVO",
    "clearingBroker": "0235",
    "brokerName": "ATIS, INC                                                             "
  },
  {
    "type": "CORP",
    "mpid": "JGUN",
    "clearingBroker": "0235",
    "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "JHDR",
    "clearingBroker": "0052",
    "brokerName": "JH DARBIE & CO. INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "JJKE",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "JKFS",
    "clearingBroker": "0279",
    "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "JKRC",
    "clearingBroker": "0443",
    "brokerName": "J.K.R. & CO., INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "JLEQ",
    "clearingBroker": "0161",
    "brokerName": "JUMP EXECUTION, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "JMLS",
    "clearingBroker": "0235",
    "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "JNSN",
    "clearingBroker": "0443",
    "brokerName": "D A DAVIDSON                                                          "
  },
  {
    "type": "CORP",
    "mpid": "JNST",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET CAPITAL LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "JONE",
    "clearingBroker": "0161",
    "brokerName": "JONESTRADING                                                          "
  },
  {
    "type": "CORP",
    "mpid": "JPMS",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "JPPB",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "CORP",
    "mpid": "JQII",
    "clearingBroker": "0443",
    "brokerName": "THE GARBACZ GROUP                                                     "
  },
  {
    "type": "CORP",
    "mpid": "JRCO",
    "clearingBroker": "0226",
    "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
  },
  {
    "type": "CORP",
    "mpid": "JSAP",
    "clearingBroker": "8497",
    "brokerName": "JANE STREET CAPITAL, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "JSBA",
    "clearingBroker": "0161",
    "brokerName": "JANE STREET CAPITAL, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "JSCL",
    "clearingBroker": "0052",
    "brokerName": "JOSEPH STONE CAPITAL L.L.C.                                           "
  },
  {
    "type": "CORP",
    "mpid": "JSCT",
    "clearingBroker": "0005",
    "brokerName": "JANE STREET CAPITAL LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "JSEB",
    "clearingBroker": "0161",
    "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
  },
  {
    "type": "CORP",
    "mpid": "JSEG",
    "clearingBroker": "0161",
    "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
  },
  {
    "type": "CORP",
    "mpid": "JSSF",
    "clearingBroker": "0226",
    "brokerName": "JMP SECURITIES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "JVBF",
    "clearingBroker": "0235",
    "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
  },
  {
    "type": "CORP",
    "mpid": "JVBG",
    "clearingBroker": "0443",
    "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "JWCF",
    "clearingBroker": "0226",
    "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "JWML",
    "clearingBroker": "0235",
    "brokerName": "MILLEGAN (J.W.), INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "KALS",
    "clearingBroker": "0235",
    "brokerName": "KALOS CAPITAL, INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "KAPG",
    "clearingBroker": "0158",
    "brokerName": "KAPITALL GENERATION, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "KART",
    "clearingBroker": "0750",
    "brokerName": "REVERE SECURITIES CORP.                                               "
  },
  {
    "type": "CORP",
    "mpid": "KAWM",
    "clearingBroker": "0443",
    "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "KBCO",
    "clearingBroker": "0443",
    "brokerName": "KAHN BROTHERS LLC                                                     "
  },
  {
    "type": "CORP",
    "mpid": "KCAM",
    "clearingBroker": "0052",
    "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "KCIM",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
  },
  {
    "type": "CORP",
    "mpid": "KCIX",
    "clearingBroker": "0279",
    "brokerName": "KILEY PARTNERS, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "KCRD",
    "clearingBroker": "0052",
    "brokerName": "PHX FINANCIAL, INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "KEEN",
    "clearingBroker": "0279",
    "brokerName": "ST. BERNARD FINANCIAL SERVICES, INC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "KENS",
    "clearingBroker": "0279",
    "brokerName": "KENSINGTON CAPITAL CORP.                                              "
  },
  {
    "type": "CORP",
    "mpid": "KERC",
    "clearingBroker": "0443",
    "brokerName": "KERCHEVILLE & COMPANY                                                 "
  },
  {
    "type": "CORP",
    "mpid": "KEYB",
    "clearingBroker": "0443",
    "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "KIML",
    "clearingBroker": "0226",
    "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "KING",
    "clearingBroker": "0235",
    "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "KISL",
    "clearingBroker": "0443",
    "brokerName": "KEY INVESTMENT SERVICES LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "KJCO",
    "clearingBroker": "0725",
    "brokerName": "KIPLING JONES & CO., LTD.                                             "
  },
  {
    "type": "CORP",
    "mpid": "KMSF",
    "clearingBroker": "0443",
    "brokerName": "KMS FINANCIAL SERVICES                                                "
  },
  {
    "type": "CORP",
    "mpid": "KNGS",
    "clearingBroker": "0235",
    "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "KOTK",
    "clearingBroker": "1043",
    "brokerName": "KOTAK MAHINDRA, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "KOVP",
    "clearingBroker": "0443",
    "brokerName": "KOVACK SECURITIES INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "KOVS",
    "clearingBroker": "0226",
    "brokerName": "KOVACK SECURITIES, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "KRCO",
    "clearingBroker": "0235",
    "brokerName": "KR SECURITIES, LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "KRSH",
    "clearingBroker": "0005",
    "brokerName": "KERSHNER SECURITIES, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "KRTH",
    "clearingBroker": "0235",
    "brokerName": "J.W. KORTH & COMPANY                                                  "
  },
  {
    "type": "CORP",
    "mpid": "KUYK",
    "clearingBroker": "0279",
    "brokerName": "KUYKENDALL & SCHNEIDER, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "LADY",
    "clearingBroker": "0443",
    "brokerName": "TRUSTFIRST, INC.                                                      "
  },
  {
    "type": "CORP",
    "mpid": "LAFB",
    "clearingBroker": "0235",
    "brokerName": "LAFFERTY (R.F.) & CO., INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "LAFC",
    "clearingBroker": "0443",
    "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "LAFF",
    "clearingBroker": "0443",
    "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "LAFI",
    "clearingBroker": "0750",
    "brokerName": "LAFISE SECURITIES CORPORATION                                         "
  },
  {
    "type": "CORP",
    "mpid": "LAGI",
    "clearingBroker": "0226",
    "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "LANE",
    "clearingBroker": "0235",
    "brokerName": "MARC J. LANE & COMPANY                                                "
  },
  {
    "type": "CORP",
    "mpid": "LARC",
    "clearingBroker": "0235",
    "brokerName": "LARIMER CAPITAL CORPORATION                                           "
  },
  {
    "type": "CORP",
    "mpid": "LASI",
    "clearingBroker": "0141",
    "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "LASS",
    "clearingBroker": "0226",
    "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "LATG",
    "clearingBroker": "0537",
    "brokerName": "GFI SECURITIES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "LATM",
    "clearingBroker": "0537",
    "brokerName": "GFI SECURITIES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "LATN",
    "clearingBroker": "0443",
    "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "LBKI",
    "clearingBroker": "0235",
    "brokerName": "LIBUCKI & CO., LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "LDAS",
    "clearingBroker": "0443",
    "brokerName": "LANDAAS & CO.                                                         "
  },
  {
    "type": "CORP",
    "mpid": "LDIL",
    "clearingBroker": "0226",
    "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "LDLW",
    "clearingBroker": "0750",
    "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
  },
  {
    "type": "CORP",
    "mpid": "LDOT",
    "clearingBroker": "0235",
    "brokerName": "LANDOLT SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "LEAD",
    "clearingBroker": "0226",
    "brokerName": "THE LEADERS GROUP, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "LEBO",
    "clearingBroker": "0226",
    "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "LEER",
    "clearingBroker": "0443",
    "brokerName": "LEERINK SWANN & COMPANY                                               "
  },
  {
    "type": "CORP",
    "mpid": "LENX",
    "clearingBroker": "0279",
    "brokerName": "LENOX FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "LEXI",
    "clearingBroker": "0226",
    "brokerName": "LEXINGTON INVESTMENT COMPANY, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "LEYA",
    "clearingBroker": "0235",
    "brokerName": "LEMLEY, YARLING & CO.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "LFAC",
    "clearingBroker": "0226",
    "brokerName": "OSAIC FA, INC.                                                        "
  },
  {
    "type": "CORP",
    "mpid": "LFRO",
    "clearingBroker": "0235",
    "brokerName": "LF ROTHSCHILD, LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "LGNT",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "CORP",
    "mpid": "LGSA",
    "clearingBroker": "0158",
    "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
  },
  {
    "type": "CORP",
    "mpid": "LIFG",
    "clearingBroker": "0279",
    "brokerName": "LONG ISLAND FINANCIAL GROUP, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "LIIS",
    "clearingBroker": "0226",
    "brokerName": "USAA FINANCIAL ADVISORS, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "LINC",
    "clearingBroker": "0158",
    "brokerName": "LIBERUM                                                               "
  },
  {
    "type": "CORP",
    "mpid": "LISI",
    "clearingBroker": "0443",
    "brokerName": "LEUMI INVESTMENT SERVICES, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "LMAR",
    "clearingBroker": "0226",
    "brokerName": "LIFEMARK SECURITIES CORP.                                             "
  },
  {
    "type": "CORP",
    "mpid": "LMBD",
    "clearingBroker": "0443",
    "brokerName": "LAZARD ASSET MANAGEMENT SECURITIES LLC                                "
  },
  {
    "type": "CORP",
    "mpid": "LMKO",
    "clearingBroker": "0235",
    "brokerName": "KOHN (L.M.) & COMPANY                                                 "
  },
  {
    "type": "CORP",
    "mpid": "LMNX",
    "clearingBroker": "0226",
    "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "LNCL",
    "clearingBroker": "0443",
    "brokerName": "LINCOLN INVESTMENT                                                    "
  },
  {
    "type": "CORP",
    "mpid": "LNKS",
    "clearingBroker": "0443",
    "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "LOMB",
    "clearingBroker": "0141",
    "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
  },
  {
    "type": "CORP",
    "mpid": "LOOP",
    "clearingBroker": "0443",
    "brokerName": "LOOP CAPITAL MARKETS, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "LOUE",
    "clearingBroker": "0161",
    "brokerName": "ICAP CORPORATES LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "LOUI",
    "clearingBroker": "0005",
    "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
  },
  {
    "type": "CORP",
    "mpid": "LPCM",
    "clearingBroker": "0103",
    "brokerName": "LAMPERT CAPITAL MARKETS INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "LPFS",
    "clearingBroker": "0235",
    "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
  },
  {
    "type": "CORP",
    "mpid": "LPLE",
    "clearingBroker": "0075",
    "brokerName": "LPL ENTERPRISE, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "LPSP",
    "clearingBroker": "1043",
    "brokerName": "LPS CAPITAL LLC                                                       "
  },
  {
    "type": "CORP",
    "mpid": "LQNA",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "CORP",
    "mpid": "LQNB",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "CORP",
    "mpid": "LQNF",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "CORP",
    "mpid": "LQNT",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "CORP",
    "mpid": "LQPT",
    "clearingBroker": "0161",
    "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "LRBC",
    "clearingBroker": "0235",
    "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "LRCM",
    "clearingBroker": "0279",
    "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "LSCM",
    "clearingBroker": "0235",
    "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "LSFB",
    "clearingBroker": "0443",
    "brokerName": "LION STREET FINANCIAL, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "LSKO",
    "clearingBroker": "0226",
    "brokerName": "LESKO SECURITIES INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "LSPI",
    "clearingBroker": "0141",
    "brokerName": "LAFAYETTE INVESTMENTS                                                 "
  },
  {
    "type": "CORP",
    "mpid": "LSSI",
    "clearingBroker": "0750",
    "brokerName": "EJ STERLING INC.                                                      "
  },
  {
    "type": "CORP",
    "mpid": "LSUS",
    "clearingBroker": "0443",
    "brokerName": "LATIN SECURITIES INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "LTAA",
    "clearingBroker": "0226",
    "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "LTCO",
    "clearingBroker": "0226",
    "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "LTIN",
    "clearingBroker": "2786",
    "brokerName": "BBVA SECURITIES INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "LVAR",
    "clearingBroker": "0443",
    "brokerName": "LARRAINVIAL SECURITIES US LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "LVMR",
    "clearingBroker": "0235",
    "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "LWFL",
    "clearingBroker": "0443",
    "brokerName": "LAWSON FINANCIAL CORPORATION                                          "
  },
  {
    "type": "CORP",
    "mpid": "LYON",
    "clearingBroker": "0651",
    "brokerName": "CREDIT AGRICOLE SECURITIES (USA) INC.                                 "
  },
  {
    "type": "CORP",
    "mpid": "LYSI",
    "clearingBroker": "0443",
    "brokerName": "LLOYDS SECURITIES INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "MACC",
    "clearingBroker": "0226",
    "brokerName": "NEWEDGE SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "MADV",
    "clearingBroker": "0443",
    "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "MAMA",
    "clearingBroker": "0443",
    "brokerName": "SECUREVEST FINANCIAL GROUP                                            "
  },
  {
    "type": "CORP",
    "mpid": "MAPA",
    "clearingBroker": "0279",
    "brokerName": "MADISON PAIGE SECURITIES LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "MASE",
    "clearingBroker": "0141",
    "brokerName": "MANAGED ACCOUNT SERVICES, LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "MAVS",
    "clearingBroker": "0443",
    "brokerName": "MADISON AVENUE SECURITIES                                             "
  },
  {
    "type": "CORP",
    "mpid": "MAXM",
    "clearingBroker": "0443",
    "brokerName": "MAXIM GROUP LLC                                                       "
  },
  {
    "type": "CORP",
    "mpid": "MBBS",
    "clearingBroker": "0443",
    "brokerName": "INFINEX INVESTMENTS                                                   "
  },
  {
    "type": "CORP",
    "mpid": "MBSA",
    "clearingBroker": "0052",
    "brokerName": "MBS SOURCE ETRADING, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "MBSE",
    "clearingBroker": "0052",
    "brokerName": "MBS SOURCE ETRADING, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "MBSL",
    "clearingBroker": "0443",
    "brokerName": "MBS CAPITAL MARKETS, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "MBUS",
    "clearingBroker": "0052",
    "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "MCAP",
    "clearingBroker": "1043",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "CORP",
    "mpid": "MCBT",
    "clearingBroker": "0235",
    "brokerName": "MOORS & CABOT, INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "MCCL",
    "clearingBroker": "0443",
    "brokerName": "MCCLURG CAPITAL CORPORATION                                           "
  },
  {
    "type": "CORP",
    "mpid": "MCMG",
    "clearingBroker": "0279",
    "brokerName": "MUNICIPAL CAPITAL MARKETS GROUP, INC.                                 "
  },
  {
    "type": "CORP",
    "mpid": "MCNA",
    "clearingBroker": "0443",
    "brokerName": "MCNALLY FINANCIAL SERVICES CORPORATION                                "
  },
  {
    "type": "CORP",
    "mpid": "MDGP",
    "clearingBroker": "0235",
    "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "MEAL",
    "clearingBroker": "0226",
    "brokerName": "M. E. ALLISON & CO., INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "MERP",
    "clearingBroker": "0235",
    "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "MERQ",
    "clearingBroker": "0052",
    "brokerName": "MERCATOR ASSOCIATES LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "MESF",
    "clearingBroker": "0443",
    "brokerName": "MESIROW FINANCIAL, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "MFGX",
    "clearingBroker": "0443",
    "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "MFRS",
    "clearingBroker": "0443",
    "brokerName": "MFR SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "MHFI",
    "clearingBroker": "0226",
    "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "MHSI",
    "clearingBroker": "0443",
    "brokerName": "M HOLDINGS SECURITIES                                                 "
  },
  {
    "type": "CORP",
    "mpid": "MIAM",
    "clearingBroker": "0141",
    "brokerName": "FMSBONDS, INC.                                                        "
  },
  {
    "type": "CORP",
    "mpid": "MIBS",
    "clearingBroker": "0443",
    "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
  },
  {
    "type": "CORP",
    "mpid": "MIDA",
    "clearingBroker": "0725",
    "brokerName": "MID-ATLANTIC SECURITIES, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "MIDL",
    "clearingBroker": "0226",
    "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
  },
  {
    "type": "CORP",
    "mpid": "MIFI",
    "clearingBroker": "0226",
    "brokerName": "MILKIE FERGUSON INVESTMENTS, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "MILE",
    "clearingBroker": "0052",
    "brokerName": "I-BANKERS SECURITIES INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "MILN",
    "clearingBroker": "1767",
    "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "MINP",
    "clearingBroker": "0235",
    "brokerName": "MINISTRY PARTNERS SECURITIES, LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "MINV",
    "clearingBroker": "0235",
    "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "MIRA",
    "clearingBroker": "1043",
    "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "MISL",
    "clearingBroker": "0161",
    "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "MITR",
    "clearingBroker": "0443",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "MJDW",
    "clearingBroker": "0279",
    "brokerName": "MURRAY SECURITIES                                                     "
  },
  {
    "type": "CORP",
    "mpid": "MJWH",
    "clearingBroker": "0235",
    "brokerName": "ETICO PARTNERS LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "MKMP",
    "clearingBroker": "0161",
    "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "MKRT",
    "clearingBroker": "0235",
    "brokerName": "MARKET SECURITIES, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "MKTI",
    "clearingBroker": "0226",
    "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "MKTX",
    "clearingBroker": "4265",
    "brokerName": "MARKETAXESS CORPORATION                                               "
  },
  {
    "type": "CORP",
    "mpid": "MKTY",
    "clearingBroker": "4265",
    "brokerName": "MARKETAXESS CORPORATION                                               "
  },
  {
    "type": "CORP",
    "mpid": "MLCO",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "MLEX",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "MLMA",
    "clearingBroker": "0671",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "CORP",
    "mpid": "MLMS",
    "clearingBroker": "0279",
    "brokerName": "MAINLINE WEST MUNICIPAL SECURITIES, LLC                               "
  },
  {
    "type": "CORP",
    "mpid": "MLTX",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "MLWM",
    "clearingBroker": "0671",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "CORP",
    "mpid": "MMCS",
    "clearingBroker": "0443",
    "brokerName": "MMC SECURITIES CORP.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "MMNT",
    "clearingBroker": "0158",
    "brokerName": "MOMENT MARKETS, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "MNCC",
    "clearingBroker": "0443",
    "brokerName": "MONEY CONCEPTS CAPITAL CORP.                                          "
  },
  {
    "type": "CORP",
    "mpid": "MNCO",
    "clearingBroker": "0279",
    "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "MNRC",
    "clearingBroker": "0443",
    "brokerName": "MONARCH CAPITAL GROUP LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "MNXS",
    "clearingBroker": "0443",
    "brokerName": "MUNIAXIS LEBENTHAL LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "MOCM",
    "clearingBroker": "0235",
    "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "MOFI",
    "clearingBroker": "0158",
    "brokerName": "M1 FINANCE LLC                                                        "
  },
  {
    "type": "CORP",
    "mpid": "MOIS",
    "clearingBroker": "0443",
    "brokerName": "MUTUAL OF OMAHA INVESTOR SERVICES INC.                                "
  },
  {
    "type": "CORP",
    "mpid": "MOLO",
    "clearingBroker": "0235",
    "brokerName": "MOLONEY SECURITIES                                                    "
  },
  {
    "type": "CORP",
    "mpid": "MOMS",
    "clearingBroker": "0750",
    "brokerName": "MOMENTUS SECURITIES LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "MONE",
    "clearingBroker": "0443",
    "brokerName": "MONERE INVESTMENTS, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "MONR",
    "clearingBroker": "0226",
    "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "MONX",
    "clearingBroker": "0443",
    "brokerName": "MONEX SECURITIES INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "MORA",
    "clearingBroker": "0443",
    "brokerName": "MORA WM SECURITIES                                                    "
  },
  {
    "type": "CORP",
    "mpid": "MPLA",
    "clearingBroker": "0158",
    "brokerName": "EMPALA SECURITIES, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "MPLW",
    "clearingBroker": "0226",
    "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
  },
  {
    "type": "CORP",
    "mpid": "MPSG",
    "clearingBroker": "0161",
    "brokerName": "ED & F MAN CAPITAL MARKETS INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "MRBA",
    "clearingBroker": "0052",
    "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "MRIS",
    "clearingBroker": "0443",
    "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
  },
  {
    "type": "CORP",
    "mpid": "MRKS",
    "clearingBroker": "0443",
    "brokerName": "M. RAMSEY KING                                                        "
  },
  {
    "type": "CORP",
    "mpid": "MRNA",
    "clearingBroker": "0161",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "MRPH",
    "clearingBroker": "0226",
    "brokerName": "WM FINANCIAL SERVICES, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "MRSC",
    "clearingBroker": "0287",
    "brokerName": "TRADEUP SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "MSCB",
    "clearingBroker": "0279",
    "brokerName": "MAINE SECURITIES CORPORATION                                          "
  },
  {
    "type": "CORP",
    "mpid": "MSCO",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "MSEC",
    "clearingBroker": "0235",
    "brokerName": "MSEC, LLC                                                             "
  },
  {
    "type": "CORP",
    "mpid": "MSII",
    "clearingBroker": "0226",
    "brokerName": "MSI FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "MSRO",
    "clearingBroker": "0226",
    "brokerName": "MESIROW FINANCIAL, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "MSTC",
    "clearingBroker": "0226",
    "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
  },
  {
    "type": "CORP",
    "mpid": "MTBK",
    "clearingBroker": "0443",
    "brokerName": "MULTI-BANK SECURITIES, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "MTDB",
    "clearingBroker": "0443",
    "brokerName": "M&T SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "MTGO",
    "clearingBroker": "0158",
    "brokerName": "MTG, LLC                                                              "
  },
  {
    "type": "CORP",
    "mpid": "MTHN",
    "clearingBroker": "0005",
    "brokerName": "MARATHON TRADING GROUP LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "MTLE",
    "clearingBroker": "0235",
    "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "MTSL",
    "clearingBroker": "0226",
    "brokerName": "MSEC, LLC                                                             "
  },
  {
    "type": "CORP",
    "mpid": "MUFG",
    "clearingBroker": "0076",
    "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "MULT",
    "clearingBroker": "0443",
    "brokerName": "MULTI-FINANCIAL SECURITIES GROUP                                      "
  },
  {
    "type": "CORP",
    "mpid": "MURJ",
    "clearingBroker": "0750",
    "brokerName": "COMMERCE ONE FINANCIAL INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "MWAF",
    "clearingBroker": "0443",
    "brokerName": "MWA FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "MWCC",
    "clearingBroker": "0235",
    "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "MWIL",
    "clearingBroker": "0235",
    "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "MWMS",
    "clearingBroker": "0443",
    "brokerName": "MUREX CAPITAL LLC                                                     "
  },
  {
    "type": "CORP",
    "mpid": "MYSS",
    "clearingBroker": "0158",
    "brokerName": "M.Y. SAFRA SECURITIES, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "MZHO",
    "clearingBroker": "0892",
    "brokerName": "MIZUHO SECURITIES USA LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "MZHO",
    "clearingBroker": "2396",
    "brokerName": "MIZUHO SECURITIES USA LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "NACM",
    "clearingBroker": "0161",
    "brokerName": "NABSECURITIES, LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "NADL",
    "clearingBroker": "0235",
    "brokerName": "WARREN D. NADEL & COMPANY                                             "
  },
  {
    "type": "CORP",
    "mpid": "NAPK",
    "clearingBroker": "0052",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "CORP",
    "mpid": "NASC",
    "clearingBroker": "0235",
    "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "NAVC",
    "clearingBroker": "0235",
    "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "NBAR",
    "clearingBroker": "0226",
    "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "NBCS",
    "clearingBroker": "0235",
    "brokerName": "NBC SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "NBLB",
    "clearingBroker": "0226",
    "brokerName": "NEUBERGER BERMAN BD LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "NBSL",
    "clearingBroker": "0226",
    "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
  },
  {
    "type": "CORP",
    "mpid": "NEED",
    "clearingBroker": "0443",
    "brokerName": "NEEDHAM & COMPANY, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "NEPP",
    "clearingBroker": "0226",
    "brokerName": "N.E. PRIVATE CLIENT ADVISORS, LTD.                                    "
  },
  {
    "type": "CORP",
    "mpid": "NEST",
    "clearingBroker": "0235",
    "brokerName": "NEST INVESTMENTS BD LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "NEXT",
    "clearingBroker": "0443",
    "brokerName": "NEXT FINANCIAL GROUP, INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "NFGR",
    "clearingBroker": "0141",
    "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "NFSC",
    "clearingBroker": "0226",
    "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "NFTY",
    "clearingBroker": "0235",
    "brokerName": "INFINITY FINANCIAL SERVICES                                           "
  },
  {
    "type": "CORP",
    "mpid": "NHFS",
    "clearingBroker": "0443",
    "brokerName": "ALIGHT FINANCIAL SOLUTIONS, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "NHWI",
    "clearingBroker": "0141",
    "brokerName": "HENNION & WALSH, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "NIAD",
    "clearingBroker": "0052",
    "brokerName": "NI ADVISORS                                                           "
  },
  {
    "type": "CORP",
    "mpid": "NILL",
    "clearingBroker": "0725",
    "brokerName": "NIAGARA INTERNATIONAL CAPITAL LIMITED                                 "
  },
  {
    "type": "CORP",
    "mpid": "NITE",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "NLOV",
    "clearingBroker": "0279",
    "brokerName": "NORTLOV SECURITIES LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "NMRA",
    "clearingBroker": "0180",
    "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC./FIXED INCOME                    "
  },
  {
    "type": "CORP",
    "mpid": "NMRA",
    "clearingBroker": "5222",
    "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC./FIXED INCOME                    "
  },
  {
    "type": "CORP",
    "mpid": "NOBL",
    "clearingBroker": "0750",
    "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
  },
  {
    "type": "CORP",
    "mpid": "NORC",
    "clearingBroker": "0235",
    "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
  },
  {
    "type": "CORP",
    "mpid": "NORP",
    "clearingBroker": "0443",
    "brokerName": "PARETO SECURITIES INC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "NORT",
    "clearingBroker": "0443",
    "brokerName": "NORTHLAND SECURITIES, INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "NOSO",
    "clearingBroker": "0443",
    "brokerName": "NORTH SOUTH CAPITAL LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "NPAI",
    "clearingBroker": "0443",
    "brokerName": "NATIONWIDE PLANNING ASSOCIATES                                        "
  },
  {
    "type": "CORP",
    "mpid": "NPBF",
    "clearingBroker": "0443",
    "brokerName": "NPB FINANCIAL GROUP, LLC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "NPNT",
    "clearingBroker": "0005",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "NPTP",
    "clearingBroker": "0443",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "NRAM",
    "clearingBroker": "0443",
    "brokerName": "CANACCORD WEALTH MANAGEMENT (USA) INC.                                "
  },
  {
    "type": "CORP",
    "mpid": "NSFP",
    "clearingBroker": "0235",
    "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "NSRD",
    "clearingBroker": "0235",
    "brokerName": "NESTLERODE & CO., INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "NTFN",
    "clearingBroker": "0052",
    "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
  },
  {
    "type": "CORP",
    "mpid": "NTRC",
    "clearingBroker": "0226",
    "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "NTSI",
    "clearingBroker": "0443",
    "brokerName": "NESBITT THOMSON SECURITIES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "NVEN",
    "clearingBroker": "0448",
    "brokerName": "NUVEEN SECURITIES, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "NWCM",
    "clearingBroker": "0235",
    "brokerName": "NW CAPITAL MARKETS INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "NWIA",
    "clearingBroker": "0750",
    "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
  },
  {
    "type": "CORP",
    "mpid": "NWML",
    "clearingBroker": "0443",
    "brokerName": "NORTHWESTERN MUTUAL INVESTMENT SERVICES, LLC                          "
  },
  {
    "type": "CORP",
    "mpid": "NYLS",
    "clearingBroker": "0226",
    "brokerName": "NYLIFE SECURITIES INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "OAKR",
    "clearingBroker": "0235",
    "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
  },
  {
    "type": "CORP",
    "mpid": "OBWS",
    "clearingBroker": "0226",
    "brokerName": "OBERWEIS SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "OCAC",
    "clearingBroker": "0235",
    "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "OCEA",
    "clearingBroker": "0052",
    "brokerName": "OCEAN FINANCIAL SERVICES, LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "OCON",
    "clearingBroker": "0103",
    "brokerName": "O'CONNOR & CO SECURITIES                                              "
  },
  {
    "type": "CORP",
    "mpid": "ODEO",
    "clearingBroker": "0388",
    "brokerName": "ODEON CAP                                                             "
  },
  {
    "type": "CORP",
    "mpid": "ODNC",
    "clearingBroker": "0235",
    "brokerName": "ODEON CAPITAL GROUP LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "OFGF",
    "clearingBroker": "0235",
    "brokerName": "OFG FINANCIAL SERVICES INC                                            "
  },
  {
    "type": "CORP",
    "mpid": "OGTL",
    "clearingBroker": "0005",
    "brokerName": "OUTSET GLOBAL TRADING LIMITED                                         "
  },
  {
    "type": "CORP",
    "mpid": "OHIO",
    "clearingBroker": "0443",
    "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "OLDM",
    "clearingBroker": "0005",
    "brokerName": "OLD MISSION CAPITAL, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "OLNE",
    "clearingBroker": "0279",
    "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "OMSL",
    "clearingBroker": "0158",
    "brokerName": "OM SECURITIES, LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "ONEL",
    "clearingBroker": "0161",
    "brokerName": "O'NEIL (WILLIAM) & CO                                                 "
  },
  {
    "type": "CORP",
    "mpid": "ONES",
    "clearingBroker": "0443",
    "brokerName": "O N EQUITY SALES CO.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "OPCO",
    "clearingBroker": "0571",
    "brokerName": "OPPENHEIMER & CO. INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "OPTF",
    "clearingBroker": "0005",
    "brokerName": "OPTIVER US LLC                                                        "
  },
  {
    "type": "CORP",
    "mpid": "ORTL",
    "clearingBroker": "0443",
    "brokerName": "ORIENTAL FINANCIAL SERVICES                                           "
  },
  {
    "type": "CORP",
    "mpid": "OSIC",
    "clearingBroker": "0226",
    "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "OTCN",
    "clearingBroker": "0158",
    "brokerName": "OTC LINK LLC                                                          "
  },
  {
    "type": "CORP",
    "mpid": "OYLD",
    "clearingBroker": "0235",
    "brokerName": "OPENYIELD TRADING LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "PACK",
    "clearingBroker": "0279",
    "brokerName": "PACKERLAND BROKERAGE SERVICES                                         "
  },
  {
    "type": "CORP",
    "mpid": "PACT",
    "clearingBroker": "0443",
    "brokerName": "BTG PACTUAL US CAPITAL LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "PAMC",
    "clearingBroker": "0226",
    "brokerName": "PROGRESSIVE ASSET MANAGEMENT                                          "
  },
  {
    "type": "CORP",
    "mpid": "PAPA",
    "clearingBroker": "0443",
    "brokerName": "PAPAMARKOU WELLNER & CO., INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "PARI",
    "clearingBroker": "0630",
    "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
  },
  {
    "type": "CORP",
    "mpid": "PARK",
    "clearingBroker": "0750",
    "brokerName": "PARK WALK CAPITAL MARKETS, LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "PARV",
    "clearingBroker": "0443",
    "brokerName": "PAR5 CAPITAL & CO LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "PASC",
    "clearingBroker": "0443",
    "brokerName": "PARK AVENUE SECURITIES LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "PASL",
    "clearingBroker": "0443",
    "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "PATR",
    "clearingBroker": "0624",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "PAUL",
    "clearingBroker": "0595",
    "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "PBON",
    "clearingBroker": "0161",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "PBSL",
    "clearingBroker": "0725",
    "brokerName": "PEAK BROKERAGE SERVICES, LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "PCCA",
    "clearingBroker": "0279",
    "brokerName": "PEACHCAP SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "PCIS",
    "clearingBroker": "0226",
    "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "PCSB",
    "clearingBroker": "0443",
    "brokerName": "PRIVATE CLIENT SERVICES, LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "PEER",
    "clearingBroker": "0226",
    "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
  },
  {
    "type": "CORP",
    "mpid": "PENG",
    "clearingBroker": "0443",
    "brokerName": "PENNSYLVANIA GROUP INCORPORATED (THE)                                 "
  },
  {
    "type": "CORP",
    "mpid": "PERC",
    "clearingBroker": "0279",
    "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
  },
  {
    "type": "CORP",
    "mpid": "PERS",
    "clearingBroker": "0443",
    "brokerName": "PERSHING LLC                                                          "
  },
  {
    "type": "CORP",
    "mpid": "PFCG",
    "clearingBroker": "0279",
    "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "PFCL",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "PFDC",
    "clearingBroker": "0235",
    "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "PFPI",
    "clearingBroker": "0161",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
  },
  {
    "type": "CORP",
    "mpid": "PHBP",
    "clearingBroker": "0052",
    "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "PHIN",
    "clearingBroker": "0443",
    "brokerName": "PHILADELPHIA INVESTORS, LTD.                                          "
  },
  {
    "type": "CORP",
    "mpid": "PHRS",
    "clearingBroker": "0279",
    "brokerName": "NAVAID FINANCIAL SERVICES, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "PICE",
    "clearingBroker": "0443",
    "brokerName": "T ROWE PRICE INVESTMENT SERV                                          "
  },
  {
    "type": "CORP",
    "mpid": "PICI",
    "clearingBroker": "0279",
    "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "PICL",
    "clearingBroker": "0052",
    "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "PIMS",
    "clearingBroker": "0226",
    "brokerName": "PRUDENTIAL INVESTMENT MANAGEMENT SERVICES, LLC                        "
  },
  {
    "type": "CORP",
    "mpid": "PINA",
    "clearingBroker": "0141",
    "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "PIPR",
    "clearingBroker": "0443",
    "brokerName": "PIPER SANDLER & CO.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "PIRR",
    "clearingBroker": "0443",
    "brokerName": "PIRRONE & CO., INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "PISC",
    "clearingBroker": "0750",
    "brokerName": "PACIFIC INVESTMENT SECURITIES CORP.                                   "
  },
  {
    "type": "CORP",
    "mpid": "PJEF",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "CORP",
    "mpid": "PKAX",
    "clearingBroker": "0158",
    "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "PLAT",
    "clearingBroker": "0443",
    "brokerName": "CLARKSONS PLATOU SECURITIES, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "PMAS",
    "clearingBroker": "0443",
    "brokerName": "PMA SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "PNCC",
    "clearingBroker": "0226",
    "brokerName": "PNC INVESTMENTS                                                       "
  },
  {
    "type": "CORP",
    "mpid": "PNCM",
    "clearingBroker": "2835",
    "brokerName": "PNC CAPITAL MARKETS LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "PNFP",
    "clearingBroker": "0279",
    "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "PNSA",
    "clearingBroker": "0235",
    "brokerName": "PENSERRA SECURITIES, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "PNSR",
    "clearingBroker": "0161",
    "brokerName": "PENSERRA SECURITIES, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "PODE",
    "clearingBroker": "0235",
    "brokerName": "PODESTA & CO.                                                         "
  },
  {
    "type": "CORP",
    "mpid": "POOH",
    "clearingBroker": "0443",
    "brokerName": "QUESTAR CAPITAL CORPORATION                                           "
  },
  {
    "type": "CORP",
    "mpid": "POPS",
    "clearingBroker": "0226",
    "brokerName": "POPULAR SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "POWL",
    "clearingBroker": "0443",
    "brokerName": "POWELL (ELMER E.) COMPANY                                             "
  },
  {
    "type": "CORP",
    "mpid": "PPSI",
    "clearingBroker": "0235",
    "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "PPSL",
    "clearingBroker": "0413",
    "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "PREB",
    "clearingBroker": "0005",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "PRFA",
    "clearingBroker": "0235",
    "brokerName": "PROOF SERVICES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "PRGI",
    "clearingBroker": "0443",
    "brokerName": "PORTFOLIO RESOURCES GROUP, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "PROE",
    "clearingBroker": "0443",
    "brokerName": "PROEQUITIES, INC.                                                     "
  },
  {
    "type": "CORP",
    "mpid": "PRPO",
    "clearingBroker": "0443",
    "brokerName": "PRIVATE PORTFOLIO, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "PRSB",
    "clearingBroker": "0141",
    "brokerName": "PRESIDENTIAL BROKERAGE, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "PRSI",
    "clearingBroker": "0103",
    "brokerName": "GLOBALINK SECURITIES                                                  "
  },
  {
    "type": "CORP",
    "mpid": "PRST",
    "clearingBroker": "0551",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "PSII",
    "clearingBroker": "0226",
    "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "PSIM",
    "clearingBroker": "0226",
    "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "PSIN",
    "clearingBroker": "0443",
    "brokerName": "LUMENT SECURITIES, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "PSUT",
    "clearingBroker": "0235",
    "brokerName": "INNOVATION PARTNERS LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "PTCM",
    "clearingBroker": "0443",
    "brokerName": "CAVU SECURITIES LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "PTIS",
    "clearingBroker": "0235",
    "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
  },
  {
    "type": "CORP",
    "mpid": "PUPL",
    "clearingBroker": "0226",
    "brokerName": "PUPLAVA SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "PURP",
    "clearingBroker": "0279",
    "brokerName": "LIBERTY CAPITAL INVESTMENT CORPORATION                                "
  },
  {
    "type": "CORP",
    "mpid": "PWAS",
    "clearingBroker": "0443",
    "brokerName": "PWA SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "PWJC",
    "clearingBroker": "0221",
    "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "PXGJ",
    "clearingBroker": "0352",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "CORP",
    "mpid": "QBND",
    "clearingBroker": "0161",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "CORP",
    "mpid": "QBSI",
    "clearingBroker": "0226",
    "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "QCAP",
    "clearingBroker": "0235",
    "brokerName": "QUINT CAPITAL CORPORATION                                             "
  },
  {
    "type": "CORP",
    "mpid": "QCAS",
    "clearingBroker": "0226",
    "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
  },
  {
    "type": "CORP",
    "mpid": "QMSR",
    "clearingBroker": "0235",
    "brokerName": "QUATTRO M SECURITIES INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "QUOI",
    "clearingBroker": "0279",
    "brokerName": "QUOIN CAPITAL LLC                                                     "
  },
  {
    "type": "CORP",
    "mpid": "QWIK",
    "clearingBroker": "0161",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "CORP",
    "mpid": "RAAA",
    "clearingBroker": "0052",
    "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "RAAI",
    "clearingBroker": "0226",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "RABO",
    "clearingBroker": "0443",
    "brokerName": "RABO SECURITIES USA, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "RACO",
    "clearingBroker": "0158",
    "brokerName": "SHEARMAN, RALSTON, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "RAJA",
    "clearingBroker": "0725",
    "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "RAJC",
    "clearingBroker": "0443",
    "brokerName": "RAYMOND JAMES USA                                                     "
  },
  {
    "type": "CORP",
    "mpid": "RAYG",
    "clearingBroker": "0443",
    "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
  },
  {
    "type": "CORP",
    "mpid": "RBAC",
    "clearingBroker": "0443",
    "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "RBCD",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
  },
  {
    "type": "CORP",
    "mpid": "RBCM",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
  },
  {
    "type": "CORP",
    "mpid": "RBCX",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
  },
  {
    "type": "CORP",
    "mpid": "RBII",
    "clearingBroker": "0279",
    "brokerName": "REGIONAL BROKERS, INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "RCMA",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS ARBITRAGE, S.A.                                   "
  },
  {
    "type": "CORP",
    "mpid": "RCRS",
    "clearingBroker": "0226",
    "brokerName": "ROOSEVELT & CROSS, INCORPORATED                                       "
  },
  {
    "type": "CORP",
    "mpid": "RDSS",
    "clearingBroker": "0141",
    "brokerName": "RDSC, LLC                                                             "
  },
  {
    "type": "CORP",
    "mpid": "REGN",
    "clearingBroker": "0443",
    "brokerName": "REGIONS SECURITIES LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "REGR",
    "clearingBroker": "0141",
    "brokerName": "REGISTER & AKERS INVESTMENTS, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "REVL",
    "clearingBroker": "0750",
    "brokerName": "REVL SECURITIES, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "RFAI",
    "clearingBroker": "0725",
    "brokerName": "RYAN FINANCIAL, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "RFRC",
    "clearingBroker": "0279",
    "brokerName": "THE ROCKWELL FINANCIAL GROUP, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "RGLD",
    "clearingBroker": "0279",
    "brokerName": "REGAL SECURITIES, INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "RGLS",
    "clearingBroker": "0235",
    "brokerName": "REGAL SECURITIES, INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "RHDS",
    "clearingBroker": "0141",
    "brokerName": "RHODES SECURITIES, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "RHOX",
    "clearingBroker": "0005",
    "brokerName": "XR SECURITIES LLC                                                     "
  },
  {
    "type": "CORP",
    "mpid": "RIAP",
    "clearingBroker": "0443",
    "brokerName": "OSAIC SERVICES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "RICE",
    "clearingBroker": "0235",
    "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
  },
  {
    "type": "CORP",
    "mpid": "RICJ",
    "clearingBroker": "0235",
    "brokerName": "RICE SECURITIES, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "RICM",
    "clearingBroker": "0595",
    "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
  },
  {
    "type": "CORP",
    "mpid": "RIED",
    "clearingBroker": "0235",
    "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
  },
  {
    "type": "CORP",
    "mpid": "RILY",
    "clearingBroker": "0226",
    "brokerName": "B. RILEY FBR, INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "RJFI",
    "clearingBroker": "0390",
    "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "RJFS",
    "clearingBroker": "0725",
    "brokerName": "RAYMOND JAMES FINANCIAL SVCS. INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "RKWS",
    "clearingBroker": "0235",
    "brokerName": "ROCKWELL SECURITIES LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "RLIN",
    "clearingBroker": "0005",
    "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "RMAC",
    "clearingBroker": "0235",
    "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "RMPI",
    "clearingBroker": "0141",
    "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "RMST",
    "clearingBroker": "0443",
    "brokerName": "R.M. STARK & CO., INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "ROAR",
    "clearingBroker": "0103",
    "brokerName": "DINOSAUR SECURITIES                                                   "
  },
  {
    "type": "CORP",
    "mpid": "ROBT",
    "clearingBroker": "0443",
    "brokerName": "ROBOTTI & COMPANY, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "ROCK",
    "clearingBroker": "0226",
    "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "ROCM",
    "clearingBroker": "0443",
    "brokerName": "RIM SECURITIES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "ROMO",
    "clearingBroker": "0141",
    "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
  },
  {
    "type": "CORP",
    "mpid": "RONI",
    "clearingBroker": "0005",
    "brokerName": "RONIN CAPITAL, LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "ROTB",
    "clearingBroker": "0235",
    "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "ROTH",
    "clearingBroker": "0161",
    "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "ROYL",
    "clearingBroker": "0443",
    "brokerName": "ROYAL ALLIANCE ASSOCIATES, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "RPTR",
    "clearingBroker": "0235",
    "brokerName": "DINOSAUR SECURITIES, L.L.C.                                           "
  },
  {
    "type": "CORP",
    "mpid": "RQDR",
    "clearingBroker": "0235",
    "brokerName": "RQD* CLEARING LLC                                                     "
  },
  {
    "type": "CORP",
    "mpid": "RREZ",
    "clearingBroker": "0443",
    "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "RRII",
    "clearingBroker": "0388",
    "brokerName": "ROBERTS & RYAN INVESTMENTS, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "RRUD",
    "clearingBroker": "0235",
    "brokerName": "REID & RUDIGER, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "RSCM",
    "clearingBroker": "0235",
    "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
  },
  {
    "type": "CORP",
    "mpid": "RSSE",
    "clearingBroker": "0443",
    "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
  },
  {
    "type": "CORP",
    "mpid": "RTHS",
    "clearingBroker": "0443",
    "brokerName": "ROTHSCHILD INVESTMENT CORPORATION                                     "
  },
  {
    "type": "CORP",
    "mpid": "RWSM",
    "clearingBroker": "0279",
    "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "RYDS",
    "clearingBroker": "0235",
    "brokerName": "RBC DOMINION SECURITIES CORPORATION                                   "
  },
  {
    "type": "CORP",
    "mpid": "SABS",
    "clearingBroker": "0443",
    "brokerName": "SABADELL SECURITIES USA, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "SAFX",
    "clearingBroker": "0235",
    "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "SAGE",
    "clearingBroker": "0141",
    "brokerName": "SAGE, RUTTY & CO., INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "SALB",
    "clearingBroker": "0274",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC./SALOMON BROTHERS                        "
  },
  {
    "type": "CORP",
    "mpid": "SALI",
    "clearingBroker": "0750",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "SAMI",
    "clearingBroker": "0226",
    "brokerName": "SAMI BROKERAGE LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "SANT",
    "clearingBroker": "0443",
    "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "SAPA",
    "clearingBroker": "0141",
    "brokerName": "SAPERSTON ASSET MANAGEMENT INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "SARG",
    "clearingBroker": "0226",
    "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
  },
  {
    "type": "CORP",
    "mpid": "SAXO",
    "clearingBroker": "0443",
    "brokerName": "SAXONY SECURITIES                                                     "
  },
  {
    "type": "CORP",
    "mpid": "SBAM",
    "clearingBroker": "0443",
    "brokerName": "INVESTMENT PROFESSIONALS, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "SBLS",
    "clearingBroker": "0235",
    "brokerName": "SAN BLAS SECURITIES LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "SBLT",
    "clearingBroker": "0226",
    "brokerName": "SUNBELT SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "SBRO",
    "clearingBroker": "0443",
    "brokerName": "STERN BROTHERS & CO.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "SBRT",
    "clearingBroker": "0226",
    "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "SBRX",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "SBSC",
    "clearingBroker": "0226",
    "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
  },
  {
    "type": "CORP",
    "mpid": "SBSI",
    "clearingBroker": "0103",
    "brokerName": "SUN'S BROTHERS SECURITIES INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "SBSL",
    "clearingBroker": "1043",
    "brokerName": "STOCKBLOCK SECURITIES LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "SCAP",
    "clearingBroker": "0595",
    "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "SCIL",
    "clearingBroker": "0052",
    "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
  },
  {
    "type": "CORP",
    "mpid": "SCMC",
    "clearingBroker": "0096",
    "brokerName": "SCOTIA CAPITAL MARKETS (USA) INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "SCSS",
    "clearingBroker": "0750",
    "brokerName": "STONECASTLE SECURITIES, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "SCTI",
    "clearingBroker": "0443",
    "brokerName": "SECURITY CAPITAL BROKERAGE, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "SCTL",
    "clearingBroker": "0443",
    "brokerName": "SENTINEL SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "SDDC",
    "clearingBroker": "0443",
    "brokerName": "SDDCO BROKERAGE AQDVISORS                                             "
  },
  {
    "type": "CORP",
    "mpid": "SDIC",
    "clearingBroker": "0235",
    "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
  },
  {
    "type": "CORP",
    "mpid": "SEAP",
    "clearingBroker": "0226",
    "brokerName": "SEAPORT SECURITIES CORP.                                              "
  },
  {
    "type": "CORP",
    "mpid": "SEBS",
    "clearingBroker": "0443",
    "brokerName": "SECU BROKERAGE SERVICES                                               "
  },
  {
    "type": "CORP",
    "mpid": "SEEL",
    "clearingBroker": "0443",
    "brokerName": "R. SEELAUS & CO., INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "SEFB",
    "clearingBroker": "0052",
    "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "SEIB",
    "clearingBroker": "0158",
    "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "SEMI",
    "clearingBroker": "0443",
    "brokerName": "SEMINARIO SECURITIES                                                  "
  },
  {
    "type": "CORP",
    "mpid": "SEMT",
    "clearingBroker": "7311",
    "brokerName": "MINT BROKERS                                                          "
  },
  {
    "type": "CORP",
    "mpid": "SEND",
    "clearingBroker": "0443",
    "brokerName": "SENDERO SECURITIES                                                    "
  },
  {
    "type": "CORP",
    "mpid": "SERL",
    "clearingBroker": "0443",
    "brokerName": "SEARLE & CO.                                                          "
  },
  {
    "type": "CORP",
    "mpid": "SEVN",
    "clearingBroker": "0443",
    "brokerName": "NATIONWIDE SECURITIES                                                 "
  },
  {
    "type": "CORP",
    "mpid": "SFGB",
    "clearingBroker": "0161",
    "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
  },
  {
    "type": "CORP",
    "mpid": "SFPS",
    "clearingBroker": "0443",
    "brokerName": "SF INVESTMENTS, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "SFSI",
    "clearingBroker": "0235",
    "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "SGAS",
    "clearingBroker": "0286",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "SGBI",
    "clearingBroker": "0226",
    "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "SGFC",
    "clearingBroker": "0226",
    "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
  },
  {
    "type": "CORP",
    "mpid": "SGLC",
    "clearingBroker": "0235",
    "brokerName": "S.G. LONG & COMPANY                                                   "
  },
  {
    "type": "CORP",
    "mpid": "SGNL",
    "clearingBroker": "0279",
    "brokerName": "SIGNAL SECURITIES, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "SGSM",
    "clearingBroker": "1043",
    "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "SHMR",
    "clearingBroker": "0443",
    "brokerName": "ABN AMRO CLEARING USA LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "SHOT",
    "clearingBroker": "0005",
    "brokerName": "SCHOTTENFELD GROUP LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "SIAN",
    "clearingBroker": "0443",
    "brokerName": "SECURIAN FINANCIAL SERVICES                                           "
  },
  {
    "type": "CORP",
    "mpid": "SJGM",
    "clearingBroker": "0443",
    "brokerName": "SCOTT JAMES GROUP, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "SKTR",
    "clearingBroker": "0279",
    "brokerName": "STOCK TRADERS                                                         "
  },
  {
    "type": "CORP",
    "mpid": "SLRD",
    "clearingBroker": "0226",
    "brokerName": "S.L. REED & COMPANY                                                   "
  },
  {
    "type": "CORP",
    "mpid": "SMCO",
    "clearingBroker": "0235",
    "brokerName": "SMITH, MOORE & CO.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "SMHI",
    "clearingBroker": "0443",
    "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "SMNS",
    "clearingBroker": "0226",
    "brokerName": "PARKLAND SECURITIES, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "SMPR",
    "clearingBroker": "0443",
    "brokerName": "SUMMIT BROKERAGE SERVICES, INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "SMRD",
    "clearingBroker": "0443",
    "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "SMRI",
    "clearingBroker": "0226",
    "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
  },
  {
    "type": "CORP",
    "mpid": "SNEX",
    "clearingBroker": "0750",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "SNWS",
    "clearingBroker": "0443",
    "brokerName": "SNOWDEN ACCOUNT SERVICES, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "SOCO",
    "clearingBroker": "0443",
    "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "SOFI",
    "clearingBroker": "0158",
    "brokerName": "SOFI SECURITIES LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "SOGO",
    "clearingBroker": "0158",
    "brokerName": "WANG INVESTMENT ASSOCIATES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "SORS",
    "clearingBroker": "0235",
    "brokerName": "SORSBY FINANCIAL CORP.                                                "
  },
  {
    "type": "CORP",
    "mpid": "SOVG",
    "clearingBroker": "8199",
    "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "SPAC",
    "clearingBroker": "0793",
    "brokerName": "SIERRA PACIFIC SECURITIES, LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "SPCS",
    "clearingBroker": "0052",
    "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "SPEX",
    "clearingBroker": "0235",
    "brokerName": "INSPEREX LLC                                                          "
  },
  {
    "type": "CORP",
    "mpid": "SPGS",
    "clearingBroker": "0443",
    "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "SPHN",
    "clearingBroker": "0443",
    "brokerName": "STEPHENS INC.                                                         "
  },
  {
    "type": "CORP",
    "mpid": "SPLC",
    "clearingBroker": "0226",
    "brokerName": "SPIRE SECURITIES, LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "SPLD",
    "clearingBroker": "0443",
    "brokerName": "SPIRE SECURITIES, LLC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "SPLN",
    "clearingBroker": "8199",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "SPOT",
    "clearingBroker": "0005",
    "brokerName": "SPOT TRADING                                                          "
  },
  {
    "type": "CORP",
    "mpid": "SPTD",
    "clearingBroker": "0052",
    "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "SPTS",
    "clearingBroker": "0158",
    "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "SRAM",
    "clearingBroker": "0443",
    "brokerName": "SAMCO CAPITAL MARKETS, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "SRBC",
    "clearingBroker": "0235",
    "brokerName": "SPIDERROCK EXS, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "SSBS",
    "clearingBroker": "0443",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "SSCO",
    "clearingBroker": "8457",
    "brokerName": "SAFRA SECURITIES LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "SSGC",
    "clearingBroker": "0226",
    "brokerName": "SIGNATURE SECURITIES                                                  "
  },
  {
    "type": "CORP",
    "mpid": "SSGM",
    "clearingBroker": "0226",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "SSGR",
    "clearingBroker": "0443",
    "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "SSIN",
    "clearingBroker": "0226",
    "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "SSLC",
    "clearingBroker": "0279",
    "brokerName": "SANDERLIN SECURITIES, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "SSLL",
    "clearingBroker": "0189",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "SSNE",
    "clearingBroker": "0226",
    "brokerName": "SANTANDER SECURITIES LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "SSNG",
    "clearingBroker": "0443",
    "brokerName": "SISUNG SECURITIES CORPORATION                                         "
  },
  {
    "type": "CORP",
    "mpid": "STCM",
    "clearingBroker": "2095",
    "brokerName": "TRUIST SECURITIES, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "STEP",
    "clearingBroker": "0235",
    "brokerName": "FERRETTI GROUP, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "STFC",
    "clearingBroker": "0443",
    "brokerName": "STUART FRANKEL & CO., INCORPORATED                                    "
  },
  {
    "type": "CORP",
    "mpid": "STFG",
    "clearingBroker": "0443",
    "brokerName": "STANFORD GROUP COMPANY                                                "
  },
  {
    "type": "CORP",
    "mpid": "STFL",
    "clearingBroker": "0793",
    "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
  },
  {
    "type": "CORP",
    "mpid": "STGC",
    "clearingBroker": "0279",
    "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
  },
  {
    "type": "CORP",
    "mpid": "STKP",
    "clearingBroker": "0158",
    "brokerName": "STOCKPILE INVESTMENTS, INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "STOX",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "STRM",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "CORP",
    "mpid": "STRS",
    "clearingBroker": "0161",
    "brokerName": "STRATEGAS RESEARCH PARTNERS, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "STSM",
    "clearingBroker": "0443",
    "brokerName": "STERLING SMITH CORPORATION                                            "
  },
  {
    "type": "CORP",
    "mpid": "STTT",
    "clearingBroker": "0052",
    "brokerName": "STATETRUST INVESTMENTS INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "STUR",
    "clearingBroker": "0158",
    "brokerName": "STURDIVANT & CO., INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "STXG",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "STXW",
    "clearingBroker": "0443",
    "brokerName": "SA STONE WEALTH MANAGEMENT INC.                                       "
  },
  {
    "type": "CORP",
    "mpid": "SUFI",
    "clearingBroker": "0551",
    "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "SUMI",
    "clearingBroker": "0443",
    "brokerName": "SMBC NIKKO SECURITIES AMERICA, INC.                                   "
  },
  {
    "type": "CORP",
    "mpid": "SUSQ",
    "clearingBroker": "0551",
    "brokerName": "SUSQUEHANNA CAPITAL GROUP                                             "
  },
  {
    "type": "CORP",
    "mpid": "SUST",
    "clearingBroker": "0235",
    "brokerName": "SUNSTREET SECURITIES, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "SVSI",
    "clearingBroker": "0725",
    "brokerName": "SILICON VALLEY SECURITIES, INC                                        "
  },
  {
    "type": "CORP",
    "mpid": "SWBC",
    "clearingBroker": "0443",
    "brokerName": "SWBC INVESTMENT SERVICES, LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "SWSS",
    "clearingBroker": "0443",
    "brokerName": "SANCTUARY SECURITIES, INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "SWST",
    "clearingBroker": "0279",
    "brokerName": "HILLTOP SECURITIES INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "SYCA",
    "clearingBroker": "0443",
    "brokerName": "SYNDICATED CAPITAL, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "TAFI",
    "clearingBroker": "0443",
    "brokerName": "NATHAN HALE CAPITAL, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "TAGB",
    "clearingBroker": "0052",
    "brokerName": "TAGLICH BROTHERS, INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "TAGC",
    "clearingBroker": "1043",
    "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "TAGD",
    "clearingBroker": "1043",
    "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "TALR",
    "clearingBroker": "0725",
    "brokerName": "TAYLOR SECURITIES, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "TBCL",
    "clearingBroker": "0750",
    "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "TBCR",
    "clearingBroker": "0235",
    "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "TBIA",
    "clearingBroker": "0158",
    "brokerName": "TRADIER BROKERAGE, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "TBIS",
    "clearingBroker": "0158",
    "brokerName": "TRADIER BROKERAGE, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "TBRD",
    "clearingBroker": "0226",
    "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
  },
  {
    "type": "CORP",
    "mpid": "TCBI",
    "clearingBroker": "0443",
    "brokerName": "TCBI SECURITIES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "TDCO",
    "clearingBroker": "0235",
    "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "TDFS",
    "clearingBroker": "0052",
    "brokerName": "TRADERFIELD SECURITIES INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "TDNF",
    "clearingBroker": "2568",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "TDPA",
    "clearingBroker": "0226",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "TDPW",
    "clearingBroker": "0443",
    "brokerName": "TD PRIVATE CLIENT WEALTH, LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "TDSI",
    "clearingBroker": "2568",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "TEDP",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "TERA",
    "clearingBroker": "0443",
    "brokerName": "CETERA FINANCIAL SPECIALISTS                                          "
  },
  {
    "type": "CORP",
    "mpid": "TFAI",
    "clearingBroker": "0226",
    "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
  },
  {
    "type": "CORP",
    "mpid": "TFAS",
    "clearingBroker": "0443",
    "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
  },
  {
    "type": "CORP",
    "mpid": "TFSL",
    "clearingBroker": "0235",
    "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
  },
  {
    "type": "CORP",
    "mpid": "TFSS",
    "clearingBroker": "0443",
    "brokerName": "TFS SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "TGHS",
    "clearingBroker": "0443",
    "brokerName": "TGH SECURITIES, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "THEM",
    "clearingBroker": "0235",
    "brokerName": "THEMIS TRADING LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "THNK",
    "clearingBroker": "0052",
    "brokerName": "THINKEQUITY, LLC                                                      "
  },
  {
    "type": "CORP",
    "mpid": "TIAD",
    "clearingBroker": "8199",
    "brokerName": "TRIAD SECURITIES                                                      "
  },
  {
    "type": "CORP",
    "mpid": "TIAN",
    "clearingBroker": "0226",
    "brokerName": "TRIAD SECURITIES CORP                                                 "
  },
  {
    "type": "CORP",
    "mpid": "TIGC",
    "clearingBroker": "0235",
    "brokerName": "NELSONREID, INC.                                                      "
  },
  {
    "type": "CORP",
    "mpid": "TIGE",
    "clearingBroker": "1043",
    "brokerName": "US TIGER SECURITIES, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "TJMB",
    "clearingBroker": "1043",
    "brokerName": "TJM INVESTMENTS, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "TKNG",
    "clearingBroker": "0158",
    "brokerName": "TRADEKING LLC                                                         "
  },
  {
    "type": "CORP",
    "mpid": "TMAS",
    "clearingBroker": "0235",
    "brokerName": "TRADEMAS INC.                                                         "
  },
  {
    "type": "CORP",
    "mpid": "TMCC",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "CORP",
    "mpid": "TMCD",
    "clearingBroker": "0235",
    "brokerName": "MCDONALD PARTNERS LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "TOCQ",
    "clearingBroker": "0443",
    "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
  },
  {
    "type": "CORP",
    "mpid": "TONE",
    "clearingBroker": "8199",
    "brokerName": "2021 CAPITAL                                                          "
  },
  {
    "type": "CORP",
    "mpid": "TORO",
    "clearingBroker": "0279",
    "brokerName": "VALDES & MORENO, INC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "TOUR",
    "clearingBroker": "0005",
    "brokerName": "TOURMALINE PARTNERS, LLC                                              "
  },
  {
    "type": "CORP",
    "mpid": "TOYS",
    "clearingBroker": "0443",
    "brokerName": "TOYOTA FINANCIAL SERVICES SECURITIES USA CORPORATION                  "
  },
  {
    "type": "CORP",
    "mpid": "TPCD",
    "clearingBroker": "0624",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "TPIS",
    "clearingBroker": "0161",
    "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
  },
  {
    "type": "CORP",
    "mpid": "TPMG",
    "clearingBroker": "0005",
    "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "TPMR",
    "clearingBroker": "0141",
    "brokerName": "TRADE-PMR INC.                                                        "
  },
  {
    "type": "CORP",
    "mpid": "TRAD",
    "clearingBroker": "0271",
    "brokerName": "TRADESTATION SECURITIES, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "TRCG",
    "clearingBroker": "0005",
    "brokerName": "TRC MARKETS LLC                                                       "
  },
  {
    "type": "CORP",
    "mpid": "TRCS",
    "clearingBroker": "0388",
    "brokerName": "TIGERRISK CAPITAL MARKETS & ADVISORY                                  "
  },
  {
    "type": "CORP",
    "mpid": "TREX",
    "clearingBroker": "1043",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "CORP",
    "mpid": "TRIB",
    "clearingBroker": "0235",
    "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "TRIP",
    "clearingBroker": "0235",
    "brokerName": "TRIDENT PARTNERS LTD                                                  "
  },
  {
    "type": "CORP",
    "mpid": "TRSH",
    "clearingBroker": "0279",
    "brokerName": "THRASHER & CHAMBERS, INC.                                             "
  },
  {
    "type": "CORP",
    "mpid": "TRUB",
    "clearingBroker": "0141",
    "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "TRWN",
    "clearingBroker": "0443",
    "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "TRYC",
    "clearingBroker": "0158",
    "brokerName": "SIXTEEN SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "TRYN",
    "clearingBroker": "0279",
    "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "TSCD",
    "clearingBroker": "0235",
    "brokerName": "STURGES COMPANY (THE)                                                 "
  },
  {
    "type": "CORP",
    "mpid": "TSER",
    "clearingBroker": "0161",
    "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "TSFA",
    "clearingBroker": "0443",
    "brokerName": "STRATEGIC FINANCIAL ALLIANCE (THE)                                    "
  },
  {
    "type": "CORP",
    "mpid": "TSSM",
    "clearingBroker": "0161",
    "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
  },
  {
    "type": "CORP",
    "mpid": "TTSC",
    "clearingBroker": "0052",
    "brokerName": "TREND TRADE SECURITIES LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "TTSI",
    "clearingBroker": "0158",
    "brokerName": "T3 SECURITIES, INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "TWCM",
    "clearingBroker": "0443",
    "brokerName": "TOWERS WATSON CAPITAL MARKETS                                         "
  },
  {
    "type": "CORP",
    "mpid": "TWDI",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "TWDL",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "TWDP",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "TWDR",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "TWDS",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "TWTT",
    "clearingBroker": "0158",
    "brokerName": "TASTYWORKS, INC.                                                      "
  },
  {
    "type": "CORP",
    "mpid": "UBSI",
    "clearingBroker": "0141",
    "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
  },
  {
    "type": "CORP",
    "mpid": "UBSW",
    "clearingBroker": "0642",
    "brokerName": "UBS SECURITIES LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "UCAP",
    "clearingBroker": "0750",
    "brokerName": "UCAP SECURITIES LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "UCCM",
    "clearingBroker": "0279",
    "brokerName": "CU INVESTMENT SOLUTIONS, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "UCML",
    "clearingBroker": "0052",
    "brokerName": "UNITED CAPITAL MARKETS, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "UFPF",
    "clearingBroker": "0226",
    "brokerName": "UNITED FIRST PARTNERS, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "UHLM",
    "clearingBroker": "0235",
    "brokerName": "UHLMANN PRICE SECURITIES, LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "UMBF",
    "clearingBroker": "0226",
    "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "UNIB",
    "clearingBroker": "0443",
    "brokerName": "UNIBANCO SECURITIES INC                                               "
  },
  {
    "type": "CORP",
    "mpid": "UNIV",
    "clearingBroker": "0595",
    "brokerName": "UNIVEST SECURITIES, LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "UNTD",
    "clearingBroker": "0443",
    "brokerName": "WADDELL & REED, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "UPLN",
    "clearingBroker": "0443",
    "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
  },
  {
    "type": "CORP",
    "mpid": "USAF",
    "clearingBroker": "0443",
    "brokerName": "USA FINANCIAL SECURITIES CORP.                                        "
  },
  {
    "type": "CORP",
    "mpid": "USCA",
    "clearingBroker": "0226",
    "brokerName": "USCA SECURITIES LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "USDB",
    "clearingBroker": "0279",
    "brokerName": "U.S. BROKERAGE, INC.                                                  "
  },
  {
    "type": "CORP",
    "mpid": "USIC",
    "clearingBroker": "0226",
    "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
  },
  {
    "type": "CORP",
    "mpid": "USSI",
    "clearingBroker": "0279",
    "brokerName": "U.S. STERLING SECURITIES, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "USTZ",
    "clearingBroker": "0595",
    "brokerName": "TRADEZERO AMERINCA, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "UVST",
    "clearingBroker": "0443",
    "brokerName": "UVEST FINANCIAL SERVICES GROUP, INC.                                  "
  },
  {
    "type": "CORP",
    "mpid": "VABD",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "CORP",
    "mpid": "VALI",
    "clearingBroker": "0226",
    "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "VALM",
    "clearingBroker": "0443",
    "brokerName": "VALMARK SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "VBCS",
    "clearingBroker": "0279",
    "brokerName": "VBC SECURITIES                                                        "
  },
  {
    "type": "CORP",
    "mpid": "VBLT",
    "clearingBroker": "0226",
    "brokerName": "VANDERBILT SECURITIES, LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "VBSL",
    "clearingBroker": "0595",
    "brokerName": "VISION BROKERAGE SERVICES, LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "VCAP",
    "clearingBroker": "0443",
    "brokerName": "VANGUARD CAPITAL                                                      "
  },
  {
    "type": "CORP",
    "mpid": "VCAS",
    "clearingBroker": "0443",
    "brokerName": "VCA SECURITIES, LP                                                    "
  },
  {
    "type": "CORP",
    "mpid": "VCFN",
    "clearingBroker": "0235",
    "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
  },
  {
    "type": "CORP",
    "mpid": "VCPL",
    "clearingBroker": "0443",
    "brokerName": "VELOCITY CLEARING, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "VCSV",
    "clearingBroker": "0052",
    "brokerName": "PRIMARY CAPITAL, LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "VENE",
    "clearingBroker": "0443",
    "brokerName": "VENECREDIT SECURITIES                                                 "
  },
  {
    "type": "CORP",
    "mpid": "VERF",
    "clearingBroker": "0235",
    "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "VERT",
    "clearingBroker": "8199",
    "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
  },
  {
    "type": "CORP",
    "mpid": "VEST",
    "clearingBroker": "0750",
    "brokerName": "VESTECH SECURITIES, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "VETS",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
  },
  {
    "type": "CORP",
    "mpid": "VFSL",
    "clearingBroker": "0443",
    "brokerName": "VALOR FINANCIAL SECURITIES LLC                                        "
  },
  {
    "type": "CORP",
    "mpid": "VGRD",
    "clearingBroker": "0062",
    "brokerName": "VANGUARD MARKETING CORPORATION                                        "
  },
  {
    "type": "CORP",
    "mpid": "VISI",
    "clearingBroker": "0443",
    "brokerName": "VISION INVESTMENT SERVICES, INC.                                      "
  },
  {
    "type": "CORP",
    "mpid": "VKMI",
    "clearingBroker": "0692",
    "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "VLEO",
    "clearingBroker": "0158",
    "brokerName": "VOLEO USA, INC                                                        "
  },
  {
    "type": "CORP",
    "mpid": "VMDI",
    "clearingBroker": "0443",
    "brokerName": "DESJARDINS SECURITIES INTERNATIONAL INC.                              "
  },
  {
    "type": "CORP",
    "mpid": "VMEX",
    "clearingBroker": "0443",
    "brokerName": "VECTORGLOBAL WMG                                                      "
  },
  {
    "type": "CORP",
    "mpid": "VPEW",
    "clearingBroker": "0158",
    "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
  },
  {
    "type": "CORP",
    "mpid": "VSIN",
    "clearingBroker": "0595",
    "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "VSRF",
    "clearingBroker": "0141",
    "brokerName": "VSR FINANCIAL SERVICES                                                "
  },
  {
    "type": "CORP",
    "mpid": "VTDT",
    "clearingBroker": "0158",
    "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "VTRN",
    "clearingBroker": "0443",
    "brokerName": "BANCROFT CAPITAL, LLC                                                 "
  },
  {
    "type": "CORP",
    "mpid": "WABR",
    "clearingBroker": "0443",
    "brokerName": "WALL STREET ACCESS                                                    "
  },
  {
    "type": "CORP",
    "mpid": "WACC",
    "clearingBroker": "0279",
    "brokerName": "MIDLAND SECURITIES, LTD                                               "
  },
  {
    "type": "CORP",
    "mpid": "WACL",
    "clearingBroker": "0709",
    "brokerName": "WACHTEL & CO., INC.                                                   "
  },
  {
    "type": "CORP",
    "mpid": "WAIN",
    "clearingBroker": "0443",
    "brokerName": "H.C. WAINWRIGHT & CO., INC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "WBAX",
    "clearingBroker": "0052",
    "brokerName": "WALLACHBETH CAPITAL LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "WBBC",
    "clearingBroker": "0226",
    "brokerName": "WBB SECURITIES, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "WBET",
    "clearingBroker": "0161",
    "brokerName": "WALLACHBETH CAPITAL LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "WBFS",
    "clearingBroker": "0443",
    "brokerName": "WOODBURY FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "WBLR",
    "clearingBroker": "0771",
    "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
  },
  {
    "type": "CORP",
    "mpid": "WBNA",
    "clearingBroker": "2072",
    "brokerName": "WELLS FARGO BANK, N.A./SIG                                            "
  },
  {
    "type": "CORP",
    "mpid": "WBNF",
    "clearingBroker": "0226",
    "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
  },
  {
    "type": "CORP",
    "mpid": "WBRO",
    "clearingBroker": "0443",
    "brokerName": "WILEY BROS.-AINTREE CAPITAL, LLC                                      "
  },
  {
    "type": "CORP",
    "mpid": "WBUL",
    "clearingBroker": "0158",
    "brokerName": "WEBULL FINANCIAL LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "WCHV",
    "clearingBroker": "0250",
    "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "WCIG",
    "clearingBroker": "0750",
    "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "WCSC",
    "clearingBroker": "0235",
    "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
  },
  {
    "type": "CORP",
    "mpid": "WCSF",
    "clearingBroker": "0235",
    "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "WEBS",
    "clearingBroker": "0226",
    "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
  },
  {
    "type": "CORP",
    "mpid": "WEDB",
    "clearingBroker": "0103",
    "brokerName": "WEDBUSH SECURITIES INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "WEGE",
    "clearingBroker": "0443",
    "brokerName": "WORLD EQUITY GROUP, INC.                                              "
  },
  {
    "type": "CORP",
    "mpid": "WEGI",
    "clearingBroker": "0235",
    "brokerName": "WORLD EQUITY GROUP INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "WEGP",
    "clearingBroker": "0235",
    "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
  },
  {
    "type": "CORP",
    "mpid": "WESC",
    "clearingBroker": "0443",
    "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
  },
  {
    "type": "CORP",
    "mpid": "WEST",
    "clearingBroker": "0443",
    "brokerName": "WESTERN GROWERS FINANCIAL SERVICES, INC.                              "
  },
  {
    "type": "CORP",
    "mpid": "WEXM",
    "clearingBroker": "0161",
    "brokerName": "W OLVERINE EXECUTION SERVICES LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "WEXR",
    "clearingBroker": "0235",
    "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "CORP",
    "mpid": "WEXX",
    "clearingBroker": "0005",
    "brokerName": "WOLVERINE EXECUTION SERVICES                                          "
  },
  {
    "type": "CORP",
    "mpid": "WHAE",
    "clearingBroker": "0443",
    "brokerName": "WHARTON EQUITY CORPORATION                                            "
  },
  {
    "type": "CORP",
    "mpid": "WHCG",
    "clearingBroker": "0388",
    "brokerName": "WHITAKER                                                              "
  },
  {
    "type": "CORP",
    "mpid": "WHOT",
    "clearingBroker": "0595",
    "brokerName": "JUST2TRADE, INC.                                                      "
  },
  {
    "type": "CORP",
    "mpid": "WIDS",
    "clearingBroker": "0279",
    "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
  },
  {
    "type": "CORP",
    "mpid": "WING",
    "clearingBroker": "0443",
    "brokerName": "ING FINANCIAL PARTNERS, INC.                                          "
  },
  {
    "type": "CORP",
    "mpid": "WISC",
    "clearingBroker": "0235",
    "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "WISE",
    "clearingBroker": "0052",
    "brokerName": "AXOS INVEST LLC                                                       "
  },
  {
    "type": "CORP",
    "mpid": "WISP",
    "clearingBroker": "0443",
    "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
  },
  {
    "type": "CORP",
    "mpid": "WJBI",
    "clearingBroker": "0443",
    "brokerName": "WJB CAPITAL GROUP                                                     "
  },
  {
    "type": "CORP",
    "mpid": "WLMS",
    "clearingBroker": "0443",
    "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
  },
  {
    "type": "CORP",
    "mpid": "WLTH",
    "clearingBroker": "0235",
    "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
  },
  {
    "type": "CORP",
    "mpid": "WMCL",
    "clearingBroker": "0279",
    "brokerName": "WHITE MOUNTAIN CAPITAL, LLC                                           "
  },
  {
    "type": "CORP",
    "mpid": "WMFS",
    "clearingBroker": "0226",
    "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
  },
  {
    "type": "CORP",
    "mpid": "WMLL",
    "clearingBroker": "0005",
    "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
  },
  {
    "type": "CORP",
    "mpid": "WOOD",
    "clearingBroker": "0725",
    "brokerName": "ARTHUR W WOOD COMPANY                                                 "
  },
  {
    "type": "CORP",
    "mpid": "WPCC",
    "clearingBroker": "0052",
    "brokerName": "WESTPARK CAPITAL, INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "WPCI",
    "clearingBroker": "0595",
    "brokerName": "WESTPARK CAPITAL, INC.                                                "
  },
  {
    "type": "CORP",
    "mpid": "WPSG",
    "clearingBroker": "0005",
    "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
  },
  {
    "type": "CORP",
    "mpid": "WPSX",
    "clearingBroker": "0445",
    "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
  },
  {
    "type": "CORP",
    "mpid": "WRET",
    "clearingBroker": "0141",
    "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
  },
  {
    "type": "CORP",
    "mpid": "WSBI",
    "clearingBroker": "0443",
    "brokerName": "W&S BROKERAGE SVCS                                                    "
  },
  {
    "type": "CORP",
    "mpid": "WSCC",
    "clearingBroker": "0235",
    "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
  },
  {
    "type": "CORP",
    "mpid": "WSCX",
    "clearingBroker": "0235",
    "brokerName": "WORKMAN SECURITIES CORP                                               "
  },
  {
    "type": "CORP",
    "mpid": "WSEC",
    "clearingBroker": "0443",
    "brokerName": "WILLIS SECURITIES, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "WSGD",
    "clearingBroker": "8199",
    "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
  },
  {
    "type": "CORP",
    "mpid": "WSIW",
    "clearingBroker": "8199",
    "brokerName": "WEDBUSH SECURITIES INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "WSRP",
    "clearingBroker": "0052",
    "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
  },
  {
    "type": "CORP",
    "mpid": "WSTI",
    "clearingBroker": "0226",
    "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
  },
  {
    "type": "CORP",
    "mpid": "WTCO",
    "clearingBroker": "0005",
    "brokerName": "WILLIAMS TRADING LLC                                                  "
  },
  {
    "type": "CORP",
    "mpid": "WTFS",
    "clearingBroker": "0052",
    "brokerName": "LIME TRADING CORP                                                     "
  },
  {
    "type": "CORP",
    "mpid": "WTKR",
    "clearingBroker": "0388",
    "brokerName": "WHITAKER                                                              "
  },
  {
    "type": "CORP",
    "mpid": "WTLP",
    "clearingBroker": "0388",
    "brokerName": "WOLVERINE TRADING, LLC                                                "
  },
  {
    "type": "CORP",
    "mpid": "WTRI",
    "clearingBroker": "0235",
    "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
  },
  {
    "type": "CORP",
    "mpid": "WUND",
    "clearingBroker": "0141",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "CORP",
    "mpid": "WVBD",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "WZVB",
    "clearingBroker": "0725",
    "brokerName": "IMPACTIVE ADVISORS, LLC                                               "
  },
  {
    "type": "CORP",
    "mpid": "XCNC",
    "clearingBroker": "0005",
    "brokerName": "C&C TRADING L.L.C.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "XPUS",
    "clearingBroker": "0443",
    "brokerName": "XP SECURITIES, LLC                                                    "
  },
  {
    "type": "CORP",
    "mpid": "XRVR",
    "clearingBroker": "0279",
    "brokerName": "CRB SECURITIES, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "XTLS",
    "clearingBroker": "0052",
    "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "XTLW",
    "clearingBroker": "0052",
    "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
  },
  {
    "type": "CORP",
    "mpid": "XTXE",
    "clearingBroker": "0161",
    "brokerName": "XTX EXECUTION SERVICES LLC                                            "
  },
  {
    "type": "CORP",
    "mpid": "YLPL",
    "clearingBroker": "0075",
    "brokerName": "LPL FINANCIAL LLC                                                     "
  },
  {
    "type": "CORP",
    "mpid": "YOSE",
    "clearingBroker": "0052",
    "brokerName": "YORK SECURITIES, INC.                                                 "
  },
  {
    "type": "CORP",
    "mpid": "ZAHK",
    "clearingBroker": "0443",
    "brokerName": "TRANSAMERICA FINANCIAL ADVISORS                                       "
  },
  {
    "type": "CORP",
    "mpid": "ZAND",
    "clearingBroker": "0443",
    "brokerName": "MCLAUGHLIN RYDER INVESTMENTS                                          "
  },
  {
    "type": "CORP",
    "mpid": "ZEDB",
    "clearingBroker": "0161",
    "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "CORP",
    "mpid": "ZERO",
    "clearingBroker": "0158",
    "brokerName": "TRADEZERO AMERICA, INC.                                               "
  },
  {
    "type": "CORP",
    "mpid": "ZEUS",
    "clearingBroker": "0443",
    "brokerName": "ZEUS FINANCIAL, LLC                                                   "
  },
  {
    "type": "CORP",
    "mpid": "ZION",
    "clearingBroker": "0065",
    "brokerName": "ZIONS DIRECT, INC.                                                    "
  },
  {
    "type": "CORP",
    "mpid": "ZIVI",
    "clearingBroker": "0235",
    "brokerName": "ZIV INVESTMENT COMPANY                                                "
  },
  {
    "type": "CORP",
    "mpid": "ZOUL",
    "clearingBroker": "0235",
    "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "AALC",
    "clearingBroker": "0226",
    "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "ABAI",
    "clearingBroker": "0279",
    "brokerName": "ABACUS INVESTMENTS, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "ABBA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ABBK",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ABDA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ABDW",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ABEA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ABEN",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ABHE",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ABIG",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ABLE",
    "clearingBroker": "0031",
    "brokerName": "NATIXIS SECURITIES AMERICAS LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "ABPI",
    "clearingBroker": "0235",
    "brokerName": "ALLIED BEACON PARTNERS, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "ABPR",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ABRP",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ABST",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ACAD",
    "clearingBroker": "0443",
    "brokerName": "ACADEMY SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "ACAP",
    "clearingBroker": "0235",
    "brokerName": "ALAMO CAPITAL                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "ACCP",
    "clearingBroker": "0158",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "ACLP",
    "clearingBroker": "0235",
    "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "ACTI",
    "clearingBroker": "0443",
    "brokerName": "ACTIVNER SECURITIES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ADAM",
    "clearingBroker": "0161",
    "brokerName": "CANACCORD GENUITY INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "ADSO",
    "clearingBroker": "0141",
    "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "AEFS",
    "clearingBroker": "0226",
    "brokerName": "AE FINANCIAL SERVICES, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "AETL",
    "clearingBroker": "0158",
    "brokerName": "AET INVESTMENT SERVICES, LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "AFBS",
    "clearingBroker": "0158",
    "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "AFCO",
    "clearingBroker": "0284",
    "brokerName": "TD PRIME SERVICES LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "AFGT",
    "clearingBroker": "0052",
    "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "AGCO",
    "clearingBroker": "0052",
    "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "AGCP",
    "clearingBroker": "0052",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "AGES",
    "clearingBroker": "0750",
    "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
  },
  {
    "type": "MUNI",
    "mpid": "AGFA",
    "clearingBroker": "0226",
    "brokerName": "VALIC FINANCIAL ADVISORS, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "AGIS",
    "clearingBroker": "0235",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "AGPM",
    "clearingBroker": "1043",
    "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
  },
  {
    "type": "MUNI",
    "mpid": "AGSS",
    "clearingBroker": "0443",
    "brokerName": "GREAT AMERICAN ADVISORS, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "AHSI",
    "clearingBroker": "0141",
    "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "AIGF",
    "clearingBroker": "0443",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "AIGN",
    "clearingBroker": "0226",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "AIRS",
    "clearingBroker": "0279",
    "brokerName": "HAND SECURITIES, INC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "AISG",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
  },
  {
    "type": "MUNI",
    "mpid": "AJCO",
    "clearingBroker": "0443",
    "brokerName": "IDB CAPITAL CORP.                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "ALAD",
    "clearingBroker": "0235",
    "brokerName": "ALLIANCE ADVISORY & SECURITIES, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "ALCG",
    "clearingBroker": "0235",
    "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "ALCM",
    "clearingBroker": "0279",
    "brokerName": "ALPHALEDGER MARKETS, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ALDN",
    "clearingBroker": "0052",
    "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ALGP",
    "clearingBroker": "0235",
    "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
  },
  {
    "type": "MUNI",
    "mpid": "ALIS",
    "clearingBroker": "0235",
    "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "ALLS",
    "clearingBroker": "0443",
    "brokerName": "ALLARIA SECURITIES, LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "ALNC",
    "clearingBroker": "0226",
    "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
  },
  {
    "type": "MUNI",
    "mpid": "ALTR",
    "clearingBroker": "3164",
    "brokerName": "ALTRUIST FINANCIAL LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "AMBB",
    "clearingBroker": "0141",
    "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
  },
  {
    "type": "MUNI",
    "mpid": "AMER",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
  },
  {
    "type": "MUNI",
    "mpid": "AMGN",
    "clearingBroker": "0443",
    "brokerName": "AMERICAN GENERAL SECURITIES INCORPORATED                              "
  },
  {
    "type": "MUNI",
    "mpid": "AMIC",
    "clearingBroker": "0226",
    "brokerName": "AMERICAN INVESTORS COMPANY                                            "
  },
  {
    "type": "MUNI",
    "mpid": "AMLU",
    "clearingBroker": "3652",
    "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "AMMI",
    "clearingBroker": "0443",
    "brokerName": "AM&M INVESTMENT BROKERS, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "AMMS",
    "clearingBroker": "0141",
    "brokerName": "AMUNI FINANCIAL, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "ANDB",
    "clearingBroker": "0443",
    "brokerName": "ANDBANC BROKERAGE, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "ANDG",
    "clearingBroker": "0235",
    "brokerName": "GARRETT (ANDREW), INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "ANOS",
    "clearingBroker": "0235",
    "brokerName": "ABEL NOSER, LLC.                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "ANOV",
    "clearingBroker": "0750",
    "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "ANSR",
    "clearingBroker": "0443",
    "brokerName": "ANDERSON & STRUDWICK, INCORPORATED                                    "
  },
  {
    "type": "MUNI",
    "mpid": "AORP",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "APBD",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "APBO",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "APFS",
    "clearingBroker": "0443",
    "brokerName": "AMERICA'S PORTFOLIO'S                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "APRT",
    "clearingBroker": "0226",
    "brokerName": "PARTNERS                                                              "
  },
  {
    "type": "MUNI",
    "mpid": "APTO",
    "clearingBroker": "0103",
    "brokerName": "APTO PARTNERS, LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "APXO",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "APXS",
    "clearingBroker": "0052",
    "brokerName": "APEXUS CAPITAL LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "AQUB",
    "clearingBroker": "0197",
    "brokerName": "AQUA SECURITIES L.P.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "ARBC",
    "clearingBroker": "0235",
    "brokerName": "ARKADIOS CAPITAL                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "ARBR",
    "clearingBroker": "6783",
    "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "ARGA",
    "clearingBroker": "0443",
    "brokerName": "AURIGA USA, INC.                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "ARKA",
    "clearingBroker": "0443",
    "brokerName": "ARKA SECURITIES, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "ARKI",
    "clearingBroker": "0226",
    "brokerName": "ARKADIOS CAPITAL                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "ARTI",
    "clearingBroker": "1043",
    "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "ARVS",
    "clearingBroker": "0443",
    "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
  },
  {
    "type": "MUNI",
    "mpid": "ASCM",
    "clearingBroker": "0052",
    "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "ASEL",
    "clearingBroker": "0370",
    "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
  },
  {
    "type": "MUNI",
    "mpid": "ASII",
    "clearingBroker": "0226",
    "brokerName": "AURORA SECURITIES                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "ASKR",
    "clearingBroker": "0141",
    "brokerName": "ASKAR CORP.                                                           "
  },
  {
    "type": "MUNI",
    "mpid": "ASOI",
    "clearingBroker": "0226",
    "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "ATIS",
    "clearingBroker": "0052",
    "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
  },
  {
    "type": "MUNI",
    "mpid": "ATMC",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "ATVT",
    "clearingBroker": "0443",
    "brokerName": "ATOMIC BROKERAGE LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "AVEN",
    "clearingBroker": "0226",
    "brokerName": "AVENTURA SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "AVEW",
    "clearingBroker": "8199",
    "brokerName": "AVENTURA SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "AVIA",
    "clearingBroker": "0443",
    "brokerName": "AVIAN SECURITIES, L.L.C.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "AVIL",
    "clearingBroker": "0158",
    "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "AVSI",
    "clearingBroker": "0443",
    "brokerName": "AMERIVET SECURITIES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "AVST",
    "clearingBroker": "0235",
    "brokerName": "ATOMIC BROKERAGE LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "AXAA",
    "clearingBroker": "0075",
    "brokerName": "AXA ADVISORS LLC                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "AXCL",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "AXIO",
    "clearingBroker": "0279",
    "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "AXOS",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "BAKR",
    "clearingBroker": "6069",
    "brokerName": "JAMES BAKER & ASSOCIATES, L.P.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "BALS",
    "clearingBroker": "0750",
    "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "BANK",
    "clearingBroker": "0701",
    "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "BARD",
    "clearingBroker": "0547",
    "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
  },
  {
    "type": "MUNI",
    "mpid": "BARR",
    "clearingBroker": "0226",
    "brokerName": "BARRETT & COMPANY                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "BAYC",
    "clearingBroker": "0161",
    "brokerName": "BAY CREST PARTNERS,  LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "BAYP",
    "clearingBroker": "0161",
    "brokerName": "BAY CREST PARTNERS, LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "BBAR",
    "clearingBroker": "0595",
    "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "BBBI",
    "clearingBroker": "0443",
    "brokerName": "BLUEBID BROKERAGE, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "BBCM",
    "clearingBroker": "1608",
    "brokerName": "BRYANT BANK                                                           "
  },
  {
    "type": "MUNI",
    "mpid": "BBGC",
    "clearingBroker": "0235",
    "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
  },
  {
    "type": "MUNI",
    "mpid": "BBID",
    "clearingBroker": "2557",
    "brokerName": "BANKERS' BANK                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "BBNI",
    "clearingBroker": "0443",
    "brokerName": "PERFORMANCE TRUST CAPITAL PARTNERS, INC.                              "
  },
  {
    "type": "MUNI",
    "mpid": "BCAP",
    "clearingBroker": "7256",
    "brokerName": "BARCLAYS CAPITAL, INC./FIXED INCOME                                   "
  },
  {
    "type": "MUNI",
    "mpid": "BCCS",
    "clearingBroker": "0443",
    "brokerName": "BAC FLORIDA INVESTMENTS CORP.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "BCIB",
    "clearingBroker": "0443",
    "brokerName": "BCI SECURITIES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "BCLE",
    "clearingBroker": "0229",
    "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
  },
  {
    "type": "MUNI",
    "mpid": "BCPI",
    "clearingBroker": "0279",
    "brokerName": "GVC CAPITAL LLC                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "BCRK",
    "clearingBroker": "0279",
    "brokerName": "BEAR CREEK SECURITIES, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "BCWM",
    "clearingBroker": "4077",
    "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "BCZC",
    "clearingBroker": "0443",
    "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
  },
  {
    "type": "MUNI",
    "mpid": "BDDK",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "BDTR",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "BEAF",
    "clearingBroker": "0235",
    "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "BEAL",
    "clearingBroker": "0443",
    "brokerName": "M.R. BEAL & COMPANY                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "BEAR",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "BECS",
    "clearingBroker": "0443",
    "brokerName": "BECKER & SUFFERN LTD.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "BELS",
    "clearingBroker": "0443",
    "brokerName": "BEL AIR SECURITIES LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "BERM",
    "clearingBroker": "0443",
    "brokerName": "BERMUDA INVESTMENT ADVISORY SERVICES                                  "
  },
  {
    "type": "MUNI",
    "mpid": "BERN",
    "clearingBroker": "0013",
    "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "BERS",
    "clearingBroker": "0235",
    "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "BEST",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "BFCM",
    "clearingBroker": "1043",
    "brokerName": "BLUEFIN CAPITAL MANAGEMENT, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "BFEW",
    "clearingBroker": "0443",
    "brokerName": "BILL FEW ASSOCIATES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "BFFI",
    "clearingBroker": "0226",
    "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
  },
  {
    "type": "MUNI",
    "mpid": "BFMA",
    "clearingBroker": "1043",
    "brokerName": "BLUEFIN CAPITAL MANAGEMENT, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "BFSL",
    "clearingBroker": "0235",
    "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "BGCF",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL, L.P.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "BGHT",
    "clearingBroker": "0141",
    "brokerName": "BRIGHTON SECURITIES CORP.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "BGMI",
    "clearingBroker": "0158",
    "brokerName": "BRICKELL GLOBAL MARKETS, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "BGSG",
    "clearingBroker": "0226",
    "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "BGVS",
    "clearingBroker": "0443",
    "brokerName": "BGV SECURITIES                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "BHII",
    "clearingBroker": "0443",
    "brokerName": "BELLE HAVEN INVESTMENTS, LP                                           "
  },
  {
    "type": "MUNI",
    "mpid": "BHKS",
    "clearingBroker": "0141",
    "brokerName": "BHK SECURITIES, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "BICA",
    "clearingBroker": "0443",
    "brokerName": "BEACON INVESTMENT COMPANY                                             "
  },
  {
    "type": "MUNI",
    "mpid": "BIDS",
    "clearingBroker": "0161",
    "brokerName": "BIDS TRADING L.P.                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "BIGP",
    "clearingBroker": "0443",
    "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "BIGZ",
    "clearingBroker": "0443",
    "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "BIMI",
    "clearingBroker": "0136",
    "brokerName": "INTESA SANPAOLO IMI SECURITIES CORP.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "BISI",
    "clearingBroker": "0443",
    "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
  },
  {
    "type": "MUNI",
    "mpid": "BJCM",
    "clearingBroker": "0235",
    "brokerName": "ESSEX SECURITIES LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "BJRC",
    "clearingBroker": "0235",
    "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "BKCM",
    "clearingBroker": "0443",
    "brokerName": "BNY CAPITAL MARKETS INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "BKES",
    "clearingBroker": "0443",
    "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "BKRT",
    "clearingBroker": "0235",
    "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "BLEY",
    "clearingBroker": "0443",
    "brokerName": "BLEY INVESTMENT GROUP, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "BLKB",
    "clearingBroker": "0642",
    "brokerName": "BLACKBURN & COMPANY                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "BLNI",
    "clearingBroker": "0226",
    "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "BMCB",
    "clearingBroker": "0103",
    "brokerName": "BACKSTROM MCCARLEY BERRY & CO., LLC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "BMKS",
    "clearingBroker": "0443",
    "brokerName": "BENCHMARK SECURITIES, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "BMSA",
    "clearingBroker": "0443",
    "brokerName": "MARIVA CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "BMUR",
    "clearingBroker": "0443",
    "brokerName": "BREAN CAPITAL, LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "BNBB",
    "clearingBroker": "0443",
    "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "BNCH",
    "clearingBroker": "0235",
    "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "BNDI",
    "clearingBroker": "0443",
    "brokerName": "BERNARDI SECURITIES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "BNDS",
    "clearingBroker": "0226",
    "brokerName": "MTS MARKETS INTERNATIONAL, INC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "BNTE",
    "clearingBroker": "0158",
    "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
  },
  {
    "type": "MUNI",
    "mpid": "BNYI",
    "clearingBroker": "0443",
    "brokerName": "BNY INVESTMENT CENTERS, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "BNYM",
    "clearingBroker": "8355",
    "brokerName": "BNYM/UIT NSCC CNS CLEARANCE                                           "
  },
  {
    "type": "MUNI",
    "mpid": "BNYN",
    "clearingBroker": "0226",
    "brokerName": "BANYAN SECURITIES, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "BOFA",
    "clearingBroker": "0773",
    "brokerName": "BOFA SECURITIES, INC./FIXED INCOME                                    "
  },
  {
    "type": "MUNI",
    "mpid": "BOKI",
    "clearingBroker": "0443",
    "brokerName": "BOSC, INC.                                                            "
  },
  {
    "type": "MUNI",
    "mpid": "BOKL",
    "clearingBroker": "6752",
    "brokerName": "BANK OF OKLAHOMA                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "BOSS",
    "clearingBroker": "0158",
    "brokerName": "ALL TIME ATS                                                          "
  },
  {
    "type": "MUNI",
    "mpid": "BOYR",
    "clearingBroker": "0443",
    "brokerName": "MARK BOYAR & CO., INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "BPNS",
    "clearingBroker": "2154",
    "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "BPSG",
    "clearingBroker": "0443",
    "brokerName": "GLEACHER & COMPANY SECURITIES, INC.                                   "
  },
  {
    "type": "MUNI",
    "mpid": "BPWP",
    "clearingBroker": "0226",
    "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "BRBR",
    "clearingBroker": "0279",
    "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "BRCY",
    "clearingBroker": "0443",
    "brokerName": "BCP SECURITIES, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "BRGE",
    "clearingBroker": "0052",
    "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
  },
  {
    "type": "MUNI",
    "mpid": "BRKE",
    "clearingBroker": "0443",
    "brokerName": "BIRKELBACH INVESTMENT SECURITIES, INC.                                "
  },
  {
    "type": "MUNI",
    "mpid": "BRLI",
    "clearingBroker": "0226",
    "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "BRNK",
    "clearingBroker": "0226",
    "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "BRNT",
    "clearingBroker": "0235",
    "brokerName": "H.D. BRENT & COMPANY, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "BRRR",
    "clearingBroker": "8199",
    "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "BRSA",
    "clearingBroker": "0103",
    "brokerName": "BOURSA INVESTMENT                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "BRSE",
    "clearingBroker": "0226",
    "brokerName": "BRADESCO SECURITIES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "BRVL",
    "clearingBroker": "0443",
    "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "BRWM",
    "clearingBroker": "0226",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "MUNI",
    "mpid": "BSAZ",
    "clearingBroker": "0103",
    "brokerName": "BERRY SHINO SECURITIES, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "BSCM",
    "clearingBroker": "0052",
    "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "BSIS",
    "clearingBroker": "0443",
    "brokerName": "BANCORPSOUTH INVESTMENT SERVICES, INC.                                "
  },
  {
    "type": "MUNI",
    "mpid": "BSPI",
    "clearingBroker": "0235",
    "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "BSSC",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "BSTO",
    "clearingBroker": "0443",
    "brokerName": "BANESTO SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "BTDG",
    "clearingBroker": "0161",
    "brokerName": "BIDS TRADING LP                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "BTIM",
    "clearingBroker": "1043",
    "brokerName": "BTIG, LLC                                                             "
  },
  {
    "type": "MUNI",
    "mpid": "BTSS",
    "clearingBroker": "0279",
    "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
  },
  {
    "type": "MUNI",
    "mpid": "BURK",
    "clearingBroker": "0141",
    "brokerName": "BURKE, LAWTON, BREWER & BURKE                                         "
  },
  {
    "type": "MUNI",
    "mpid": "BUZZ",
    "clearingBroker": "0141",
    "brokerName": "HEIDTKE & COMPANY, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "BWNA",
    "clearingBroker": "0235",
    "brokerName": "BROWN ASSOCIATES INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "BYAI",
    "clearingBroker": "0226",
    "brokerName": "BRECEK & YOUNG                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "BZCP",
    "clearingBroker": "0443",
    "brokerName": "BALANZ CAPITAL USA LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "BZTN",
    "clearingBroker": "0141",
    "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
  },
  {
    "type": "MUNI",
    "mpid": "BZWV",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "BZYD",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "BZYF",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "CABA",
    "clearingBroker": "0443",
    "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "CABR",
    "clearingBroker": "0161",
    "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "CADG",
    "clearingBroker": "0005",
    "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "CADZ",
    "clearingBroker": "0279",
    "brokerName": "CADZ SECURITIES INC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "CAFS",
    "clearingBroker": "0158",
    "brokerName": "COMMUNITYAMERICA FINANCIAL SOLUTIONS, LLC                             "
  },
  {
    "type": "MUNI",
    "mpid": "CAGI",
    "clearingBroker": "0279",
    "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "CAIX",
    "clearingBroker": "0235",
    "brokerName": "CAIS CAPITAL LLC                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "CALD",
    "clearingBroker": "0103",
    "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "CALT",
    "clearingBroker": "0279",
    "brokerName": "CALTON & ASSOCIATES                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "CAMS",
    "clearingBroker": "0443",
    "brokerName": "COMPREHENSIVE ASSET MANAGEMENT AND SERVICING, INC.                    "
  },
  {
    "type": "MUNI",
    "mpid": "CANR",
    "clearingBroker": "0388",
    "brokerName": "CANTONE RESEARCH INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "CANT",
    "clearingBroker": "0696",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "CAPC",
    "clearingBroker": "0235",
    "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "CAPE",
    "clearingBroker": "0279",
    "brokerName": "CAPE SECURITIES, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "CAPI",
    "clearingBroker": "0443",
    "brokerName": "CAPITAL ANALYSTS INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "CARL",
    "clearingBroker": "0443",
    "brokerName": "BASE SECURITIES LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "CART",
    "clearingBroker": "0443",
    "brokerName": "CARTY & COMPANY, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "CARY",
    "clearingBroker": "0141",
    "brokerName": "CARY STREET PARTNERS                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "CATC",
    "clearingBroker": "0443",
    "brokerName": "CHICAGO ANALYTIC TRADING COMPANY, LLC                                 "
  },
  {
    "type": "MUNI",
    "mpid": "CATE",
    "clearingBroker": "0235",
    "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "CAVU",
    "clearingBroker": "0443",
    "brokerName": "CAVU SECURITIES LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "CBAL",
    "clearingBroker": "0443",
    "brokerName": "ACCESS SECURITIES, INC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "CBEV",
    "clearingBroker": "0226",
    "brokerName": "CITY NATIONAL BANK, BEVERLY HILLS, CALIFORNIA                         "
  },
  {
    "type": "MUNI",
    "mpid": "CBII",
    "clearingBroker": "0443",
    "brokerName": "WESBANCO SECURITIES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "CBIN",
    "clearingBroker": "0443",
    "brokerName": "COMPASS BROKERAGE, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "CBKC",
    "clearingBroker": "2170",
    "brokerName": "COMMERCE BANK                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "CBNA",
    "clearingBroker": "0950",
    "brokerName": "CITIBANK N.A./DEALER                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "CBOL",
    "clearingBroker": "0226",
    "brokerName": "MUTUAL SECURITIES, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "CBSE",
    "clearingBroker": "1043",
    "brokerName": "CAMBRIDGE INTERNATIONAL SECURITIES, LLC                               "
  },
  {
    "type": "MUNI",
    "mpid": "CBTD",
    "clearingBroker": "0226",
    "brokerName": "SYNOVOUS SECURITIES INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "CCBI",
    "clearingBroker": "6744",
    "brokerName": "COUNTRY CLUB BANK, KANSAS, KANSAS CITY, MO.                           "
  },
  {
    "type": "MUNI",
    "mpid": "CCCO",
    "clearingBroker": "0226",
    "brokerName": "CARNES CAPITAL CORPORATION                                            "
  },
  {
    "type": "MUNI",
    "mpid": "CCIG",
    "clearingBroker": "0235",
    "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "CCMC",
    "clearingBroker": "0443",
    "brokerName": "COMMERZEBANK CAPITAL CORP.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "CCPM",
    "clearingBroker": "0595",
    "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "CCSS",
    "clearingBroker": "0443",
    "brokerName": "CROWN CAPITAL SECURITIES, L.P.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "CERS",
    "clearingBroker": "0226",
    "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "CESI",
    "clearingBroker": "0235",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "CFCO",
    "clearingBroker": "7311",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "CFGM",
    "clearingBroker": "0235",
    "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "CFGO",
    "clearingBroker": "0161",
    "brokerName": "CF GLOBAL TRADING, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "CFGT",
    "clearingBroker": "0235",
    "brokerName": "CF GLOBAL TRADING, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "CFII",
    "clearingBroker": "0235",
    "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
  },
  {
    "type": "MUNI",
    "mpid": "CFIN",
    "clearingBroker": "0279",
    "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
  },
  {
    "type": "MUNI",
    "mpid": "CFSI",
    "clearingBroker": "0052",
    "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "CFSX",
    "clearingBroker": "0794",
    "brokerName": "CF SECURED, LLC                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "CGAT",
    "clearingBroker": "0443",
    "brokerName": "CADARET, GRANT & CO., INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "CGCO",
    "clearingBroker": "0443",
    "brokerName": "CG COMPASS (USA) LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "CGLN",
    "clearingBroker": "0103",
    "brokerName": "COUGHLIN & CO                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "CGMI",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "CHAS",
    "clearingBroker": "0164",
    "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "CHBC",
    "clearingBroker": "0235",
    "brokerName": "PENSERRA SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "CHCH",
    "clearingBroker": "0226",
    "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "CHCK",
    "clearingBroker": "0226",
    "brokerName": "CHICKASAW SECURITIES, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "CHDA",
    "clearingBroker": "0141",
    "brokerName": "CHAPIN, DAVIS                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "CHPP",
    "clearingBroker": "0624",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "CHSI",
    "clearingBroker": "0187",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "CHUB",
    "clearingBroker": "0226",
    "brokerName": "OSAIC FS, INC.                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "CICI",
    "clearingBroker": "0443",
    "brokerName": "COMMERCE BANK INVESTMENT SERVICES, INC.                               "
  },
  {
    "type": "MUNI",
    "mpid": "CICL",
    "clearingBroker": "0141",
    "brokerName": "CAROLINAS INVESTMENT CONSULTING                                       "
  },
  {
    "type": "MUNI",
    "mpid": "CIIV",
    "clearingBroker": "0052",
    "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "CIMB",
    "clearingBroker": "0005",
    "brokerName": "CIMB SECURITIES (USA), INC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "CINV",
    "clearingBroker": "0158",
    "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "CIRI",
    "clearingBroker": "0443",
    "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
  },
  {
    "type": "MUNI",
    "mpid": "CISI",
    "clearingBroker": "0352",
    "brokerName": "CHASE INVESTMENT SERVICES CORP.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "CIST",
    "clearingBroker": "0161",
    "brokerName": "CAPITAL INSTITUTIONAL SERVICES, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "CISV",
    "clearingBroker": "0226",
    "brokerName": "CITIZENS SECURITIES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "CLDN",
    "clearingBroker": "0235",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "CLRK",
    "clearingBroker": "0235",
    "brokerName": "CLARK DODGE & CO, INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "CLRT",
    "clearingBroker": "1043",
    "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "CLSA",
    "clearingBroker": "0161",
    "brokerName": "CLSA AMERICAS, LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "CLSS",
    "clearingBroker": "0443",
    "brokerName": "CABOT LODGE SECURITIES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "CLTN",
    "clearingBroker": "0226",
    "brokerName": "CALTON & ASSOCIATES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "CLYN",
    "clearingBroker": "0443",
    "brokerName": "CARLIN EQUITIES, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "CMCE",
    "clearingBroker": "0226",
    "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
  },
  {
    "type": "MUNI",
    "mpid": "CMCX",
    "clearingBroker": "0624",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "CMGF",
    "clearingBroker": "0443",
    "brokerName": "CMG SECURITIES LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "CMMB",
    "clearingBroker": "2781",
    "brokerName": "U.S. BANK N.A./U.S. BANK MUNICIPAL SECURITIES GROUP                   "
  },
  {
    "type": "MUNI",
    "mpid": "CMMW",
    "clearingBroker": "0226",
    "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
  },
  {
    "type": "MUNI",
    "mpid": "CNCD",
    "clearingBroker": "0235",
    "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "CNFI",
    "clearingBroker": "0443",
    "brokerName": "CENTAURUS FINANCIAL INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "CNFR",
    "clearingBroker": "0443",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "CNSI",
    "clearingBroker": "0226",
    "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "COAK",
    "clearingBroker": "0443",
    "brokerName": "CASTLE OAK SECURITIES, L.P.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "COAS",
    "clearingBroker": "0443",
    "brokerName": "REALTA EQUITIES, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "CODA",
    "clearingBroker": "0161",
    "brokerName": "CODA MARKETS, INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "COEI",
    "clearingBroker": "0052",
    "brokerName": "COASTAL EQUITIES, INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "COEX",
    "clearingBroker": "0161",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "COFS",
    "clearingBroker": "0279",
    "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
  },
  {
    "type": "MUNI",
    "mpid": "COHN",
    "clearingBroker": "0235",
    "brokerName": "COHEN BROS. & COMPANY                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "COLS",
    "clearingBroker": "0279",
    "brokerName": "COLONIAL SECURITIES INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "COMP",
    "clearingBroker": "0595",
    "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
  },
  {
    "type": "MUNI",
    "mpid": "CONI",
    "clearingBroker": "0235",
    "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "CONS",
    "clearingBroker": "0141",
    "brokerName": "CONSULTIVA SECURITIES, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "COOR",
    "clearingBroker": "0141",
    "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "COWN",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "COWP",
    "clearingBroker": "0226",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "COWX",
    "clearingBroker": "0161",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "COYL",
    "clearingBroker": "0235",
    "brokerName": "COYLE SECURITIES LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "CPAM",
    "clearingBroker": "0141",
    "brokerName": "CAPITAL SECURITIES OF AMERICA, INC.                                   "
  },
  {
    "type": "MUNI",
    "mpid": "CPEM",
    "clearingBroker": "0161",
    "brokerName": "CLEARPOOL EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "CPGL",
    "clearingBroker": "0226",
    "brokerName": "CONTINUITY PARTNERS GROUP, LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "CPLC",
    "clearingBroker": "0595",
    "brokerName": "COVA CAPITAL PARTNERS LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "CPPM",
    "clearingBroker": "0443",
    "brokerName": "COKER & PALMER                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "CPRC",
    "clearingBroker": "0235",
    "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "CPRM",
    "clearingBroker": "8199",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "CQSI",
    "clearingBroker": "0443",
    "brokerName": "CAPITALQUEST SECURITIES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "CRCM",
    "clearingBroker": "0235",
    "brokerName": "COHNREZNICK CAPITAL                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "CRDL",
    "clearingBroker": "0235",
    "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "CRED",
    "clearingBroker": "0443",
    "brokerName": "CREDICORP CAPITAL LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "CREF",
    "clearingBroker": "0443",
    "brokerName": "TIAA-CREF INDIVIDUAL AND INSTITUTIONAL SERVICES, LLC                  "
  },
  {
    "type": "MUNI",
    "mpid": "CREW",
    "clearingBroker": "0443",
    "brokerName": "CREWS & ASSOCIATES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "CRII",
    "clearingBroker": "0443",
    "brokerName": "CRI SECURITIES INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "CRIS",
    "clearingBroker": "0443",
    "brokerName": "CARIS & COMPANY, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "CRNJ",
    "clearingBroker": "0103",
    "brokerName": "CANTONE RESEARCH                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "CRON",
    "clearingBroker": "0443",
    "brokerName": "CRONIN & CO., INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "CRPT",
    "clearingBroker": "0235",
    "brokerName": "CROSS POINT CAPITAL LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "CRRT",
    "clearingBroker": "0443",
    "brokerName": "BREAN MURRAY, CARRET & CO., LLC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "CRTH",
    "clearingBroker": "0443",
    "brokerName": "CORINTHIAN PARTNERS, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "CRYN",
    "clearingBroker": "0235",
    "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "CSAI",
    "clearingBroker": "0793",
    "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "CSCA",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "MUNI",
    "mpid": "CSCB",
    "clearingBroker": "0161",
    "brokerName": "COMPUTERSHARE SECURITIES, CORP.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "CSCM",
    "clearingBroker": "0279",
    "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "CSFL",
    "clearingBroker": "6770",
    "brokerName": "SOUTH STATE BANK, NATIONAL ASSOCIATION                                "
  },
  {
    "type": "MUNI",
    "mpid": "CSIB",
    "clearingBroker": "0443",
    "brokerName": "RBC CENTURA SECURITIES, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "CSII",
    "clearingBroker": "0443",
    "brokerName": "COMMONWEALTH SECURITIES AND INVESTMENTS, INC.                         "
  },
  {
    "type": "MUNI",
    "mpid": "CSIN",
    "clearingBroker": "0161",
    "brokerName": "CITADEL SECURITIES INSTITUTIONAL LLC                                  "
  },
  {
    "type": "MUNI",
    "mpid": "CSOA",
    "clearingBroker": "0443",
    "brokerName": "CLEARING SERVICES OF AMERICA                                          "
  },
  {
    "type": "MUNI",
    "mpid": "CSPA",
    "clearingBroker": "0226",
    "brokerName": "CREDIT SUISSE PRIVATE ADVISORS                                        "
  },
  {
    "type": "MUNI",
    "mpid": "CSPD",
    "clearingBroker": "0197",
    "brokerName": "CANTOR FITZGERALD & CO.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "CSPI",
    "clearingBroker": "0235",
    "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
  },
  {
    "type": "MUNI",
    "mpid": "CSTI",
    "clearingBroker": "0161",
    "brokerName": "CANACCORD GENUITY INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "CTBK",
    "clearingBroker": "4270",
    "brokerName": "CENTRAL TRUST BANK                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "CTNL",
    "clearingBroker": "0235",
    "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "CTSC",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "MUNI",
    "mpid": "CUEF",
    "clearingBroker": "0443",
    "brokerName": "CUE FINANCIAL GROUP, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "CUFT",
    "clearingBroker": "0226",
    "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "CUSO",
    "clearingBroker": "0443",
    "brokerName": "CUSO FINANCIAL SERVICES, L.P.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "CUTW",
    "clearingBroker": "0235",
    "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "CUWB",
    "clearingBroker": "0103",
    "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "CWEI",
    "clearingBroker": "0443",
    "brokerName": "BEECH HILL SECURITIES, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "CWMK",
    "clearingBroker": "0438",
    "brokerName": "CIBC WORLD MARKETS CORP.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "DADA",
    "clearingBroker": "0361",
    "brokerName": "D. A. DAVIDSON & CO.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DAGH",
    "clearingBroker": "0443",
    "brokerName": "DAUGHERTY COLE, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DAIS",
    "clearingBroker": "0052",
    "brokerName": "DAI SECURITIES, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "DARA",
    "clearingBroker": "0235",
    "brokerName": "DARWOOD ASSOCIATES, INC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "DART",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DASH",
    "clearingBroker": "0161",
    "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "DAVA",
    "clearingBroker": "0443",
    "brokerName": "DAVENPORT & COMPANY LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "DAWA",
    "clearingBroker": "0647",
    "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "DBAB",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "DBCC",
    "clearingBroker": "0235",
    "brokerName": "D. BORAL CAPITAL                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "DBCH",
    "clearingBroker": "0052",
    "brokerName": "D. BORAL CAPITAL                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "DBIB",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "DBKS",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "DBMC",
    "clearingBroker": "0725",
    "brokerName": "D.B. MCKENNA & CO., INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "DBPC",
    "clearingBroker": "0443",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "DCAN",
    "clearingBroker": "0279",
    "brokerName": "R. M. DUNCAN SECURITIES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "DCSD",
    "clearingBroker": "0235",
    "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
  },
  {
    "type": "MUNI",
    "mpid": "DCVL",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DEAN",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "DEFA",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "DEGS",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DELA",
    "clearingBroker": "0443",
    "brokerName": "DELAFIELD & HAMBRECHT, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "DEMF",
    "clearingBroker": "0443",
    "brokerName": "DEMPSEY FINANCIAL NETWORK                                             "
  },
  {
    "type": "MUNI",
    "mpid": "DENI",
    "clearingBroker": "0279",
    "brokerName": "H.C. DENISON CO.                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "DETF",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DIDI",
    "clearingBroker": "0443",
    "brokerName": "DWS INVESTMENT DISTRIBUTORS INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "DIGG",
    "clearingBroker": "0595",
    "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "DINO",
    "clearingBroker": "0103",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "MUNI",
    "mpid": "DKEI",
    "clearingBroker": "0141",
    "brokerName": "DALE K. EHRHART, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "DLAI",
    "clearingBroker": "0235",
    "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "DLPS",
    "clearingBroker": "0595",
    "brokerName": "DLP SECURITIES,.LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "DLSI",
    "clearingBroker": "0226",
    "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "DLTA",
    "clearingBroker": "0161",
    "brokerName": "DEALERWEB INC.                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "DMCD",
    "clearingBroker": "0279",
    "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
  },
  {
    "type": "MUNI",
    "mpid": "DMKC",
    "clearingBroker": "0141",
    "brokerName": "D.M. KELLY & COMPANY                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DNOR",
    "clearingBroker": "0005",
    "brokerName": "DNB MARKETS, INC.                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "DNSR",
    "clearingBroker": "0158",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "MUNI",
    "mpid": "DNWL",
    "clearingBroker": "0443",
    "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "DOFT",
    "clearingBroker": "0443",
    "brokerName": "DOFT & CO., INC.                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "DOMI",
    "clearingBroker": "0279",
    "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "DOMK",
    "clearingBroker": "0443",
    "brokerName": "DOMINICK & DOMINICK LLC/CDS                                           "
  },
  {
    "type": "MUNI",
    "mpid": "DOMS",
    "clearingBroker": "0235",
    "brokerName": "DOMINARI SECURITIES LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "DOTC",
    "clearingBroker": "0226",
    "brokerName": "COLLIERS SECURITIES LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "DOVE",
    "clearingBroker": "0226",
    "brokerName": "SECURITIES EQUITY GROUP                                               "
  },
  {
    "type": "MUNI",
    "mpid": "DOWD",
    "clearingBroker": "0161",
    "brokerName": "WALTER J. DOWD, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DRAT",
    "clearingBroker": "0571",
    "brokerName": "DRATEL GROUP (THE)                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "DREX",
    "clearingBroker": "0443",
    "brokerName": "DREXEL HAMILTON, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DRTG",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DRTR",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DRVW",
    "clearingBroker": "0235",
    "brokerName": "DRIVEWEALTH, LLC                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "DRWM",
    "clearingBroker": "0005",
    "brokerName": "DRW SECURITIES, L.L.C.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "DSGG",
    "clearingBroker": "0226",
    "brokerName": "DMG SECURITIES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DSTR",
    "clearingBroker": "0443",
    "brokerName": "DESTRA CAPITAL INVESTMENTS LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "DTAP",
    "clearingBroker": "0161",
    "brokerName": "DIRECT TRADING INSTITUTIONAL L.P.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "DTEX",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
  },
  {
    "type": "MUNI",
    "mpid": "DUST",
    "clearingBroker": "0161",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "DVES",
    "clearingBroker": "0005",
    "brokerName": "DV EQUITIES                                                           "
  },
  {
    "type": "MUNI",
    "mpid": "DWFN",
    "clearingBroker": "0443",
    "brokerName": "DEWAY FINANCIAL NETWORK, LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "DWIZ",
    "clearingBroker": "0235",
    "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "EAMC",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
  },
  {
    "type": "MUNI",
    "mpid": "EAMG",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
  },
  {
    "type": "MUNI",
    "mpid": "EAST",
    "clearingBroker": "6742",
    "brokerName": "EASTERN BANK CAPITAL MARKETS                                          "
  },
  {
    "type": "MUNI",
    "mpid": "EBRD",
    "clearingBroker": "0103",
    "brokerName": "EARLYBIRD CAPITAL, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "ECCC",
    "clearingBroker": "0226",
    "brokerName": "EAGLES COAST CAPITAL, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ECUT",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "EDFC",
    "clearingBroker": "0443",
    "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "EDJO",
    "clearingBroker": "0057",
    "brokerName": "EDWARD D. JONES & CO.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "EDLR",
    "clearingBroker": "0103",
    "brokerName": "DE LA ROSA (E.J.) & CO., INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "EGLE",
    "clearingBroker": "1043",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "MUNI",
    "mpid": "EGMT",
    "clearingBroker": "0005",
    "brokerName": "EG MARKET TECHNOLOGIES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "ELEQ",
    "clearingBroker": "0551",
    "brokerName": "ELEQUIN SECURITIES LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "ELEV",
    "clearingBroker": "0235",
    "brokerName": "ELEVATION, LLC                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "ELQN",
    "clearingBroker": "0443",
    "brokerName": "ELEQUIN SECURITIES LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "EMOC",
    "clearingBroker": "0750",
    "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "EMPR",
    "clearingBroker": "0279",
    "brokerName": "SELKIRK INVESTMENTS, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ENTR",
    "clearingBroker": "0235",
    "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "EPIC",
    "clearingBroker": "0443",
    "brokerName": "EPIC CAPITAL SECURITIES                                               "
  },
  {
    "type": "MUNI",
    "mpid": "EQHA",
    "clearingBroker": "0075",
    "brokerName": "EQUITABLE ADVISORS, LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "EQSV",
    "clearingBroker": "0226",
    "brokerName": "EQUITY SERVICES, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "EQUA",
    "clearingBroker": "0443",
    "brokerName": "EQUITAS AMERICA, L.L.C.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "ESBD",
    "clearingBroker": "0235",
    "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "ESHC",
    "clearingBroker": "0443",
    "brokerName": "FIRST SOUTHERN, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "ESUS",
    "clearingBroker": "0443",
    "brokerName": "EVOLUTION SECURITIES US INC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "ETCB",
    "clearingBroker": "3505",
    "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "ETCL",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "ETRF",
    "clearingBroker": "0161",
    "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "ETRS",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "EVOL",
    "clearingBroker": "0226",
    "brokerName": "EVOLVE SECURITIES, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "EWMX",
    "clearingBroker": "0279",
    "brokerName": "EAST WEST MARKETS, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "EXCS",
    "clearingBroker": "0443",
    "brokerName": "EXCEL SECURITIES AND ASSOCIATES, INC.                                 "
  },
  {
    "type": "MUNI",
    "mpid": "EXCU",
    "clearingBroker": "0443",
    "brokerName": "XCU CAPITAL CORPORATION, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "FACA",
    "clearingBroker": "0443",
    "brokerName": "FINANCIAL ASSETS CORPORATION                                          "
  },
  {
    "type": "MUNI",
    "mpid": "FAFT",
    "clearingBroker": "0161",
    "brokerName": "FACTFET SYSTEMS, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "FALC",
    "clearingBroker": "0103",
    "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "FAMI",
    "clearingBroker": "0235",
    "brokerName": "FIRST AMERICAN MUNICIPALS, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "FARA",
    "clearingBroker": "8199",
    "brokerName": "FARINA & ASSOCIATES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "FATS",
    "clearingBroker": "0443",
    "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "FBLM",
    "clearingBroker": "0235",
    "brokerName": "FBL MARKETING SERVICES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "FBLT",
    "clearingBroker": "8199",
    "brokerName": "FIRST BALLANTYNE, LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "FBNS",
    "clearingBroker": "0235",
    "brokerName": "FBN SECURITIES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "FBPC",
    "clearingBroker": "0443",
    "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
  },
  {
    "type": "MUNI",
    "mpid": "FBSB",
    "clearingBroker": "0280",
    "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "FCCP",
    "clearingBroker": "0141",
    "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
  },
  {
    "type": "MUNI",
    "mpid": "FCIT",
    "clearingBroker": "0443",
    "brokerName": "FIRST CITIZENS INVESTOR SERVICES, INC.                                "
  },
  {
    "type": "MUNI",
    "mpid": "FCML",
    "clearingBroker": "0279",
    "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "FCMP",
    "clearingBroker": "0595",
    "brokerName": "PRIME EXECUTIONS, INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "FDMI",
    "clearingBroker": "0571",
    "brokerName": "FREEDOM INVESTMENTS, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "FDSC",
    "clearingBroker": "0158",
    "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "FDSI",
    "clearingBroker": "0141",
    "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "FENX",
    "clearingBroker": "0595",
    "brokerName": "FENIX SECURITIES, LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "FFCI",
    "clearingBroker": "0443",
    "brokerName": "FRONTIER FINANCIAL CONSULTANTS, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "FFCM",
    "clearingBroker": "0235",
    "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "FFGI",
    "clearingBroker": "0235",
    "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "FFPS",
    "clearingBroker": "0443",
    "brokerName": "FFP SECURITIES                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "FGOE",
    "clearingBroker": "0226",
    "brokerName": "FIRST GEORGETOWN SECURITIES, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "FHCI",
    "clearingBroker": "0443",
    "brokerName": "FIRST HEARTLAND CAPITAL, INC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "FHON",
    "clearingBroker": "0235",
    "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "FIAF",
    "clearingBroker": "0443",
    "brokerName": "FLORIDA INVESTMENT ADVISERS                                           "
  },
  {
    "type": "MUNI",
    "mpid": "FIBS",
    "clearingBroker": "0226",
    "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "FINC",
    "clearingBroker": "0443",
    "brokerName": "AWM SECURITIES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "FISA",
    "clearingBroker": "0443",
    "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "FISB",
    "clearingBroker": "0226",
    "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "FISH",
    "clearingBroker": "0235",
    "brokerName": "L.B. FISHER & COMPANY                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "FITE",
    "clearingBroker": "0443",
    "brokerName": "FORESIGHT INVESTMENTS, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "FJRF",
    "clearingBroker": "0052",
    "brokerName": "PARITER SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "FKSC",
    "clearingBroker": "0235",
    "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "FLAT",
    "clearingBroker": "0226",
    "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "FLEX",
    "clearingBroker": "0158",
    "brokerName": "GWM GROUP, INC.                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "FLIB",
    "clearingBroker": "0235",
    "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
  },
  {
    "type": "MUNI",
    "mpid": "FLOU",
    "clearingBroker": "0443",
    "brokerName": "FIRST ST. LOUIS SECURITIES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "FLTL",
    "clearingBroker": "0235",
    "brokerName": "FELTL & COMPANY                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "FLTU",
    "clearingBroker": "0551",
    "brokerName": "FLOW TRADERS US LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "FLWT",
    "clearingBroker": "0161",
    "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
  },
  {
    "type": "MUNI",
    "mpid": "FMAT",
    "clearingBroker": "0608",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "FMCO",
    "clearingBroker": "0443",
    "brokerName": "FIRST MANHATTAN CO.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "FMFS",
    "clearingBroker": "0226",
    "brokerName": "FISRT MERIT FINANCIAL SERVICES, INC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "FMGT",
    "clearingBroker": "0443",
    "brokerName": "FAMILY MANAGEMENT SECURITIES, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "FNBB",
    "clearingBroker": "6753",
    "brokerName": "FIRST NATIONAL BANKERS BANK                                           "
  },
  {
    "type": "MUNI",
    "mpid": "FNET",
    "clearingBroker": "0141",
    "brokerName": "WACHOVIA SECURITIES FINANCIAL NETWORK, LLC                            "
  },
  {
    "type": "MUNI",
    "mpid": "FNFD",
    "clearingBroker": "0443",
    "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
  },
  {
    "type": "MUNI",
    "mpid": "FNIC",
    "clearingBroker": "0443",
    "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "FNSJ",
    "clearingBroker": "0443",
    "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
  },
  {
    "type": "MUNI",
    "mpid": "FOGS",
    "clearingBroker": "0235",
    "brokerName": "FOG EQUITIES LLC                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "FORD",
    "clearingBroker": "0052",
    "brokerName": "THINKEQUITY, LLC                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "FORT",
    "clearingBroker": "0443",
    "brokerName": "FORTE SECURITIES LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "FRLZ",
    "clearingBroker": "0103",
    "brokerName": "FRIEDMAN LUZZATTO & CO                                                "
  },
  {
    "type": "MUNI",
    "mpid": "FROS",
    "clearingBroker": "6751",
    "brokerName": "FROST BANK                                                            "
  },
  {
    "type": "MUNI",
    "mpid": "FRSE",
    "clearingBroker": "0443",
    "brokerName": "FRANKLIN SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "FSCN",
    "clearingBroker": "0226",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "FSCS",
    "clearingBroker": "0443",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "FSEC",
    "clearingBroker": "0161",
    "brokerName": "FRS SECURITIES, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "FSFA",
    "clearingBroker": "0443",
    "brokerName": "FIRST SECURITY FINANCIAL ADVISORS, INC.                               "
  },
  {
    "type": "MUNI",
    "mpid": "FSRP",
    "clearingBroker": "0443",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "FSST",
    "clearingBroker": "0443",
    "brokerName": "FRANKLIN STREET SECURITIES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "FTCM",
    "clearingBroker": "2445",
    "brokerName": "FHN FINANCIAL CAPITAL MARKETS A DIVISION OF FIRST HORIZON BANK-DTC 244"
  },
  {
    "type": "MUNI",
    "mpid": "FTEN",
    "clearingBroker": "0226",
    "brokerName": "FTB ADVISORS, INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "FTLP",
    "clearingBroker": "8244",
    "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "FTSC",
    "clearingBroker": "0202",
    "brokerName": "FHN FINANCIAL SECURITIES CORP.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "FTSR",
    "clearingBroker": "0226",
    "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "FUJI",
    "clearingBroker": "0443",
    "brokerName": "MIZUHO SECURITIES USA INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "FWCO",
    "clearingBroker": "0443",
    "brokerName": "FIRST WASHINGTON CORPORATION                                          "
  },
  {
    "type": "MUNI",
    "mpid": "FWSI",
    "clearingBroker": "0141",
    "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "GABE",
    "clearingBroker": "0141",
    "brokerName": "G. RESEARCH, INC.                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "GAFI",
    "clearingBroker": "0235",
    "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "GARB",
    "clearingBroker": "0148",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "GARC",
    "clearingBroker": "0161",
    "brokerName": "ICAP CORPORATES LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "GARQ",
    "clearingBroker": "0161",
    "brokerName": "ICAP CORPORATES, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "GARR",
    "clearingBroker": "0226",
    "brokerName": "GARRETT NAGLE & CO., INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "GARW",
    "clearingBroker": "0595",
    "brokerName": "GAR WOOD SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "GBMT",
    "clearingBroker": "0443",
    "brokerName": "GBM INTERNATIONAL, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "GBSI",
    "clearingBroker": "0443",
    "brokerName": "GREENTREE BROKERAGE SERVICES, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "GBTS",
    "clearingBroker": "0005",
    "brokerName": "GTS SECURITIES, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "GCMC",
    "clearingBroker": "0443",
    "brokerName": "GLADOWSKY CAPITAL MANAGEMENT CORP.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "GCMT",
    "clearingBroker": "0443",
    "brokerName": "GOLD CAPITAL MANAGEMENT, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "GDCO",
    "clearingBroker": "0443",
    "brokerName": "GILBERT, DONIGER CO., INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "GFBD",
    "clearingBroker": "0226",
    "brokerName": "G. F. INVESTMENT SERVICES, LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "GFIG",
    "clearingBroker": "0537",
    "brokerName": "GFI SECURITIES LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "GFSI",
    "clearingBroker": "0443",
    "brokerName": "GLOBAL FINANCIAL SERVICES, L.L.C.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "GGWI",
    "clearingBroker": "0141",
    "brokerName": "GAGE-WILEY & COMPANY INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "GHCC",
    "clearingBroker": "0226",
    "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
  },
  {
    "type": "MUNI",
    "mpid": "GILG",
    "clearingBroker": "0226",
    "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "GJSS",
    "clearingBroker": "0235",
    "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "GLBZ",
    "clearingBroker": "0443",
    "brokerName": "ONLINE BROKERAGE SERVICES                                             "
  },
  {
    "type": "MUNI",
    "mpid": "GLII",
    "clearingBroker": "5005",
    "brokerName": "TD SECURITIES INC./CDS                                                "
  },
  {
    "type": "MUNI",
    "mpid": "GLIR",
    "clearingBroker": "5021",
    "brokerName": "TD WATERHOUSE CANADA INC. #5/CDS                                      "
  },
  {
    "type": "MUNI",
    "mpid": "GLLL",
    "clearingBroker": "0279",
    "brokerName": "GILL CAPITAL PARTNERS                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "GLYN",
    "clearingBroker": "0443",
    "brokerName": "GLYNN (J.A.) & CO.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "GMSG",
    "clearingBroker": "0443",
    "brokerName": "GMS GROUP (THE), L.L.C.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "GPCA",
    "clearingBroker": "0158",
    "brokerName": "GREAT POINT CAPITAL LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "GPCG",
    "clearingBroker": "0443",
    "brokerName": "GREENMAN, PARKER, CONNALLY, GREENMAN, INC.                            "
  },
  {
    "type": "MUNI",
    "mpid": "GPSS",
    "clearingBroker": "0443",
    "brokerName": "GREAT PACIFIC SECURITIES                                              "
  },
  {
    "type": "MUNI",
    "mpid": "GRBD",
    "clearingBroker": "0052",
    "brokerName": "GREENBIRD CAPITAL LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "GRCF",
    "clearingBroker": "0443",
    "brokerName": "GREATER COMMUNITY FINANCIAL L.L.C.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "GRIN",
    "clearingBroker": "0443",
    "brokerName": "SANDGRAIN SECURITIES, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "GROD",
    "clearingBroker": "0226",
    "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "GRPS",
    "clearingBroker": "0226",
    "brokerName": "MML INVESTORS SERVICES, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "GRWC",
    "clearingBroker": "0443",
    "brokerName": "GRW CAPITAL CORPORATION                                               "
  },
  {
    "type": "MUNI",
    "mpid": "GRWD",
    "clearingBroker": "0052",
    "brokerName": "GAR WOOD SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "GRYG",
    "clearingBroker": "0226",
    "brokerName": "GOLDBERG (GARY) & CO., INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "GSAD",
    "clearingBroker": "0235",
    "brokerName": "GATTEN SADOWSKI INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "GSBI",
    "clearingBroker": "0279",
    "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "GSCO",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "GSIL",
    "clearingBroker": "0158",
    "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "GSMM",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "GSQQ",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "GSRI",
    "clearingBroker": "0443",
    "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "GSSC",
    "clearingBroker": "0161",
    "brokerName": "GEORGESON SHAREHOLDER SECURITIES CORP.                                "
  },
  {
    "type": "MUNI",
    "mpid": "GSSI",
    "clearingBroker": "0052",
    "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "GSUU",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "GSVV",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "GTNB",
    "clearingBroker": "0595",
    "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
  },
  {
    "type": "MUNI",
    "mpid": "GTSM",
    "clearingBroker": "0005",
    "brokerName": "GTS SECURITIES LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "GUGI",
    "clearingBroker": "0526",
    "brokerName": "GUGGENHEIM FUNDS DISTRIBUTORS, LLC                                    "
  },
  {
    "type": "MUNI",
    "mpid": "GWFS",
    "clearingBroker": "0443",
    "brokerName": "GWFS EQUITIES, INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "GWNS",
    "clearingBroker": "0226",
    "brokerName": "GWN SECURITIES INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "GZML",
    "clearingBroker": "0161",
    "brokerName": "GUZMAN & COMPANY                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "HACA",
    "clearingBroker": "0701",
    "brokerName": "HARVEST CAPITAL LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "HALO",
    "clearingBroker": "0235",
    "brokerName": "HALO SECURITIES, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "HARB",
    "clearingBroker": "0443",
    "brokerName": "HARBOUR INVESTMENTS INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "HARC",
    "clearingBroker": "0235",
    "brokerName": "HARLEY CAPITAL LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "HARS",
    "clearingBroker": "8199",
    "brokerName": "HARVESTONS SECURITIES, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "HAVK",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "HAZL",
    "clearingBroker": "0226",
    "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "HBCO",
    "clearingBroker": "0443",
    "brokerName": "GLOBAL INVESTOR SERVICES, L.C.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "HBKI",
    "clearingBroker": "0352",
    "brokerName": "HBK FINANCE, LP                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "HBUS",
    "clearingBroker": "0443",
    "brokerName": "HOLISTIC BROKERAGE, LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "HCGC",
    "clearingBroker": "0103",
    "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "HCMX",
    "clearingBroker": "0235",
    "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "HCTA",
    "clearingBroker": "0005",
    "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "HCWW",
    "clearingBroker": "0235",
    "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "HDVS",
    "clearingBroker": "0226",
    "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "HEAD",
    "clearingBroker": "0443",
    "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "HEGS",
    "clearingBroker": "1043",
    "brokerName": "HEG SECURITIES, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "HENN",
    "clearingBroker": "0235",
    "brokerName": "CARL M. HENNIG, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "HENY",
    "clearingBroker": "0443",
    "brokerName": "HENLEY & COMPANY LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "HFIS",
    "clearingBroker": "0141",
    "brokerName": "HFI SECURITIES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "HFLD",
    "clearingBroker": "0279",
    "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "HIGG",
    "clearingBroker": "0235",
    "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "HIGH",
    "clearingBroker": "0443",
    "brokerName": "HIGHLANDER CAPITAL GROUP, INC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "HILF",
    "clearingBroker": "0443",
    "brokerName": "HILL THOMPSON MAGID & CO INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "HINO",
    "clearingBroker": "0235",
    "brokerName": "TRB CAPITAL MARKETS,LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "HJSC",
    "clearingBroker": "0443",
    "brokerName": "SIMS (HERBERT J.) & CO., INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "HMRB",
    "clearingBroker": "0235",
    "brokerName": "W.R. HAMBRECHT + CO., LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "HNTR",
    "clearingBroker": "0443",
    "brokerName": "HUNTER ASSOCIATES, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "HONR",
    "clearingBroker": "0235",
    "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "HOPK",
    "clearingBroker": "0750",
    "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
  },
  {
    "type": "MUNI",
    "mpid": "HOTO",
    "clearingBroker": "0443",
    "brokerName": "HORNOR, TOWNSEND & KENT, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "HPOM",
    "clearingBroker": "0235",
    "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "HPWD",
    "clearingBroker": "0443",
    "brokerName": "PIPER SANDLER & CO.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "HRBF",
    "clearingBroker": "0756",
    "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
  },
  {
    "type": "MUNI",
    "mpid": "HRCS",
    "clearingBroker": "0443",
    "brokerName": "HRC INVESTMENT SERVICES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "HRGR",
    "clearingBroker": "0235",
    "brokerName": "HARGER AND COMPANY, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "HRRS",
    "clearingBroker": "0443",
    "brokerName": "HARRIS INVESTORS SERVICES, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "HSBM",
    "clearingBroker": "0486",
    "brokerName": "HSBC SECURITIES (USA), INC/ FIXED INCOME SECS                         "
  },
  {
    "type": "MUNI",
    "mpid": "HTCM",
    "clearingBroker": "0235",
    "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
  },
  {
    "type": "MUNI",
    "mpid": "HTIS",
    "clearingBroker": "0443",
    "brokerName": "HAITONG INTERNATIONAL SECURITIES (USA) INC.                           "
  },
  {
    "type": "MUNI",
    "mpid": "HTPS",
    "clearingBroker": "0443",
    "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "HTWR",
    "clearingBroker": "0226",
    "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "HUCO",
    "clearingBroker": "0226",
    "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
  },
  {
    "type": "MUNI",
    "mpid": "HUTC",
    "clearingBroker": "0443",
    "brokerName": "HUNTINGTON SECURITIES, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "HWLS",
    "clearingBroker": "0443",
    "brokerName": "M.S. HOWELLS & CO.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "HXGN",
    "clearingBroker": "0443",
    "brokerName": "HEXAGON SECURITIES, LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "IAAK",
    "clearingBroker": "0279",
    "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "IAEW",
    "clearingBroker": "0595",
    "brokerName": "SRT SECURITIES LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "IAEX",
    "clearingBroker": "0235",
    "brokerName": "SRT SECURITIES LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "IBCO",
    "clearingBroker": "0534",
    "brokerName": "INTERACTIVE BROKERS CORP.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "IBFS",
    "clearingBroker": "0824",
    "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
  },
  {
    "type": "MUNI",
    "mpid": "IBKR",
    "clearingBroker": "0534",
    "brokerName": "INTERACTIVE BROKERS LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "IBND",
    "clearingBroker": "0103",
    "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "IBPR",
    "clearingBroker": "0052",
    "brokerName": "IB CAPITAL LLC                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "IBSH",
    "clearingBroker": "0595",
    "brokerName": "INTEGRITY BROKERAGE SERVICES, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "IBSJ",
    "clearingBroker": "0052",
    "brokerName": "INTEGRITY BROKERAGE                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "ICAN",
    "clearingBroker": "0226",
    "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "ICBK",
    "clearingBroker": "0388",
    "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
  },
  {
    "type": "MUNI",
    "mpid": "ICCP",
    "clearingBroker": "0443",
    "brokerName": "INVESTORS CAPITAL CORPORATION                                         "
  },
  {
    "type": "MUNI",
    "mpid": "ICEX",
    "clearingBroker": "4264",
    "brokerName": "ICE SECURITIES EXECUTION & CLEARING, LLC                              "
  },
  {
    "type": "MUNI",
    "mpid": "ICMH",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
  },
  {
    "type": "MUNI",
    "mpid": "ICMI",
    "clearingBroker": "0279",
    "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "ICON",
    "clearingBroker": "0595",
    "brokerName": "ICON CAPITAL GROUP, LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "ICPX",
    "clearingBroker": "0443",
    "brokerName": "ICP SECURITIES LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "ICRL",
    "clearingBroker": "0443",
    "brokerName": "RIDEAU (I.C.) LYONS AND CO.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "ICTI",
    "clearingBroker": "0158",
    "brokerName": "INTERNATIONAL CORRESPONDENT TRADING, INC.                             "
  },
  {
    "type": "MUNI",
    "mpid": "IESI",
    "clearingBroker": "0443",
    "brokerName": "ITAU EUROPA SECURITIES INC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "IFCS",
    "clearingBroker": "0161",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "IMCC",
    "clearingBroker": "0005",
    "brokerName": "IMC FINANCIAL MARKETS                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "IMPC",
    "clearingBroker": "0443",
    "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "INGS",
    "clearingBroker": "0124",
    "brokerName": "INGALLS & SNYDER, LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "INGW",
    "clearingBroker": "0443",
    "brokerName": "ING PRIVATE WEALTH MANAGEMENT LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "INNO",
    "clearingBroker": "0052",
    "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "INPI",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT PLANNERS INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "INPS",
    "clearingBroker": "0235",
    "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "INTL",
    "clearingBroker": "0750",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "INTX",
    "clearingBroker": "0235",
    "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
  },
  {
    "type": "MUNI",
    "mpid": "IPGR",
    "clearingBroker": "0443",
    "brokerName": "INVESTMENT PLACEMENT GROUP                                            "
  },
  {
    "type": "MUNI",
    "mpid": "IRIS",
    "clearingBroker": "0279",
    "brokerName": "IRIS TRADING, INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "ISCN",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
  },
  {
    "type": "MUNI",
    "mpid": "ISIG",
    "clearingBroker": "0226",
    "brokerName": "EVERCORE GROUP L.L.C.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "ISLL",
    "clearingBroker": "0052",
    "brokerName": "INLET SECURITIES LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "ISSB",
    "clearingBroker": "0443",
    "brokerName": "IRONSTONE SECURITIES INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ISSC",
    "clearingBroker": "0443",
    "brokerName": "INVESTORS SECURITIES SERVICES, LLC                                    "
  },
  {
    "type": "MUNI",
    "mpid": "ISSI",
    "clearingBroker": "0052",
    "brokerName": "INSIGHT SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "ITCC",
    "clearingBroker": "0750",
    "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "ITFS",
    "clearingBroker": "0226",
    "brokerName": "KEEL POINT CAPITAL, LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "IVEX",
    "clearingBroker": "0443",
    "brokerName": "INVEX, INC.                                                           "
  },
  {
    "type": "MUNI",
    "mpid": "IVNT",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT NETWORK, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "IVOL",
    "clearingBroker": "0235",
    "brokerName": "UNION CAPITAL COMPANY                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "IVST",
    "clearingBroker": "0443",
    "brokerName": "INTERVEST INTERNATIONAL EQUITIES CORPORATION                          "
  },
  {
    "type": "MUNI",
    "mpid": "JACK",
    "clearingBroker": "0443",
    "brokerName": "JACKSON SECURITIES LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "JANC",
    "clearingBroker": "0443",
    "brokerName": "JANCO PARTNERS INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "JANE",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET MARKETS, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "JANY",
    "clearingBroker": "0374",
    "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "JASC",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET CAPITAL, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "JDAA",
    "clearingBroker": "0443",
    "brokerName": "DARDIS (JACK) & ASSOCIATES                                            "
  },
  {
    "type": "MUNI",
    "mpid": "JDRB",
    "clearingBroker": "0595",
    "brokerName": "J.H. DARBIE & CO., INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "JEFF",
    "clearingBroker": "0019",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "JEFM",
    "clearingBroker": "0235",
    "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
  },
  {
    "type": "MUNI",
    "mpid": "JEVO",
    "clearingBroker": "0235",
    "brokerName": "ATIS, INC                                                             "
  },
  {
    "type": "MUNI",
    "mpid": "JGUN",
    "clearingBroker": "0235",
    "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "JHDR",
    "clearingBroker": "0052",
    "brokerName": "JH DARBIE & CO. INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "JHYT",
    "clearingBroker": "0019",
    "brokerName": "JEFFERIES PARTNER OPPORTUNITY FUND II, LLC                            "
  },
  {
    "type": "MUNI",
    "mpid": "JJKE",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "JKCA",
    "clearingBroker": "0103",
    "brokerName": "J.K. CHILTON & ASSOCIATES, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "JKFS",
    "clearingBroker": "0279",
    "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "JKRC",
    "clearingBroker": "0443",
    "brokerName": "J.K.R. & CO., INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "JLEQ",
    "clearingBroker": "0161",
    "brokerName": "JUMP EXECUTION, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "JMFL",
    "clearingBroker": "0235",
    "brokerName": "THE JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                          "
  },
  {
    "type": "MUNI",
    "mpid": "JMLS",
    "clearingBroker": "0235",
    "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "JNST",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET CAPITAL LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "JNWS",
    "clearingBroker": "0443",
    "brokerName": "WHIPPLE (J.N.) INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "JONE",
    "clearingBroker": "0161",
    "brokerName": "JONESTRADING                                                          "
  },
  {
    "type": "MUNI",
    "mpid": "JPMC",
    "clearingBroker": "0443",
    "brokerName": "MCGOWAN (J.P.) & COMPANY, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "JPMT",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "JPPB",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "JRCO",
    "clearingBroker": "0226",
    "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "JSAP",
    "clearingBroker": "8497",
    "brokerName": "JANE STREET CAPITAL, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "JSBA",
    "clearingBroker": "0161",
    "brokerName": "JANE STREET CAPITAL, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "JSCT",
    "clearingBroker": "0005",
    "brokerName": "JANE STREET CAPITAL LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "JSEB",
    "clearingBroker": "0161",
    "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "JSEG",
    "clearingBroker": "0161",
    "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "JSSF",
    "clearingBroker": "0226",
    "brokerName": "JMP SECURITIES LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "JVBF",
    "clearingBroker": "0235",
    "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
  },
  {
    "type": "MUNI",
    "mpid": "JVBG",
    "clearingBroker": "0443",
    "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "JWCF",
    "clearingBroker": "0226",
    "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "KALA",
    "clearingBroker": "0226",
    "brokerName": "KA ASSOCIATES, INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "KALS",
    "clearingBroker": "0235",
    "brokerName": "KALOS CAPITAL, INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "KART",
    "clearingBroker": "0750",
    "brokerName": "REVERE SECURITIES CORP.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "KAWM",
    "clearingBroker": "0443",
    "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "KBWI",
    "clearingBroker": "0793",
    "brokerName": "KEEFE, BRUYETTE & WOODS, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "KCAM",
    "clearingBroker": "0052",
    "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "KCIM",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
  },
  {
    "type": "MUNI",
    "mpid": "KCIX",
    "clearingBroker": "0279",
    "brokerName": "KILEY PARTNERS, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "KCRD",
    "clearingBroker": "0052",
    "brokerName": "PHX FINANCIAL, INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "KENY",
    "clearingBroker": "0443",
    "brokerName": "KENNY SECURITIES CORP.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "KEYB",
    "clearingBroker": "0443",
    "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "KILD",
    "clearingBroker": "0103",
    "brokerName": "KILDARE CAPITAL, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "KIML",
    "clearingBroker": "0226",
    "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "KING",
    "clearingBroker": "0235",
    "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "KISL",
    "clearingBroker": "0443",
    "brokerName": "KEY INVESTMENT SERVICES LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "KMSF",
    "clearingBroker": "0443",
    "brokerName": "KMS FINANCIAL SERVICES                                                "
  },
  {
    "type": "MUNI",
    "mpid": "KNGS",
    "clearingBroker": "0235",
    "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "KOVP",
    "clearingBroker": "0443",
    "brokerName": "KOVACK SECURITIES INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "KOVS",
    "clearingBroker": "0226",
    "brokerName": "KOVACK SECURITIES, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "KRAM",
    "clearingBroker": "0141",
    "brokerName": "KRAMER SECURITIES CORP.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "KRCO",
    "clearingBroker": "0235",
    "brokerName": "KR SECURITIES, LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "KRSH",
    "clearingBroker": "0005",
    "brokerName": "KERSHNER SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "KRTH",
    "clearingBroker": "0235",
    "brokerName": "J.W. KORTH & COMPANY                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "KRUG",
    "clearingBroker": "0235",
    "brokerName": "KRUEGER BROKERAGE, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "KUYK",
    "clearingBroker": "0279",
    "brokerName": "KUYKENDALL & SCHNEIDER, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "LAFB",
    "clearingBroker": "0235",
    "brokerName": "LAFFERTY (R.F.) & CO., INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "LAFC",
    "clearingBroker": "0443",
    "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "LAFF",
    "clearingBroker": "0443",
    "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "LAGI",
    "clearingBroker": "0226",
    "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "LAMA",
    "clearingBroker": "0141",
    "brokerName": "XML SECURITIES                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "LANE",
    "clearingBroker": "0235",
    "brokerName": "MARC J. LANE & COMPANY                                                "
  },
  {
    "type": "MUNI",
    "mpid": "LARC",
    "clearingBroker": "0235",
    "brokerName": "LARIMER CAPITAL CORPORATION                                           "
  },
  {
    "type": "MUNI",
    "mpid": "LASE",
    "clearingBroker": "0235",
    "brokerName": "LEGACY ASSET SECURITIES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "LASI",
    "clearingBroker": "0141",
    "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "LASS",
    "clearingBroker": "0226",
    "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "LATG",
    "clearingBroker": "0537",
    "brokerName": "GFI SECURITIES LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "LATN",
    "clearingBroker": "0443",
    "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "LBKI",
    "clearingBroker": "0235",
    "brokerName": "LIBUCKI & CO., LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "LDIL",
    "clearingBroker": "0226",
    "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "LDLW",
    "clearingBroker": "0750",
    "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "LDOT",
    "clearingBroker": "0235",
    "brokerName": "LANDOLT SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "LEAD",
    "clearingBroker": "0226",
    "brokerName": "THE LEADERS GROUP, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "LEBO",
    "clearingBroker": "0226",
    "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "LEDG",
    "clearingBroker": "0443",
    "brokerName": "LEDGEWOOD CAPITAL MANAGEMENT, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "LEER",
    "clearingBroker": "0443",
    "brokerName": "LEERINK SWANN & COMPANY                                               "
  },
  {
    "type": "MUNI",
    "mpid": "LENX",
    "clearingBroker": "0279",
    "brokerName": "LENOX FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "LEON",
    "clearingBroker": "0235",
    "brokerName": "LEONARD SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "LESW",
    "clearingBroker": "0443",
    "brokerName": "LEERINK SWANN & COMPANY                                               "
  },
  {
    "type": "MUNI",
    "mpid": "LEXI",
    "clearingBroker": "0226",
    "brokerName": "LEXINGTON INVESTMENT COMPANY, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "LEYA",
    "clearingBroker": "0235",
    "brokerName": "LEMLEY, YARLING & CO.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "LFAC",
    "clearingBroker": "0226",
    "brokerName": "OSAIC FA, INC.                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "LFIN",
    "clearingBroker": "0161",
    "brokerName": "LIGHTHOUSE FINANCIAL GROUP, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LFRO",
    "clearingBroker": "0235",
    "brokerName": "LF ROTHSCHILD, LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "LGLL",
    "clearingBroker": "0141",
    "brokerName": "MM GLOBAL SECURITIES, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "LGNT",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "LGSA",
    "clearingBroker": "0443",
    "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
  },
  {
    "type": "MUNI",
    "mpid": "LIBE",
    "clearingBroker": "0443",
    "brokerName": "KCG AMERICAS LLC                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "LIFG",
    "clearingBroker": "0279",
    "brokerName": "LONG ISLAND FINANCIAL GROUP, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "LIIS",
    "clearingBroker": "0226",
    "brokerName": "USAA FINANCIAL ADVISORS, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "LINQ",
    "clearingBroker": "0443",
    "brokerName": "LINKBROKERS DERIVATIVES CORPORATION                                   "
  },
  {
    "type": "MUNI",
    "mpid": "LISI",
    "clearingBroker": "0443",
    "brokerName": "LEUMI INVESTMENT SERVICES, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LMAR",
    "clearingBroker": "0226",
    "brokerName": "LIFEMARK SECURITIES CORP.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "LMKO",
    "clearingBroker": "0235",
    "brokerName": "KOHN (L.M.) & COMPANY                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "LMSC",
    "clearingBroker": "0235",
    "brokerName": "BAY COLONY SECURITIES CO., INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LNKS",
    "clearingBroker": "0443",
    "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "LOMB",
    "clearingBroker": "0141",
    "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LOOP",
    "clearingBroker": "0443",
    "brokerName": "LOOP CAPITAL MARKETS, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "LOUE",
    "clearingBroker": "0161",
    "brokerName": "ICAP CORPORATES LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "LOUI",
    "clearingBroker": "0005",
    "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
  },
  {
    "type": "MUNI",
    "mpid": "LPCM",
    "clearingBroker": "0103",
    "brokerName": "LAMPERT CAPITAL MARKETS INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "LPFS",
    "clearingBroker": "0235",
    "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
  },
  {
    "type": "MUNI",
    "mpid": "LPLE",
    "clearingBroker": "0075",
    "brokerName": "LPL ENTERPRISE, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "LPSP",
    "clearingBroker": "1043",
    "brokerName": "LPS CAPITAL LLC                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LQNA",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LQNB",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LQNF",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LQNT",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LQPT",
    "clearingBroker": "0161",
    "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LRBC",
    "clearingBroker": "0235",
    "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "LRCM",
    "clearingBroker": "0279",
    "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LSCM",
    "clearingBroker": "0235",
    "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "LSKO",
    "clearingBroker": "0226",
    "brokerName": "LESKO SECURITIES INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "LSPI",
    "clearingBroker": "0141",
    "brokerName": "LAFAYETTE INVESTMENTS                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "LSSM",
    "clearingBroker": "0443",
    "brokerName": "LOCUST STREET SECURITIES, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "LSUS",
    "clearingBroker": "0443",
    "brokerName": "LATIN SECURITIES INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "LTCO",
    "clearingBroker": "0226",
    "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "LTCS",
    "clearingBroker": "0141",
    "brokerName": "LINDEN THOMAS AND COMPANY SECURITIES, LLC                             "
  },
  {
    "type": "MUNI",
    "mpid": "LTIN",
    "clearingBroker": "2786",
    "brokerName": "BBVA SECURITIES INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "LTLI",
    "clearingBroker": "0141",
    "brokerName": "L.P. LITTLEWOOD & ASSOCIATES, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "LVMR",
    "clearingBroker": "0235",
    "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "LYON",
    "clearingBroker": "0651",
    "brokerName": "CREDIT AGRICOLE SECURITIES (USA) INC.                                 "
  },
  {
    "type": "MUNI",
    "mpid": "LYSI",
    "clearingBroker": "0443",
    "brokerName": "LLOYDS SECURITIES INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "MACC",
    "clearingBroker": "0226",
    "brokerName": "NEWEDGE SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "MACP",
    "clearingBroker": "0443",
    "brokerName": "GRIFFON MAY, INC.                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "MADV",
    "clearingBroker": "0443",
    "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "MAMA",
    "clearingBroker": "0443",
    "brokerName": "SECUREVEST FINANCIAL GROUP                                            "
  },
  {
    "type": "MUNI",
    "mpid": "MASE",
    "clearingBroker": "0141",
    "brokerName": "MANAGED ACCOUNT SERVICES, LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "MAVS",
    "clearingBroker": "0443",
    "brokerName": "MADISON AVENUE SECURITIES                                             "
  },
  {
    "type": "MUNI",
    "mpid": "MAXM",
    "clearingBroker": "0443",
    "brokerName": "MAXIM GROUP LLC                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "MBSA",
    "clearingBroker": "0052",
    "brokerName": "MBS SOURCE ETRADING, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "MBSE",
    "clearingBroker": "0052",
    "brokerName": "MBS SOURCE ETRADING, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "MBSL",
    "clearingBroker": "0443",
    "brokerName": "MBS CAPITAL MARKETS, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "MBTS",
    "clearingBroker": "0158",
    "brokerName": "MB TRADING                                                            "
  },
  {
    "type": "MUNI",
    "mpid": "MBUS",
    "clearingBroker": "0052",
    "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "MCAP",
    "clearingBroker": "0161",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "MUNI",
    "mpid": "MCBT",
    "clearingBroker": "0235",
    "brokerName": "MOORS & CABOT, INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "MCCL",
    "clearingBroker": "0443",
    "brokerName": "MCCLURG CAPITAL CORPORATION                                           "
  },
  {
    "type": "MUNI",
    "mpid": "MCMG",
    "clearingBroker": "0279",
    "brokerName": "MUNICIPAL CAPITAL MARKETS GROUP, INC.                                 "
  },
  {
    "type": "MUNI",
    "mpid": "MDGP",
    "clearingBroker": "0235",
    "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "MDGS",
    "clearingBroker": "0103",
    "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "MDTH",
    "clearingBroker": "0443",
    "brokerName": "MEREDITH (ROBERT R.) & CO.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "MEAL",
    "clearingBroker": "0226",
    "brokerName": "M. E. ALLISON & CO., INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "MERP",
    "clearingBroker": "0235",
    "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "MERQ",
    "clearingBroker": "0161",
    "brokerName": "MERCATOR ASSOCIATES LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "MESF",
    "clearingBroker": "0443",
    "brokerName": "MESIROW FINANCIAL, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "MFCA",
    "clearingBroker": "0141",
    "brokerName": "MONARCH FINANCIAL CORPORATION OF AMERICA                              "
  },
  {
    "type": "MUNI",
    "mpid": "MFGX",
    "clearingBroker": "0443",
    "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "MFRS",
    "clearingBroker": "0443",
    "brokerName": "MFR SECURITIES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "MHFI",
    "clearingBroker": "0226",
    "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "MIAM",
    "clearingBroker": "6440",
    "brokerName": "FMSBONDS, INC.                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "MICG",
    "clearingBroker": "0141",
    "brokerName": "MICG INVESTMENT MANAGEMENT                                            "
  },
  {
    "type": "MUNI",
    "mpid": "MIDL",
    "clearingBroker": "0226",
    "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "MIFI",
    "clearingBroker": "0226",
    "brokerName": "MILKIE FERGUSON INVESTMENTS, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "MILN",
    "clearingBroker": "1767",
    "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "MINV",
    "clearingBroker": "0235",
    "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "MIRA",
    "clearingBroker": "1043",
    "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "MISL",
    "clearingBroker": "0161",
    "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "MISM",
    "clearingBroker": "0161",
    "brokerName": "MISMI, INC.                                                           "
  },
  {
    "type": "MUNI",
    "mpid": "MITR",
    "clearingBroker": "0443",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "MJWH",
    "clearingBroker": "0235",
    "brokerName": "ETICO PARTNERS LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "MKRT",
    "clearingBroker": "0235",
    "brokerName": "MARKET SECURITIES, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "MKTI",
    "clearingBroker": "0226",
    "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "MKTX",
    "clearingBroker": "4265",
    "brokerName": "MARKETAXESS CORPORATION                                               "
  },
  {
    "type": "MUNI",
    "mpid": "MKTY",
    "clearingBroker": "4265",
    "brokerName": "MARKETAXESS CORPORATION                                               "
  },
  {
    "type": "MUNI",
    "mpid": "MLCO",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "MLMA",
    "clearingBroker": "0671",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "MUNI",
    "mpid": "MLMS",
    "clearingBroker": "0279",
    "brokerName": "MAINLINE WEST MUNICIPAL SECURITIES, LLC                               "
  },
  {
    "type": "MUNI",
    "mpid": "MLWM",
    "clearingBroker": "0671",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "MUNI",
    "mpid": "MMAN",
    "clearingBroker": "0443",
    "brokerName": "MCMAHAN SECURITIES CO. L.P.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "MMNT",
    "clearingBroker": "0158",
    "brokerName": "MOMENT MARKETS, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "MNCO",
    "clearingBroker": "0279",
    "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "MNRC",
    "clearingBroker": "0443",
    "brokerName": "MONARCH CAPITAL GROUP LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "MNXS",
    "clearingBroker": "0443",
    "brokerName": "MUNIAXIS LEBENTHAL LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "MOCM",
    "clearingBroker": "0235",
    "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "MOJO",
    "clearingBroker": "0103",
    "brokerName": "MONTAG & JOSELSON                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "MOLO",
    "clearingBroker": "0235",
    "brokerName": "MOLONEY SECURITIES                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "MOMS",
    "clearingBroker": "0750",
    "brokerName": "MOMENTUS SECURITIES LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "MONR",
    "clearingBroker": "0226",
    "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "MORA",
    "clearingBroker": "0443",
    "brokerName": "MORA WM SECURITIES                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "MPLA",
    "clearingBroker": "0158",
    "brokerName": "EMPALA SECURITIES, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "MPLM",
    "clearingBroker": "0651",
    "brokerName": "MOMENTUM TRADING PARTNERS, LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "MPLW",
    "clearingBroker": "0226",
    "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
  },
  {
    "type": "MUNI",
    "mpid": "MPSG",
    "clearingBroker": "0161",
    "brokerName": "ED & F MAN CAPITAL MARKETS INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "MRBA",
    "clearingBroker": "0052",
    "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "MRNA",
    "clearingBroker": "0161",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "MRPH",
    "clearingBroker": "0226",
    "brokerName": "WM FINANCIAL SERVICES, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "MRSC",
    "clearingBroker": "0287",
    "brokerName": "TRADEUP SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "MSCH",
    "clearingBroker": "0443",
    "brokerName": "MAGNA SECURITIES CORP.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "MSCO",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "MSEC",
    "clearingBroker": "0235",
    "brokerName": "MSEC, LLC                                                             "
  },
  {
    "type": "MUNI",
    "mpid": "MSII",
    "clearingBroker": "0226",
    "brokerName": "MSI FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "MSNY",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY & CO. LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "MSPW",
    "clearingBroker": "0050",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "MSRO",
    "clearingBroker": "0226",
    "brokerName": "MESIROW FINANCIAL, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "MSSS",
    "clearingBroker": "0050",
    "brokerName": "MS SECURITIES SERVICES, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "MSTC",
    "clearingBroker": "0226",
    "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
  },
  {
    "type": "MUNI",
    "mpid": "MTBK",
    "clearingBroker": "0443",
    "brokerName": "MULTI-BANK SECURITIES, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "MTCN",
    "clearingBroker": "0443",
    "brokerName": "MILLER TABAK & CO., LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "MTDB",
    "clearingBroker": "0443",
    "brokerName": "M&T SECURITIES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "MTHN",
    "clearingBroker": "0005",
    "brokerName": "MARATHON TRADING GROUP LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "MTLE",
    "clearingBroker": "0235",
    "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "MTNS",
    "clearingBroker": "0443",
    "brokerName": "MOUNTAINSIDE SECURITIES LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "MTRN",
    "clearingBroker": "0443",
    "brokerName": "MULTITRADE SECURITIES LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "MTSL",
    "clearingBroker": "0226",
    "brokerName": "MSEC, LLC                                                             "
  },
  {
    "type": "MUNI",
    "mpid": "MUFG",
    "clearingBroker": "0076",
    "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "MULT",
    "clearingBroker": "0443",
    "brokerName": "MULTI-FINANCIAL SECURITIES GROUP                                      "
  },
  {
    "type": "MUNI",
    "mpid": "MUNP",
    "clearingBroker": "0443",
    "brokerName": "MUNICIPAL PARTNERS                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "MURF",
    "clearingBroker": "0443",
    "brokerName": "MURPHY & DURIEU                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "MVII",
    "clearingBroker": "0235",
    "brokerName": "MINNESOTA VALLEY INVESTMENTS                                          "
  },
  {
    "type": "MUNI",
    "mpid": "MWCC",
    "clearingBroker": "0235",
    "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "MWCO",
    "clearingBroker": "0443",
    "brokerName": "MADISON WILLIAMS AND COMPANY                                          "
  },
  {
    "type": "MUNI",
    "mpid": "MWIL",
    "clearingBroker": "0235",
    "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "MYMK",
    "clearingBroker": "0443",
    "brokerName": "MONEY MARKET 1 INSTITUTIONAL INVESTMENT DEALER                        "
  },
  {
    "type": "MUNI",
    "mpid": "MYSS",
    "clearingBroker": "0158",
    "brokerName": "M.Y. SAFRA SECURITIES, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "MZHO",
    "clearingBroker": "2396",
    "brokerName": "MIZUHO SECURITIES USA LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "NACM",
    "clearingBroker": "0161",
    "brokerName": "NABSECURITIES, LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "NADL",
    "clearingBroker": "0235",
    "brokerName": "WARREN D. NADEL & COMPANY                                             "
  },
  {
    "type": "MUNI",
    "mpid": "NAIS",
    "clearingBroker": "0443",
    "brokerName": "NORTH AMERICAN CAPITAL MARKETS                                        "
  },
  {
    "type": "MUNI",
    "mpid": "NAPK",
    "clearingBroker": "0052",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "MUNI",
    "mpid": "NASC",
    "clearingBroker": "0235",
    "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "NAVC",
    "clearingBroker": "0235",
    "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "NBAR",
    "clearingBroker": "0226",
    "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "NBCS",
    "clearingBroker": "0235",
    "brokerName": "NBC SECURITIES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "NBLB",
    "clearingBroker": "0226",
    "brokerName": "NEUBERGER BERMAN BD LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "NBNA",
    "clearingBroker": "6737",
    "brokerName": "BANK OF AMERICA, N.A.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "NBSL",
    "clearingBroker": "0226",
    "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "NBST",
    "clearingBroker": "0103",
    "brokerName": "BRANDIS TALLMAN LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "NEPP",
    "clearingBroker": "0226",
    "brokerName": "N.E. PRIVATE CLIENT ADVISORS, LTD.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "NEST",
    "clearingBroker": "0235",
    "brokerName": "NEST INVESTMENTS BD LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "NEXT",
    "clearingBroker": "0443",
    "brokerName": "NEXT FINANCIAL GROUP, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "NFGR",
    "clearingBroker": "0141",
    "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "NFSC",
    "clearingBroker": "0226",
    "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "NFTY",
    "clearingBroker": "0235",
    "brokerName": "INFINITY FINANCIAL SERVICES                                           "
  },
  {
    "type": "MUNI",
    "mpid": "NHWI",
    "clearingBroker": "0141",
    "brokerName": "HENNION & WALSH, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "NIAD",
    "clearingBroker": "0052",
    "brokerName": "NI ADVISORS                                                           "
  },
  {
    "type": "MUNI",
    "mpid": "NITC",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "NLOV",
    "clearingBroker": "0279",
    "brokerName": "NORTLOV SECURITIES LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "NOBL",
    "clearingBroker": "0443",
    "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
  },
  {
    "type": "MUNI",
    "mpid": "NORC",
    "clearingBroker": "0235",
    "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "NORP",
    "clearingBroker": "0443",
    "brokerName": "PARETO SECURITIES INC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "NORT",
    "clearingBroker": "0443",
    "brokerName": "NORTHLAND SECURITIES, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "NORW",
    "clearingBroker": "0250",
    "brokerName": "WELLS FARGO BROKERAGE SERVICES, LLC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "NQBX",
    "clearingBroker": "0163",
    "brokerName": "NASDAQ BX, INC.                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "NSFP",
    "clearingBroker": "0235",
    "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "NSRD",
    "clearingBroker": "0235",
    "brokerName": "NESTLERODE & CO., INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "NTFN",
    "clearingBroker": "0052",
    "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
  },
  {
    "type": "MUNI",
    "mpid": "NTRC",
    "clearingBroker": "0226",
    "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "NTSI",
    "clearingBroker": "0443",
    "brokerName": "NESBITT THOMSON SECURITIES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "NVEN",
    "clearingBroker": "0448",
    "brokerName": "NUVEEN SECURITIES, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "NVGT",
    "clearingBroker": "0388",
    "brokerName": "NAVIGATE ADVISORS LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "NWCM",
    "clearingBroker": "0235",
    "brokerName": "NW CAPITAL MARKETS INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "NWIA",
    "clearingBroker": "0750",
    "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
  },
  {
    "type": "MUNI",
    "mpid": "NYLS",
    "clearingBroker": "0226",
    "brokerName": "NYLIFE SECURITIES INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "OAKR",
    "clearingBroker": "0235",
    "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
  },
  {
    "type": "MUNI",
    "mpid": "OBWS",
    "clearingBroker": "0226",
    "brokerName": "OBERWEIS SECURITIES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "OCAC",
    "clearingBroker": "0235",
    "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "OCON",
    "clearingBroker": "0103",
    "brokerName": "O'CONNOR & CO SECURITIES                                              "
  },
  {
    "type": "MUNI",
    "mpid": "ODEO",
    "clearingBroker": "0388",
    "brokerName": "ODEON CAP                                                             "
  },
  {
    "type": "MUNI",
    "mpid": "ODNC",
    "clearingBroker": "0235",
    "brokerName": "ODEON CAPITAL GROUP LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "OFGF",
    "clearingBroker": "0235",
    "brokerName": "OFG FINANCIAL SERVICES INC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "OGRU",
    "clearingBroker": "0161",
    "brokerName": "OSCAR GRUSS & SON, INCORPORATED                                       "
  },
  {
    "type": "MUNI",
    "mpid": "OGTL",
    "clearingBroker": "0005",
    "brokerName": "OUTSET GLOBAL TRADING LIMITED                                         "
  },
  {
    "type": "MUNI",
    "mpid": "OHIO",
    "clearingBroker": "0443",
    "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "OLDM",
    "clearingBroker": "0005",
    "brokerName": "OLD MISSION CAPITAL, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "OLNE",
    "clearingBroker": "0279",
    "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "OMMA",
    "clearingBroker": "0005",
    "brokerName": "OLD MISSION MARKETS LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "ONEL",
    "clearingBroker": "0161",
    "brokerName": "O'NEIL (WILLIAM) & CO                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "ONES",
    "clearingBroker": "0443",
    "brokerName": "O N EQUITY SALES CO.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "OPCO",
    "clearingBroker": "0571",
    "brokerName": "OPPENHEIMER & CO. INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "OPTF",
    "clearingBroker": "0005",
    "brokerName": "OPTIVER US LLC                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "ORTL",
    "clearingBroker": "0443",
    "brokerName": "ORIENTAL FINANCIAL SERVICES                                           "
  },
  {
    "type": "MUNI",
    "mpid": "OSIC",
    "clearingBroker": "0226",
    "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "OTCN",
    "clearingBroker": "0158",
    "brokerName": "OTC LINK LLC                                                          "
  },
  {
    "type": "MUNI",
    "mpid": "OTSC",
    "clearingBroker": "0443",
    "brokerName": "OGILVIE SECURITY ADVISORS CORPORATION                                 "
  },
  {
    "type": "MUNI",
    "mpid": "OYLD",
    "clearingBroker": "0235",
    "brokerName": "OPENYIELD TRADING LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "PAFA",
    "clearingBroker": "0443",
    "brokerName": "PAN-AMERICAN FINANCIAL ADVISORS                                       "
  },
  {
    "type": "MUNI",
    "mpid": "PAMC",
    "clearingBroker": "0226",
    "brokerName": "PROGRESSIVE ASSET MANAGEMENT                                          "
  },
  {
    "type": "MUNI",
    "mpid": "PAMI",
    "clearingBroker": "0141",
    "brokerName": "PROFESSIONAL ASSET MANAGEMENT, INC.                                   "
  },
  {
    "type": "MUNI",
    "mpid": "PAMS",
    "clearingBroker": "0443",
    "brokerName": "PACIFIC AMERICAN SECURITIES, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "PANA",
    "clearingBroker": "0443",
    "brokerName": "PANAMERICA CAPITAL GROUP INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "PAPA",
    "clearingBroker": "0443",
    "brokerName": "PAPAMARKOU WELLNER & CO., INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "PARI",
    "clearingBroker": "0630",
    "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "PARK",
    "clearingBroker": "0443",
    "brokerName": "PARK WALK CAPITAL MARKETS, LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "PARV",
    "clearingBroker": "0443",
    "brokerName": "PAR5 CAPITAL & CO LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "PASC",
    "clearingBroker": "0443",
    "brokerName": "PARK AVENUE SECURITIES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "PASL",
    "clearingBroker": "0443",
    "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "PASQ",
    "clearingBroker": "0443",
    "brokerName": "DUPASQUIER & CO., INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "PATR",
    "clearingBroker": "0624",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "PAUL",
    "clearingBroker": "0595",
    "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "PBON",
    "clearingBroker": "0161",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "PCAP",
    "clearingBroker": "0608",
    "brokerName": "SG AMERICAS SECURITIES, LLC/SUB 608                                   "
  },
  {
    "type": "MUNI",
    "mpid": "PCCA",
    "clearingBroker": "0279",
    "brokerName": "PEACHCAP SECURITIES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "PCCN",
    "clearingBroker": "0443",
    "brokerName": "PACTUAL CAPITAL CORPORATION                                           "
  },
  {
    "type": "MUNI",
    "mpid": "PCIS",
    "clearingBroker": "0226",
    "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "PEER",
    "clearingBroker": "0226",
    "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
  },
  {
    "type": "MUNI",
    "mpid": "PENG",
    "clearingBroker": "0443",
    "brokerName": "PENNSYLVANIA GROUP INCORPORATED (THE)                                 "
  },
  {
    "type": "MUNI",
    "mpid": "PERC",
    "clearingBroker": "0279",
    "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "PERS",
    "clearingBroker": "0443",
    "brokerName": "PERSHING LLC                                                          "
  },
  {
    "type": "MUNI",
    "mpid": "PFCG",
    "clearingBroker": "0279",
    "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "PFCL",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "PFDC",
    "clearingBroker": "0235",
    "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "PFPI",
    "clearingBroker": "0443",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "PGRS",
    "clearingBroker": "0443",
    "brokerName": "PGR SECURITIES, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "PGSI",
    "clearingBroker": "0443",
    "brokerName": "PRIME GLOBAL SECURITIES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "PHBP",
    "clearingBroker": "0052",
    "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "PHIN",
    "clearingBroker": "0443",
    "brokerName": "PHILADELPHIA INVESTORS, LTD.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "PHRS",
    "clearingBroker": "0279",
    "brokerName": "NAVAID FINANCIAL SERVICES, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "PICI",
    "clearingBroker": "0279",
    "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "PICL",
    "clearingBroker": "0052",
    "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "PIGS",
    "clearingBroker": "0443",
    "brokerName": "PENN INVESTMENT GROUP, INC. (THE)                                     "
  },
  {
    "type": "MUNI",
    "mpid": "PIMS",
    "clearingBroker": "0226",
    "brokerName": "PRUDENTIAL INVESTMENT MANAGEMENT SERVICES, LLC                        "
  },
  {
    "type": "MUNI",
    "mpid": "PINA",
    "clearingBroker": "0141",
    "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "PIPR",
    "clearingBroker": "0443",
    "brokerName": "PIPER SANDLER & CO.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "PIRR",
    "clearingBroker": "0443",
    "brokerName": "PIRRONE & CO., INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "PJEF",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "PKAX",
    "clearingBroker": "0158",
    "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "PMAS",
    "clearingBroker": "0443",
    "brokerName": "PMA SECURITIES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "PMKS",
    "clearingBroker": "0141",
    "brokerName": "PMK SECURITIES & RESEARCH, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "PNCC",
    "clearingBroker": "0226",
    "brokerName": "PNC INVESTMENTS                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "PNCM",
    "clearingBroker": "2835",
    "brokerName": "PNC CAPITAL MARKETS LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "PNFP",
    "clearingBroker": "0279",
    "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "PNSA",
    "clearingBroker": "0235",
    "brokerName": "PENSERRA SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "PNSR",
    "clearingBroker": "0161",
    "brokerName": "PENSERRA SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "PODE",
    "clearingBroker": "0235",
    "brokerName": "PODESTA & CO.                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "POND",
    "clearingBroker": "0141",
    "brokerName": "POND EQUITIES                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "POOH",
    "clearingBroker": "0443",
    "brokerName": "QUESTAR CAPITAL CORPORATION                                           "
  },
  {
    "type": "MUNI",
    "mpid": "POPS",
    "clearingBroker": "0226",
    "brokerName": "POPULAR SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "POWL",
    "clearingBroker": "0443",
    "brokerName": "POWELL (ELMER E.) COMPANY                                             "
  },
  {
    "type": "MUNI",
    "mpid": "PPSI",
    "clearingBroker": "0235",
    "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "PPSL",
    "clearingBroker": "0413",
    "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "PREB",
    "clearingBroker": "0005",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "PRFA",
    "clearingBroker": "0235",
    "brokerName": "PROOF SERVICES LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "PRGL",
    "clearingBroker": "0141",
    "brokerName": "PRUDENTIAL EQUITY GROUP, LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "PROE",
    "clearingBroker": "0443",
    "brokerName": "PROEQUITIES, INC.                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "PRPO",
    "clearingBroker": "0443",
    "brokerName": "PRIVATE PORTFOLIO, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "PRSB",
    "clearingBroker": "0141",
    "brokerName": "PRESIDENTIAL BROKERAGE, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "PRST",
    "clearingBroker": "0551",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "PSAE",
    "clearingBroker": "0141",
    "brokerName": "PSA EQUITIES, INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "PSII",
    "clearingBroker": "0226",
    "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "PSIM",
    "clearingBroker": "0226",
    "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "PSIN",
    "clearingBroker": "0443",
    "brokerName": "LUMENT SECURITIES, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "PSRI",
    "clearingBroker": "0103",
    "brokerName": "GLOBALINK SECURITIES, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "PSUT",
    "clearingBroker": "0235",
    "brokerName": "INNOVATION PARTNERS LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "PTCM",
    "clearingBroker": "0443",
    "brokerName": "CAVU SECURITIES LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "PTIS",
    "clearingBroker": "0235",
    "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "PTRI",
    "clearingBroker": "0443",
    "brokerName": "PETRIE PARKMAN & CO.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "PULB",
    "clearingBroker": "0052",
    "brokerName": "PULASKI BANK                                                          "
  },
  {
    "type": "MUNI",
    "mpid": "PUMP",
    "clearingBroker": "0141",
    "brokerName": "C.E. GAYE & SONS SECURITIES LTD.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "PUPL",
    "clearingBroker": "0226",
    "brokerName": "PUPLAVA SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "PURP",
    "clearingBroker": "0279",
    "brokerName": "LIBERTY CAPITAL INVESTMENT CORPORATION                                "
  },
  {
    "type": "MUNI",
    "mpid": "PWJC",
    "clearingBroker": "0221",
    "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "PWPR",
    "clearingBroker": "0221",
    "brokerName": "UBS FINANCIAL SERVICE INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "PXGJ",
    "clearingBroker": "0352",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "QBND",
    "clearingBroker": "0161",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "MUNI",
    "mpid": "QBSI",
    "clearingBroker": "0226",
    "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "QCAP",
    "clearingBroker": "0235",
    "brokerName": "QUINT CAPITAL CORPORATION                                             "
  },
  {
    "type": "MUNI",
    "mpid": "QCAS",
    "clearingBroker": "0226",
    "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
  },
  {
    "type": "MUNI",
    "mpid": "QMSR",
    "clearingBroker": "0235",
    "brokerName": "QUATTRO M SECURITIES INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "QUOI",
    "clearingBroker": "0279",
    "brokerName": "QUOIN CAPITAL LLC                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "QWIK",
    "clearingBroker": "0161",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "MUNI",
    "mpid": "RAAA",
    "clearingBroker": "0052",
    "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "RAAI",
    "clearingBroker": "0226",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "RACO",
    "clearingBroker": "0158",
    "brokerName": "SHEARMAN, RALSTON, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "RAIS",
    "clearingBroker": "0443",
    "brokerName": "ROYAL AMERICAN INVESTMENT SERVICES, INC.                              "
  },
  {
    "type": "MUNI",
    "mpid": "RAIT",
    "clearingBroker": "0161",
    "brokerName": "RAIT SECURITIES                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "RAJA",
    "clearingBroker": "0725",
    "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "RAYG",
    "clearingBroker": "0443",
    "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "RBAC",
    "clearingBroker": "0235",
    "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "RBCD",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
  },
  {
    "type": "MUNI",
    "mpid": "RBCX",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
  },
  {
    "type": "MUNI",
    "mpid": "RBII",
    "clearingBroker": "0279",
    "brokerName": "REGIONAL BROKERS, INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "RBMU",
    "clearingBroker": "0279",
    "brokerName": "BLUM (ROBERT) MUNICIPALS INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "RCRS",
    "clearingBroker": "0226",
    "brokerName": "ROOSEVELT & CROSS, INCORPORATED                                       "
  },
  {
    "type": "MUNI",
    "mpid": "RCSK",
    "clearingBroker": "0642",
    "brokerName": "RUANE, CUNNIFF & GOLDBARB LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "RDSS",
    "clearingBroker": "0141",
    "brokerName": "RDSC, LLC                                                             "
  },
  {
    "type": "MUNI",
    "mpid": "REID",
    "clearingBroker": "0141",
    "brokerName": "REID AND ASSOCIATES LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "REPG",
    "clearingBroker": "0443",
    "brokerName": "FIRST REPUBLIC GROUP, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "REVL",
    "clearingBroker": "0750",
    "brokerName": "REVL SECURITIES, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "RFRC",
    "clearingBroker": "0279",
    "brokerName": "THE ROCKWELL FINANCIAL GROUP, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "RGIC",
    "clearingBroker": "0443",
    "brokerName": "R-G INVESTMENTS CORPORATION                                           "
  },
  {
    "type": "MUNI",
    "mpid": "RGLD",
    "clearingBroker": "0279",
    "brokerName": "REGAL SECURITIES, INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "RGLS",
    "clearingBroker": "0235",
    "brokerName": "REGAL SECURITIES, INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "RGWD",
    "clearingBroker": "0141",
    "brokerName": "RIDGEWOOD ASSOCIATES INC., NJ                                         "
  },
  {
    "type": "MUNI",
    "mpid": "RHCO",
    "clearingBroker": "0505",
    "brokerName": "TRUIST SECURITIES, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "RHDS",
    "clearingBroker": "0141",
    "brokerName": "RHODES SECURITIES, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "RHOX",
    "clearingBroker": "0005",
    "brokerName": "XR SECURITIES LLC                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "RIAP",
    "clearingBroker": "0443",
    "brokerName": "OSAIC SERVICES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "RICE",
    "clearingBroker": "0235",
    "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
  },
  {
    "type": "MUNI",
    "mpid": "RICJ",
    "clearingBroker": "0235",
    "brokerName": "RICE SECURITIES, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "RICM",
    "clearingBroker": "0595",
    "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
  },
  {
    "type": "MUNI",
    "mpid": "RIED",
    "clearingBroker": "0235",
    "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
  },
  {
    "type": "MUNI",
    "mpid": "RILY",
    "clearingBroker": "0226",
    "brokerName": "B. RILEY FBR, INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "RINO",
    "clearingBroker": "0019",
    "brokerName": "RHINO TRADING PARTNERS, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "RJFI",
    "clearingBroker": "0390",
    "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "RKWS",
    "clearingBroker": "0235",
    "brokerName": "ROCKWELL SECURITIES LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "RMAC",
    "clearingBroker": "0235",
    "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "RMPI",
    "clearingBroker": "0141",
    "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "RMST",
    "clearingBroker": "0443",
    "brokerName": "R.M. STARK & CO., INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "ROAR",
    "clearingBroker": "0103",
    "brokerName": "DINOSAUR SECURITIES                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "ROBT",
    "clearingBroker": "0443",
    "brokerName": "ROBOTTI & COMPANY, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "ROCH",
    "clearingBroker": "0443",
    "brokerName": "ROCHDALE SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "ROCK",
    "clearingBroker": "0226",
    "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "RODE",
    "clearingBroker": "0443",
    "brokerName": "RODECKER & COMPANY, INVESTMENT BROKERS, INC.                          "
  },
  {
    "type": "MUNI",
    "mpid": "ROMO",
    "clearingBroker": "0141",
    "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
  },
  {
    "type": "MUNI",
    "mpid": "RONI",
    "clearingBroker": "0005",
    "brokerName": "RONIN CAPITAL, LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "ROPK",
    "clearingBroker": "0443",
    "brokerName": "REINOSO & COMPANY, INCORPORATED                                       "
  },
  {
    "type": "MUNI",
    "mpid": "ROTB",
    "clearingBroker": "0235",
    "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "ROTH",
    "clearingBroker": "0161",
    "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "ROYL",
    "clearingBroker": "0443",
    "brokerName": "ROYAL ALLIANCE ASSOCIATES, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "RQDR",
    "clearingBroker": "0235",
    "brokerName": "RQD* CLEARING LLC                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "RREZ",
    "clearingBroker": "0443",
    "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "RRII",
    "clearingBroker": "0388",
    "brokerName": "ROBERTS & RYAN INVESTMENTS, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "RRPR",
    "clearingBroker": "0443",
    "brokerName": "SAMUEL A RAMIREZ, & CO., INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "RRUD",
    "clearingBroker": "0235",
    "brokerName": "REID & RUDIGER, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "RSCM",
    "clearingBroker": "0235",
    "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
  },
  {
    "type": "MUNI",
    "mpid": "RSCO",
    "clearingBroker": "0443",
    "brokerName": "RAMIUS SECURITIES, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "RSSE",
    "clearingBroker": "0443",
    "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
  },
  {
    "type": "MUNI",
    "mpid": "RSWM",
    "clearingBroker": "0141",
    "brokerName": "RIVERSTONE WEALTH MANAGEMENT, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "RVSI",
    "clearingBroker": "0103",
    "brokerName": "ROBERT VAN SECURITIES, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "RWPS",
    "clearingBroker": "0443",
    "brokerName": "R.W. PRESSPRICH & CO.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "RWSM",
    "clearingBroker": "0279",
    "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "RYAN",
    "clearingBroker": "0443",
    "brokerName": "RYAN, BECK & CO.                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "SABF",
    "clearingBroker": "0161",
    "brokerName": "SAUDI AMERICAN BANK                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "SABS",
    "clearingBroker": "0443",
    "brokerName": "SABADELL SECURITIES USA, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "SAFS",
    "clearingBroker": "0750",
    "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "SAFX",
    "clearingBroker": "0235",
    "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "SAGE",
    "clearingBroker": "0141",
    "brokerName": "SAGE, RUTTY & CO., INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "SALB",
    "clearingBroker": "0274",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC./SALOMON BROTHERS                        "
  },
  {
    "type": "MUNI",
    "mpid": "SALI",
    "clearingBroker": "0750",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "SAMI",
    "clearingBroker": "0226",
    "brokerName": "SAMI BROKERAGE LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "SAPA",
    "clearingBroker": "0141",
    "brokerName": "SAPERSTON ASSET MANAGEMENT INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "SARG",
    "clearingBroker": "0226",
    "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
  },
  {
    "type": "MUNI",
    "mpid": "SAYB",
    "clearingBroker": "0103",
    "brokerName": "SAYBROOK CAPITAL CORPORATION                                          "
  },
  {
    "type": "MUNI",
    "mpid": "SBAM",
    "clearingBroker": "0443",
    "brokerName": "INVESTMENT PROFESSIONALS, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "SBER",
    "clearingBroker": "0013",
    "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "SBLS",
    "clearingBroker": "0235",
    "brokerName": "SAN BLAS SECURITIES LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "SBLT",
    "clearingBroker": "0226",
    "brokerName": "SUNBELT SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "SBRO",
    "clearingBroker": "0443",
    "brokerName": "STERN BROTHERS & CO.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "SBRT",
    "clearingBroker": "0226",
    "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "SBRX",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "SBSC",
    "clearingBroker": "0226",
    "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "SBSL",
    "clearingBroker": "1043",
    "brokerName": "STOCKBLOCK SECURITIES LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "SCAP",
    "clearingBroker": "0595",
    "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "SCFL",
    "clearingBroker": "0443",
    "brokerName": "STANCHART SECURITES INTL, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "SCHM",
    "clearingBroker": "0443",
    "brokerName": "A. R. SCHMEIDLER & CO., INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "SCIL",
    "clearingBroker": "0052",
    "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
  },
  {
    "type": "MUNI",
    "mpid": "SCMC",
    "clearingBroker": "0096",
    "brokerName": "SCOTIA CAPITAL MARKETS (USA) INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "SCSI",
    "clearingBroker": "0370",
    "brokerName": "STANDARD CREDIT SECURITIES INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "SCSS",
    "clearingBroker": "0161",
    "brokerName": "STONECASTLE SECURITIES, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "SCTI",
    "clearingBroker": "0443",
    "brokerName": "SECURITY CAPITAL BROKERAGE, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "SDIC",
    "clearingBroker": "0235",
    "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "SEAP",
    "clearingBroker": "0226",
    "brokerName": "SEAPORT SECURITIES CORP.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "SEBR",
    "clearingBroker": "0158",
    "brokerName": "SENTINEL BROKERS COMPANY, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "SECS",
    "clearingBroker": "0161",
    "brokerName": "SECOND STREET SECURITIES, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "SEEL",
    "clearingBroker": "0443",
    "brokerName": "R. SEELAUS & CO., INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "SEFB",
    "clearingBroker": "0052",
    "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "SEGE",
    "clearingBroker": "0443",
    "brokerName": "SEGERDAHL & CO.                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "SEIB",
    "clearingBroker": "0158",
    "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "SEMT",
    "clearingBroker": "7311",
    "brokerName": "MINT BROKERS                                                          "
  },
  {
    "type": "MUNI",
    "mpid": "SEPN",
    "clearingBroker": "0161",
    "brokerName": "SEAPINE SECURITIES LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "SERL",
    "clearingBroker": "0443",
    "brokerName": "SEARLE & CO.                                                          "
  },
  {
    "type": "MUNI",
    "mpid": "SESL",
    "clearingBroker": "0158",
    "brokerName": "SESLIA SECURITIES                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "SFCO",
    "clearingBroker": "0443",
    "brokerName": "SYMETRA INVESTMENT SERVICES, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "SFGB",
    "clearingBroker": "0161",
    "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
  },
  {
    "type": "MUNI",
    "mpid": "SFPS",
    "clearingBroker": "0443",
    "brokerName": "SF INVESTMENTS, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "SFSI",
    "clearingBroker": "0235",
    "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "SGAS",
    "clearingBroker": "0286",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "SGBI",
    "clearingBroker": "0226",
    "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "SGFC",
    "clearingBroker": "0226",
    "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
  },
  {
    "type": "MUNI",
    "mpid": "SGLC",
    "clearingBroker": "0235",
    "brokerName": "S.G. LONG & COMPANY                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "SGNL",
    "clearingBroker": "0279",
    "brokerName": "SIGNAL SECURITIES, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "SGOV",
    "clearingBroker": "0286",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "SGSM",
    "clearingBroker": "1043",
    "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "SHOT",
    "clearingBroker": "0005",
    "brokerName": "SCHOTTENFELD GROUP LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "SHRR",
    "clearingBroker": "0443",
    "brokerName": "CARL P. SHERR AND CO., LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "SIBI",
    "clearingBroker": "0573",
    "brokerName": "SUNGARD INSITUTIONAL BROKERAGE, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "SILK",
    "clearingBroker": "0161",
    "brokerName": "GOLDMAN SACHS EXECUTION & CLEARING, L.P.                              "
  },
  {
    "type": "MUNI",
    "mpid": "SIMC",
    "clearingBroker": "0443",
    "brokerName": "SECURITIES INDUSTRY MANAGEMENT CORP.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "SKFS",
    "clearingBroker": "0443",
    "brokerName": "HEFREN-TILLOTSON/SHELBY, KERN, FREDERICK AND SHELB                    "
  },
  {
    "type": "MUNI",
    "mpid": "SKTR",
    "clearingBroker": "0279",
    "brokerName": "STOCK TRADERS                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "SLRD",
    "clearingBroker": "0226",
    "brokerName": "S.L. REED & COMPANY                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "SMCO",
    "clearingBroker": "0235",
    "brokerName": "SMITH, MOORE & CO.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "SMHI",
    "clearingBroker": "0443",
    "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "SMHJ",
    "clearingBroker": "0141",
    "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "SMNS",
    "clearingBroker": "0226",
    "brokerName": "PARKLAND SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "SMPR",
    "clearingBroker": "0443",
    "brokerName": "SUMMIT BROKERAGE SERVICES, INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "SMRD",
    "clearingBroker": "0443",
    "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "SMRI",
    "clearingBroker": "0226",
    "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
  },
  {
    "type": "MUNI",
    "mpid": "SNEX",
    "clearingBroker": "0750",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "SNTE",
    "clearingBroker": "0279",
    "brokerName": "SENATE SECURITIES                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "SNWS",
    "clearingBroker": "0443",
    "brokerName": "SNOWDEN ACCOUNT SERVICES, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "SOCO",
    "clearingBroker": "0443",
    "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "SORS",
    "clearingBroker": "0235",
    "brokerName": "SORSBY FINANCIAL CORP.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "SOVG",
    "clearingBroker": "8199",
    "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "SPAC",
    "clearingBroker": "0793",
    "brokerName": "SIERRA PACIFIC SECURITIES, LLC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "SPCS",
    "clearingBroker": "0052",
    "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "SPEN",
    "clearingBroker": "0443",
    "brokerName": "SPENCER CLARKE LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "SPEX",
    "clearingBroker": "0235",
    "brokerName": "INSPEREX LLC                                                          "
  },
  {
    "type": "MUNI",
    "mpid": "SPGS",
    "clearingBroker": "0443",
    "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "SPHN",
    "clearingBroker": "0443",
    "brokerName": "STEPHENS INC.                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "SPLC",
    "clearingBroker": "0226",
    "brokerName": "SPIRE SECURITIES, LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "SPLN",
    "clearingBroker": "8199",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "SPOT",
    "clearingBroker": "0005",
    "brokerName": "SPOT TRADING                                                          "
  },
  {
    "type": "MUNI",
    "mpid": "SPSR",
    "clearingBroker": "0279",
    "brokerName": "STARK MUNICIPAL BROKERS                                               "
  },
  {
    "type": "MUNI",
    "mpid": "SPTD",
    "clearingBroker": "0052",
    "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "SPTS",
    "clearingBroker": "0158",
    "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "SPWM",
    "clearingBroker": "0443",
    "brokerName": "STILLPOINT WEALTH MANAGEMENT, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "SRAM",
    "clearingBroker": "0443",
    "brokerName": "SAMCO CAPITAL MARKETS, INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "SRBC",
    "clearingBroker": "0235",
    "brokerName": "SPIDERROCK EXS, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "SSBS",
    "clearingBroker": "0189",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "SSCO",
    "clearingBroker": "8457",
    "brokerName": "SAFRA SECURITIES LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "SSET",
    "clearingBroker": "0226",
    "brokerName": "SUNSET FINANCIAL SERVICES, INC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "SSGC",
    "clearingBroker": "0226",
    "brokerName": "SIGNATURE SECURITIES                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "SSGI",
    "clearingBroker": "0443",
    "brokerName": "SETON SECURITIES GROUP, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "SSGM",
    "clearingBroker": "0226",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "SSGR",
    "clearingBroker": "0443",
    "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "SSIN",
    "clearingBroker": "0226",
    "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "SSLC",
    "clearingBroker": "0279",
    "brokerName": "SANDERLIN SECURITIES, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "SSLL",
    "clearingBroker": "0189",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "SSNE",
    "clearingBroker": "0226",
    "brokerName": "SANTANDER SECURITIES LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "SSNG",
    "clearingBroker": "0443",
    "brokerName": "SISUNG SECURITIES CORPORATION                                         "
  },
  {
    "type": "MUNI",
    "mpid": "STAD",
    "clearingBroker": "0141",
    "brokerName": "STEELE ADVISORS, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "STCM",
    "clearingBroker": "2095",
    "brokerName": "TRUIST SECURITIES, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "STEP",
    "clearingBroker": "0235",
    "brokerName": "FERRETTI GROUP, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "STFL",
    "clearingBroker": "0793",
    "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
  },
  {
    "type": "MUNI",
    "mpid": "STGC",
    "clearingBroker": "0279",
    "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
  },
  {
    "type": "MUNI",
    "mpid": "STHR",
    "clearingBroker": "0388",
    "brokerName": "STORMHARBOUR SECURITIES LP                                            "
  },
  {
    "type": "MUNI",
    "mpid": "STND",
    "clearingBroker": "0279",
    "brokerName": "FIRST STANDARD FINANCIAL COMPANY LLC                                  "
  },
  {
    "type": "MUNI",
    "mpid": "STOX",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "STRM",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "STRS",
    "clearingBroker": "0161",
    "brokerName": "STRATEGAS RESEARCH PARTNERS, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "STRT",
    "clearingBroker": "0352",
    "brokerName": "OCTAVUS, LLC                                                          "
  },
  {
    "type": "MUNI",
    "mpid": "STSI",
    "clearingBroker": "0235",
    "brokerName": "SPENCER TRASK VENTURES, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "STTR",
    "clearingBroker": "0443",
    "brokerName": "STATE TRUST INVESTMENTS INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "STTT",
    "clearingBroker": "0052",
    "brokerName": "STATETRUST INVESTMENTS INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "STUR",
    "clearingBroker": "0158",
    "brokerName": "STURDIVANT & CO., INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "STXW",
    "clearingBroker": "0443",
    "brokerName": "SA STONE WEALTH MANAGEMENT INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "STYO",
    "clearingBroker": "0443",
    "brokerName": "STONE & YOUNGBERG L.L.C.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "SUFI",
    "clearingBroker": "0551",
    "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "SUSQ",
    "clearingBroker": "0551",
    "brokerName": "SUSQUEHANNA CAPITAL GROUP                                             "
  },
  {
    "type": "MUNI",
    "mpid": "SUST",
    "clearingBroker": "0235",
    "brokerName": "SUNSTREET SECURITIES, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "SWBC",
    "clearingBroker": "0443",
    "brokerName": "SWBC INVESTMENT SERVICES, LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "SWSS",
    "clearingBroker": "0443",
    "brokerName": "SANCTUARY SECURITIES, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "SWST",
    "clearingBroker": "0279",
    "brokerName": "HILLTOP SECURITIES INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "SWTX",
    "clearingBroker": "0443",
    "brokerName": "SWBT SECURITIES, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "SYCA",
    "clearingBroker": "0443",
    "brokerName": "SYNDICATED CAPITAL, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "SZZI",
    "clearingBroker": "0141",
    "brokerName": "STOFAN, AGAZZI & COMPANY INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "TAFI",
    "clearingBroker": "0443",
    "brokerName": "NATHAN HALE CAPITAL, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "TAGB",
    "clearingBroker": "0052",
    "brokerName": "TAGLICH BROTHERS, INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "TAGC",
    "clearingBroker": "1043",
    "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "TAGD",
    "clearingBroker": "1043",
    "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "TASE",
    "clearingBroker": "0443",
    "brokerName": "TRADITION ASIEL SECURITIES INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "TBCL",
    "clearingBroker": "0750",
    "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "TBCR",
    "clearingBroker": "0235",
    "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "TBIA",
    "clearingBroker": "0158",
    "brokerName": "TRADIER BROKERAGE, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "TBRD",
    "clearingBroker": "0226",
    "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
  },
  {
    "type": "MUNI",
    "mpid": "TCBI",
    "clearingBroker": "0443",
    "brokerName": "TCBI SECURITIES, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "TCMU",
    "clearingBroker": "0443",
    "brokerName": "TCM CAPITAL, INC.                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "TCPX",
    "clearingBroker": "0443",
    "brokerName": "TOUSSAINT CAPITAL PARTNERS, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "TDCO",
    "clearingBroker": "0235",
    "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "TDNF",
    "clearingBroker": "2568",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "TDPA",
    "clearingBroker": "0226",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "TDSI",
    "clearingBroker": "2568",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "TFAI",
    "clearingBroker": "0226",
    "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
  },
  {
    "type": "MUNI",
    "mpid": "TFAS",
    "clearingBroker": "0443",
    "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
  },
  {
    "type": "MUNI",
    "mpid": "TFSL",
    "clearingBroker": "0235",
    "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
  },
  {
    "type": "MUNI",
    "mpid": "TFSS",
    "clearingBroker": "0443",
    "brokerName": "TFS SECURITIES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "TGHS",
    "clearingBroker": "0443",
    "brokerName": "TGH SECURITIES, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "THEM",
    "clearingBroker": "0235",
    "brokerName": "THEMIS TRADING LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "THIM",
    "clearingBroker": "0443",
    "brokerName": "LONGVIEW FINANCIAL GROUP INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "TIAN",
    "clearingBroker": "0226",
    "brokerName": "TRIAD SECURITIES CORP                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "TIBD",
    "clearingBroker": "6412",
    "brokerName": "TIB THE INDEPENDENT BANKERS BANK                                      "
  },
  {
    "type": "MUNI",
    "mpid": "TIBS",
    "clearingBroker": "0443",
    "brokerName": "TELEMUS INVESTMENT BROKERS, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "TIGC",
    "clearingBroker": "0235",
    "brokerName": "NELSONREID, INC.                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "TIGE",
    "clearingBroker": "1043",
    "brokerName": "US TIGER SECURITIES, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "TLDX",
    "clearingBroker": "0226",
    "brokerName": "TULLETT LIBERTY SECURITIES, INC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "TMAS",
    "clearingBroker": "0235",
    "brokerName": "TRADEMAS INC.                                                         "
  },
  {
    "type": "MUNI",
    "mpid": "TMBI",
    "clearingBroker": "0141",
    "brokerName": "THURSTON SPRINGER FINANCIAL                                           "
  },
  {
    "type": "MUNI",
    "mpid": "TMBR",
    "clearingBroker": "0534",
    "brokerName": "IBKR SECURITIES SERVICES LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "TMBS",
    "clearingBroker": "0443",
    "brokerName": "TRADITION ASIEL SECURITIES INC.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "TMCC",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "MUNI",
    "mpid": "TMCD",
    "clearingBroker": "0235",
    "brokerName": "MCDONALD PARTNERS LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "TOCQ",
    "clearingBroker": "0443",
    "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "TONE",
    "clearingBroker": "8199",
    "brokerName": "2021 CAPITAL                                                          "
  },
  {
    "type": "MUNI",
    "mpid": "TONG",
    "clearingBroker": "0443",
    "brokerName": "TONGE (R.M.) & COMPANY                                                "
  },
  {
    "type": "MUNI",
    "mpid": "TORO",
    "clearingBroker": "0279",
    "brokerName": "VALDES & MORENO, INC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "TOUR",
    "clearingBroker": "0005",
    "brokerName": "TOURMALINE PARTNERS, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "TOVC",
    "clearingBroker": "0235",
    "brokerName": "TOV CAPITAL MARKETS, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "TPIS",
    "clearingBroker": "0161",
    "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
  },
  {
    "type": "MUNI",
    "mpid": "TPMG",
    "clearingBroker": "0005",
    "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "TPMR",
    "clearingBroker": "0141",
    "brokerName": "TRADE-PMR INC.                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "TRAD",
    "clearingBroker": "0271",
    "brokerName": "TRADESTATION SECURITIES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "TRCG",
    "clearingBroker": "0005",
    "brokerName": "TRC MARKETS LLC                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "TREX",
    "clearingBroker": "1043",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "MUNI",
    "mpid": "TRIB",
    "clearingBroker": "0235",
    "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "TRIM",
    "clearingBroker": "0161",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "TRIN",
    "clearingBroker": "0141",
    "brokerName": "TRIANGLE SECURITIES, LLC                                              "
  },
  {
    "type": "MUNI",
    "mpid": "TRIP",
    "clearingBroker": "0235",
    "brokerName": "TRIDENT PARTNERS LTD                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "TRSH",
    "clearingBroker": "0279",
    "brokerName": "THRASHER & CHAMBERS, INC.                                             "
  },
  {
    "type": "MUNI",
    "mpid": "TRSQ",
    "clearingBroker": "0443",
    "brokerName": "TOWER SQUARE SECURITIES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "TRUB",
    "clearingBroker": "0141",
    "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "TRWN",
    "clearingBroker": "0443",
    "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "TRYN",
    "clearingBroker": "0279",
    "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "TSCD",
    "clearingBroker": "0235",
    "brokerName": "STURGES COMPANY (THE)                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "TSER",
    "clearingBroker": "0161",
    "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "TSFA",
    "clearingBroker": "0443",
    "brokerName": "STRATEGIC FINANCIAL ALLIANCE (THE)                                    "
  },
  {
    "type": "MUNI",
    "mpid": "TSSM",
    "clearingBroker": "0161",
    "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
  },
  {
    "type": "MUNI",
    "mpid": "TTSC",
    "clearingBroker": "0052",
    "brokerName": "TREND TRADE SECURITIES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "TTSI",
    "clearingBroker": "0158",
    "brokerName": "T3 SECURITIES, INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "TWDI",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "TWDL",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "TWDP",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "TWDR",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "TWDS",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "TWPL",
    "clearingBroker": "0793",
    "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
  },
  {
    "type": "MUNI",
    "mpid": "UBII",
    "clearingBroker": "0221",
    "brokerName": "UBS INTERNATIONAL, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "UBKR",
    "clearingBroker": "6732",
    "brokerName": "UNITED BANKERS' BANK                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "UBSI",
    "clearingBroker": "0141",
    "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
  },
  {
    "type": "MUNI",
    "mpid": "UBSW",
    "clearingBroker": "0642",
    "brokerName": "UBS SECURITIES LLC                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "UMBF",
    "clearingBroker": "0226",
    "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "UMBI",
    "clearingBroker": "2451",
    "brokerName": "UMB BANK, NATIONAL ASSOCIATION                                        "
  },
  {
    "type": "MUNI",
    "mpid": "UNIB",
    "clearingBroker": "0443",
    "brokerName": "UNIBANCO SECURITIES INC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "UNIV",
    "clearingBroker": "0595",
    "brokerName": "UNIVEST SECURITIES, LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "UPLN",
    "clearingBroker": "0443",
    "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
  },
  {
    "type": "MUNI",
    "mpid": "USCA",
    "clearingBroker": "0226",
    "brokerName": "USCA SECURITIES LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "USDB",
    "clearingBroker": "0279",
    "brokerName": "U.S. BROKERAGE, INC.                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "USFB",
    "clearingBroker": "0595",
    "brokerName": "U.S. FINANCIAL INVESTMENTS, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "USIC",
    "clearingBroker": "0226",
    "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "USSI",
    "clearingBroker": "0279",
    "brokerName": "U.S. STERLING SECURITIES, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "USTZ",
    "clearingBroker": "0595",
    "brokerName": "TRADEZERO AMERINCA, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "UVST",
    "clearingBroker": "0443",
    "brokerName": "UVEST FINANCIAL SERVICES GROUP, INC.                                  "
  },
  {
    "type": "MUNI",
    "mpid": "VABD",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "MUNI",
    "mpid": "VALI",
    "clearingBroker": "0226",
    "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "VBCS",
    "clearingBroker": "0279",
    "brokerName": "VBC SECURITIES                                                        "
  },
  {
    "type": "MUNI",
    "mpid": "VBLT",
    "clearingBroker": "0226",
    "brokerName": "VANDERBILT SECURITIES, LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "VCAS",
    "clearingBroker": "0443",
    "brokerName": "VCA SECURITIES, LP                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "VCFN",
    "clearingBroker": "0235",
    "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
  },
  {
    "type": "MUNI",
    "mpid": "VCMM",
    "clearingBroker": "0279",
    "brokerName": "VIRTUS CAPITAL MARKETS LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "VCMS",
    "clearingBroker": "0443",
    "brokerName": "VCM SECURITIES, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "VCSV",
    "clearingBroker": "0052",
    "brokerName": "PRIMARY CAPITAL, LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "VERF",
    "clearingBroker": "0235",
    "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "VERT",
    "clearingBroker": "8199",
    "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
  },
  {
    "type": "MUNI",
    "mpid": "VEST",
    "clearingBroker": "0750",
    "brokerName": "VESTECH SECURITIES, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "VETS",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "VGRD",
    "clearingBroker": "0062",
    "brokerName": "VANGUARD MARKETING CORPORATION                                        "
  },
  {
    "type": "MUNI",
    "mpid": "VISI",
    "clearingBroker": "0443",
    "brokerName": "VISION INVESTMENT SERVICES, INC.                                      "
  },
  {
    "type": "MUNI",
    "mpid": "VKMI",
    "clearingBroker": "0692",
    "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "VLYF",
    "clearingBroker": "0443",
    "brokerName": "VALLEY FORGE ASSET MANAGEMENT                                         "
  },
  {
    "type": "MUNI",
    "mpid": "VMEX",
    "clearingBroker": "0443",
    "brokerName": "VECTORGLOBAL WMG                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "VOLS",
    "clearingBroker": "2447",
    "brokerName": "HOME FINANCIAL SERVICES INC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "VPEW",
    "clearingBroker": "0158",
    "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
  },
  {
    "type": "MUNI",
    "mpid": "VSIN",
    "clearingBroker": "0595",
    "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "VSLP",
    "clearingBroker": "6043",
    "brokerName": "VINING-SPARKS IBG, L.P.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "VTDT",
    "clearingBroker": "0158",
    "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "VTRN",
    "clearingBroker": "0443",
    "brokerName": "BANCROFT CAPITAL, LLC                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "WABR",
    "clearingBroker": "0443",
    "brokerName": "WALL STREET ACCESS                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "WACC",
    "clearingBroker": "0279",
    "brokerName": "MIDLAND SECURITIES, LTD                                               "
  },
  {
    "type": "MUNI",
    "mpid": "WACL",
    "clearingBroker": "0709",
    "brokerName": "WACHTEL & CO., INC.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "WARF",
    "clearingBroker": "0235",
    "brokerName": "WARD'S FINANCIAL SERVICES, LTD.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "WBAX",
    "clearingBroker": "0052",
    "brokerName": "WALLACHBETH CAPITAL LLC                                               "
  },
  {
    "type": "MUNI",
    "mpid": "WBBC",
    "clearingBroker": "0226",
    "brokerName": "WBB SECURITIES, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "WBFS",
    "clearingBroker": "0443",
    "brokerName": "WOODBURY FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "WBLR",
    "clearingBroker": "0771",
    "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
  },
  {
    "type": "MUNI",
    "mpid": "WBNA",
    "clearingBroker": "2072",
    "brokerName": "WELLS FARGO BANK, N.A./SIG                                            "
  },
  {
    "type": "MUNI",
    "mpid": "WBNF",
    "clearingBroker": "0226",
    "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "WBRO",
    "clearingBroker": "0443",
    "brokerName": "WILEY BROS.-AINTREE CAPITAL, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "WCHV",
    "clearingBroker": "0250",
    "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "WCIG",
    "clearingBroker": "0750",
    "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "WCIS",
    "clearingBroker": "0443",
    "brokerName": "WESCORP INVESTMENT SERVICES, LLC                                      "
  },
  {
    "type": "MUNI",
    "mpid": "WCSC",
    "clearingBroker": "0235",
    "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
  },
  {
    "type": "MUNI",
    "mpid": "WCSF",
    "clearingBroker": "0235",
    "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "WEBS",
    "clearingBroker": "0226",
    "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
  },
  {
    "type": "MUNI",
    "mpid": "WEDB",
    "clearingBroker": "0103",
    "brokerName": "WEDBUSH SECURITIES INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "WEGE",
    "clearingBroker": "0443",
    "brokerName": "WORLD EQUITY GROUP, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "WEGI",
    "clearingBroker": "0235",
    "brokerName": "WORLD EQUITY GROUP INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "WEGP",
    "clearingBroker": "0235",
    "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "WEIL",
    "clearingBroker": "0226",
    "brokerName": "THE WEIL COMPANY, INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "WELD",
    "clearingBroker": "0443",
    "brokerName": "WHITE, WELD & CO. SECURITIES, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "WESC",
    "clearingBroker": "0443",
    "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
  },
  {
    "type": "MUNI",
    "mpid": "WEXR",
    "clearingBroker": "0235",
    "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "MUNI",
    "mpid": "WEXX",
    "clearingBroker": "0005",
    "brokerName": "WOLVERINE EXECUTION SERVICES                                          "
  },
  {
    "type": "MUNI",
    "mpid": "WFPB",
    "clearingBroker": "0250",
    "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "WGWD",
    "clearingBroker": "0158",
    "brokerName": "WEDGEWOOD PARTNERS, INC.                                              "
  },
  {
    "type": "MUNI",
    "mpid": "WHAE",
    "clearingBroker": "0158",
    "brokerName": "WHARTON EQUITY CORPORATION                                            "
  },
  {
    "type": "MUNI",
    "mpid": "WHBB",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "WHOT",
    "clearingBroker": "0595",
    "brokerName": "JUST2TRADE, INC.                                                      "
  },
  {
    "type": "MUNI",
    "mpid": "WIDS",
    "clearingBroker": "0279",
    "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
  },
  {
    "type": "MUNI",
    "mpid": "WING",
    "clearingBroker": "0443",
    "brokerName": "ING FINANCIAL PARTNERS, INC.                                          "
  },
  {
    "type": "MUNI",
    "mpid": "WISC",
    "clearingBroker": "0226",
    "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "WISE",
    "clearingBroker": "0052",
    "brokerName": "AXOS INVEST LLC                                                       "
  },
  {
    "type": "MUNI",
    "mpid": "WISP",
    "clearingBroker": "0443",
    "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
  },
  {
    "type": "MUNI",
    "mpid": "WLTH",
    "clearingBroker": "0235",
    "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
  },
  {
    "type": "MUNI",
    "mpid": "WMCL",
    "clearingBroker": "0279",
    "brokerName": "WHITE MOUNTAIN CAPITAL, LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "WMFS",
    "clearingBroker": "0226",
    "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
  },
  {
    "type": "MUNI",
    "mpid": "WMLL",
    "clearingBroker": "0005",
    "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
  },
  {
    "type": "MUNI",
    "mpid": "WNUT",
    "clearingBroker": "0443",
    "brokerName": "WALNUT STREET SECURITIES, INC.                                        "
  },
  {
    "type": "MUNI",
    "mpid": "WOHU",
    "clearingBroker": "0537",
    "brokerName": "BGC FINANCIAL, L.P.                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "WPCC",
    "clearingBroker": "0052",
    "brokerName": "WESTPARK CAPITAL, INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "WPCI",
    "clearingBroker": "0595",
    "brokerName": "WESTPARK CAPITAL, INC.                                                "
  },
  {
    "type": "MUNI",
    "mpid": "WPSG",
    "clearingBroker": "0005",
    "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
  },
  {
    "type": "MUNI",
    "mpid": "WPST",
    "clearingBroker": "0443",
    "brokerName": "W.P. STEWART SECURITIES LIMITED                                       "
  },
  {
    "type": "MUNI",
    "mpid": "WPSX",
    "clearingBroker": "0445",
    "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
  },
  {
    "type": "MUNI",
    "mpid": "WRET",
    "clearingBroker": "0141",
    "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
  },
  {
    "type": "MUNI",
    "mpid": "WRIS",
    "clearingBroker": "0141",
    "brokerName": "SMH CAPITAL INVESTMENTS LLC                                           "
  },
  {
    "type": "MUNI",
    "mpid": "WRLD",
    "clearingBroker": "0235",
    "brokerName": "HUNTER WORLD MARKETS, INC.                                            "
  },
  {
    "type": "MUNI",
    "mpid": "WSCC",
    "clearingBroker": "0235",
    "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
  },
  {
    "type": "MUNI",
    "mpid": "WSCX",
    "clearingBroker": "0235",
    "brokerName": "WORKMAN SECURITIES CORP                                               "
  },
  {
    "type": "MUNI",
    "mpid": "WSEC",
    "clearingBroker": "0443",
    "brokerName": "WILLIS SECURITIES, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "WSGD",
    "clearingBroker": "8199",
    "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
  },
  {
    "type": "MUNI",
    "mpid": "WSIW",
    "clearingBroker": "8199",
    "brokerName": "WEDBUSH SECURITIES INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "WSMC",
    "clearingBroker": "0443",
    "brokerName": "WALL STREET MANAGEMENT CORPORATION                                    "
  },
  {
    "type": "MUNI",
    "mpid": "WSRP",
    "clearingBroker": "0052",
    "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
  },
  {
    "type": "MUNI",
    "mpid": "WSTI",
    "clearingBroker": "0226",
    "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
  },
  {
    "type": "MUNI",
    "mpid": "WSWW",
    "clearingBroker": "0443",
    "brokerName": "WESTMINSTER SECURITIES CORPORATION                                    "
  },
  {
    "type": "MUNI",
    "mpid": "WTCO",
    "clearingBroker": "0050",
    "brokerName": "WILLIAMS TRADING LLC                                                  "
  },
  {
    "type": "MUNI",
    "mpid": "WTFS",
    "clearingBroker": "0052",
    "brokerName": "LIME TRADING CORP                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "WTLP",
    "clearingBroker": "0388",
    "brokerName": "WOLVERINE TRADING, LLC                                                "
  },
  {
    "type": "MUNI",
    "mpid": "WTRI",
    "clearingBroker": "0235",
    "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
  },
  {
    "type": "MUNI",
    "mpid": "WUND",
    "clearingBroker": "0141",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "MUNI",
    "mpid": "WVBD",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "WVEX",
    "clearingBroker": "0161",
    "brokerName": "MERRILL LYNCH PIERCE FENNER & SMITH INCORPOTATED                      "
  },
  {
    "type": "MUNI",
    "mpid": "XCNC",
    "clearingBroker": "0005",
    "brokerName": "C&C TRADING L.L.C.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "XRVR",
    "clearingBroker": "0279",
    "brokerName": "CRB SECURITIES, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "XTXE",
    "clearingBroker": "0161",
    "brokerName": "XTX EXECUTION SERVICES LLC                                            "
  },
  {
    "type": "MUNI",
    "mpid": "YLPL",
    "clearingBroker": "0075",
    "brokerName": "LPL FINANCIAL LLC                                                     "
  },
  {
    "type": "MUNI",
    "mpid": "YOSE",
    "clearingBroker": "0052",
    "brokerName": "YORK SECURITIES, INC.                                                 "
  },
  {
    "type": "MUNI",
    "mpid": "ZEDB",
    "clearingBroker": "0161",
    "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "MUNI",
    "mpid": "ZERO",
    "clearingBroker": "0158",
    "brokerName": "TRADEZERO AMERICA, INC.                                               "
  },
  {
    "type": "MUNI",
    "mpid": "ZEUS",
    "clearingBroker": "0443",
    "brokerName": "ZEUS FINANCIAL, LLC                                                   "
  },
  {
    "type": "MUNI",
    "mpid": "ZFNB",
    "clearingBroker": "2104",
    "brokerName": "ZB, NATIONAL ASSOCIATION                                              "
  },
  {
    "type": "MUNI",
    "mpid": "ZION",
    "clearingBroker": "0065",
    "brokerName": "ZIONS DIRECT, INC.                                                    "
  },
  {
    "type": "MUNI",
    "mpid": "ZIVI",
    "clearingBroker": "0235",
    "brokerName": "ZIV INVESTMENT COMPANY                                                "
  },
  {
    "type": "MUNI",
    "mpid": "ZOUL",
    "clearingBroker": "0235",
    "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "AALC",
    "clearingBroker": "0226",
    "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "ABAI",
    "clearingBroker": "0279",
    "brokerName": "ABACUS INVESTMENTS, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "ABBA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "ABBK",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "ABDA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "ABDW",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "ABEA",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "ABEN",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "ABHE",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "ABIG",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "ABPR",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "ABRP",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "ABST",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "ACAP",
    "clearingBroker": "0235",
    "brokerName": "ALAMO CAPITAL                                                         "
  },
  {
    "type": "UIT",
    "mpid": "ACCP",
    "clearingBroker": "0158",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "ACCU",
    "clearingBroker": "0052",
    "brokerName": "ATB CAPITAL MARKETS USA INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "ACII",
    "clearingBroker": "0158",
    "brokerName": "ARCA CAPITAL INVESTMENTS, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "ACLP",
    "clearingBroker": "0235",
    "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
  },
  {
    "type": "UIT",
    "mpid": "ACPL",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN CAPITAL PARTNERS                                             "
  },
  {
    "type": "UIT",
    "mpid": "ACPS",
    "clearingBroker": "0443",
    "brokerName": "ACP SECURITIES LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "ACRN",
    "clearingBroker": "0235",
    "brokerName": "ACORNS SECURITIES, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "ACTI",
    "clearingBroker": "0443",
    "brokerName": "ACTIVNER SECURITIES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "ADSO",
    "clearingBroker": "0141",
    "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "AEFS",
    "clearingBroker": "0226",
    "brokerName": "AE FINANCIAL SERVICES, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "AEXG",
    "clearingBroker": "0158",
    "brokerName": "ALTERNATIVE EXECUTION GROUP                                           "
  },
  {
    "type": "UIT",
    "mpid": "AFBS",
    "clearingBroker": "0158",
    "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
  },
  {
    "type": "UIT",
    "mpid": "AFSL",
    "clearingBroker": "0443",
    "brokerName": "SORRENTO PACIFIC FINANCIAL                                            "
  },
  {
    "type": "UIT",
    "mpid": "AFSS",
    "clearingBroker": "0750",
    "brokerName": "FOUR POINTS CAPITAL PARTNERS LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "AGCO",
    "clearingBroker": "0052",
    "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "AGCP",
    "clearingBroker": "0052",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "AGES",
    "clearingBroker": "0750",
    "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
  },
  {
    "type": "UIT",
    "mpid": "AGIS",
    "clearingBroker": "0235",
    "brokerName": "AEGIS CAPITAL CORP.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "AGSS",
    "clearingBroker": "0443",
    "brokerName": "GREAT AMERICAN ADVISORS, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "AHSI",
    "clearingBroker": "0141",
    "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
  },
  {
    "type": "UIT",
    "mpid": "AIGF",
    "clearingBroker": "0443",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "AIGN",
    "clearingBroker": "0226",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "AISG",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
  },
  {
    "type": "UIT",
    "mpid": "AJCO",
    "clearingBroker": "0443",
    "brokerName": "IDB CAPITAL CORP.                                                     "
  },
  {
    "type": "UIT",
    "mpid": "ALCG",
    "clearingBroker": "0235",
    "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "ALCM",
    "clearingBroker": "0279",
    "brokerName": "ALPHALEDGER MARKETS, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "ALDN",
    "clearingBroker": "0052",
    "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "ALGP",
    "clearingBroker": "0235",
    "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
  },
  {
    "type": "UIT",
    "mpid": "ALGR",
    "clearingBroker": "0158",
    "brokerName": "ALGER (FRED) & CO INC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "ALIS",
    "clearingBroker": "0235",
    "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
  },
  {
    "type": "UIT",
    "mpid": "ALLN",
    "clearingBroker": "0443",
    "brokerName": "ALLEN & COMPANY LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "ALNC",
    "clearingBroker": "0226",
    "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
  },
  {
    "type": "UIT",
    "mpid": "ALTR",
    "clearingBroker": "3164",
    "brokerName": "ALTRUIST FINANCIAL LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "AMBB",
    "clearingBroker": "0141",
    "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
  },
  {
    "type": "UIT",
    "mpid": "AMER",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
  },
  {
    "type": "UIT",
    "mpid": "AMIC",
    "clearingBroker": "0226",
    "brokerName": "AMERICAN INVESTORS COMPANY                                            "
  },
  {
    "type": "UIT",
    "mpid": "AMLU",
    "clearingBroker": "3652",
    "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "AMMS",
    "clearingBroker": "0141",
    "brokerName": "AMUNI FINANCIAL, INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "AMRG",
    "clearingBroker": "0443",
    "brokerName": "WORLD CAPITAL BROKERAGE, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "ANDB",
    "clearingBroker": "0443",
    "brokerName": "ANDBANC BROKERAGE, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "ANDG",
    "clearingBroker": "0235",
    "brokerName": "GARRETT (ANDREW), INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "ANOS",
    "clearingBroker": "0235",
    "brokerName": "ABEL NOSER, LLC.                                                      "
  },
  {
    "type": "UIT",
    "mpid": "ANOV",
    "clearingBroker": "0750",
    "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "AOCS",
    "clearingBroker": "0388",
    "brokerName": "AOC SECURITIES                                                        "
  },
  {
    "type": "UIT",
    "mpid": "AONC",
    "clearingBroker": "0443",
    "brokerName": "AON BENFIELD SECURITIES                                               "
  },
  {
    "type": "UIT",
    "mpid": "AORP",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "AOSD",
    "clearingBroker": "0158",
    "brokerName": "TRADING BLOCK                                                         "
  },
  {
    "type": "UIT",
    "mpid": "APBD",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "APBO",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "APFS",
    "clearingBroker": "0443",
    "brokerName": "AMERICA'S PORTFOLIO'S                                                 "
  },
  {
    "type": "UIT",
    "mpid": "APRT",
    "clearingBroker": "0226",
    "brokerName": "PARTNERS                                                              "
  },
  {
    "type": "UIT",
    "mpid": "APXO",
    "clearingBroker": "0158",
    "brokerName": "APEX CLEARING CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "APXS",
    "clearingBroker": "0052",
    "brokerName": "APEXUS CAPITAL LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "ARBC",
    "clearingBroker": "0235",
    "brokerName": "ARKADIOS CAPITAL                                                      "
  },
  {
    "type": "UIT",
    "mpid": "ARCD",
    "clearingBroker": "0443",
    "brokerName": "ARCADIA SECURITIES, LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "ARKA",
    "clearingBroker": "0443",
    "brokerName": "ARKA SECURITIES, INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "ARKI",
    "clearingBroker": "0226",
    "brokerName": "ARKADIOS CAPITAL                                                      "
  },
  {
    "type": "UIT",
    "mpid": "ARUS",
    "clearingBroker": "0158",
    "brokerName": "AUTONOMOUS RESEARCH US LP                                             "
  },
  {
    "type": "UIT",
    "mpid": "ARVS",
    "clearingBroker": "0443",
    "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
  },
  {
    "type": "UIT",
    "mpid": "ASCM",
    "clearingBroker": "0052",
    "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "ASCP",
    "clearingBroker": "0443",
    "brokerName": "BOK FINANCIAL SECURITIES                                              "
  },
  {
    "type": "UIT",
    "mpid": "ASII",
    "clearingBroker": "0226",
    "brokerName": "AURORA SECURITIES                                                     "
  },
  {
    "type": "UIT",
    "mpid": "ASOI",
    "clearingBroker": "0226",
    "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "ATIS",
    "clearingBroker": "0052",
    "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
  },
  {
    "type": "UIT",
    "mpid": "ATMC",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "ATRU",
    "clearingBroker": "0158",
    "brokerName": "ATREYU TRADING                                                        "
  },
  {
    "type": "UIT",
    "mpid": "ATVT",
    "clearingBroker": "0443",
    "brokerName": "ATOMIC BROKERAGE LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "AULC",
    "clearingBroker": "0443",
    "brokerName": "ONEAMERICA SECURITIES, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "AVEN",
    "clearingBroker": "0226",
    "brokerName": "AVENTURA SECURITIES, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "AVIL",
    "clearingBroker": "0158",
    "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "AVML",
    "clearingBroker": "0443",
    "brokerName": "AVM, L.P.                                                             "
  },
  {
    "type": "UIT",
    "mpid": "AVST",
    "clearingBroker": "0235",
    "brokerName": "ATOMIC BROKERAGE LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "AXAA",
    "clearingBroker": "0075",
    "brokerName": "AXA ADVISORS LLC                                                      "
  },
  {
    "type": "UIT",
    "mpid": "AXCB",
    "clearingBroker": "0443",
    "brokerName": "ACCESS SECURITIES                                                     "
  },
  {
    "type": "UIT",
    "mpid": "AXCL",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "UIT",
    "mpid": "AXCS",
    "clearingBroker": "0443",
    "brokerName": "ACCESS SECURITIES INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "AXGP",
    "clearingBroker": "0443",
    "brokerName": "ACCESS SECURITIES, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "AXIO",
    "clearingBroker": "0279",
    "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "AXOS",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "UIT",
    "mpid": "AXTN",
    "clearingBroker": "0052",
    "brokerName": "AX TRADING, LLC                                                       "
  },
  {
    "type": "UIT",
    "mpid": "BAKR",
    "clearingBroker": "0443",
    "brokerName": "JAMES BAKER & ASSOCIATES, L.P.                                        "
  },
  {
    "type": "UIT",
    "mpid": "BALE",
    "clearingBroker": "0443",
    "brokerName": "M&T SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "BALS",
    "clearingBroker": "0750",
    "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "BANK",
    "clearingBroker": "0701",
    "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "BARC",
    "clearingBroker": "0388",
    "brokerName": "BARCLAY                                                               "
  },
  {
    "type": "UIT",
    "mpid": "BARD",
    "clearingBroker": "0547",
    "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
  },
  {
    "type": "UIT",
    "mpid": "BARR",
    "clearingBroker": "0226",
    "brokerName": "BARRETT & COMPANY                                                     "
  },
  {
    "type": "UIT",
    "mpid": "BAYP",
    "clearingBroker": "0161",
    "brokerName": "BAY CREST PARTNERS, LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "BBAR",
    "clearingBroker": "0595",
    "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "BBGC",
    "clearingBroker": "0235",
    "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
  },
  {
    "type": "UIT",
    "mpid": "BBNI",
    "clearingBroker": "0443",
    "brokerName": "PERFORMANCE TRUST CAPITAL PARTNERS, INC.                              "
  },
  {
    "type": "UIT",
    "mpid": "BCCS",
    "clearingBroker": "0443",
    "brokerName": "BAC FLORIDA INVESTMENTS CORP.                                         "
  },
  {
    "type": "UIT",
    "mpid": "BCGS",
    "clearingBroker": "0443",
    "brokerName": "BCG SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "BCIB",
    "clearingBroker": "0443",
    "brokerName": "BCI SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "BCSA",
    "clearingBroker": "0443",
    "brokerName": "BCS AMERICAS, INC.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "BCWM",
    "clearingBroker": "4077",
    "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "BCZC",
    "clearingBroker": "0443",
    "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
  },
  {
    "type": "UIT",
    "mpid": "BDBS",
    "clearingBroker": "0443",
    "brokerName": "BANCO DO BRASIL SECURITIES                                            "
  },
  {
    "type": "UIT",
    "mpid": "BDDK",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "BDIR",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "UIT",
    "mpid": "BDTR",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "BEAF",
    "clearingBroker": "0235",
    "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
  },
  {
    "type": "UIT",
    "mpid": "BELS",
    "clearingBroker": "0443",
    "brokerName": "BEL AIR SECURITIES LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "BERN",
    "clearingBroker": "0013",
    "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "BERS",
    "clearingBroker": "0235",
    "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "BEST",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "BFEC",
    "clearingBroker": "0443",
    "brokerName": "BENJAMIN F. EDWARDS & COMPANY                                         "
  },
  {
    "type": "UIT",
    "mpid": "BFEW",
    "clearingBroker": "0443",
    "brokerName": "BILL FEW ASSOCIATES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "BFFI",
    "clearingBroker": "0226",
    "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
  },
  {
    "type": "UIT",
    "mpid": "BFSL",
    "clearingBroker": "0235",
    "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "BGHT",
    "clearingBroker": "0141",
    "brokerName": "BRIGHTON SECURITIES CORP.                                             "
  },
  {
    "type": "UIT",
    "mpid": "BGIS",
    "clearingBroker": "0443",
    "brokerName": "BLACKROCK EXECUTION SERVICES                                          "
  },
  {
    "type": "UIT",
    "mpid": "BGSG",
    "clearingBroker": "0226",
    "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "BGVS",
    "clearingBroker": "0443",
    "brokerName": "BGV SECURITIES                                                        "
  },
  {
    "type": "UIT",
    "mpid": "BHII",
    "clearingBroker": "0443",
    "brokerName": "BELLE HAVEN INVESTMENTS, LP                                           "
  },
  {
    "type": "UIT",
    "mpid": "BHKS",
    "clearingBroker": "0141",
    "brokerName": "BHK SECURITIES, LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "BIFS",
    "clearingBroker": "0443",
    "brokerName": "BROKERS INTERNATIONAL FINANCIAL SERVICES, LLC                         "
  },
  {
    "type": "UIT",
    "mpid": "BIGG",
    "clearingBroker": "0005",
    "brokerName": "BROWNSTONE INVESTMENT GROUP                                           "
  },
  {
    "type": "UIT",
    "mpid": "BIGP",
    "clearingBroker": "0443",
    "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "BISI",
    "clearingBroker": "0443",
    "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
  },
  {
    "type": "UIT",
    "mpid": "BJCM",
    "clearingBroker": "0235",
    "brokerName": "ESSEX SECURITIES LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "BJRC",
    "clearingBroker": "0235",
    "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "BKCM",
    "clearingBroker": "0443",
    "brokerName": "BNY CAPITAL MARKETS INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "BKES",
    "clearingBroker": "0443",
    "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "BKRT",
    "clearingBroker": "0235",
    "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "BLNI",
    "clearingBroker": "0226",
    "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "BLOC",
    "clearingBroker": "0158",
    "brokerName": "TRADING BLOCK                                                         "
  },
  {
    "type": "UIT",
    "mpid": "BLTK",
    "clearingBroker": "0443",
    "brokerName": "BULLTICK, LLC                                                         "
  },
  {
    "type": "UIT",
    "mpid": "BMSA",
    "clearingBroker": "0443",
    "brokerName": "MARIVA CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "BMUR",
    "clearingBroker": "0443",
    "brokerName": "BREAN CAPITAL, LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "BNBB",
    "clearingBroker": "0750",
    "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
  },
  {
    "type": "UIT",
    "mpid": "BNCH",
    "clearingBroker": "0235",
    "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "BNDI",
    "clearingBroker": "0443",
    "brokerName": "BERNARDI SECURITIES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "BNDS",
    "clearingBroker": "0226",
    "brokerName": "MTS MARKETS INTERNATIONAL, INC                                        "
  },
  {
    "type": "UIT",
    "mpid": "BNJM",
    "clearingBroker": "0235",
    "brokerName": "BENJAMIN SECURITIES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "BNPS",
    "clearingBroker": "2154",
    "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
  },
  {
    "type": "UIT",
    "mpid": "BNPX",
    "clearingBroker": "2154",
    "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
  },
  {
    "type": "UIT",
    "mpid": "BNTE",
    "clearingBroker": "0158",
    "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
  },
  {
    "type": "UIT",
    "mpid": "BNYM",
    "clearingBroker": "8355",
    "brokerName": "BNYM/UIT NSCC CNS CLEARANCE                                           "
  },
  {
    "type": "UIT",
    "mpid": "BNYN",
    "clearingBroker": "0226",
    "brokerName": "BANYAN SECURITIES, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "BOFA",
    "clearingBroker": "0773",
    "brokerName": "BOFA SECURITIES, INC./FIXED INCOME                                    "
  },
  {
    "type": "UIT",
    "mpid": "BOKI",
    "clearingBroker": "0443",
    "brokerName": "BOSC, INC.                                                            "
  },
  {
    "type": "UIT",
    "mpid": "BOSE",
    "clearingBroker": "0443",
    "brokerName": "BOE SECURITIES INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "BOSS",
    "clearingBroker": "0158",
    "brokerName": "ALL TIME ATS                                                          "
  },
  {
    "type": "UIT",
    "mpid": "BOTS",
    "clearingBroker": "0052",
    "brokerName": "C A BOTZUM & CO                                                       "
  },
  {
    "type": "UIT",
    "mpid": "BPWP",
    "clearingBroker": "0226",
    "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "BRAD",
    "clearingBroker": "0443",
    "brokerName": "BERNARD HEROLD & CO                                                   "
  },
  {
    "type": "UIT",
    "mpid": "BRBR",
    "clearingBroker": "0279",
    "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "BRCY",
    "clearingBroker": "0443",
    "brokerName": "BCP SECURITIES, LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "BRGE",
    "clearingBroker": "0052",
    "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
  },
  {
    "type": "UIT",
    "mpid": "BRLI",
    "clearingBroker": "0226",
    "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "BRNK",
    "clearingBroker": "0226",
    "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "BROC",
    "clearingBroker": "0443",
    "brokerName": "PAVILION GLOBAL MARKETS LTD                                           "
  },
  {
    "type": "UIT",
    "mpid": "BRRR",
    "clearingBroker": "8199",
    "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "BRSE",
    "clearingBroker": "0226",
    "brokerName": "BRADESCO SECURITIES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "BRVL",
    "clearingBroker": "0443",
    "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "BRWM",
    "clearingBroker": "0226",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "UIT",
    "mpid": "BSCM",
    "clearingBroker": "0052",
    "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "BSPI",
    "clearingBroker": "0235",
    "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "BTDG",
    "clearingBroker": "0161",
    "brokerName": "BIDS TRADING LP                                                       "
  },
  {
    "type": "UIT",
    "mpid": "BTIM",
    "clearingBroker": "1043",
    "brokerName": "BTIG, LLC                                                             "
  },
  {
    "type": "UIT",
    "mpid": "BTIS",
    "clearingBroker": "0443",
    "brokerName": "BTIG, LLC                                                             "
  },
  {
    "type": "UIT",
    "mpid": "BTSS",
    "clearingBroker": "0279",
    "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
  },
  {
    "type": "UIT",
    "mpid": "BURK",
    "clearingBroker": "0141",
    "brokerName": "BURKE, LAWTON, BREWER & BURKE                                         "
  },
  {
    "type": "UIT",
    "mpid": "BWNA",
    "clearingBroker": "0235",
    "brokerName": "BROWN ASSOCIATES INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "BYAI",
    "clearingBroker": "0226",
    "brokerName": "BRECEK & YOUNG                                                        "
  },
  {
    "type": "UIT",
    "mpid": "BZTN",
    "clearingBroker": "0141",
    "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
  },
  {
    "type": "UIT",
    "mpid": "BZWV",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "BZYD",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "BZYF",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "CADG",
    "clearingBroker": "0005",
    "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "CADZ",
    "clearingBroker": "0279",
    "brokerName": "CADZ SECURITIES INC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "CAGI",
    "clearingBroker": "0279",
    "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "CAIX",
    "clearingBroker": "0235",
    "brokerName": "CAIS CAPITAL LLC                                                      "
  },
  {
    "type": "UIT",
    "mpid": "CALD",
    "clearingBroker": "0103",
    "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "CALT",
    "clearingBroker": "0279",
    "brokerName": "CALTON & ASSOCIATES                                                   "
  },
  {
    "type": "UIT",
    "mpid": "CAMS",
    "clearingBroker": "0443",
    "brokerName": "COMPREHENSIVE ASSET MANAGEMENT AND SERVICING, INC.                    "
  },
  {
    "type": "UIT",
    "mpid": "CANA",
    "clearingBroker": "0443",
    "brokerName": "CANACCORD GENUITY INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "CAPC",
    "clearingBroker": "0235",
    "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "CAPE",
    "clearingBroker": "0279",
    "brokerName": "CAPE SECURITIES, INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "CAPF",
    "clearingBroker": "0443",
    "brokerName": "CAPITAL FINANCIAL SERVICES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "CAPP",
    "clearingBroker": "0443",
    "brokerName": "CAPTRUST FINANCIAL ADVISORS                                           "
  },
  {
    "type": "UIT",
    "mpid": "CARG",
    "clearingBroker": "0141",
    "brokerName": "CARTHAGE GROUP INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "CART",
    "clearingBroker": "0443",
    "brokerName": "CARTY & COMPANY, INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "CARY",
    "clearingBroker": "0141",
    "brokerName": "CARY STREET PARTNERS                                                  "
  },
  {
    "type": "UIT",
    "mpid": "CASH",
    "clearingBroker": "0158",
    "brokerName": "PLANNER SECURITIES LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "CATE",
    "clearingBroker": "0235",
    "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "CAVU",
    "clearingBroker": "0443",
    "brokerName": "CAVU SECURITIES LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "CBEV",
    "clearingBroker": "0226",
    "brokerName": "CITY NATIONAL BANK, BEVERLY HILLS, CALIFORNIA                         "
  },
  {
    "type": "UIT",
    "mpid": "CBII",
    "clearingBroker": "0443",
    "brokerName": "WESBANCO SECURITIES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "CBIN",
    "clearingBroker": "0443",
    "brokerName": "COMPASS BROKERAGE, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "CBOL",
    "clearingBroker": "0226",
    "brokerName": "MUTUAL SECURITIES, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "CBTD",
    "clearingBroker": "0226",
    "brokerName": "SYNOVOUS SECURITIES INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "CCCO",
    "clearingBroker": "0226",
    "brokerName": "CARNES CAPITAL CORPORATION                                            "
  },
  {
    "type": "UIT",
    "mpid": "CCIG",
    "clearingBroker": "0235",
    "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
  },
  {
    "type": "UIT",
    "mpid": "CCMB",
    "clearingBroker": "0443",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "CCMC",
    "clearingBroker": "0443",
    "brokerName": "COMMERZEBANK CAPITAL CORP.                                            "
  },
  {
    "type": "UIT",
    "mpid": "CCMM",
    "clearingBroker": "0235",
    "brokerName": "CRAFT CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "CCPM",
    "clearingBroker": "0595",
    "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "CCRD",
    "clearingBroker": "0443",
    "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "CCSS",
    "clearingBroker": "0443",
    "brokerName": "CROWN CAPITAL SECURITIES, L.P.                                        "
  },
  {
    "type": "UIT",
    "mpid": "CDFS",
    "clearingBroker": "0052",
    "brokerName": "NAVIAN CAPITAL SECURITIES, LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "CDMA",
    "clearingBroker": "0505",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "CERS",
    "clearingBroker": "0226",
    "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "CFCS",
    "clearingBroker": "0005",
    "brokerName": "CANTOR FITZGERALD & CO                                                "
  },
  {
    "type": "UIT",
    "mpid": "CFGM",
    "clearingBroker": "0235",
    "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "CFGT",
    "clearingBroker": "0235",
    "brokerName": "CF GLOBAL TRADING, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "CFII",
    "clearingBroker": "0235",
    "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
  },
  {
    "type": "UIT",
    "mpid": "CFIN",
    "clearingBroker": "0279",
    "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
  },
  {
    "type": "UIT",
    "mpid": "CFSC",
    "clearingBroker": "0443",
    "brokerName": "INSIGNEO SECURITIES LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "CFSI",
    "clearingBroker": "0052",
    "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "CFSX",
    "clearingBroker": "0794",
    "brokerName": "CF SECURED, LLC                                                       "
  },
  {
    "type": "UIT",
    "mpid": "CGAM",
    "clearingBroker": "0443",
    "brokerName": "CGIS SECURITIES LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "CGAT",
    "clearingBroker": "0443",
    "brokerName": "CADARET, GRANT & CO., INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "CGCO",
    "clearingBroker": "0443",
    "brokerName": "CG COMPASS (USA) LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "CGLN",
    "clearingBroker": "0103",
    "brokerName": "COUGHLIN & CO                                                         "
  },
  {
    "type": "UIT",
    "mpid": "CGWM",
    "clearingBroker": "0443",
    "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "CHAS",
    "clearingBroker": "0164",
    "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "CHBC",
    "clearingBroker": "0235",
    "brokerName": "PENSERRA SECURITIES, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "CHCH",
    "clearingBroker": "0226",
    "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "CHCK",
    "clearingBroker": "0226",
    "brokerName": "CHICKASAW SECURITIES, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "CHDA",
    "clearingBroker": "0141",
    "brokerName": "CHAPIN, DAVIS                                                         "
  },
  {
    "type": "UIT",
    "mpid": "CHHS",
    "clearingBroker": "0141",
    "brokerName": "CHESTER HARRIS & CO., INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "CHLC",
    "clearingBroker": "0443",
    "brokerName": "CHURCHILL CAPITAL USA, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "CHPP",
    "clearingBroker": "0624",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "CICC",
    "clearingBroker": "0443",
    "brokerName": "CICC US SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "CICI",
    "clearingBroker": "0443",
    "brokerName": "COMMERCE BANK INVESTMENT SERVICES, INC.                               "
  },
  {
    "type": "UIT",
    "mpid": "CICL",
    "clearingBroker": "0141",
    "brokerName": "CAROLINAS INVESTMENT CONSULTING                                       "
  },
  {
    "type": "UIT",
    "mpid": "CIIV",
    "clearingBroker": "0052",
    "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "CIMB",
    "clearingBroker": "0005",
    "brokerName": "CIMB SECURITIES (USA), INC                                            "
  },
  {
    "type": "UIT",
    "mpid": "CIRI",
    "clearingBroker": "0443",
    "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
  },
  {
    "type": "UIT",
    "mpid": "CISV",
    "clearingBroker": "0226",
    "brokerName": "CITIZENS SECURITIES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "CJSC",
    "clearingBroker": "0443",
    "brokerName": "CJS SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "CLDN",
    "clearingBroker": "0235",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "CLRK",
    "clearingBroker": "0235",
    "brokerName": "CLARK DODGE & CO, INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "CLSC",
    "clearingBroker": "0235",
    "brokerName": "CABOT LODGE SECURITIES LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "CLSS",
    "clearingBroker": "0235",
    "brokerName": "CABOT LODGE SECURITIES LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "CLTN",
    "clearingBroker": "0226",
    "brokerName": "CALTON & ASSOCIATES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "CMCE",
    "clearingBroker": "0226",
    "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
  },
  {
    "type": "UIT",
    "mpid": "CMFS",
    "clearingBroker": "0443",
    "brokerName": "BNY MELLON CAP MKTS                                                   "
  },
  {
    "type": "UIT",
    "mpid": "CMGF",
    "clearingBroker": "0443",
    "brokerName": "CMG SECURITIES LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "CMMW",
    "clearingBroker": "0226",
    "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
  },
  {
    "type": "UIT",
    "mpid": "CNCD",
    "clearingBroker": "0235",
    "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "CNFI",
    "clearingBroker": "0443",
    "brokerName": "CENTAURUS FINANCIAL INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "CNFR",
    "clearingBroker": "0443",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "CNSI",
    "clearingBroker": "0226",
    "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "COAS",
    "clearingBroker": "0443",
    "brokerName": "REALTA EQUITIES, INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "CODA",
    "clearingBroker": "0161",
    "brokerName": "CODA MARKETS, INC.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "COEI",
    "clearingBroker": "0052",
    "brokerName": "COASTAL EQUITIES, INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "COEX",
    "clearingBroker": "0161",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "COFS",
    "clearingBroker": "0279",
    "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
  },
  {
    "type": "UIT",
    "mpid": "COHN",
    "clearingBroker": "0235",
    "brokerName": "COHEN BROS. & COMPANY                                                 "
  },
  {
    "type": "UIT",
    "mpid": "COKE",
    "clearingBroker": "0235",
    "brokerName": "COKER & PALMER, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "COMP",
    "clearingBroker": "0595",
    "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
  },
  {
    "type": "UIT",
    "mpid": "CONI",
    "clearingBroker": "0235",
    "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "CONR",
    "clearingBroker": "0235",
    "brokerName": "CONNERS & CO., INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "CONS",
    "clearingBroker": "0141",
    "brokerName": "CONSULTIVA SECURITIES, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "COOR",
    "clearingBroker": "0141",
    "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "COSL",
    "clearingBroker": "0443",
    "brokerName": "CLIENT ONE SECURITIES, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "COWN",
    "clearingBroker": "0100",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "COWP",
    "clearingBroker": "0226",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "COWR",
    "clearingBroker": "0443",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "COYL",
    "clearingBroker": "0235",
    "brokerName": "COYLE SECURITIES LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "CPGL",
    "clearingBroker": "0226",
    "brokerName": "CONTINUITY PARTNERS GROUP, LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "CPRC",
    "clearingBroker": "0235",
    "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
  },
  {
    "type": "UIT",
    "mpid": "CPRM",
    "clearingBroker": "8199",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "CRCM",
    "clearingBroker": "0235",
    "brokerName": "COHNREZNICK CAPITAL                                                   "
  },
  {
    "type": "UIT",
    "mpid": "CRDL",
    "clearingBroker": "0235",
    "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "CRED",
    "clearingBroker": "0443",
    "brokerName": "CREDICORP CAPITAL LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "CREF",
    "clearingBroker": "0443",
    "brokerName": "TIAA-CREF INDIVIDUAL AND INSTITUTIONAL SERVICES, LLC                  "
  },
  {
    "type": "UIT",
    "mpid": "CREW",
    "clearingBroker": "0443",
    "brokerName": "CREWS & ASSOCIATES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "CRFN",
    "clearingBroker": "6769",
    "brokerName": "ROBINHOOD FINANCIAL, LLC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "CRII",
    "clearingBroker": "0443",
    "brokerName": "CRI SECURITIES INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "CRNJ",
    "clearingBroker": "0103",
    "brokerName": "CANTONE RESEARCH                                                      "
  },
  {
    "type": "UIT",
    "mpid": "CRON",
    "clearingBroker": "0443",
    "brokerName": "CRONIN & CO., INC.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "CRPT",
    "clearingBroker": "0235",
    "brokerName": "CROSS POINT CAPITAL LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "CRTH",
    "clearingBroker": "0443",
    "brokerName": "CORINTHIAN PARTNERS, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "CRYN",
    "clearingBroker": "0235",
    "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
  },
  {
    "type": "UIT",
    "mpid": "CSAI",
    "clearingBroker": "0793",
    "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "CSAP",
    "clearingBroker": "0141",
    "brokerName": "CRESAP, INC.                                                          "
  },
  {
    "type": "UIT",
    "mpid": "CSCA",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "UIT",
    "mpid": "CSCM",
    "clearingBroker": "0279",
    "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
  },
  {
    "type": "UIT",
    "mpid": "CSPA",
    "clearingBroker": "0226",
    "brokerName": "CREDIT SUISSE PRIVATE ADVISORS                                        "
  },
  {
    "type": "UIT",
    "mpid": "CSPI",
    "clearingBroker": "0235",
    "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
  },
  {
    "type": "UIT",
    "mpid": "CTAS",
    "clearingBroker": "0443",
    "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "CTBK",
    "clearingBroker": "4270",
    "brokerName": "CENTRAL TRUST BANK                                                    "
  },
  {
    "type": "UIT",
    "mpid": "CTNL",
    "clearingBroker": "0235",
    "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "CTSC",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "UIT",
    "mpid": "CUFT",
    "clearingBroker": "0226",
    "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "CUSO",
    "clearingBroker": "0443",
    "brokerName": "CUSO FINANCIAL SERVICES, L.P.                                         "
  },
  {
    "type": "UIT",
    "mpid": "CUTW",
    "clearingBroker": "0235",
    "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "CUWB",
    "clearingBroker": "0103",
    "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "CVGP",
    "clearingBroker": "0443",
    "brokerName": "COWEN AND COMPANY LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "CWEI",
    "clearingBroker": "0443",
    "brokerName": "BEECH HILL SECURITIES, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "CWMK",
    "clearingBroker": "0438",
    "brokerName": "CIBC WORLD MARKETS CORP.                                              "
  },
  {
    "type": "UIT",
    "mpid": "CYND",
    "clearingBroker": "0443",
    "brokerName": "TIGRESS FINANCIAL PARTNERS LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "DADA",
    "clearingBroker": "0361",
    "brokerName": "D. A. DAVIDSON & CO.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "DAII",
    "clearingBroker": "0235",
    "brokerName": "ALEXANDER (DON) INVESTMENTS, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "DAIN",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "DAIS",
    "clearingBroker": "0052",
    "brokerName": "DAI SECURITIES, LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "DARA",
    "clearingBroker": "0235",
    "brokerName": "DARWOOD ASSOCIATES, INC                                               "
  },
  {
    "type": "UIT",
    "mpid": "DART",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "DASH",
    "clearingBroker": "0161",
    "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "DAVA",
    "clearingBroker": "0443",
    "brokerName": "DAVENPORT & COMPANY LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "DAWA",
    "clearingBroker": "0647",
    "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
  },
  {
    "type": "UIT",
    "mpid": "DBCC",
    "clearingBroker": "0235",
    "brokerName": "D. BORAL CAPITAL                                                      "
  },
  {
    "type": "UIT",
    "mpid": "DBCH",
    "clearingBroker": "0052",
    "brokerName": "D. BORAL CAPITAL                                                      "
  },
  {
    "type": "UIT",
    "mpid": "DBKS",
    "clearingBroker": "0573",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "DBPC",
    "clearingBroker": "0443",
    "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "DCAN",
    "clearingBroker": "0279",
    "brokerName": "R. M. DUNCAN SECURITIES, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "DCSD",
    "clearingBroker": "0235",
    "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
  },
  {
    "type": "UIT",
    "mpid": "DCVL",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "DEAN",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "DEGS",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "DENI",
    "clearingBroker": "0279",
    "brokerName": "H.C. DENISON CO.                                                      "
  },
  {
    "type": "UIT",
    "mpid": "DETF",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "DFPG",
    "clearingBroker": "0235",
    "brokerName": "DFPG INVESTMENTS, INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "DIBS",
    "clearingBroker": "0226",
    "brokerName": "DIGITAL BROKERAGE SERVICES LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "DIGG",
    "clearingBroker": "0595",
    "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "DINO",
    "clearingBroker": "0103",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "UIT",
    "mpid": "DJSA",
    "clearingBroker": "0750",
    "brokerName": "DAWSON JAMES SECURITIES, INC                                          "
  },
  {
    "type": "UIT",
    "mpid": "DLAI",
    "clearingBroker": "0235",
    "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "DLPS",
    "clearingBroker": "0595",
    "brokerName": "DLP SECURITIES,.LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "DLSI",
    "clearingBroker": "0226",
    "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "DMCD",
    "clearingBroker": "0279",
    "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
  },
  {
    "type": "UIT",
    "mpid": "DMKC",
    "clearingBroker": "0141",
    "brokerName": "D.M. KELLY & COMPANY                                                  "
  },
  {
    "type": "UIT",
    "mpid": "DNOR",
    "clearingBroker": "0005",
    "brokerName": "DNB MARKETS, INC.                                                     "
  },
  {
    "type": "UIT",
    "mpid": "DNSR",
    "clearingBroker": "0158",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "UIT",
    "mpid": "DNWL",
    "clearingBroker": "0443",
    "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "DOFT",
    "clearingBroker": "0443",
    "brokerName": "DOFT & CO., INC.                                                      "
  },
  {
    "type": "UIT",
    "mpid": "DOMI",
    "clearingBroker": "0279",
    "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "DOMS",
    "clearingBroker": "0235",
    "brokerName": "DOMINARI SECURITIES LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "DORN",
    "clearingBroker": "0235",
    "brokerName": "DORN & CO., INC.                                                      "
  },
  {
    "type": "UIT",
    "mpid": "DOTC",
    "clearingBroker": "0226",
    "brokerName": "COLLIERS SECURITIES LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "DOVE",
    "clearingBroker": "0226",
    "brokerName": "SECURITIES EQUITY GROUP                                               "
  },
  {
    "type": "UIT",
    "mpid": "DOWL",
    "clearingBroker": "0443",
    "brokerName": "DOWLING & PARTNERS SECURITIES LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "DREX",
    "clearingBroker": "0443",
    "brokerName": "DREXEL HAMILTON, LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "DRSC",
    "clearingBroker": "0443",
    "brokerName": "BNY MELLON SECURITIES CORPORATION                                     "
  },
  {
    "type": "UIT",
    "mpid": "DRTG",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "DRTR",
    "clearingBroker": "0005",
    "brokerName": "DART EXECUTIONS, LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "DRVW",
    "clearingBroker": "0235",
    "brokerName": "DRIVEWEALTH, LLC                                                      "
  },
  {
    "type": "UIT",
    "mpid": "DSAI",
    "clearingBroker": "0443",
    "brokerName": "DAEWOO SECURITIES (AMERICA) INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "DSGG",
    "clearingBroker": "0226",
    "brokerName": "DMG SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "DTEX",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
  },
  {
    "type": "UIT",
    "mpid": "DUST",
    "clearingBroker": "0161",
    "brokerName": "JUMP TRADING, LLC                                                     "
  },
  {
    "type": "UIT",
    "mpid": "DWIZ",
    "clearingBroker": "0235",
    "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "EAMC",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
  },
  {
    "type": "UIT",
    "mpid": "EAMG",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
  },
  {
    "type": "UIT",
    "mpid": "ECCC",
    "clearingBroker": "0226",
    "brokerName": "EAGLES COAST CAPITAL, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "EDFC",
    "clearingBroker": "0443",
    "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "EDFO",
    "clearingBroker": "0158",
    "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "EDIR",
    "clearingBroker": "0235",
    "brokerName": "EDI FINANCIAL, INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "EDJO",
    "clearingBroker": "0057",
    "brokerName": "EDWARD D. JONES & CO.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "EFGC",
    "clearingBroker": "0443",
    "brokerName": "EFG CAPITAL INTERNATIONAL                                             "
  },
  {
    "type": "UIT",
    "mpid": "EFSP",
    "clearingBroker": "0443",
    "brokerName": "ESSEX FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "EGLE",
    "clearingBroker": "1043",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "UIT",
    "mpid": "EGMT",
    "clearingBroker": "0005",
    "brokerName": "EG MARKET TECHNOLOGIES LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "ELET",
    "clearingBroker": "0388",
    "brokerName": "ELECTRONIFIE SECURITIES LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "ELEV",
    "clearingBroker": "0235",
    "brokerName": "ELEVATION, LLC                                                        "
  },
  {
    "type": "UIT",
    "mpid": "EMER",
    "clearingBroker": "0443",
    "brokerName": "EMERSON EQUITY LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "EMOC",
    "clearingBroker": "0750",
    "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "EMPR",
    "clearingBroker": "0279",
    "brokerName": "SELKIRK INVESTMENTS, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "ENTR",
    "clearingBroker": "0235",
    "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "EPIC",
    "clearingBroker": "0443",
    "brokerName": "EPIC CAPITAL SECURITIES                                               "
  },
  {
    "type": "UIT",
    "mpid": "EQHA",
    "clearingBroker": "0075",
    "brokerName": "EQUITABLE ADVISORS, LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "EQSV",
    "clearingBroker": "0226",
    "brokerName": "EQUITY SERVICES, INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "EROP",
    "clearingBroker": "0158",
    "brokerName": "EROOM SECURITIES LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "ESBD",
    "clearingBroker": "0235",
    "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "ETCB",
    "clearingBroker": "3505",
    "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "ETCL",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "ETRS",
    "clearingBroker": "0015",
    "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "EVOL",
    "clearingBroker": "0226",
    "brokerName": "EVOLVE SECURITIES, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "EXCS",
    "clearingBroker": "0443",
    "brokerName": "EXCEL SECURITIES AND ASSOCIATES, INC.                                 "
  },
  {
    "type": "UIT",
    "mpid": "FAFI",
    "clearingBroker": "0279",
    "brokerName": "FIRST ASSET FINANCIAL                                                 "
  },
  {
    "type": "UIT",
    "mpid": "FALC",
    "clearingBroker": "0103",
    "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "FANC",
    "clearingBroker": "0235",
    "brokerName": "FINANCE 500, INC.                                                     "
  },
  {
    "type": "UIT",
    "mpid": "FATS",
    "clearingBroker": "0443",
    "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "FBLM",
    "clearingBroker": "0235",
    "brokerName": "FBL MARKETING SERVICES LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "FBLT",
    "clearingBroker": "8199",
    "brokerName": "FIRST BALLANTYNE, LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "FBNS",
    "clearingBroker": "0235",
    "brokerName": "FBN SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "FBPC",
    "clearingBroker": "0443",
    "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
  },
  {
    "type": "UIT",
    "mpid": "FBSB",
    "clearingBroker": "0280",
    "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "FCFP",
    "clearingBroker": "0141",
    "brokerName": "FIRST CITIZENS FINANCIAL PLUS, INC.                                   "
  },
  {
    "type": "UIT",
    "mpid": "FCFS",
    "clearingBroker": "0443",
    "brokerName": "FIRST COMMAND FINANCIAL PLANNING, INC.                                "
  },
  {
    "type": "UIT",
    "mpid": "FCIT",
    "clearingBroker": "0443",
    "brokerName": "FIRST CITIZENS INVESTOR SERVICES, INC.                                "
  },
  {
    "type": "UIT",
    "mpid": "FCML",
    "clearingBroker": "0279",
    "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "FCMP",
    "clearingBroker": "0595",
    "brokerName": "PRIME EXECUTIONS, INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "FCST",
    "clearingBroker": "0443",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "FDSC",
    "clearingBroker": "0158",
    "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "FDSI",
    "clearingBroker": "0141",
    "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "FEDR",
    "clearingBroker": "0235",
    "brokerName": "FEDERATED SECURITIES INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "FENX",
    "clearingBroker": "0595",
    "brokerName": "FENIX SECURITIES, LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "FERN",
    "clearingBroker": "0443",
    "brokerName": "FEARNLEY SECURITIES                                                   "
  },
  {
    "type": "UIT",
    "mpid": "FFCM",
    "clearingBroker": "0235",
    "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "FFGI",
    "clearingBroker": "0235",
    "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "FFSI",
    "clearingBroker": "0158",
    "brokerName": "FIRSTRADE SECURITIES INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "FHCI",
    "clearingBroker": "0443",
    "brokerName": "FIRST HEARTLAND CAPITAL, INC                                          "
  },
  {
    "type": "UIT",
    "mpid": "FHON",
    "clearingBroker": "0235",
    "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "FIBS",
    "clearingBroker": "0226",
    "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "FISA",
    "clearingBroker": "0443",
    "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "FISB",
    "clearingBroker": "0226",
    "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "FISH",
    "clearingBroker": "0235",
    "brokerName": "L.B. FISHER & COMPANY                                                 "
  },
  {
    "type": "UIT",
    "mpid": "FJRF",
    "clearingBroker": "0052",
    "brokerName": "PARITER SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "FKSC",
    "clearingBroker": "0235",
    "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
  },
  {
    "type": "UIT",
    "mpid": "FLAT",
    "clearingBroker": "0226",
    "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
  },
  {
    "type": "UIT",
    "mpid": "FLIB",
    "clearingBroker": "0235",
    "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
  },
  {
    "type": "UIT",
    "mpid": "FLOU",
    "clearingBroker": "0443",
    "brokerName": "FIRST ST. LOUIS SECURITIES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "FLTG",
    "clearingBroker": "0005",
    "brokerName": "FLOW TRADERS U.S. LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "FLTL",
    "clearingBroker": "0235",
    "brokerName": "FELTL & COMPANY                                                       "
  },
  {
    "type": "UIT",
    "mpid": "FMAT",
    "clearingBroker": "0608",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "FMCO",
    "clearingBroker": "0443",
    "brokerName": "FIRST MANHATTAN CO.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "FMEX",
    "clearingBroker": "0750",
    "brokerName": "FINAMEX INTERNATIONAL, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "FMFS",
    "clearingBroker": "0226",
    "brokerName": "FISRT MERIT FINANCIAL SERVICES, INC                                   "
  },
  {
    "type": "UIT",
    "mpid": "FMGT",
    "clearingBroker": "0443",
    "brokerName": "FAMILY MANAGEMENT SECURITIES, LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "FNFD",
    "clearingBroker": "0443",
    "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
  },
  {
    "type": "UIT",
    "mpid": "FNIC",
    "clearingBroker": "0443",
    "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
  },
  {
    "type": "UIT",
    "mpid": "FNPN",
    "clearingBroker": "0443",
    "brokerName": "UNIVEST INVESTMENTS                                                   "
  },
  {
    "type": "UIT",
    "mpid": "FNSJ",
    "clearingBroker": "0443",
    "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
  },
  {
    "type": "UIT",
    "mpid": "FOGS",
    "clearingBroker": "0235",
    "brokerName": "FOG EQUITIES LLC                                                      "
  },
  {
    "type": "UIT",
    "mpid": "FOXC",
    "clearingBroker": "0443",
    "brokerName": "FOX CHASE CAPITAL PARTNERS, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "FSCS",
    "clearingBroker": "0443",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "FSRP",
    "clearingBroker": "0443",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "FTBR",
    "clearingBroker": "0728",
    "brokerName": "FOLIO INVESTMENTS, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "FTEN",
    "clearingBroker": "0226",
    "brokerName": "FTB ADVISORS, INC.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "FTLP",
    "clearingBroker": "8244",
    "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
  },
  {
    "type": "UIT",
    "mpid": "FTSR",
    "clearingBroker": "0226",
    "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "FUBO",
    "clearingBroker": "0443",
    "brokerName": "GRIFFINEST ASIA SECURITIES, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "FWSI",
    "clearingBroker": "0141",
    "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "GABE",
    "clearingBroker": "0141",
    "brokerName": "G. RESEARCH, INC.                                                     "
  },
  {
    "type": "UIT",
    "mpid": "GAFI",
    "clearingBroker": "0235",
    "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "GAGN",
    "clearingBroker": "0226",
    "brokerName": "GAGNON SECURITIES, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "GAII",
    "clearingBroker": "0279",
    "brokerName": "GREAT AMERICAN INVESTORS, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "GARB",
    "clearingBroker": "0148",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
  },
  {
    "type": "UIT",
    "mpid": "GARC",
    "clearingBroker": "0161",
    "brokerName": "ICAP CORPORATES LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "GARE",
    "clearingBroker": "0148",
    "brokerName": "GARE                                                                  "
  },
  {
    "type": "UIT",
    "mpid": "GARR",
    "clearingBroker": "0226",
    "brokerName": "GARRETT NAGLE & CO., INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "GARW",
    "clearingBroker": "0595",
    "brokerName": "GAR WOOD SECURITIES, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "GBMS",
    "clearingBroker": "0158",
    "brokerName": "GBM INTERNATIONAL, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "GBMT",
    "clearingBroker": "0443",
    "brokerName": "GBM INTERNATIONAL, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "GCMC",
    "clearingBroker": "0443",
    "brokerName": "GLADOWSKY CAPITAL MANAGEMENT CORP.                                    "
  },
  {
    "type": "UIT",
    "mpid": "GDCO",
    "clearingBroker": "0443",
    "brokerName": "GILBERT, DONIGER CO., INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "GELP",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "GENS",
    "clearingBroker": "0279",
    "brokerName": "GENERAL SECURITIES CORP                                               "
  },
  {
    "type": "UIT",
    "mpid": "GENW",
    "clearingBroker": "0443",
    "brokerName": "GENEOS WEALTH MANAGEMENT, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "GFBD",
    "clearingBroker": "0226",
    "brokerName": "G. F. INVESTMENT SERVICES, LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "GFSI",
    "clearingBroker": "0443",
    "brokerName": "GLOBAL FINANCIAL SERVICES, L.L.C.                                     "
  },
  {
    "type": "UIT",
    "mpid": "GGWI",
    "clearingBroker": "0141",
    "brokerName": "GAGE-WILEY & COMPANY INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "GHCC",
    "clearingBroker": "0226",
    "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
  },
  {
    "type": "UIT",
    "mpid": "GILG",
    "clearingBroker": "0226",
    "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "GJSS",
    "clearingBroker": "0235",
    "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "GLCM",
    "clearingBroker": "0443",
    "brokerName": "GREENSLEDGE CAPITAL MARKETS                                           "
  },
  {
    "type": "UIT",
    "mpid": "GLYN",
    "clearingBroker": "0443",
    "brokerName": "GLYNN (J.A.) & CO.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "GMSG",
    "clearingBroker": "0443",
    "brokerName": "GMS GROUP (THE), L.L.C.                                               "
  },
  {
    "type": "UIT",
    "mpid": "GPCA",
    "clearingBroker": "0235",
    "brokerName": "GREAT POINT CAPITAL LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "GPCG",
    "clearingBroker": "0443",
    "brokerName": "GREENMAN, PARKER, CONNALLY, GREENMAN, INC.                            "
  },
  {
    "type": "UIT",
    "mpid": "GRAD",
    "clearingBroker": "0235",
    "brokerName": "GRADIENT SECURITIES, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "GRBD",
    "clearingBroker": "0052",
    "brokerName": "GREENBIRD CAPITAL LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "GRIL",
    "clearingBroker": "0235",
    "brokerName": "GLOBAL RESOURCE INVESTMENTS, LTD.                                     "
  },
  {
    "type": "UIT",
    "mpid": "GROD",
    "clearingBroker": "0226",
    "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "GRPS",
    "clearingBroker": "0226",
    "brokerName": "MML INVESTORS SERVICES, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "GRWD",
    "clearingBroker": "0052",
    "brokerName": "GAR WOOD SECURITIES, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "GRYG",
    "clearingBroker": "0226",
    "brokerName": "GOLDBERG (GARY) & CO., INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "GSBI",
    "clearingBroker": "0279",
    "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "GSCO",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "GSIL",
    "clearingBroker": "0158",
    "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "GSMM",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "GSQQ",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "GSSI",
    "clearingBroker": "0052",
    "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "GSUU",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "GSVV",
    "clearingBroker": "0005",
    "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "GTNB",
    "clearingBroker": "0595",
    "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
  },
  {
    "type": "UIT",
    "mpid": "GUGI",
    "clearingBroker": "0526",
    "brokerName": "GUGGENHEIM FUNDS DISTRIBUTORS, LLC                                    "
  },
  {
    "type": "UIT",
    "mpid": "GWFS",
    "clearingBroker": "0443",
    "brokerName": "GWFS EQUITIES, INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "GWNS",
    "clearingBroker": "0443",
    "brokerName": "GWN SECURITIES INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "HAFS",
    "clearingBroker": "0279",
    "brokerName": "HANTZ FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "HALO",
    "clearingBroker": "0235",
    "brokerName": "HALO SECURITIES, LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "HARB",
    "clearingBroker": "0443",
    "brokerName": "HARBOUR INVESTMENTS INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "HARC",
    "clearingBroker": "0235",
    "brokerName": "HARLEY CAPITAL LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "HAVK",
    "clearingBroker": "0235",
    "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "HAZL",
    "clearingBroker": "0226",
    "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "HBCO",
    "clearingBroker": "0443",
    "brokerName": "GLOBAL INVESTOR SERVICES, L.C.                                        "
  },
  {
    "type": "UIT",
    "mpid": "HBUS",
    "clearingBroker": "0443",
    "brokerName": "HOLISTIC BROKERAGE, LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "HCMX",
    "clearingBroker": "0235",
    "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "HCTA",
    "clearingBroker": "0005",
    "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "HCWW",
    "clearingBroker": "0235",
    "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "HDVS",
    "clearingBroker": "0226",
    "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "HEAD",
    "clearingBroker": "0443",
    "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
  },
  {
    "type": "UIT",
    "mpid": "HENN",
    "clearingBroker": "0235",
    "brokerName": "CARL M. HENNIG, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "HENY",
    "clearingBroker": "0443",
    "brokerName": "HENLEY & COMPANY LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "HIAL",
    "clearingBroker": "0443",
    "brokerName": "HARBOR INVESTMENT ADVISORY, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "HIGG",
    "clearingBroker": "0235",
    "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "HINO",
    "clearingBroker": "0235",
    "brokerName": "TRB CAPITAL MARKETS,LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "HITS",
    "clearingBroker": "0443",
    "brokerName": "HEIGHT SECURITIES, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "HJSC",
    "clearingBroker": "0443",
    "brokerName": "SIMS (HERBERT J.) & CO., INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "HNTR",
    "clearingBroker": "0443",
    "brokerName": "HUNTER ASSOCIATES, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "HONR",
    "clearingBroker": "0235",
    "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "HOOD",
    "clearingBroker": "6769",
    "brokerName": "ROBINHOOD SECURITIES, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "HOPK",
    "clearingBroker": "0750",
    "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
  },
  {
    "type": "UIT",
    "mpid": "HOTO",
    "clearingBroker": "0443",
    "brokerName": "HORNOR, TOWNSEND & KENT, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "HPOM",
    "clearingBroker": "0235",
    "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
  },
  {
    "type": "UIT",
    "mpid": "HRBF",
    "clearingBroker": "0756",
    "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
  },
  {
    "type": "UIT",
    "mpid": "HRCS",
    "clearingBroker": "0443",
    "brokerName": "HRC INVESTMENT SERVICES, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "HRGR",
    "clearingBroker": "0235",
    "brokerName": "HARGER AND COMPANY, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "HRRS",
    "clearingBroker": "0443",
    "brokerName": "HARRIS INVESTORS SERVICES, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "HSAI",
    "clearingBroker": "0443",
    "brokerName": "INDEPENDENT FINANCIAL GROUP, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "HSBK",
    "clearingBroker": "0443",
    "brokerName": "HSBC SECURITIES (USA) INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "HSBM",
    "clearingBroker": "0486",
    "brokerName": "HSBC SECURITIES (USA), INC/ FIXED INCOME SECS                         "
  },
  {
    "type": "UIT",
    "mpid": "HTCM",
    "clearingBroker": "0235",
    "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
  },
  {
    "type": "UIT",
    "mpid": "HTPS",
    "clearingBroker": "0443",
    "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "HTWR",
    "clearingBroker": "0226",
    "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "HUCO",
    "clearingBroker": "0226",
    "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
  },
  {
    "type": "UIT",
    "mpid": "HUNT",
    "clearingBroker": "0141",
    "brokerName": "HUNTLEIGH SECURITIES CORPORATION                                      "
  },
  {
    "type": "UIT",
    "mpid": "HWJC",
    "clearingBroker": "0052",
    "brokerName": "HWJ CAPITAL PARTNERS II, LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "HWLS",
    "clearingBroker": "0443",
    "brokerName": "M.S. HOWELLS & CO.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "IAAK",
    "clearingBroker": "0279",
    "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "IAEW",
    "clearingBroker": "0595",
    "brokerName": "SRT SECURITIES LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "IAEX",
    "clearingBroker": "0235",
    "brokerName": "SRT SECURITIES LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "IBND",
    "clearingBroker": "0103",
    "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "IBOT",
    "clearingBroker": "0279",
    "brokerName": "INVESTORS BROKERAGE OF TEXAS, INC                                     "
  },
  {
    "type": "UIT",
    "mpid": "IBPR",
    "clearingBroker": "0052",
    "brokerName": "IB CAPITAL LLC                                                        "
  },
  {
    "type": "UIT",
    "mpid": "IBSJ",
    "clearingBroker": "0052",
    "brokerName": "INTEGRITY BROKERAGE                                                   "
  },
  {
    "type": "UIT",
    "mpid": "ICAN",
    "clearingBroker": "0226",
    "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "ICBK",
    "clearingBroker": "0388",
    "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
  },
  {
    "type": "UIT",
    "mpid": "ICCI",
    "clearingBroker": "0279",
    "brokerName": "INDEPENDENCE CAPITAL CO.                                              "
  },
  {
    "type": "UIT",
    "mpid": "ICDS",
    "clearingBroker": "0750",
    "brokerName": "ICD SECURITIES                                                        "
  },
  {
    "type": "UIT",
    "mpid": "ICEX",
    "clearingBroker": "4264",
    "brokerName": "ICE SECURITIES EXECUTION & CLEARING, LLC                              "
  },
  {
    "type": "UIT",
    "mpid": "ICMH",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
  },
  {
    "type": "UIT",
    "mpid": "ICMI",
    "clearingBroker": "0279",
    "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
  },
  {
    "type": "UIT",
    "mpid": "ICON",
    "clearingBroker": "0595",
    "brokerName": "ICON CAPITAL GROUP, LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "ICRL",
    "clearingBroker": "0443",
    "brokerName": "RIDEAU (I.C.) LYONS AND CO.                                           "
  },
  {
    "type": "UIT",
    "mpid": "ICTI",
    "clearingBroker": "0158",
    "brokerName": "INTERNATIONAL CORRESPONDENT TRADING, INC.                             "
  },
  {
    "type": "UIT",
    "mpid": "IDAY",
    "clearingBroker": "0103",
    "brokerName": "BROKERAGESELECT                                                       "
  },
  {
    "type": "UIT",
    "mpid": "IESI",
    "clearingBroker": "0443",
    "brokerName": "ITAU EUROPA SECURITIES INC                                            "
  },
  {
    "type": "UIT",
    "mpid": "IFCS",
    "clearingBroker": "0161",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "IMCC",
    "clearingBroker": "0005",
    "brokerName": "IMC FINANCIAL MARKETS                                                 "
  },
  {
    "type": "UIT",
    "mpid": "IMPC",
    "clearingBroker": "0443",
    "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "INCC",
    "clearingBroker": "0443",
    "brokerName": "SATURNA BROKERAGE SERVICES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "INFI",
    "clearingBroker": "0279",
    "brokerName": "INTEGRAL FINANCIAL, LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "INGS",
    "clearingBroker": "0124",
    "brokerName": "INGALLS & SNYDER, LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "INNO",
    "clearingBroker": "0052",
    "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "INPI",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT PLANNERS INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "INPS",
    "clearingBroker": "0235",
    "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "INTX",
    "clearingBroker": "0235",
    "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
  },
  {
    "type": "UIT",
    "mpid": "IPGR",
    "clearingBroker": "0443",
    "brokerName": "INVESTMENT PLACEMENT GROUP                                            "
  },
  {
    "type": "UIT",
    "mpid": "IRMD",
    "clearingBroker": "0443",
    "brokerName": "PLANMEMBER SECURITIES CORP                                            "
  },
  {
    "type": "UIT",
    "mpid": "ISCN",
    "clearingBroker": "0235",
    "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
  },
  {
    "type": "UIT",
    "mpid": "ISIG",
    "clearingBroker": "0226",
    "brokerName": "EVERCORE GROUP L.L.C.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "ISLL",
    "clearingBroker": "0052",
    "brokerName": "INLET SECURITIES LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "ISSI",
    "clearingBroker": "0052",
    "brokerName": "INSIGHT SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "ITAU",
    "clearingBroker": "0443",
    "brokerName": "ITAU BBA USA SECURITIES INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "ITCC",
    "clearingBroker": "0750",
    "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "ITCM",
    "clearingBroker": "0443",
    "brokerName": "INTERCAM SECURITIES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "ITFS",
    "clearingBroker": "0226",
    "brokerName": "KEEL POINT CAPITAL, LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "IVEX",
    "clearingBroker": "0443",
    "brokerName": "INVEX, INC.                                                           "
  },
  {
    "type": "UIT",
    "mpid": "IVNT",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT NETWORK, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "IVOL",
    "clearingBroker": "0235",
    "brokerName": "UNION CAPITAL COMPANY                                                 "
  },
  {
    "type": "UIT",
    "mpid": "IVST",
    "clearingBroker": "0443",
    "brokerName": "INTERVEST INTERNATIONAL EQUITIES CORPORATION                          "
  },
  {
    "type": "UIT",
    "mpid": "JANY",
    "clearingBroker": "0374",
    "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "JDRB",
    "clearingBroker": "0595",
    "brokerName": "J.H. DARBIE & CO., INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "JEFF",
    "clearingBroker": "0019",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "UIT",
    "mpid": "JEFM",
    "clearingBroker": "0235",
    "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
  },
  {
    "type": "UIT",
    "mpid": "JEVO",
    "clearingBroker": "0235",
    "brokerName": "ATIS, INC                                                             "
  },
  {
    "type": "UIT",
    "mpid": "JGUN",
    "clearingBroker": "0235",
    "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "JHDR",
    "clearingBroker": "0052",
    "brokerName": "JH DARBIE & CO. INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "JJKE",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "JKFS",
    "clearingBroker": "0279",
    "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "JKRC",
    "clearingBroker": "0443",
    "brokerName": "J.K.R. & CO., INC.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "JLEQ",
    "clearingBroker": "0161",
    "brokerName": "JUMP EXECUTION, LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "JMLS",
    "clearingBroker": "0235",
    "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "JNSN",
    "clearingBroker": "0443",
    "brokerName": "D A DAVIDSON                                                          "
  },
  {
    "type": "UIT",
    "mpid": "JNST",
    "clearingBroker": "0352",
    "brokerName": "JANE STREET CAPITAL LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "JPMS",
    "clearingBroker": "0352",
    "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "JPPB",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "UIT",
    "mpid": "JQII",
    "clearingBroker": "0443",
    "brokerName": "THE GARBACZ GROUP                                                     "
  },
  {
    "type": "UIT",
    "mpid": "JRCO",
    "clearingBroker": "0226",
    "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
  },
  {
    "type": "UIT",
    "mpid": "JSAP",
    "clearingBroker": "8497",
    "brokerName": "JANE STREET CAPITAL, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "JSBA",
    "clearingBroker": "0161",
    "brokerName": "JANE STREET CAPITAL, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "JSCL",
    "clearingBroker": "0052",
    "brokerName": "JOSEPH STONE CAPITAL L.L.C.                                           "
  },
  {
    "type": "UIT",
    "mpid": "JSCT",
    "clearingBroker": "0005",
    "brokerName": "JANE STREET CAPITAL LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "JSEG",
    "clearingBroker": "0161",
    "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
  },
  {
    "type": "UIT",
    "mpid": "JSSF",
    "clearingBroker": "0226",
    "brokerName": "JMP SECURITIES LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "JVBF",
    "clearingBroker": "0235",
    "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
  },
  {
    "type": "UIT",
    "mpid": "JVBG",
    "clearingBroker": "0443",
    "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "JWCF",
    "clearingBroker": "0226",
    "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "JWML",
    "clearingBroker": "0235",
    "brokerName": "MILLEGAN (J.W.), INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "KALS",
    "clearingBroker": "0235",
    "brokerName": "KALOS CAPITAL, INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "KAPG",
    "clearingBroker": "0158",
    "brokerName": "KAPITALL GENERATION, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "KART",
    "clearingBroker": "0750",
    "brokerName": "REVERE SECURITIES CORP.                                               "
  },
  {
    "type": "UIT",
    "mpid": "KAWM",
    "clearingBroker": "0443",
    "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "KBCO",
    "clearingBroker": "0443",
    "brokerName": "KAHN BROTHERS LLC                                                     "
  },
  {
    "type": "UIT",
    "mpid": "KCAM",
    "clearingBroker": "0052",
    "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "KCIM",
    "clearingBroker": "0235",
    "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
  },
  {
    "type": "UIT",
    "mpid": "KCIX",
    "clearingBroker": "0279",
    "brokerName": "KILEY PARTNERS, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "KCRD",
    "clearingBroker": "0052",
    "brokerName": "PHX FINANCIAL, INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "KEEN",
    "clearingBroker": "0279",
    "brokerName": "ST. BERNARD FINANCIAL SERVICES, INC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "KEYB",
    "clearingBroker": "0443",
    "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "KIML",
    "clearingBroker": "0226",
    "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "KING",
    "clearingBroker": "0235",
    "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "KISL",
    "clearingBroker": "0443",
    "brokerName": "KEY INVESTMENT SERVICES LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "KMSF",
    "clearingBroker": "0443",
    "brokerName": "KMS FINANCIAL SERVICES                                                "
  },
  {
    "type": "UIT",
    "mpid": "KNGS",
    "clearingBroker": "0235",
    "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "KOVP",
    "clearingBroker": "0443",
    "brokerName": "KOVACK SECURITIES INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "KOVS",
    "clearingBroker": "0226",
    "brokerName": "KOVACK SECURITIES, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "KRCO",
    "clearingBroker": "0235",
    "brokerName": "KR SECURITIES, LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "KRSH",
    "clearingBroker": "0005",
    "brokerName": "KERSHNER SECURITIES, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "KRTH",
    "clearingBroker": "0235",
    "brokerName": "J.W. KORTH & COMPANY                                                  "
  },
  {
    "type": "UIT",
    "mpid": "LADY",
    "clearingBroker": "0443",
    "brokerName": "TRUSTFIRST, INC.                                                      "
  },
  {
    "type": "UIT",
    "mpid": "LAFB",
    "clearingBroker": "0235",
    "brokerName": "LAFFERTY (R.F.) & CO., INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "LAFC",
    "clearingBroker": "0443",
    "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "LAFF",
    "clearingBroker": "0443",
    "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "LAGI",
    "clearingBroker": "0226",
    "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "LANE",
    "clearingBroker": "0235",
    "brokerName": "MARC J. LANE & COMPANY                                                "
  },
  {
    "type": "UIT",
    "mpid": "LARC",
    "clearingBroker": "0235",
    "brokerName": "LARIMER CAPITAL CORPORATION                                           "
  },
  {
    "type": "UIT",
    "mpid": "LASI",
    "clearingBroker": "0141",
    "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "LASS",
    "clearingBroker": "0226",
    "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "LATN",
    "clearingBroker": "0443",
    "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
  },
  {
    "type": "UIT",
    "mpid": "LBKI",
    "clearingBroker": "0235",
    "brokerName": "LIBUCKI & CO., LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "LDAS",
    "clearingBroker": "0443",
    "brokerName": "LANDAAS & CO.                                                         "
  },
  {
    "type": "UIT",
    "mpid": "LDIL",
    "clearingBroker": "0226",
    "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "LDLW",
    "clearingBroker": "0750",
    "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
  },
  {
    "type": "UIT",
    "mpid": "LDOT",
    "clearingBroker": "0235",
    "brokerName": "LANDOLT SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "LEAD",
    "clearingBroker": "0226",
    "brokerName": "THE LEADERS GROUP, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "LEBO",
    "clearingBroker": "0226",
    "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "LEER",
    "clearingBroker": "0443",
    "brokerName": "LEERINK SWANN & COMPANY                                               "
  },
  {
    "type": "UIT",
    "mpid": "LENX",
    "clearingBroker": "0279",
    "brokerName": "LENOX FINANCIAL SERVICES, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "LEXI",
    "clearingBroker": "0226",
    "brokerName": "LEXINGTON INVESTMENT COMPANY, INC.                                    "
  },
  {
    "type": "UIT",
    "mpid": "LEYA",
    "clearingBroker": "0235",
    "brokerName": "LEMLEY, YARLING & CO.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "LFAC",
    "clearingBroker": "0226",
    "brokerName": "OSAIC FA, INC.                                                        "
  },
  {
    "type": "UIT",
    "mpid": "LFRO",
    "clearingBroker": "0235",
    "brokerName": "LF ROTHSCHILD, LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "LGNT",
    "clearingBroker": "0052",
    "brokerName": "AXOS CLEARING LLC                                                     "
  },
  {
    "type": "UIT",
    "mpid": "LGSA",
    "clearingBroker": "0158",
    "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
  },
  {
    "type": "UIT",
    "mpid": "LIIS",
    "clearingBroker": "0226",
    "brokerName": "USAA FINANCIAL ADVISORS, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "LINC",
    "clearingBroker": "0158",
    "brokerName": "LIBERUM                                                               "
  },
  {
    "type": "UIT",
    "mpid": "LISI",
    "clearingBroker": "0443",
    "brokerName": "LEUMI INVESTMENT SERVICES, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "LMAR",
    "clearingBroker": "0226",
    "brokerName": "LIFEMARK SECURITIES CORP.                                             "
  },
  {
    "type": "UIT",
    "mpid": "LMBD",
    "clearingBroker": "0443",
    "brokerName": "LAZARD ASSET MANAGEMENT SECURITIES LLC                                "
  },
  {
    "type": "UIT",
    "mpid": "LMKO",
    "clearingBroker": "0235",
    "brokerName": "KOHN (L.M.) & COMPANY                                                 "
  },
  {
    "type": "UIT",
    "mpid": "LMNX",
    "clearingBroker": "0226",
    "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "LNCL",
    "clearingBroker": "0443",
    "brokerName": "LINCOLN INVESTMENT                                                    "
  },
  {
    "type": "UIT",
    "mpid": "LNKS",
    "clearingBroker": "0443",
    "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "LOMB",
    "clearingBroker": "0141",
    "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
  },
  {
    "type": "UIT",
    "mpid": "LOOP",
    "clearingBroker": "0443",
    "brokerName": "LOOP CAPITAL MARKETS, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "LOUE",
    "clearingBroker": "0161",
    "brokerName": "ICAP CORPORATES LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "LOUI",
    "clearingBroker": "0005",
    "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
  },
  {
    "type": "UIT",
    "mpid": "LPFS",
    "clearingBroker": "0235",
    "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
  },
  {
    "type": "UIT",
    "mpid": "LPLE",
    "clearingBroker": "0075",
    "brokerName": "LPL ENTERPRISE, LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "LQNA",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "UIT",
    "mpid": "LQNB",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "UIT",
    "mpid": "LQNF",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "UIT",
    "mpid": "LQNT",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "UIT",
    "mpid": "LQPT",
    "clearingBroker": "0161",
    "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "LRBC",
    "clearingBroker": "0235",
    "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "LRCM",
    "clearingBroker": "0279",
    "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "LSCM",
    "clearingBroker": "0235",
    "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "LSFB",
    "clearingBroker": "0443",
    "brokerName": "LION STREET FINANCIAL, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "LSKO",
    "clearingBroker": "0226",
    "brokerName": "LESKO SECURITIES INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "LSPI",
    "clearingBroker": "0141",
    "brokerName": "LAFAYETTE INVESTMENTS                                                 "
  },
  {
    "type": "UIT",
    "mpid": "LSSI",
    "clearingBroker": "0750",
    "brokerName": "EJ STERLING INC.                                                      "
  },
  {
    "type": "UIT",
    "mpid": "LSUS",
    "clearingBroker": "0443",
    "brokerName": "LATIN SECURITIES INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "LTAA",
    "clearingBroker": "0226",
    "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "LTCO",
    "clearingBroker": "0226",
    "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "LVAR",
    "clearingBroker": "0443",
    "brokerName": "LARRAINVIAL SECURITIES US LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "LVMR",
    "clearingBroker": "0235",
    "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "LWFL",
    "clearingBroker": "0443",
    "brokerName": "LAWSON FINANCIAL CORPORATION                                          "
  },
  {
    "type": "UIT",
    "mpid": "LYSI",
    "clearingBroker": "0443",
    "brokerName": "LLOYDS SECURITIES INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "MACC",
    "clearingBroker": "0226",
    "brokerName": "NEWEDGE SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "MADV",
    "clearingBroker": "0443",
    "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "MAMA",
    "clearingBroker": "0443",
    "brokerName": "SECUREVEST FINANCIAL GROUP                                            "
  },
  {
    "type": "UIT",
    "mpid": "MAPA",
    "clearingBroker": "0279",
    "brokerName": "MADISON PAIGE SECURITIES LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "MASE",
    "clearingBroker": "0141",
    "brokerName": "MANAGED ACCOUNT SERVICES, LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "MAVS",
    "clearingBroker": "0443",
    "brokerName": "MADISON AVENUE SECURITIES                                             "
  },
  {
    "type": "UIT",
    "mpid": "MAXM",
    "clearingBroker": "0443",
    "brokerName": "MAXIM GROUP LLC                                                       "
  },
  {
    "type": "UIT",
    "mpid": "MBBS",
    "clearingBroker": "0443",
    "brokerName": "INFINEX INVESTMENTS                                                   "
  },
  {
    "type": "UIT",
    "mpid": "MBSE",
    "clearingBroker": "0052",
    "brokerName": "MBS SOURCE ETRADING, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "MBSL",
    "clearingBroker": "0443",
    "brokerName": "MBS CAPITAL MARKETS, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "MBUS",
    "clearingBroker": "0052",
    "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "MCAP",
    "clearingBroker": "1043",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "UIT",
    "mpid": "MCBT",
    "clearingBroker": "0235",
    "brokerName": "MOORS & CABOT, INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "MCCL",
    "clearingBroker": "0443",
    "brokerName": "MCCLURG CAPITAL CORPORATION                                           "
  },
  {
    "type": "UIT",
    "mpid": "MCNA",
    "clearingBroker": "0443",
    "brokerName": "MCNALLY FINANCIAL SERVICES CORPORATION                                "
  },
  {
    "type": "UIT",
    "mpid": "MDGP",
    "clearingBroker": "0235",
    "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "MEAL",
    "clearingBroker": "0226",
    "brokerName": "M. E. ALLISON & CO., INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "MERP",
    "clearingBroker": "0235",
    "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "MERQ",
    "clearingBroker": "0052",
    "brokerName": "MERCATOR ASSOCIATES LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "MESF",
    "clearingBroker": "0443",
    "brokerName": "MESIROW FINANCIAL, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "MFGX",
    "clearingBroker": "0443",
    "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "MFRS",
    "clearingBroker": "0443",
    "brokerName": "MFR SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "MHFI",
    "clearingBroker": "0226",
    "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "MHSI",
    "clearingBroker": "0443",
    "brokerName": "M HOLDINGS SECURITIES                                                 "
  },
  {
    "type": "UIT",
    "mpid": "MIAM",
    "clearingBroker": "0141",
    "brokerName": "FMSBONDS, INC.                                                        "
  },
  {
    "type": "UIT",
    "mpid": "MIBS",
    "clearingBroker": "0443",
    "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
  },
  {
    "type": "UIT",
    "mpid": "MIFI",
    "clearingBroker": "0226",
    "brokerName": "MILKIE FERGUSON INVESTMENTS, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "MILE",
    "clearingBroker": "0052",
    "brokerName": "I-BANKERS SECURITIES INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "MILN",
    "clearingBroker": "1767",
    "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "MINP",
    "clearingBroker": "0235",
    "brokerName": "MINISTRY PARTNERS SECURITIES, LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "MINV",
    "clearingBroker": "0235",
    "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "MIRA",
    "clearingBroker": "1043",
    "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "MITR",
    "clearingBroker": "0443",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "MJDW",
    "clearingBroker": "0279",
    "brokerName": "MURRAY SECURITIES                                                     "
  },
  {
    "type": "UIT",
    "mpid": "MJWH",
    "clearingBroker": "0235",
    "brokerName": "ETICO PARTNERS LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "MKRT",
    "clearingBroker": "0235",
    "brokerName": "MARKET SECURITIES, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "MKTI",
    "clearingBroker": "0226",
    "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "MKTX",
    "clearingBroker": "4265",
    "brokerName": "MARKETAXESS CORPORATION                                               "
  },
  {
    "type": "UIT",
    "mpid": "MKTY",
    "clearingBroker": "4265",
    "brokerName": "MARKETAXESS CORPORATION                                               "
  },
  {
    "type": "UIT",
    "mpid": "MLCO",
    "clearingBroker": "0161",
    "brokerName": "BOFA SECURITIES, INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "MLMS",
    "clearingBroker": "0279",
    "brokerName": "MAINLINE WEST MUNICIPAL SECURITIES, LLC                               "
  },
  {
    "type": "UIT",
    "mpid": "MLWM",
    "clearingBroker": "0671",
    "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
  },
  {
    "type": "UIT",
    "mpid": "MMCS",
    "clearingBroker": "0443",
    "brokerName": "MMC SECURITIES CORP.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "MNCC",
    "clearingBroker": "0443",
    "brokerName": "MONEY CONCEPTS CAPITAL CORP.                                          "
  },
  {
    "type": "UIT",
    "mpid": "MNCO",
    "clearingBroker": "0279",
    "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "MNRC",
    "clearingBroker": "0443",
    "brokerName": "MONARCH CAPITAL GROUP LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "MNXS",
    "clearingBroker": "0443",
    "brokerName": "MUNIAXIS LEBENTHAL LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "MOCM",
    "clearingBroker": "0235",
    "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "MOFI",
    "clearingBroker": "0158",
    "brokerName": "M1 FINANCE LLC                                                        "
  },
  {
    "type": "UIT",
    "mpid": "MOIS",
    "clearingBroker": "0443",
    "brokerName": "MUTUAL OF OMAHA INVESTOR SERVICES INC.                                "
  },
  {
    "type": "UIT",
    "mpid": "MOLO",
    "clearingBroker": "0235",
    "brokerName": "MOLONEY SECURITIES                                                    "
  },
  {
    "type": "UIT",
    "mpid": "MONE",
    "clearingBroker": "0443",
    "brokerName": "MONERE INVESTMENTS, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "MONR",
    "clearingBroker": "0226",
    "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "MONX",
    "clearingBroker": "0443",
    "brokerName": "MONEX SECURITIES INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "MORA",
    "clearingBroker": "0443",
    "brokerName": "MORA WM SECURITIES                                                    "
  },
  {
    "type": "UIT",
    "mpid": "MPLW",
    "clearingBroker": "0226",
    "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
  },
  {
    "type": "UIT",
    "mpid": "MRAD",
    "clearingBroker": "0052",
    "brokerName": "MACRO RISK ADVISORS LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "MRBA",
    "clearingBroker": "0052",
    "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "MRIS",
    "clearingBroker": "0443",
    "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
  },
  {
    "type": "UIT",
    "mpid": "MRKS",
    "clearingBroker": "0443",
    "brokerName": "M. RAMSEY KING                                                        "
  },
  {
    "type": "UIT",
    "mpid": "MRNA",
    "clearingBroker": "0161",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "MRPH",
    "clearingBroker": "0226",
    "brokerName": "WM FINANCIAL SERVICES, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "MRSC",
    "clearingBroker": "0287",
    "brokerName": "TRADEUP SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "MSCB",
    "clearingBroker": "0279",
    "brokerName": "MAINE SECURITIES CORPORATION                                          "
  },
  {
    "type": "UIT",
    "mpid": "MSEC",
    "clearingBroker": "0235",
    "brokerName": "MSEC, LLC                                                             "
  },
  {
    "type": "UIT",
    "mpid": "MSII",
    "clearingBroker": "0226",
    "brokerName": "MSI FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "MSRO",
    "clearingBroker": "0226",
    "brokerName": "MESIROW FINANCIAL, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "MSTC",
    "clearingBroker": "0226",
    "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
  },
  {
    "type": "UIT",
    "mpid": "MTBK",
    "clearingBroker": "0443",
    "brokerName": "MULTI-BANK SECURITIES, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "MTDB",
    "clearingBroker": "0443",
    "brokerName": "M&T SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "MTGO",
    "clearingBroker": "0158",
    "brokerName": "MTG, LLC                                                              "
  },
  {
    "type": "UIT",
    "mpid": "MTHN",
    "clearingBroker": "0005",
    "brokerName": "MARATHON TRADING GROUP LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "MTLE",
    "clearingBroker": "0235",
    "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "MTSL",
    "clearingBroker": "0226",
    "brokerName": "MSEC, LLC                                                             "
  },
  {
    "type": "UIT",
    "mpid": "MUFG",
    "clearingBroker": "0076",
    "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "MULT",
    "clearingBroker": "0443",
    "brokerName": "MULTI-FINANCIAL SECURITIES GROUP                                      "
  },
  {
    "type": "UIT",
    "mpid": "MURJ",
    "clearingBroker": "0750",
    "brokerName": "COMMERCE ONE FINANCIAL INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "MWAF",
    "clearingBroker": "0443",
    "brokerName": "MWA FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "MWCC",
    "clearingBroker": "0235",
    "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "MWIL",
    "clearingBroker": "0235",
    "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "MWMS",
    "clearingBroker": "0443",
    "brokerName": "MUREX CAPITAL LLC                                                     "
  },
  {
    "type": "UIT",
    "mpid": "MZHO",
    "clearingBroker": "2396",
    "brokerName": "MIZUHO SECURITIES USA LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "NACM",
    "clearingBroker": "0161",
    "brokerName": "NABSECURITIES, LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "NADL",
    "clearingBroker": "0235",
    "brokerName": "WARREN D. NADEL & COMPANY                                             "
  },
  {
    "type": "UIT",
    "mpid": "NAPK",
    "clearingBroker": "0052",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "UIT",
    "mpid": "NASC",
    "clearingBroker": "0235",
    "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "NAVC",
    "clearingBroker": "0235",
    "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "NBAR",
    "clearingBroker": "0226",
    "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "NBCS",
    "clearingBroker": "0235",
    "brokerName": "NBC SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "NBLB",
    "clearingBroker": "0226",
    "brokerName": "NEUBERGER BERMAN BD LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "NBSL",
    "clearingBroker": "0226",
    "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
  },
  {
    "type": "UIT",
    "mpid": "NEED",
    "clearingBroker": "0443",
    "brokerName": "NEEDHAM & COMPANY, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "NEPP",
    "clearingBroker": "0226",
    "brokerName": "N.E. PRIVATE CLIENT ADVISORS, LTD.                                    "
  },
  {
    "type": "UIT",
    "mpid": "NEST",
    "clearingBroker": "0235",
    "brokerName": "NEST INVESTMENTS BD LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "NEXT",
    "clearingBroker": "0443",
    "brokerName": "NEXT FINANCIAL GROUP, INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "NFGR",
    "clearingBroker": "0141",
    "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "NFSC",
    "clearingBroker": "0226",
    "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "NFTY",
    "clearingBroker": "0235",
    "brokerName": "INFINITY FINANCIAL SERVICES                                           "
  },
  {
    "type": "UIT",
    "mpid": "NHFS",
    "clearingBroker": "0443",
    "brokerName": "ALIGHT FINANCIAL SOLUTIONS, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "NHWI",
    "clearingBroker": "0141",
    "brokerName": "HENNION & WALSH, INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "NIAD",
    "clearingBroker": "0052",
    "brokerName": "NI ADVISORS                                                           "
  },
  {
    "type": "UIT",
    "mpid": "NITE",
    "clearingBroker": "0295",
    "brokerName": "VIRTU AMERICAS LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "NLOV",
    "clearingBroker": "0279",
    "brokerName": "NORTLOV SECURITIES LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "NOBL",
    "clearingBroker": "0750",
    "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
  },
  {
    "type": "UIT",
    "mpid": "NORC",
    "clearingBroker": "0235",
    "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
  },
  {
    "type": "UIT",
    "mpid": "NORP",
    "clearingBroker": "0443",
    "brokerName": "PARETO SECURITIES INC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "NORT",
    "clearingBroker": "0443",
    "brokerName": "NORTHLAND SECURITIES, INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "NOSO",
    "clearingBroker": "0443",
    "brokerName": "NORTH SOUTH CAPITAL LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "NPAI",
    "clearingBroker": "0443",
    "brokerName": "NATIONWIDE PLANNING ASSOCIATES                                        "
  },
  {
    "type": "UIT",
    "mpid": "NPBF",
    "clearingBroker": "0443",
    "brokerName": "NPB FINANCIAL GROUP, LLC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "NPNT",
    "clearingBroker": "0005",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "NPTP",
    "clearingBroker": "0443",
    "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "NRAM",
    "clearingBroker": "0443",
    "brokerName": "CANACCORD WEALTH MANAGEMENT (USA) INC.                                "
  },
  {
    "type": "UIT",
    "mpid": "NSFP",
    "clearingBroker": "0235",
    "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
  },
  {
    "type": "UIT",
    "mpid": "NSRD",
    "clearingBroker": "0235",
    "brokerName": "NESTLERODE & CO., INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "NTFN",
    "clearingBroker": "0052",
    "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
  },
  {
    "type": "UIT",
    "mpid": "NTRC",
    "clearingBroker": "0226",
    "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "NTSI",
    "clearingBroker": "0443",
    "brokerName": "NESBITT THOMSON SECURITIES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "NVEN",
    "clearingBroker": "0448",
    "brokerName": "NUVEEN SECURITIES, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "NWCM",
    "clearingBroker": "0235",
    "brokerName": "NW CAPITAL MARKETS INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "NWIA",
    "clearingBroker": "0750",
    "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
  },
  {
    "type": "UIT",
    "mpid": "NWML",
    "clearingBroker": "0443",
    "brokerName": "NORTHWESTERN MUTUAL INVESTMENT SERVICES, LLC                          "
  },
  {
    "type": "UIT",
    "mpid": "NYLS",
    "clearingBroker": "0226",
    "brokerName": "NYLIFE SECURITIES INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "OAKR",
    "clearingBroker": "0235",
    "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
  },
  {
    "type": "UIT",
    "mpid": "OBWS",
    "clearingBroker": "0226",
    "brokerName": "OBERWEIS SECURITIES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "OCAC",
    "clearingBroker": "0235",
    "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "OCEA",
    "clearingBroker": "0052",
    "brokerName": "OCEAN FINANCIAL SERVICES, LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "OCON",
    "clearingBroker": "0103",
    "brokerName": "O'CONNOR & CO SECURITIES                                              "
  },
  {
    "type": "UIT",
    "mpid": "ODEO",
    "clearingBroker": "0388",
    "brokerName": "ODEON CAP                                                             "
  },
  {
    "type": "UIT",
    "mpid": "ODNC",
    "clearingBroker": "0235",
    "brokerName": "ODEON CAPITAL GROUP LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "OFGF",
    "clearingBroker": "0235",
    "brokerName": "OFG FINANCIAL SERVICES INC                                            "
  },
  {
    "type": "UIT",
    "mpid": "OLNE",
    "clearingBroker": "0279",
    "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "OMSL",
    "clearingBroker": "0158",
    "brokerName": "OM SECURITIES, LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "ONES",
    "clearingBroker": "0443",
    "brokerName": "O N EQUITY SALES CO.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "OPCO",
    "clearingBroker": "0571",
    "brokerName": "OPPENHEIMER & CO. INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "ORTL",
    "clearingBroker": "0443",
    "brokerName": "ORIENTAL FINANCIAL SERVICES                                           "
  },
  {
    "type": "UIT",
    "mpid": "OTCN",
    "clearingBroker": "0158",
    "brokerName": "OTC LINK LLC                                                          "
  },
  {
    "type": "UIT",
    "mpid": "OYLD",
    "clearingBroker": "0235",
    "brokerName": "OPENYIELD TRADING LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "PACK",
    "clearingBroker": "0279",
    "brokerName": "PACKERLAND BROKERAGE SERVICES                                         "
  },
  {
    "type": "UIT",
    "mpid": "PACT",
    "clearingBroker": "0443",
    "brokerName": "BTG PACTUAL US CAPITAL LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "PAMC",
    "clearingBroker": "0226",
    "brokerName": "PROGRESSIVE ASSET MANAGEMENT                                          "
  },
  {
    "type": "UIT",
    "mpid": "PAPA",
    "clearingBroker": "0443",
    "brokerName": "PAPAMARKOU WELLNER & CO., INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "PARI",
    "clearingBroker": "0630",
    "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
  },
  {
    "type": "UIT",
    "mpid": "PASC",
    "clearingBroker": "0443",
    "brokerName": "PARK AVENUE SECURITIES LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "PASL",
    "clearingBroker": "0443",
    "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "PATR",
    "clearingBroker": "0624",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "PAUL",
    "clearingBroker": "0595",
    "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "PBON",
    "clearingBroker": "0161",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "PCCA",
    "clearingBroker": "0279",
    "brokerName": "PEACHCAP SECURITIES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "PCIS",
    "clearingBroker": "0226",
    "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "PCSB",
    "clearingBroker": "0443",
    "brokerName": "PRIVATE CLIENT SERVICES, LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "PENG",
    "clearingBroker": "0443",
    "brokerName": "PENNSYLVANIA GROUP INCORPORATED (THE)                                 "
  },
  {
    "type": "UIT",
    "mpid": "PERC",
    "clearingBroker": "0279",
    "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
  },
  {
    "type": "UIT",
    "mpid": "PERS",
    "clearingBroker": "0443",
    "brokerName": "PERSHING LLC                                                          "
  },
  {
    "type": "UIT",
    "mpid": "PFCG",
    "clearingBroker": "0279",
    "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "PFDC",
    "clearingBroker": "0235",
    "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "PHBP",
    "clearingBroker": "0052",
    "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "PHIN",
    "clearingBroker": "0443",
    "brokerName": "PHILADELPHIA INVESTORS, LTD.                                          "
  },
  {
    "type": "UIT",
    "mpid": "PICE",
    "clearingBroker": "0443",
    "brokerName": "T ROWE PRICE INVESTMENT SERV                                          "
  },
  {
    "type": "UIT",
    "mpid": "PICI",
    "clearingBroker": "0279",
    "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "PICL",
    "clearingBroker": "0052",
    "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "PIMS",
    "clearingBroker": "0226",
    "brokerName": "PRUDENTIAL INVESTMENT MANAGEMENT SERVICES, LLC                        "
  },
  {
    "type": "UIT",
    "mpid": "PINA",
    "clearingBroker": "0141",
    "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "PIPR",
    "clearingBroker": "0443",
    "brokerName": "PIPER SANDLER & CO.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "PIRR",
    "clearingBroker": "0443",
    "brokerName": "PIRRONE & CO., INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "PISC",
    "clearingBroker": "0750",
    "brokerName": "PACIFIC INVESTMENT SECURITIES CORP.                                   "
  },
  {
    "type": "UIT",
    "mpid": "PJEF",
    "clearingBroker": "0443",
    "brokerName": "JEFFERIES LLC                                                         "
  },
  {
    "type": "UIT",
    "mpid": "PKAX",
    "clearingBroker": "0158",
    "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "PLAT",
    "clearingBroker": "0443",
    "brokerName": "CLARKSONS PLATOU SECURITIES, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "PMAS",
    "clearingBroker": "0443",
    "brokerName": "PMA SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "PNCC",
    "clearingBroker": "0226",
    "brokerName": "PNC INVESTMENTS                                                       "
  },
  {
    "type": "UIT",
    "mpid": "PNCM",
    "clearingBroker": "2835",
    "brokerName": "PNC CAPITAL MARKETS LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "PNFP",
    "clearingBroker": "0279",
    "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "PNSA",
    "clearingBroker": "0235",
    "brokerName": "PENSERRA SECURITIES, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "PODE",
    "clearingBroker": "0235",
    "brokerName": "PODESTA & CO.                                                         "
  },
  {
    "type": "UIT",
    "mpid": "POOH",
    "clearingBroker": "0443",
    "brokerName": "QUESTAR CAPITAL CORPORATION                                           "
  },
  {
    "type": "UIT",
    "mpid": "POPS",
    "clearingBroker": "0226",
    "brokerName": "POPULAR SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "POWL",
    "clearingBroker": "0443",
    "brokerName": "POWELL (ELMER E.) COMPANY                                             "
  },
  {
    "type": "UIT",
    "mpid": "PPSI",
    "clearingBroker": "0235",
    "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "PPSL",
    "clearingBroker": "0413",
    "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "PREB",
    "clearingBroker": "0005",
    "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "PRFA",
    "clearingBroker": "0235",
    "brokerName": "PROOF SERVICES LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "PRGI",
    "clearingBroker": "0443",
    "brokerName": "PORTFOLIO RESOURCES GROUP, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "PROE",
    "clearingBroker": "0443",
    "brokerName": "PROEQUITIES, INC.                                                     "
  },
  {
    "type": "UIT",
    "mpid": "PRPO",
    "clearingBroker": "0443",
    "brokerName": "PRIVATE PORTFOLIO, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "PRSB",
    "clearingBroker": "0141",
    "brokerName": "PRESIDENTIAL BROKERAGE, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "PSII",
    "clearingBroker": "0226",
    "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "PSIM",
    "clearingBroker": "0226",
    "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "PSIN",
    "clearingBroker": "0443",
    "brokerName": "LUMENT SECURITIES, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "PSUT",
    "clearingBroker": "0235",
    "brokerName": "INNOVATION PARTNERS LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "PTCM",
    "clearingBroker": "0443",
    "brokerName": "CAVU SECURITIES LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "PTIS",
    "clearingBroker": "0235",
    "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
  },
  {
    "type": "UIT",
    "mpid": "PUPL",
    "clearingBroker": "0226",
    "brokerName": "PUPLAVA SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "PWAS",
    "clearingBroker": "0443",
    "brokerName": "PWA SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "PWJC",
    "clearingBroker": "0221",
    "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "QBND",
    "clearingBroker": "0161",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "UIT",
    "mpid": "QBSI",
    "clearingBroker": "0226",
    "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "QCAP",
    "clearingBroker": "0235",
    "brokerName": "QUINT CAPITAL CORPORATION                                             "
  },
  {
    "type": "UIT",
    "mpid": "QCAS",
    "clearingBroker": "0226",
    "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
  },
  {
    "type": "UIT",
    "mpid": "QMSR",
    "clearingBroker": "0235",
    "brokerName": "QUATTRO M SECURITIES INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "QWIK",
    "clearingBroker": "0161",
    "brokerName": "MCAP LLC                                                              "
  },
  {
    "type": "UIT",
    "mpid": "RAAA",
    "clearingBroker": "0052",
    "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "RAAI",
    "clearingBroker": "0226",
    "brokerName": "OSAIC WEALTH, INC.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "RABO",
    "clearingBroker": "0443",
    "brokerName": "RABO SECURITIES USA, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "RACO",
    "clearingBroker": "0158",
    "brokerName": "SHEARMAN, RALSTON, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "RAJA",
    "clearingBroker": "0725",
    "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "RAJC",
    "clearingBroker": "0443",
    "brokerName": "RAYMOND JAMES USA                                                     "
  },
  {
    "type": "UIT",
    "mpid": "RAYG",
    "clearingBroker": "0443",
    "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
  },
  {
    "type": "UIT",
    "mpid": "RBAC",
    "clearingBroker": "0443",
    "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "RBCD",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
  },
  {
    "type": "UIT",
    "mpid": "RBCM",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
  },
  {
    "type": "UIT",
    "mpid": "RBCX",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
  },
  {
    "type": "UIT",
    "mpid": "RBII",
    "clearingBroker": "0279",
    "brokerName": "REGIONAL BROKERS, INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "RCMA",
    "clearingBroker": "0235",
    "brokerName": "RBC CAPITAL MARKETS ARBITRAGE, S.A.                                   "
  },
  {
    "type": "UIT",
    "mpid": "RCRS",
    "clearingBroker": "0226",
    "brokerName": "ROOSEVELT & CROSS, INCORPORATED                                       "
  },
  {
    "type": "UIT",
    "mpid": "RDSS",
    "clearingBroker": "0141",
    "brokerName": "RDSC, LLC                                                             "
  },
  {
    "type": "UIT",
    "mpid": "REGR",
    "clearingBroker": "0141",
    "brokerName": "REGISTER & AKERS INVESTMENTS, INC.                                    "
  },
  {
    "type": "UIT",
    "mpid": "RGLD",
    "clearingBroker": "0279",
    "brokerName": "REGAL SECURITIES, INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "RGLS",
    "clearingBroker": "0235",
    "brokerName": "REGAL SECURITIES, INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "RHDS",
    "clearingBroker": "0141",
    "brokerName": "RHODES SECURITIES, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "RHOX",
    "clearingBroker": "0005",
    "brokerName": "XR SECURITIES LLC                                                     "
  },
  {
    "type": "UIT",
    "mpid": "RIAP",
    "clearingBroker": "0443",
    "brokerName": "OSAIC SERVICES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "RICE",
    "clearingBroker": "0235",
    "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
  },
  {
    "type": "UIT",
    "mpid": "RICJ",
    "clearingBroker": "0235",
    "brokerName": "RICE SECURITIES, LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "RICM",
    "clearingBroker": "0595",
    "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
  },
  {
    "type": "UIT",
    "mpid": "RIED",
    "clearingBroker": "0235",
    "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
  },
  {
    "type": "UIT",
    "mpid": "RILY",
    "clearingBroker": "0226",
    "brokerName": "B. RILEY FBR, INC.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "RJFI",
    "clearingBroker": "0390",
    "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "RKWS",
    "clearingBroker": "0235",
    "brokerName": "ROCKWELL SECURITIES LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "RLIN",
    "clearingBroker": "0005",
    "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "RMAC",
    "clearingBroker": "0235",
    "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "RMPI",
    "clearingBroker": "0141",
    "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
  },
  {
    "type": "UIT",
    "mpid": "RMST",
    "clearingBroker": "0443",
    "brokerName": "R.M. STARK & CO., INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "ROAR",
    "clearingBroker": "0103",
    "brokerName": "DINOSAUR SECURITIES                                                   "
  },
  {
    "type": "UIT",
    "mpid": "ROBT",
    "clearingBroker": "0443",
    "brokerName": "ROBOTTI & COMPANY, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "ROCK",
    "clearingBroker": "0226",
    "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "ROCM",
    "clearingBroker": "0443",
    "brokerName": "RIM SECURITIES LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "ROMO",
    "clearingBroker": "0141",
    "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
  },
  {
    "type": "UIT",
    "mpid": "RONI",
    "clearingBroker": "0005",
    "brokerName": "RONIN CAPITAL, LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "ROTB",
    "clearingBroker": "0235",
    "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "ROYL",
    "clearingBroker": "0443",
    "brokerName": "ROYAL ALLIANCE ASSOCIATES, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "RPTR",
    "clearingBroker": "0235",
    "brokerName": "DINOSAUR SECURITIES, L.L.C.                                           "
  },
  {
    "type": "UIT",
    "mpid": "RQDR",
    "clearingBroker": "0235",
    "brokerName": "RQD* CLEARING LLC                                                     "
  },
  {
    "type": "UIT",
    "mpid": "RREZ",
    "clearingBroker": "0443",
    "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "RRUD",
    "clearingBroker": "0235",
    "brokerName": "REID & RUDIGER, LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "RSCM",
    "clearingBroker": "0235",
    "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
  },
  {
    "type": "UIT",
    "mpid": "RSSE",
    "clearingBroker": "0443",
    "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
  },
  {
    "type": "UIT",
    "mpid": "RTHS",
    "clearingBroker": "0443",
    "brokerName": "ROTHSCHILD INVESTMENT CORPORATION                                     "
  },
  {
    "type": "UIT",
    "mpid": "RWPC",
    "clearingBroker": "0443",
    "brokerName": "R.W. PRESSPRICH & CO.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "RWSM",
    "clearingBroker": "0279",
    "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "RYDS",
    "clearingBroker": "0235",
    "brokerName": "RBC DOMINION SECURITIES CORPORATION                                   "
  },
  {
    "type": "UIT",
    "mpid": "SABS",
    "clearingBroker": "0443",
    "brokerName": "SABADELL SECURITIES USA, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "SAFX",
    "clearingBroker": "0235",
    "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "SAGE",
    "clearingBroker": "0141",
    "brokerName": "SAGE, RUTTY & CO., INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "SALI",
    "clearingBroker": "0750",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "SAMI",
    "clearingBroker": "0226",
    "brokerName": "SAMI BROKERAGE LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "SANT",
    "clearingBroker": "0443",
    "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "SAPA",
    "clearingBroker": "0141",
    "brokerName": "SAPERSTON ASSET MANAGEMENT INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "SARG",
    "clearingBroker": "0226",
    "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
  },
  {
    "type": "UIT",
    "mpid": "SAXO",
    "clearingBroker": "0443",
    "brokerName": "SAXONY SECURITIES                                                     "
  },
  {
    "type": "UIT",
    "mpid": "SBAM",
    "clearingBroker": "0443",
    "brokerName": "INVESTMENT PROFESSIONALS, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "SBLS",
    "clearingBroker": "0235",
    "brokerName": "SAN BLAS SECURITIES LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "SBLT",
    "clearingBroker": "0226",
    "brokerName": "SUNBELT SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "SBRO",
    "clearingBroker": "0443",
    "brokerName": "STERN BROTHERS & CO.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "SBRT",
    "clearingBroker": "0226",
    "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "SBRX",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "SBSC",
    "clearingBroker": "0226",
    "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
  },
  {
    "type": "UIT",
    "mpid": "SCAP",
    "clearingBroker": "0595",
    "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "SCIL",
    "clearingBroker": "0052",
    "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
  },
  {
    "type": "UIT",
    "mpid": "SCSS",
    "clearingBroker": "0750",
    "brokerName": "STONECASTLE SECURITIES, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "SCTI",
    "clearingBroker": "0443",
    "brokerName": "SECURITY CAPITAL BROKERAGE, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "SCTL",
    "clearingBroker": "0443",
    "brokerName": "SENTINEL SECURITIES, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "SDDC",
    "clearingBroker": "0443",
    "brokerName": "SDDCO BROKERAGE AQDVISORS                                             "
  },
  {
    "type": "UIT",
    "mpid": "SDIC",
    "clearingBroker": "0235",
    "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
  },
  {
    "type": "UIT",
    "mpid": "SEAP",
    "clearingBroker": "0226",
    "brokerName": "SEAPORT SECURITIES CORP.                                              "
  },
  {
    "type": "UIT",
    "mpid": "SEBS",
    "clearingBroker": "0443",
    "brokerName": "SECU BROKERAGE SERVICES                                               "
  },
  {
    "type": "UIT",
    "mpid": "SEEL",
    "clearingBroker": "0443",
    "brokerName": "R. SEELAUS & CO., INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "SEFB",
    "clearingBroker": "0052",
    "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "SEIB",
    "clearingBroker": "0158",
    "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "SEIC",
    "clearingBroker": "0443",
    "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
  },
  {
    "type": "UIT",
    "mpid": "SEMI",
    "clearingBroker": "0443",
    "brokerName": "SEMINARIO SECURITIES                                                  "
  },
  {
    "type": "UIT",
    "mpid": "SEND",
    "clearingBroker": "0443",
    "brokerName": "SENDERO SECURITIES                                                    "
  },
  {
    "type": "UIT",
    "mpid": "SERL",
    "clearingBroker": "0443",
    "brokerName": "SEARLE & CO.                                                          "
  },
  {
    "type": "UIT",
    "mpid": "SEVN",
    "clearingBroker": "0443",
    "brokerName": "NATIONWIDE SECURITIES                                                 "
  },
  {
    "type": "UIT",
    "mpid": "SFPS",
    "clearingBroker": "0443",
    "brokerName": "SF INVESTMENTS, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "SFSI",
    "clearingBroker": "0235",
    "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "SGAS",
    "clearingBroker": "0286",
    "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "SGBI",
    "clearingBroker": "0226",
    "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "SGFC",
    "clearingBroker": "0226",
    "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
  },
  {
    "type": "UIT",
    "mpid": "SGLC",
    "clearingBroker": "0235",
    "brokerName": "S.G. LONG & COMPANY                                                   "
  },
  {
    "type": "UIT",
    "mpid": "SGNL",
    "clearingBroker": "0279",
    "brokerName": "SIGNAL SECURITIES, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "SGSM",
    "clearingBroker": "1043",
    "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "SHMR",
    "clearingBroker": "0443",
    "brokerName": "ABN AMRO CLEARING USA LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "SHOT",
    "clearingBroker": "0005",
    "brokerName": "SCHOTTENFELD GROUP LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "SIAN",
    "clearingBroker": "0443",
    "brokerName": "SECURIAN FINANCIAL SERVICES                                           "
  },
  {
    "type": "UIT",
    "mpid": "SJGM",
    "clearingBroker": "0443",
    "brokerName": "SCOTT JAMES GROUP, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "SKTR",
    "clearingBroker": "0279",
    "brokerName": "STOCK TRADERS                                                         "
  },
  {
    "type": "UIT",
    "mpid": "SLRD",
    "clearingBroker": "0226",
    "brokerName": "S.L. REED & COMPANY                                                   "
  },
  {
    "type": "UIT",
    "mpid": "SMCO",
    "clearingBroker": "0235",
    "brokerName": "SMITH, MOORE & CO.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "SMHI",
    "clearingBroker": "0443",
    "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "SMNS",
    "clearingBroker": "0226",
    "brokerName": "PARKLAND SECURITIES, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "SMPR",
    "clearingBroker": "0443",
    "brokerName": "SUMMIT BROKERAGE SERVICES, INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "SMRD",
    "clearingBroker": "0443",
    "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "SMRI",
    "clearingBroker": "0226",
    "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
  },
  {
    "type": "UIT",
    "mpid": "SNEX",
    "clearingBroker": "0750",
    "brokerName": "STONEX FINANCIAL INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "SNWS",
    "clearingBroker": "0443",
    "brokerName": "SNOWDEN ACCOUNT SERVICES, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "SOCO",
    "clearingBroker": "0443",
    "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "SOFI",
    "clearingBroker": "0158",
    "brokerName": "SOFI SECURITIES LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "SOGO",
    "clearingBroker": "0158",
    "brokerName": "WANG INVESTMENT ASSOCIATES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "SORS",
    "clearingBroker": "0235",
    "brokerName": "SORSBY FINANCIAL CORP.                                                "
  },
  {
    "type": "UIT",
    "mpid": "SOVG",
    "clearingBroker": "8199",
    "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "SPCS",
    "clearingBroker": "0052",
    "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "SPEX",
    "clearingBroker": "0235",
    "brokerName": "INSPEREX LLC                                                          "
  },
  {
    "type": "UIT",
    "mpid": "SPGS",
    "clearingBroker": "0443",
    "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "SPHN",
    "clearingBroker": "0443",
    "brokerName": "STEPHENS INC.                                                         "
  },
  {
    "type": "UIT",
    "mpid": "SPLC",
    "clearingBroker": "0226",
    "brokerName": "SPIRE SECURITIES, LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "SPLD",
    "clearingBroker": "0443",
    "brokerName": "SPIRE SECURITIES, LLC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "SPLN",
    "clearingBroker": "8199",
    "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "SPOT",
    "clearingBroker": "0005",
    "brokerName": "SPOT TRADING                                                          "
  },
  {
    "type": "UIT",
    "mpid": "SPTD",
    "clearingBroker": "0052",
    "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "SPTS",
    "clearingBroker": "0158",
    "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "SRAM",
    "clearingBroker": "0443",
    "brokerName": "SAMCO CAPITAL MARKETS, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "SRBC",
    "clearingBroker": "0235",
    "brokerName": "SPIDERROCK EXS, LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "SSBS",
    "clearingBroker": "0443",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "SSCO",
    "clearingBroker": "8457",
    "brokerName": "SAFRA SECURITIES LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "SSGC",
    "clearingBroker": "0226",
    "brokerName": "SIGNATURE SECURITIES                                                  "
  },
  {
    "type": "UIT",
    "mpid": "SSGM",
    "clearingBroker": "0226",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "SSGR",
    "clearingBroker": "0443",
    "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "SSIN",
    "clearingBroker": "0226",
    "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "SSLL",
    "clearingBroker": "0189",
    "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "SSNE",
    "clearingBroker": "0226",
    "brokerName": "SANTANDER SECURITIES LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "SSNG",
    "clearingBroker": "0443",
    "brokerName": "SISUNG SECURITIES CORPORATION                                         "
  },
  {
    "type": "UIT",
    "mpid": "STCM",
    "clearingBroker": "2095",
    "brokerName": "TRUIST SECURITIES, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "STEP",
    "clearingBroker": "0235",
    "brokerName": "FERRETTI GROUP, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "STFC",
    "clearingBroker": "0443",
    "brokerName": "STUART FRANKEL & CO., INCORPORATED                                    "
  },
  {
    "type": "UIT",
    "mpid": "STFG",
    "clearingBroker": "0443",
    "brokerName": "STANFORD GROUP COMPANY                                                "
  },
  {
    "type": "UIT",
    "mpid": "STFL",
    "clearingBroker": "0793",
    "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
  },
  {
    "type": "UIT",
    "mpid": "STGC",
    "clearingBroker": "0279",
    "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
  },
  {
    "type": "UIT",
    "mpid": "STKP",
    "clearingBroker": "0158",
    "brokerName": "STOCKPILE INVESTMENTS, INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "STND",
    "clearingBroker": "0279",
    "brokerName": "FIRST STANDARD FINANCIAL COMPANY LLC                                  "
  },
  {
    "type": "UIT",
    "mpid": "STOX",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "STRM",
    "clearingBroker": "0005",
    "brokerName": "LIQUIDNET, INC.                                                       "
  },
  {
    "type": "UIT",
    "mpid": "STSM",
    "clearingBroker": "0443",
    "brokerName": "STERLING SMITH CORPORATION                                            "
  },
  {
    "type": "UIT",
    "mpid": "STTT",
    "clearingBroker": "0052",
    "brokerName": "STATETRUST INVESTMENTS INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "STUR",
    "clearingBroker": "0158",
    "brokerName": "STURDIVANT & CO., INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "STXG",
    "clearingBroker": "0445",
    "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "STXW",
    "clearingBroker": "0443",
    "brokerName": "SA STONE WEALTH MANAGEMENT INC.                                       "
  },
  {
    "type": "UIT",
    "mpid": "SUMI",
    "clearingBroker": "0443",
    "brokerName": "SMBC NIKKO SECURITIES AMERICA, INC.                                   "
  },
  {
    "type": "UIT",
    "mpid": "SUST",
    "clearingBroker": "0235",
    "brokerName": "SUNSTREET SECURITIES, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "SWBC",
    "clearingBroker": "0443",
    "brokerName": "SWBC INVESTMENT SERVICES, LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "SWSS",
    "clearingBroker": "0443",
    "brokerName": "SANCTUARY SECURITIES, INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "SWST",
    "clearingBroker": "0279",
    "brokerName": "HILLTOP SECURITIES INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "SYCA",
    "clearingBroker": "0443",
    "brokerName": "SYNDICATED CAPITAL, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "TAFI",
    "clearingBroker": "0443",
    "brokerName": "NATHAN HALE CAPITAL, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "TAGB",
    "clearingBroker": "0052",
    "brokerName": "TAGLICH BROTHERS, INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "TAGC",
    "clearingBroker": "1043",
    "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "TAGD",
    "clearingBroker": "1043",
    "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "TBCL",
    "clearingBroker": "0750",
    "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "TBCR",
    "clearingBroker": "0235",
    "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "TBIA",
    "clearingBroker": "0158",
    "brokerName": "TRADIER BROKERAGE, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "TBIS",
    "clearingBroker": "0158",
    "brokerName": "TRADIER BROKERAGE, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "TBRD",
    "clearingBroker": "0226",
    "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
  },
  {
    "type": "UIT",
    "mpid": "TCBI",
    "clearingBroker": "0443",
    "brokerName": "TCBI SECURITIES, INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "TDCO",
    "clearingBroker": "0235",
    "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "TDFS",
    "clearingBroker": "0052",
    "brokerName": "TRADERFIELD SECURITIES INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "TDNF",
    "clearingBroker": "2568",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "TDPA",
    "clearingBroker": "0226",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "TDPW",
    "clearingBroker": "0443",
    "brokerName": "TD PRIVATE CLIENT WEALTH, LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "TDSI",
    "clearingBroker": "2568",
    "brokerName": "TD SECURITIES (USA) LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "TERA",
    "clearingBroker": "0443",
    "brokerName": "CETERA FINANCIAL SPECIALISTS                                          "
  },
  {
    "type": "UIT",
    "mpid": "TFAI",
    "clearingBroker": "0226",
    "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
  },
  {
    "type": "UIT",
    "mpid": "TFAS",
    "clearingBroker": "0443",
    "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
  },
  {
    "type": "UIT",
    "mpid": "TFSL",
    "clearingBroker": "0235",
    "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
  },
  {
    "type": "UIT",
    "mpid": "TFSS",
    "clearingBroker": "0443",
    "brokerName": "TFS SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "TGHS",
    "clearingBroker": "0443",
    "brokerName": "TGH SECURITIES, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "THEM",
    "clearingBroker": "0235",
    "brokerName": "THEMIS TRADING LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "THNK",
    "clearingBroker": "0052",
    "brokerName": "THINKEQUITY, LLC                                                      "
  },
  {
    "type": "UIT",
    "mpid": "TIAN",
    "clearingBroker": "0226",
    "brokerName": "TRIAD SECURITIES CORP                                                 "
  },
  {
    "type": "UIT",
    "mpid": "TIGC",
    "clearingBroker": "0235",
    "brokerName": "NELSONREID, INC.                                                      "
  },
  {
    "type": "UIT",
    "mpid": "TKGA",
    "clearingBroker": "0226",
    "brokerName": "KELT (THE) GROUP, LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "TKNG",
    "clearingBroker": "0158",
    "brokerName": "TRADEKING LLC                                                         "
  },
  {
    "type": "UIT",
    "mpid": "TMAS",
    "clearingBroker": "0235",
    "brokerName": "TRADEMAS INC.                                                         "
  },
  {
    "type": "UIT",
    "mpid": "TMCC",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "UIT",
    "mpid": "TMCD",
    "clearingBroker": "0235",
    "brokerName": "MCDONALD PARTNERS LLC                                                 "
  },
  {
    "type": "UIT",
    "mpid": "TOCQ",
    "clearingBroker": "0443",
    "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
  },
  {
    "type": "UIT",
    "mpid": "TOUR",
    "clearingBroker": "0005",
    "brokerName": "TOURMALINE PARTNERS, LLC                                              "
  },
  {
    "type": "UIT",
    "mpid": "TOYS",
    "clearingBroker": "0443",
    "brokerName": "TOYOTA FINANCIAL SERVICES SECURITIES USA CORPORATION                  "
  },
  {
    "type": "UIT",
    "mpid": "TPIS",
    "clearingBroker": "0161",
    "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
  },
  {
    "type": "UIT",
    "mpid": "TPMR",
    "clearingBroker": "0141",
    "brokerName": "TRADE-PMR INC.                                                        "
  },
  {
    "type": "UIT",
    "mpid": "TRAD",
    "clearingBroker": "0271",
    "brokerName": "TRADESTATION SECURITIES, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "TRCG",
    "clearingBroker": "0005",
    "brokerName": "TRC MARKETS LLC                                                       "
  },
  {
    "type": "UIT",
    "mpid": "TRCS",
    "clearingBroker": "0388",
    "brokerName": "TIGERRISK CAPITAL MARKETS & ADVISORY                                  "
  },
  {
    "type": "UIT",
    "mpid": "TREX",
    "clearingBroker": "1043",
    "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
  },
  {
    "type": "UIT",
    "mpid": "TRIB",
    "clearingBroker": "0235",
    "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "TRIP",
    "clearingBroker": "0235",
    "brokerName": "TRIDENT PARTNERS LTD                                                  "
  },
  {
    "type": "UIT",
    "mpid": "TRSH",
    "clearingBroker": "0279",
    "brokerName": "THRASHER & CHAMBERS, INC.                                             "
  },
  {
    "type": "UIT",
    "mpid": "TRUB",
    "clearingBroker": "0141",
    "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "TRWN",
    "clearingBroker": "0443",
    "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "TRYC",
    "clearingBroker": "0158",
    "brokerName": "SIXTEEN SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "TRYN",
    "clearingBroker": "0279",
    "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
  },
  {
    "type": "UIT",
    "mpid": "TSCD",
    "clearingBroker": "0235",
    "brokerName": "STURGES COMPANY (THE)                                                 "
  },
  {
    "type": "UIT",
    "mpid": "TSER",
    "clearingBroker": "0161",
    "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "TSFA",
    "clearingBroker": "0443",
    "brokerName": "STRATEGIC FINANCIAL ALLIANCE (THE)                                    "
  },
  {
    "type": "UIT",
    "mpid": "TSSM",
    "clearingBroker": "0161",
    "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
  },
  {
    "type": "UIT",
    "mpid": "TTSC",
    "clearingBroker": "0052",
    "brokerName": "TREND TRADE SECURITIES LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "TTSI",
    "clearingBroker": "0158",
    "brokerName": "T3 SECURITIES, INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "TWCM",
    "clearingBroker": "0443",
    "brokerName": "TOWERS WATSON CAPITAL MARKETS                                         "
  },
  {
    "type": "UIT",
    "mpid": "TWDI",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "TWDL",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "TWDP",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "TWDR",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "TWDS",
    "clearingBroker": "0443",
    "brokerName": "TRADEWEB DIRECT LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "TWTT",
    "clearingBroker": "0158",
    "brokerName": "TASTYWORKS, INC.                                                      "
  },
  {
    "type": "UIT",
    "mpid": "UBSI",
    "clearingBroker": "0141",
    "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
  },
  {
    "type": "UIT",
    "mpid": "UBSW",
    "clearingBroker": "0642",
    "brokerName": "UBS SECURITIES LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "UCAP",
    "clearingBroker": "0750",
    "brokerName": "UCAP SECURITIES LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "UCCM",
    "clearingBroker": "0279",
    "brokerName": "CU INVESTMENT SOLUTIONS, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "UCML",
    "clearingBroker": "0052",
    "brokerName": "UNITED CAPITAL MARKETS, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "UHLM",
    "clearingBroker": "0235",
    "brokerName": "UHLMANN PRICE SECURITIES, LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "UMBF",
    "clearingBroker": "0226",
    "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "UNIB",
    "clearingBroker": "0443",
    "brokerName": "UNIBANCO SECURITIES INC                                               "
  },
  {
    "type": "UIT",
    "mpid": "UNIV",
    "clearingBroker": "0595",
    "brokerName": "UNIVEST SECURITIES, LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "UNTD",
    "clearingBroker": "0443",
    "brokerName": "WADDELL & REED, INC.                                                  "
  },
  {
    "type": "UIT",
    "mpid": "UPLN",
    "clearingBroker": "0443",
    "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
  },
  {
    "type": "UIT",
    "mpid": "USAF",
    "clearingBroker": "0443",
    "brokerName": "USA FINANCIAL SECURITIES CORP.                                        "
  },
  {
    "type": "UIT",
    "mpid": "USCA",
    "clearingBroker": "0226",
    "brokerName": "USCA SECURITIES LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "USIC",
    "clearingBroker": "0226",
    "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
  },
  {
    "type": "UIT",
    "mpid": "USTZ",
    "clearingBroker": "0595",
    "brokerName": "TRADEZERO AMERINCA, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "UVST",
    "clearingBroker": "0443",
    "brokerName": "UVEST FINANCIAL SERVICES GROUP, INC.                                  "
  },
  {
    "type": "UIT",
    "mpid": "VABD",
    "clearingBroker": "4264",
    "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
  },
  {
    "type": "UIT",
    "mpid": "VALI",
    "clearingBroker": "0226",
    "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "VALM",
    "clearingBroker": "0443",
    "brokerName": "VALMARK SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "VBCS",
    "clearingBroker": "0279",
    "brokerName": "VBC SECURITIES                                                        "
  },
  {
    "type": "UIT",
    "mpid": "VBLT",
    "clearingBroker": "0226",
    "brokerName": "VANDERBILT SECURITIES, LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "VBSL",
    "clearingBroker": "0595",
    "brokerName": "VISION BROKERAGE SERVICES, LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "VCAP",
    "clearingBroker": "0443",
    "brokerName": "VANGUARD CAPITAL                                                      "
  },
  {
    "type": "UIT",
    "mpid": "VCAS",
    "clearingBroker": "0443",
    "brokerName": "VCA SECURITIES, LP                                                    "
  },
  {
    "type": "UIT",
    "mpid": "VCFN",
    "clearingBroker": "0235",
    "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
  },
  {
    "type": "UIT",
    "mpid": "VCSV",
    "clearingBroker": "0052",
    "brokerName": "PRIMARY CAPITAL, LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "VENE",
    "clearingBroker": "0443",
    "brokerName": "VENECREDIT SECURITIES                                                 "
  },
  {
    "type": "UIT",
    "mpid": "VERF",
    "clearingBroker": "0235",
    "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "VERT",
    "clearingBroker": "8199",
    "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
  },
  {
    "type": "UIT",
    "mpid": "VEST",
    "clearingBroker": "0750",
    "brokerName": "VESTECH SECURITIES, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "VETS",
    "clearingBroker": "0235",
    "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
  },
  {
    "type": "UIT",
    "mpid": "VFSL",
    "clearingBroker": "0443",
    "brokerName": "VALOR FINANCIAL SECURITIES LLC                                        "
  },
  {
    "type": "UIT",
    "mpid": "VGRD",
    "clearingBroker": "0062",
    "brokerName": "VANGUARD MARKETING CORPORATION                                        "
  },
  {
    "type": "UIT",
    "mpid": "VISI",
    "clearingBroker": "0443",
    "brokerName": "VISION INVESTMENT SERVICES, INC.                                      "
  },
  {
    "type": "UIT",
    "mpid": "VKMI",
    "clearingBroker": "0692",
    "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "VLEO",
    "clearingBroker": "0158",
    "brokerName": "VOLEO USA, INC                                                        "
  },
  {
    "type": "UIT",
    "mpid": "VMDI",
    "clearingBroker": "0443",
    "brokerName": "DESJARDINS SECURITIES INTERNATIONAL INC.                              "
  },
  {
    "type": "UIT",
    "mpid": "VMEX",
    "clearingBroker": "0443",
    "brokerName": "VECTORGLOBAL WMG                                                      "
  },
  {
    "type": "UIT",
    "mpid": "VPEW",
    "clearingBroker": "0158",
    "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
  },
  {
    "type": "UIT",
    "mpid": "VSIN",
    "clearingBroker": "0595",
    "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "VSRF",
    "clearingBroker": "0141",
    "brokerName": "VSR FINANCIAL SERVICES                                                "
  },
  {
    "type": "UIT",
    "mpid": "VTDT",
    "clearingBroker": "0158",
    "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "WABR",
    "clearingBroker": "0443",
    "brokerName": "WALL STREET ACCESS                                                    "
  },
  {
    "type": "UIT",
    "mpid": "WACC",
    "clearingBroker": "0279",
    "brokerName": "MIDLAND SECURITIES, LTD                                               "
  },
  {
    "type": "UIT",
    "mpid": "WACL",
    "clearingBroker": "0709",
    "brokerName": "WACHTEL & CO., INC.                                                   "
  },
  {
    "type": "UIT",
    "mpid": "WAIN",
    "clearingBroker": "0443",
    "brokerName": "H.C. WAINWRIGHT & CO., INC.                                           "
  },
  {
    "type": "UIT",
    "mpid": "WBAX",
    "clearingBroker": "0052",
    "brokerName": "WALLACHBETH CAPITAL LLC                                               "
  },
  {
    "type": "UIT",
    "mpid": "WBBC",
    "clearingBroker": "0226",
    "brokerName": "WBB SECURITIES, LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "WBFS",
    "clearingBroker": "0443",
    "brokerName": "WOODBURY FINANCIAL SERVICES, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "WBLR",
    "clearingBroker": "0771",
    "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
  },
  {
    "type": "UIT",
    "mpid": "WBNF",
    "clearingBroker": "0226",
    "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
  },
  {
    "type": "UIT",
    "mpid": "WBRO",
    "clearingBroker": "0443",
    "brokerName": "WILEY BROS.-AINTREE CAPITAL, LLC                                      "
  },
  {
    "type": "UIT",
    "mpid": "WCIG",
    "clearingBroker": "0750",
    "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
  },
  {
    "type": "UIT",
    "mpid": "WCSC",
    "clearingBroker": "0235",
    "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
  },
  {
    "type": "UIT",
    "mpid": "WCSF",
    "clearingBroker": "0235",
    "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "WEBS",
    "clearingBroker": "0226",
    "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
  },
  {
    "type": "UIT",
    "mpid": "WEDB",
    "clearingBroker": "0103",
    "brokerName": "WEDBUSH SECURITIES INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "WEGE",
    "clearingBroker": "0443",
    "brokerName": "WORLD EQUITY GROUP, INC.                                              "
  },
  {
    "type": "UIT",
    "mpid": "WEGI",
    "clearingBroker": "0235",
    "brokerName": "WORLD EQUITY GROUP INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "WEGP",
    "clearingBroker": "0235",
    "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
  },
  {
    "type": "UIT",
    "mpid": "WESC",
    "clearingBroker": "0443",
    "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
  },
  {
    "type": "UIT",
    "mpid": "WEST",
    "clearingBroker": "0443",
    "brokerName": "WESTERN GROWERS FINANCIAL SERVICES, INC.                              "
  },
  {
    "type": "UIT",
    "mpid": "WEXR",
    "clearingBroker": "0235",
    "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
  },
  {
    "type": "UIT",
    "mpid": "WEXX",
    "clearingBroker": "0005",
    "brokerName": "WOLVERINE EXECUTION SERVICES                                          "
  },
  {
    "type": "UIT",
    "mpid": "WHAE",
    "clearingBroker": "0443",
    "brokerName": "WHARTON EQUITY CORPORATION                                            "
  },
  {
    "type": "UIT",
    "mpid": "WHCG",
    "clearingBroker": "0388",
    "brokerName": "WHITAKER                                                              "
  },
  {
    "type": "UIT",
    "mpid": "WHOT",
    "clearingBroker": "0595",
    "brokerName": "JUST2TRADE, INC.                                                      "
  },
  {
    "type": "UIT",
    "mpid": "WIDS",
    "clearingBroker": "0279",
    "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
  },
  {
    "type": "UIT",
    "mpid": "WING",
    "clearingBroker": "0443",
    "brokerName": "ING FINANCIAL PARTNERS, INC.                                          "
  },
  {
    "type": "UIT",
    "mpid": "WISC",
    "clearingBroker": "0235",
    "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "WISE",
    "clearingBroker": "0052",
    "brokerName": "AXOS INVEST LLC                                                       "
  },
  {
    "type": "UIT",
    "mpid": "WISP",
    "clearingBroker": "0443",
    "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
  },
  {
    "type": "UIT",
    "mpid": "WJBI",
    "clearingBroker": "0443",
    "brokerName": "WJB CAPITAL GROUP                                                     "
  },
  {
    "type": "UIT",
    "mpid": "WLMS",
    "clearingBroker": "0443",
    "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
  },
  {
    "type": "UIT",
    "mpid": "WLTH",
    "clearingBroker": "0235",
    "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
  },
  {
    "type": "UIT",
    "mpid": "WMFS",
    "clearingBroker": "0226",
    "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
  },
  {
    "type": "UIT",
    "mpid": "WMLL",
    "clearingBroker": "0005",
    "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
  },
  {
    "type": "UIT",
    "mpid": "WPCC",
    "clearingBroker": "0052",
    "brokerName": "WESTPARK CAPITAL, INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "WPCI",
    "clearingBroker": "0595",
    "brokerName": "WESTPARK CAPITAL, INC.                                                "
  },
  {
    "type": "UIT",
    "mpid": "WPSX",
    "clearingBroker": "0445",
    "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
  },
  {
    "type": "UIT",
    "mpid": "WRET",
    "clearingBroker": "0141",
    "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
  },
  {
    "type": "UIT",
    "mpid": "WSBI",
    "clearingBroker": "0443",
    "brokerName": "W&S BROKERAGE SVCS                                                    "
  },
  {
    "type": "UIT",
    "mpid": "WSCC",
    "clearingBroker": "0235",
    "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
  },
  {
    "type": "UIT",
    "mpid": "WSCX",
    "clearingBroker": "0235",
    "brokerName": "WORKMAN SECURITIES CORP                                               "
  },
  {
    "type": "UIT",
    "mpid": "WSEC",
    "clearingBroker": "0443",
    "brokerName": "WILLIS SECURITIES, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "WSGD",
    "clearingBroker": "8199",
    "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
  },
  {
    "type": "UIT",
    "mpid": "WSIW",
    "clearingBroker": "8199",
    "brokerName": "WEDBUSH SECURITIES INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "WSRP",
    "clearingBroker": "0052",
    "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
  },
  {
    "type": "UIT",
    "mpid": "WSTI",
    "clearingBroker": "0226",
    "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
  },
  {
    "type": "UIT",
    "mpid": "WTCO",
    "clearingBroker": "0005",
    "brokerName": "WILLIAMS TRADING LLC                                                  "
  },
  {
    "type": "UIT",
    "mpid": "WTFS",
    "clearingBroker": "0052",
    "brokerName": "LIME TRADING CORP                                                     "
  },
  {
    "type": "UIT",
    "mpid": "WTKR",
    "clearingBroker": "0388",
    "brokerName": "WHITAKER                                                              "
  },
  {
    "type": "UIT",
    "mpid": "WTLP",
    "clearingBroker": "0388",
    "brokerName": "WOLVERINE TRADING, LLC                                                "
  },
  {
    "type": "UIT",
    "mpid": "WTRI",
    "clearingBroker": "0235",
    "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
  },
  {
    "type": "UIT",
    "mpid": "WUND",
    "clearingBroker": "0141",
    "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
  },
  {
    "type": "UIT",
    "mpid": "XPUS",
    "clearingBroker": "0443",
    "brokerName": "XP SECURITIES, LLC                                                    "
  },
  {
    "type": "UIT",
    "mpid": "XRVR",
    "clearingBroker": "0279",
    "brokerName": "CRB SECURITIES, LLC                                                   "
  },
  {
    "type": "UIT",
    "mpid": "XTLS",
    "clearingBroker": "0052",
    "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "XTLW",
    "clearingBroker": "0052",
    "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
  },
  {
    "type": "UIT",
    "mpid": "XTXE",
    "clearingBroker": "0161",
    "brokerName": "XTX EXECUTION SERVICES LLC                                            "
  },
  {
    "type": "UIT",
    "mpid": "YLPL",
    "clearingBroker": "0075",
    "brokerName": "LPL FINANCIAL LLC                                                     "
  },
  {
    "type": "UIT",
    "mpid": "YOSE",
    "clearingBroker": "0052",
    "brokerName": "YORK SECURITIES, INC.                                                 "
  },
  {
    "type": "UIT",
    "mpid": "ZAHK",
    "clearingBroker": "0443",
    "brokerName": "TRANSAMERICA FINANCIAL ADVISORS                                       "
  },
  {
    "type": "UIT",
    "mpid": "ZAND",
    "clearingBroker": "0443",
    "brokerName": "MCLAUGHLIN RYDER INVESTMENTS                                          "
  },
  {
    "type": "UIT",
    "mpid": "ZEDB",
    "clearingBroker": "0161",
    "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
  },
  {
    "type": "UIT",
    "mpid": "ZERO",
    "clearingBroker": "0158",
    "brokerName": "TRADEZERO AMERICA, INC.                                               "
  },
  {
    "type": "UIT",
    "mpid": "ZION",
    "clearingBroker": "0065",
    "brokerName": "ZIONS DIRECT, INC.                                                    "
  },
  {
    "type": "UIT",
    "mpid": "ZIVI",
    "clearingBroker": "0235",
    "brokerName": "ZIV INVESTMENT COMPANY                                                "
  },
  {
    "type": "UIT",
    "mpid": "ZOUL",
    "clearingBroker": "0235",
    "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
  }
];

export const lastRefreshed = "2025-06-06T21:50:06.884Z";